// AUTO-GENERATED by scripts/states/gen_states_data_native.js — do not edit by hand.
// Source: iso3166-2_native_names.csv (ISO 3166-2, native names + English).
// `name` is the English name; `i18n` holds the native name keyed by its language.
// Regenerate: node scripts/states/gen_states_data_native.js
//
// @deprecated States now come from the API's geo master:
// GET /v1/meta/countries/:country_code/states?locale=xx → [{ code, name, category, parent }].
// Kept until every screen has moved over. Save the ISO 3166-2 code, never the name.
/* eslint-disable */

export const STATES_BY_COUNTRY = {
    "AD": [
        { code: "AD-07", name: "Andorra la Vella", i18n: {} },
        { code: "AD-02", name: "Canillo", i18n: {} },
        { code: "AD-03", name: "Encamp", i18n: {} },
        { code: "AD-08", name: "Escaldes-Engordany", i18n: {} },
        { code: "AD-04", name: "La Massana", i18n: {} },
        { code: "AD-05", name: "Ordino", i18n: {} },
        { code: "AD-06", name: "Sant Julià de Lòria", i18n: {} },
    ],
    "AE": [
        { code: "AE-AZ", name: "Abu Dhabi", i18n: {"ar":"إمارة أبوظبي"} },
        { code: "AE-AJ", name: "Ajman", i18n: {"ar":"عجمان"} },
        { code: "AE-DU", name: "Dubai", i18n: {"ar":"امارة دبي"} },
        { code: "AE-FU", name: "Fujairah", i18n: {"ar":"الفجيرة"} },
        { code: "AE-RK", name: "Ras al-Khaimah", i18n: {"ar":"رأس الخيمة"} },
        { code: "AE-SH", name: "Sharjah", i18n: {"ar":"إمارة الشارقة"} },
        { code: "AE-UQ", name: "Umm al-Quwain", i18n: {"ar":"أم القيوين"} },
    ],
    "AF": [
        { code: "AF-BDS", name: "Badakhshan", i18n: {"fa":"ولایت بدخشان"} },
        { code: "AF-BDG", name: "Badghis", i18n: {"fa":"ولایت بادغیس"} },
        { code: "AF-BGL", name: "Baghlan", i18n: {"fa":"ولایت بغلان"} },
        { code: "AF-BAL", name: "Balkh", i18n: {"fa":"ولایت بلخ"} },
        { code: "AF-BAM", name: "Bamyan", i18n: {"fa":"ولایت بامیان"} },
        { code: "AF-DAY", name: "Daykundi", i18n: {"fa":"ولایت دایکندی"} },
        { code: "AF-FRA", name: "Farah", i18n: {"fa":"ولایت فراه"} },
        { code: "AF-FYB", name: "Faryab", i18n: {"fa":"ولایت فاریاب"} },
        { code: "AF-GHA", name: "Ghazni", i18n: {"fa":"ولایت غزنی"} },
        { code: "AF-GHO", name: "Ghōr", i18n: {"fa":"ولایت غور"} },
        { code: "AF-HEL", name: "Helmand", i18n: {"fa":"ولایت هلمند"} },
        { code: "AF-HER", name: "Herat", i18n: {"fa":"ولایت هرات"} },
        { code: "AF-JOW", name: "Jowzjan", i18n: {"fa":"ولایت جوزجان"} },
        { code: "AF-KAB", name: "Kabul", i18n: {"fa":"ولایت کابل"} },
        { code: "AF-KAN", name: "Kandahar", i18n: {"fa":"ولایت قندهار"} },
        { code: "AF-KAP", name: "Kapisa", i18n: {"fa":"ولایت کاپیسا"} },
        { code: "AF-KHO", name: "Khost", i18n: {"fa":"ولایت خوست"} },
        { code: "AF-KNR", name: "Kunar", i18n: {"fa":"ولایت کنر"} },
        { code: "AF-KDZ", name: "Kunduz", i18n: {"fa":"ولایت کندوز"} },
        { code: "AF-LAG", name: "Laghman", i18n: {"fa":"ولایت لغمان"} },
        { code: "AF-LOG", name: "Logar", i18n: {"fa":"ولایت لوگر"} },
        { code: "AF-WAR", name: "Maidan Wardak", i18n: {"fa":"ولایت وردک"} },
        { code: "AF-NAN", name: "Nangarhar", i18n: {"fa":"ولایت ننگرهار"} },
        { code: "AF-NIM", name: "Nimruz", i18n: {"fa":"ولایت نیمروز"} },
        { code: "AF-NUR", name: "Nuristan", i18n: {"fa":"ولایت نورستان"} },
        { code: "AF-PIA", name: "Paktia", i18n: {"fa":"ولایت پکتیا"} },
        { code: "AF-PKA", name: "Paktika", i18n: {"fa":"ولایت پکتیکا"} },
        { code: "AF-PAN", name: "Panjshir", i18n: {"fa":"ولایت پنجشیر"} },
        { code: "AF-PAR", name: "Parwan", i18n: {"fa":"ولایت پروان"} },
        { code: "AF-SAM", name: "Samangan", i18n: {"fa":"ولایت سمنگان"} },
        { code: "AF-SAR", name: "Sar-e Pol", i18n: {"fa":"ولایت سرپل"} },
        { code: "AF-TAK", name: "Takhar", i18n: {"fa":"ولایت تخار"} },
        { code: "AF-URU", name: "Urozgan", i18n: {"fa":"ولایت اروزگان"} },
        { code: "AF-ZAB", name: "Zabul", i18n: {"fa":"ولایت زابل"} },
    ],
    "AG": [
        { code: "AG-10", name: "Barbuda", i18n: {} },
        { code: "AG-11", name: "Redonda", i18n: {} },
        { code: "AG-03", name: "Saint George", i18n: {} },
        { code: "AG-04", name: "Saint John", i18n: {} },
        { code: "AG-05", name: "Saint Mary", i18n: {} },
        { code: "AG-06", name: "Saint Paul", i18n: {} },
        { code: "AG-07", name: "Saint Peter", i18n: {} },
        { code: "AG-08", name: "Saint Philip", i18n: {} },
    ],
    "AL": [
        { code: "AL-01", name: "Berat County", i18n: {"sq":"Qarku i Beratit"} },
        { code: "AL-09", name: "Dibër County", i18n: {"sq":"Qarku i Dibrës"} },
        { code: "AL-02", name: "Durrës County", i18n: {"sq":"Qarku i Durrësit"} },
        { code: "AL-03", name: "Elbasan County", i18n: {"sq":"Qarku i Elbasanit"} },
        { code: "AL-04", name: "Fier County", i18n: {"sq":"Qarku i Fierit"} },
        { code: "AL-05", name: "Gjirokastër County", i18n: {"sq":"Qarku i Gjirokastrës"} },
        { code: "AL-06", name: "Korçë County", i18n: {"sq":"Qarku i Korçës"} },
        { code: "AL-07", name: "Kukës County", i18n: {"sq":"Qarku i Kukësit"} },
        { code: "AL-08", name: "Lezhë County", i18n: {"sq":"Qarku i Lezhës"} },
        { code: "AL-10", name: "Shkodër County", i18n: {"sq":"Qarku i Shkodrës"} },
        { code: "AL-11", name: "Tirana County", i18n: {"sq":"Qarku i Tiranës"} },
        { code: "AL-12", name: "Vlorë County", i18n: {"sq":"Qarku i Vlorës"} },
    ],
    "AM": [
        { code: "AM-AG", name: "Aragatsotn", i18n: {"hy":"Արագածոտնի մարզ"} },
        { code: "AM-AR", name: "Ararat", i18n: {"hy":"Արարատի մարզ"} },
        { code: "AM-AV", name: "Armavir", i18n: {"hy":"Արմավիրի մարզ"} },
        { code: "AM-GR", name: "Gegharkunik", i18n: {"hy":"Գեղարքունիքի մարզ"} },
        { code: "AM-KT", name: "Kotayk", i18n: {"hy":"Կոտայքի մարզ"} },
        { code: "AM-LO", name: "Lori", i18n: {"hy":"Լոռու մարզ"} },
        { code: "AM-SH", name: "Shirak", i18n: {"hy":"Շիրակի մարզ"} },
        { code: "AM-SU", name: "Syunik", i18n: {"hy":"Սյունիքի մարզ"} },
        { code: "AM-TV", name: "Tavush", i18n: {"hy":"Տավուշի մարզ"} },
        { code: "AM-VD", name: "Vayots Dzor", i18n: {"hy":"Վայոց ձորի մարզ"} },
        { code: "AM-ER", name: "Yerevan", i18n: {"hy":"Երևան"} },
    ],
    "AO": [
        { code: "AO-BGO", name: "Bengo", i18n: {} },
        { code: "AO-BGU", name: "Benguela", i18n: {} },
        { code: "AO-BIE", name: "Bié", i18n: {} },
        { code: "AO-CAB", name: "Cabinda", i18n: {} },
        { code: "AO-CCU", name: "Cuando Cubango", i18n: {"pt":"Cuando-Cubango"} },
        { code: "AO-CNO", name: "Cuanza Norte", i18n: {"pt":"Kwanza-Norte"} },
        { code: "AO-CUS", name: "Cuanza Sul", i18n: {"pt":"Kwanza-Sul"} },
        { code: "AO-CNN", name: "Cunene", i18n: {} },
        { code: "AO-HUA", name: "Huambo", i18n: {} },
        { code: "AO-HUI", name: "Huíla", i18n: {} },
        { code: "AO-LUA", name: "Luanda", i18n: {} },
        { code: "AO-LNO", name: "Lunda Norte", i18n: {"pt":"Lunda-Norte"} },
        { code: "AO-LSU", name: "Lunda Sul", i18n: {"pt":"Lunda-Sul"} },
        { code: "AO-MAL", name: "Malanje", i18n: {} },
        { code: "AO-MOX", name: "Moxico", i18n: {} },
        { code: "AO-NAM", name: "Namibe", i18n: {} },
        { code: "AO-UIG", name: "Uíge", i18n: {} },
        { code: "AO-ZAI", name: "Zaire", i18n: {} },
    ],
    "AR": [
        { code: "AR-C", name: "Buenos Aires", i18n: {} },
        { code: "AR-B", name: "Buenos Aires Province", i18n: {"es":"provincia de Buenos Aires"} },
        { code: "AR-K", name: "Catamarca", i18n: {} },
        { code: "AR-H", name: "Chaco", i18n: {"es":"Provincia del Chaco"} },
        { code: "AR-U", name: "Chubut", i18n: {"es":"Provincia del Chubut"} },
        { code: "AR-X", name: "Córdoba", i18n: {"es":"Provincia de Córdoba"} },
        { code: "AR-W", name: "Corrientes", i18n: {"es":"Provincia de Corrientes"} },
        { code: "AR-E", name: "Entre Ríos", i18n: {"es":"Provincia de Entre Ríos"} },
        { code: "AR-P", name: "Formosa", i18n: {"es":"Provincia de Formosa"} },
        { code: "AR-Y", name: "Jujuy", i18n: {"es":"Provincia de Jujuy"} },
        { code: "AR-L", name: "La Pampa", i18n: {"es":"Provincia de La Pampa"} },
        { code: "AR-F", name: "La Rioja", i18n: {"es":"Provincia de La Rioja"} },
        { code: "AR-M", name: "Mendoza", i18n: {"es":"Provincia de Mendoza"} },
        { code: "AR-N", name: "Misiones", i18n: {"es":"Provincia de Misiones"} },
        { code: "AR-Q", name: "Neuquén", i18n: {"es":"Provincia de Neuquén"} },
        { code: "AR-R", name: "Río Negro", i18n: {"es":"Provincia de Río Negro"} },
        { code: "AR-A", name: "Salta", i18n: {"es":"Provincia de Salta"} },
        { code: "AR-J", name: "San Juan", i18n: {"es":"Provincia de San Juan"} },
        { code: "AR-D", name: "San Luis", i18n: {"es":"Provincia de San Luis"} },
        { code: "AR-Z", name: "Santa Cruz", i18n: {"es":"Provincia de Santa Cruz"} },
        { code: "AR-S", name: "Santa Fe", i18n: {"es":"Provincia de Santa Fe"} },
        { code: "AR-G", name: "Santiago del Estero", i18n: {"es":"Provincia de Santiago del Estero"} },
        { code: "AR-V", name: "Tierra del Fuego", i18n: {"es":"Provincia de Tierra del Fuego, Antártida e islas del Atlántico Sur"} },
        { code: "AR-T", name: "Tucumán", i18n: {"es":"Provincia de Tucumán"} },
    ],
    "AT": [
        { code: "AT-1", name: "Burgenland", i18n: {} },
        { code: "AT-2", name: "Carinthia", i18n: {"de":"Kärnten"} },
        { code: "AT-3", name: "Lower Austria", i18n: {"de":"Niederösterreich"} },
        { code: "AT-5", name: "Salzburg", i18n: {} },
        { code: "AT-6", name: "Styria", i18n: {"de":"Steiermark"} },
        { code: "AT-7", name: "Tyrol", i18n: {"de":"Tirol"} },
        { code: "AT-4", name: "Upper Austria", i18n: {"de":"Oberösterreich"} },
        { code: "AT-9", name: "Vienna", i18n: {"de":"Wien"} },
        { code: "AT-8", name: "Vorarlberg", i18n: {} },
    ],
    "AU": [
        { code: "AU-ACT", name: "Australian Capital Territory", i18n: {} },
        { code: "AU-NSW", name: "New South Wales", i18n: {} },
        { code: "AU-NT", name: "Northern Territory", i18n: {} },
        { code: "AU-QLD", name: "Queensland", i18n: {} },
        { code: "AU-SA", name: "South Australia", i18n: {} },
        { code: "AU-TAS", name: "Tasmania", i18n: {} },
        { code: "AU-VIC", name: "Victoria", i18n: {} },
        { code: "AU-WA", name: "Western Australia", i18n: {} },
    ],
    "AZ": [
        { code: "AZ-ABS", name: "Absheron", i18n: {"az":"Abşeron"} },
        { code: "AZ-AGM", name: "Agdam", i18n: {"az":"Ağdam"} },
        { code: "AZ-AGS", name: "Agdash", i18n: {"az":"Ağdaş"} },
        { code: "AZ-AGC", name: "Aghjabadi", i18n: {"az":"Ağcabədi"} },
        { code: "AZ-AGA", name: "Agstafa", i18n: {"az":"Ağstafa"} },
        { code: "AZ-AGU", name: "Agsu", i18n: {"az":"Ağsu"} },
        { code: "AZ-AST", name: "Astara", i18n: {} },
        { code: "AZ-BAB", name: "Babek", i18n: {"az":"Babək"} },
        { code: "AZ-BA", name: "Baku", i18n: {"az":"Bakı"} },
        { code: "AZ-BAL", name: "Balakan", i18n: {"az":"Balakən"} },
        { code: "AZ-BAR", name: "Barda", i18n: {"az":"Bərdə"} },
        { code: "AZ-BEY", name: "Beylagan", i18n: {"az":"Beyləqan"} },
        { code: "AZ-BIL", name: "Bilasuvar", i18n: {"az":"Biləsuvar rayonu"} },
        { code: "AZ-DAS", name: "Dashkasan", i18n: {"az":"Daşkəsən"} },
        { code: "AZ-FUZ", name: "Fizuli", i18n: {"az":"Füzuli"} },
        { code: "AZ-GAD", name: "Gadabay", i18n: {"az":"Gədəbəy"} },
        { code: "AZ-GA", name: "Ganja", i18n: {"az":"Gəncə"} },
        { code: "AZ-QOB", name: "Gobustan", i18n: {"az":"Qobustan"} },
        { code: "AZ-GOR", name: "Goranboy", i18n: {} },
        { code: "AZ-GOY", name: "Goychay", i18n: {"az":"Göyçay"} },
        { code: "AZ-GYG", name: "Goygol", i18n: {"az":"Göygöl"} },
        { code: "AZ-HAC", name: "Hajigabul", i18n: {"az":"Hacıqabul"} },
        { code: "AZ-IMI", name: "Imishli", i18n: {"az":"İmişli"} },
        { code: "AZ-ISM", name: "Ismailli", i18n: {"az":"İsmayıllı"} },
        { code: "AZ-CAB", name: "Jabrayil", i18n: {"az":"Cəbrayıl"} },
        { code: "AZ-CAL", name: "Jalilabad", i18n: {"az":"Cəlilabad"} },
        { code: "AZ-CUL", name: "Julfa", i18n: {"az":"Culfa rayonu"} },
        { code: "AZ-KAL", name: "Kalbajar", i18n: {"az":"Kəlbəcər"} },
        { code: "AZ-KAN", name: "Kangarli", i18n: {"az":"Kəngərli"} },
        { code: "AZ-XAC", name: "Khachmaz", i18n: {"az":"Xaçmaz"} },
        { code: "AZ-XIZ", name: "Khizi", i18n: {"az":"Xızı"} },
        { code: "AZ-XCI", name: "Khojali", i18n: {"az":"Xocalı"} },
        { code: "AZ-XVD", name: "Khojavend", i18n: {"az":"Xocavənd"} },
        { code: "AZ-KUR", name: "Kurdamir", i18n: {"az":"Kürdəmir"} },
        { code: "AZ-LAC", name: "Lachin", i18n: {"az":"Laçın"} },
        { code: "AZ-LA", name: "Lankaran", i18n: {"az":"Lənkəran"} },
        { code: "AZ-LAN", name: "Lankaran District", i18n: {"az":"Lənkəran²"} },
        { code: "AZ-LER", name: "Lerik", i18n: {} },
        { code: "AZ-MAS", name: "Masally", i18n: {"az":"Masallı"} },
        { code: "AZ-MI", name: "Mingachevir", i18n: {"az":"Mingəçevir"} },
        { code: "AZ-NA", name: "Naftalan", i18n: {} },
        { code: "AZ-NV", name: "Nakhchivan", i18n: {"az":"Naxçıvan"} },
        { code: "AZ-NX", name: "Nakhchivan AR", i18n: {"az":"Naxçıvan Muxtar Respublikası"} },
        { code: "AZ-NEF", name: "Neftchala", i18n: {"az":"Neftçala"} },
        { code: "AZ-OGU", name: "Oghuz", i18n: {"az":"Oğuz"} },
        { code: "AZ-ORD", name: "Ordubad", i18n: {} },
        { code: "AZ-QAB", name: "Qabala", i18n: {"az":"Qəbələ"} },
        { code: "AZ-QAX", name: "Qakh", i18n: {"az":"Qax"} },
        { code: "AZ-QAZ", name: "Qazakh", i18n: {"az":"Qazax"} },
        { code: "AZ-QBA", name: "Quba", i18n: {} },
        { code: "AZ-QBI", name: "Qubadli", i18n: {"az":"Qubadlı"} },
        { code: "AZ-QUS", name: "Qusar", i18n: {} },
        { code: "AZ-SAT", name: "Saatly", i18n: {"az":"Saatlı"} },
        { code: "AZ-SAB", name: "Sabirabad", i18n: {} },
        { code: "AZ-SAD", name: "Sadarak", i18n: {"az":"Sədərək"} },
        { code: "AZ-SAL", name: "Salyan", i18n: {} },
        { code: "AZ-SMX", name: "Samukh", i18n: {"az":"Samux"} },
        { code: "AZ-SBN", name: "Shabran", i18n: {"az":"Şabran (rayon)"} },
        { code: "AZ-SAH", name: "Shahbuz", i18n: {"az":"Şahbuz"} },
        { code: "AZ-SA", name: "Shaki", i18n: {"az":"Şəki"} },
        { code: "AZ-SAK", name: "Shaki District", i18n: {"az":"Şəki²"} },
        { code: "AZ-SMI", name: "Shamakhi", i18n: {"az":"Şamaxı"} },
        { code: "AZ-SKR", name: "Shamkir", i18n: {"az":"Şəmkir"} },
        { code: "AZ-SAR", name: "Sharur", i18n: {"az":"Şərur"} },
        { code: "AZ-SR", name: "Shirvan", i18n: {"az":"Şirvan"} },
        { code: "AZ-SUS", name: "Shusha", i18n: {"az":"Şuşa"} },
        { code: "AZ-SIY", name: "Siazan", i18n: {"az":"Siyəzən"} },
        { code: "AZ-XA", name: "Stepanakert", i18n: {"az":"Xankəndi"} },
        { code: "AZ-SM", name: "Sumqayit", i18n: {"az":"Sumqayıt"} },
        { code: "AZ-TAR", name: "Tartar", i18n: {"az":"Tərtər"} },
        { code: "AZ-TOV", name: "Tovuz", i18n: {} },
        { code: "AZ-UCA", name: "Ujar", i18n: {"az":"Ucar"} },
        { code: "AZ-YAR", name: "Yardymli", i18n: {"az":"Yardımlı"} },
        { code: "AZ-YE", name: "Yevlakh", i18n: {"az":"Yevlax"} },
        { code: "AZ-YEV", name: "Yevlakh District", i18n: {"az":"Yevlax²"} },
        { code: "AZ-ZAN", name: "Zangilan", i18n: {"az":"Zəngilan"} },
        { code: "AZ-ZAQ", name: "Zaqatala", i18n: {} },
        { code: "AZ-ZAR", name: "Zardab", i18n: {"az":"Zərdab"} },
    ],
    "BA": [
        { code: "BA-BRC", name: "Brčko District", i18n: {"bs":"Brčko Distrikt"} },
        { code: "BA-BIH", name: "Federation of Bosnia and Herzegovina", i18n: {"bs":"Federacija Bosne i Hercegovine"} },
        { code: "BA-SRP", name: "Republika Srpska", i18n: {} },
    ],
    "BB": [
        { code: "BB-01", name: "Christ Church", i18n: {} },
        { code: "BB-02", name: "Saint Andrew", i18n: {} },
        { code: "BB-03", name: "Saint George", i18n: {} },
        { code: "BB-04", name: "Saint James", i18n: {} },
        { code: "BB-05", name: "Saint John", i18n: {} },
        { code: "BB-06", name: "Saint Joseph", i18n: {} },
        { code: "BB-07", name: "Saint Lucy", i18n: {} },
        { code: "BB-08", name: "Saint Michael", i18n: {} },
        { code: "BB-09", name: "Saint Peter", i18n: {} },
        { code: "BB-10", name: "Saint Philip", i18n: {} },
        { code: "BB-11", name: "Saint Thomas", i18n: {} },
    ],
    "BD": [
        { code: "BD-05", name: "Bagerhat", i18n: {"bn":"বাগেরহাট জেলা"} },
        { code: "BD-01", name: "Bandarban", i18n: {"bn":"বান্দরবান জেলা"} },
        { code: "BD-02", name: "Barguna", i18n: {"bn":"বরগুনা জেলা"} },
        { code: "BD-A", name: "Barisal", i18n: {"bn":"বরিশাল বিভাগ"} },
        { code: "BD-06", name: "Barisal Division", i18n: {"bn":"বরিশাল জেলা"} },
        { code: "BD-07", name: "Bhola", i18n: {"bn":"ভোলা জেলা"} },
        { code: "BD-03", name: "Bogra", i18n: {"bn":"বগুড়া জেলা"} },
        { code: "BD-04", name: "Brahmanbaria", i18n: {"bn":"ব্রাহ্মণবাড়ীয়া জেলা"} },
        { code: "BD-09", name: "Chandpur", i18n: {"bn":"চাঁদপুর জেলা"} },
        { code: "BD-10", name: "Chittagong", i18n: {"bn":"চট্টগ্রাম জেলা"} },
        { code: "BD-B", name: "Chittagong Division", i18n: {"bn":"চট্টগ্রাম বিভাগ"} },
        { code: "BD-12", name: "Chuadanga", i18n: {"bn":"চুয়াডাঙ্গা জেলা"} },
        { code: "BD-08", name: "Comilla", i18n: {"bn":"কুমিল্লা জেলা"} },
        { code: "BD-11", name: "Cox’s Bazar", i18n: {"bn":"কক্সবাজার জেলা"} },
        { code: "BD-13", name: "Dhaka", i18n: {"bn":"ঢাকা জেলা"} },
        { code: "BD-C", name: "Dhaka Division", i18n: {"bn":"ঢাকা বিভাগ"} },
        { code: "BD-14", name: "Dinajpur", i18n: {"bn":"দিনাজপুর জেলা"} },
        { code: "BD-15", name: "Faridpur", i18n: {"bn":"ফরিদপুর জেলা"} },
        { code: "BD-16", name: "Feni", i18n: {"bn":"ফেনী জেলা"} },
        { code: "BD-19", name: "Gaibandha", i18n: {"bn":"গাইবান্ধা জেলা"} },
        { code: "BD-18", name: "Gazipur", i18n: {"bn":"গাজীপুর জেলা"} },
        { code: "BD-17", name: "Gopalganj", i18n: {"bn":"গোপালগঞ্জ জেলা"} },
        { code: "BD-20", name: "Habiganj", i18n: {"bn":"হবিগঞ্জ জেলা"} },
        { code: "BD-21", name: "Jamalpur", i18n: {"bn":"জামালপুর জেলা"} },
        { code: "BD-22", name: "Jessore", i18n: {"bn":"যশোর জেলা"} },
        { code: "BD-25", name: "Jhalokati", i18n: {"bn":"ঝালকাঠি জেলা"} },
        { code: "BD-23", name: "Jhenaidah", i18n: {"bn":"ঝিনাইদহ জেলা"} },
        { code: "BD-24", name: "Joypurhat", i18n: {"bn":"জয়পুরহাট জেলা"} },
        { code: "BD-29", name: "Khagrachari", i18n: {"bn":"খাগড়াছড়ি জেলা"} },
        { code: "BD-27", name: "Khulna", i18n: {"bn":"খুলনা জেলা"} },
        { code: "BD-D", name: "Khulna Division", i18n: {"bn":"খুলনা বিভাগ"} },
        { code: "BD-26", name: "Kishoreganj", i18n: {"bn":"কিশোরগঞ্জ জেলা"} },
        { code: "BD-28", name: "Kurigram", i18n: {"bn":"কুড়িগ্রাম জেলা"} },
        { code: "BD-30", name: "Kushtia", i18n: {"bn":"কুষ্টিয়া জেলা"} },
        { code: "BD-31", name: "Lakshmipur", i18n: {"bn":"লক্ষ্মীপুর জেলা"} },
        { code: "BD-32", name: "Lalmonirhat", i18n: {"bn":"লালমনিরহাট জেলা"} },
        { code: "BD-36", name: "Madaripur", i18n: {"bn":"মাদারীপুর জেলা"} },
        { code: "BD-37", name: "Magura", i18n: {"bn":"মাগুরা জেলা"} },
        { code: "BD-33", name: "Manikganj", i18n: {"bn":"মানিকগঞ্জ জেলা"} },
        { code: "BD-38", name: "Maulvi Bazar", i18n: {"bn":"মৌলভীবাজার জেলা"} },
        { code: "BD-39", name: "Meherpur", i18n: {"bn":"মেহেরপুর জেলা"} },
        { code: "BD-35", name: "Munshiganj", i18n: {"bn":"মুন্সিগঞ্জ জেলা"} },
        { code: "BD-34", name: "Mymensingh", i18n: {"bn":"ময়মনসিংহ জেলা"} },
        { code: "BD-H", name: "Mymensingh Division", i18n: {"bn":"ময়মনসিংহ বিভাগ"} },
        { code: "BD-48", name: "Naogaon", i18n: {"bn":"নওগাঁ জেলা"} },
        { code: "BD-43", name: "Narail", i18n: {"bn":"নড়াইল জেলা"} },
        { code: "BD-40", name: "Narayanganj", i18n: {"bn":"নারায়ণগঞ্জ জেলা"} },
        { code: "BD-42", name: "Narsingdi", i18n: {"bn":"নরসিংদী জেলা"} },
        { code: "BD-44", name: "Natore", i18n: {"bn":"নাটোর জেলা"} },
        { code: "BD-45", name: "Nawabganj", i18n: {"bn":"চাঁপাইনবাবগঞ্জ জেলা"} },
        { code: "BD-41", name: "Netrokona", i18n: {"bn":"নেত্রকোনা জেলা"} },
        { code: "BD-46", name: "Nilphamari", i18n: {"bn":"নীলফামারী জেলা"} },
        { code: "BD-47", name: "Noakhali", i18n: {"bn":"নোয়াখালী জেলা"} },
        { code: "BD-49", name: "Pabna", i18n: {"bn":"পাবনা জেলা"} },
        { code: "BD-52", name: "Panchagarh", i18n: {"bn":"পঞ্চগড় জেলা"} },
        { code: "BD-51", name: "Patuakhali", i18n: {"bn":"পটুয়াখালী জেলা"} },
        { code: "BD-50", name: "Pirojpur", i18n: {"bn":"পিরোজপুর জেলা"} },
        { code: "BD-53", name: "Rajbari", i18n: {"bn":"রাজবাড়ী জেলা"} },
        { code: "BD-54", name: "Rajshahi", i18n: {"bn":"রাজশাহী জেলা"} },
        { code: "BD-E", name: "Rajshahi Division", i18n: {"bn":"রাজশাহী বিভাগ"} },
        { code: "BD-56", name: "Rangamati Hill", i18n: {"bn":"রাঙামাটি জেলা"} },
        { code: "BD-55", name: "Rangpur", i18n: {"bn":"রংপুর জেলা"} },
        { code: "BD-F", name: "Rangpur Division", i18n: {"bn":"রংপুর বিভাগ"} },
        { code: "BD-58", name: "Satkhira", i18n: {"bn":"সাতক্ষীরা জেলা"} },
        { code: "BD-62", name: "Shariatpur", i18n: {"bn":"শরিয়তপুর জেলা"} },
        { code: "BD-57", name: "Sherpur", i18n: {"bn":"শেরপুর জেলা"} },
        { code: "BD-59", name: "Sirajganj", i18n: {"bn":"সিরাজগঞ্জ জেলা"} },
        { code: "BD-61", name: "Sunamganj", i18n: {"bn":"সুনামগঞ্জ জেলা"} },
        { code: "BD-60", name: "Sylhet", i18n: {"bn":"সিলেট জেলা"} },
        { code: "BD-G", name: "Sylhet Division", i18n: {"bn":"সিলেট বিভাগ"} },
        { code: "BD-63", name: "Tangail", i18n: {"bn":"টাঙ্গাইল জেলা"} },
        { code: "BD-64", name: "Thakurgaon", i18n: {"bn":"ঠাকুরগাঁও জেলা"} },
    ],
    "BE": [
        { code: "BE-VAN", name: "Antwerp", i18n: {"nl":"Provincie Antwerpen"} },
        { code: "BE-BRU", name: "Brussels", i18n: {"nl":"Brussels Hoofdstedelijk Gewest"} },
        { code: "BE-VOV", name: "East Flanders", i18n: {"nl":"Oost-Vlaanderen"} },
        { code: "BE-VLG", name: "Flanders", i18n: {"nl":"Vlaams Gewest"} },
        { code: "BE-VBR", name: "Flemish Brabant", i18n: {"nl":"Vlaams-Brabant"} },
        { code: "BE-WHT", name: "Hainaut", i18n: {"nl":"Henegouwen"} },
        { code: "BE-WLG", name: "Liège", i18n: {"nl":"provincie Luik"} },
        { code: "BE-VLI", name: "Limburg", i18n: {} },
        { code: "BE-WLX", name: "Luxembourg", i18n: {"nl":"Provincie Luxemburg"} },
        { code: "BE-WNA", name: "Namur", i18n: {"nl":"Provincie Namen"} },
        { code: "BE-WAL", name: "Wallonia", i18n: {"nl":"Wallonië"} },
        { code: "BE-WBR", name: "Walloon Brabant", i18n: {"nl":"Waals-Brabant"} },
        { code: "BE-VWV", name: "West Flanders", i18n: {"nl":"West-Vlaanderen"} },
    ],
    "BF": [
        { code: "BF-BAL", name: "Balé", i18n: {"fr":"Balé (province du Burkina Faso)"} },
        { code: "BF-BAM", name: "Bam", i18n: {} },
        { code: "BF-BAN", name: "Banwa", i18n: {} },
        { code: "BF-BAZ", name: "Bazèga", i18n: {} },
        { code: "BF-01", name: "Boucle du Mouhoun", i18n: {} },
        { code: "BF-BGR", name: "Bougouriba", i18n: {} },
        { code: "BF-BLG", name: "Boulgou", i18n: {} },
        { code: "BF-BLK", name: "Boulkiemdé", i18n: {} },
        { code: "BF-02", name: "Cascades", i18n: {} },
        { code: "BF-03", name: "Centre", i18n: {} },
        { code: "BF-04", name: "Centre-Est", i18n: {} },
        { code: "BF-05", name: "Centre-Nord", i18n: {} },
        { code: "BF-06", name: "Centre-Ouest", i18n: {} },
        { code: "BF-07", name: "Centre-Sud", i18n: {} },
        { code: "BF-COM", name: "Comoé", i18n: {} },
        { code: "BF-08", name: "Est", i18n: {} },
        { code: "BF-GAN", name: "Ganzourgou", i18n: {} },
        { code: "BF-GNA", name: "Gnagna", i18n: {} },
        { code: "BF-GOU", name: "Gourma", i18n: {} },
        { code: "BF-09", name: "Hauts-Bassins", i18n: {} },
        { code: "BF-HOU", name: "Houet", i18n: {} },
        { code: "BF-IOB", name: "Ioba", i18n: {} },
        { code: "BF-KAD", name: "Kadiogo", i18n: {} },
        { code: "BF-KEN", name: "Kénédougou", i18n: {} },
        { code: "BF-KMD", name: "Komondjari", i18n: {} },
        { code: "BF-KMP", name: "Kompienga", i18n: {} },
        { code: "BF-KOS", name: "Kossi", i18n: {} },
        { code: "BF-KOP", name: "Koulpélogo", i18n: {} },
        { code: "BF-KOT", name: "Kouritenga", i18n: {} },
        { code: "BF-KOW", name: "Kourwéogo", i18n: {} },
        { code: "BF-LER", name: "Léraba", i18n: {} },
        { code: "BF-LOR", name: "Loroum", i18n: {} },
        { code: "BF-MOU", name: "Mouhoun", i18n: {} },
        { code: "BF-NAO", name: "Nahouri", i18n: {} },
        { code: "BF-NAM", name: "Namentenga", i18n: {} },
        { code: "BF-NAY", name: "Nayala", i18n: {} },
        { code: "BF-10", name: "Nord", i18n: {} },
        { code: "BF-NOU", name: "Noumbiel", i18n: {} },
        { code: "BF-OUB", name: "Oubritenga", i18n: {} },
        { code: "BF-OUD", name: "Oudalan", i18n: {} },
        { code: "BF-PAS", name: "Passoré", i18n: {} },
        { code: "BF-11", name: "Plateau-Central", i18n: {} },
        { code: "BF-PON", name: "Poni", i18n: {} },
        { code: "BF-12", name: "Sahel", i18n: {} },
        { code: "BF-SNG", name: "Sanguié", i18n: {} },
        { code: "BF-SMT", name: "Sanmatenga", i18n: {} },
        { code: "BF-SEN", name: "Séno", i18n: {} },
        { code: "BF-SIS", name: "Sissili", i18n: {} },
        { code: "BF-SOM", name: "Soum", i18n: {} },
        { code: "BF-SOR", name: "Sourou", i18n: {} },
        { code: "BF-13", name: "Sud-Ouest", i18n: {} },
        { code: "BF-TAP", name: "Tapoa", i18n: {} },
        { code: "BF-TUI", name: "Tuy", i18n: {} },
        { code: "BF-YAG", name: "Yagha", i18n: {} },
        { code: "BF-YAT", name: "Yatenga", i18n: {} },
        { code: "BF-ZIR", name: "Ziro", i18n: {} },
        { code: "BF-ZON", name: "Zondoma", i18n: {} },
        { code: "BF-ZOU", name: "Zoundwéogo", i18n: {} },
    ],
    "BG": [
        { code: "BG-01", name: "Blagoevgrad", i18n: {"bg":"Област Благоевград"} },
        { code: "BG-02", name: "Burgas", i18n: {"bg":"Област Бургас"} },
        { code: "BG-08", name: "Dobrich", i18n: {"bg":"Област Добрич"} },
        { code: "BG-07", name: "Gabrovo", i18n: {"bg":"Област Габрово"} },
        { code: "BG-26", name: "Haskovo", i18n: {"bg":"Област Хасково"} },
        { code: "BG-09", name: "Kardzhali", i18n: {"bg":"Област Кърджали"} },
        { code: "BG-10", name: "Kyustendil", i18n: {"bg":"Област Кюстендил"} },
        { code: "BG-11", name: "Lovech", i18n: {"bg":"Област Ловеч"} },
        { code: "BG-12", name: "Montana", i18n: {"bg":"Област Монтана"} },
        { code: "BG-13", name: "Pazardzhik", i18n: {"bg":"Област Пазарджик"} },
        { code: "BG-14", name: "Pernik", i18n: {"bg":"Област Перник"} },
        { code: "BG-15", name: "Pleven", i18n: {"bg":"Област Плевен"} },
        { code: "BG-16", name: "Plovdiv", i18n: {"bg":"Област Пловдив"} },
        { code: "BG-17", name: "Razgrad", i18n: {"bg":"Област Разград"} },
        { code: "BG-18", name: "Ruse", i18n: {"bg":"Област Русе"} },
        { code: "BG-27", name: "Shumen", i18n: {"bg":"Област Шумен"} },
        { code: "BG-19", name: "Silistra", i18n: {"bg":"Област Силистра"} },
        { code: "BG-20", name: "Sliven", i18n: {"bg":"Област Сливен"} },
        { code: "BG-21", name: "Smolyan", i18n: {"bg":"Област Смолян"} },
        { code: "BG-22", name: "Sofia", i18n: {"bg":"Област София"} },
        { code: "BG-23", name: "Sofia District", i18n: {"bg":"Софийска област"} },
        { code: "BG-24", name: "Stara Zagora", i18n: {"bg":"Област Стара Загора"} },
        { code: "BG-25", name: "Targovishte", i18n: {"bg":"Област Търговище"} },
        { code: "BG-03", name: "Varna", i18n: {"bg":"Област Варна"} },
        { code: "BG-04", name: "Veliko Tarnovo", i18n: {"bg":"Област Велико Търново"} },
        { code: "BG-05", name: "Vidin", i18n: {"bg":"Област Видин"} },
        { code: "BG-06", name: "Vratsa", i18n: {"bg":"Област Враца"} },
        { code: "BG-28", name: "Yambol", i18n: {"bg":"Област Ямбол"} },
    ],
    "BH": [
        { code: "BH-13", name: "Capital", i18n: {"ar":"محافظة العاصمة"} },
        { code: "BH-15", name: "Muharraq", i18n: {"ar":"محافظة المحرق"} },
        { code: "BH-17", name: "Northern", i18n: {"ar":"شمالية"} },
        { code: "BH-14", name: "Southern", i18n: {"ar":"جنوبية"} },
    ],
    "BI": [
        { code: "BI-BB", name: "Bubanza", i18n: {} },
        { code: "BI-BM", name: "Bujumbura", i18n: {} },
        { code: "BI-BL", name: "Bujumbura Rural", i18n: {} },
        { code: "BI-BR", name: "Bururi", i18n: {} },
        { code: "BI-CA", name: "Cankuzo", i18n: {} },
        { code: "BI-CI", name: "Cibitoke", i18n: {} },
        { code: "BI-GI", name: "Gitega", i18n: {} },
        { code: "BI-KR", name: "Karuzi", i18n: {} },
        { code: "BI-KY", name: "Kayanza", i18n: {} },
        { code: "BI-KI", name: "Kirundo", i18n: {} },
        { code: "BI-MA", name: "Makamba", i18n: {} },
        { code: "BI-MU", name: "Muramvya", i18n: {} },
        { code: "BI-MY", name: "Muyinga", i18n: {} },
        { code: "BI-MW", name: "Mwaro", i18n: {} },
        { code: "BI-NG", name: "Ngozi", i18n: {} },
        { code: "BI-RM", name: "Rumonge", i18n: {} },
        { code: "BI-RT", name: "Rutana", i18n: {} },
        { code: "BI-RY", name: "Ruyigi", i18n: {} },
    ],
    "BJ": [
        { code: "BJ-AL", name: "Alibori", i18n: {} },
        { code: "BJ-AK", name: "Atakora", i18n: {"fr":"Atacora"} },
        { code: "BJ-AQ", name: "Atlantique", i18n: {} },
        { code: "BJ-BO", name: "Borgou", i18n: {} },
        { code: "BJ-CO", name: "Collines", i18n: {} },
        { code: "BJ-DO", name: "Donga", i18n: {} },
        { code: "BJ-KO", name: "Kouffo", i18n: {"fr":"Couffo"} },
        { code: "BJ-LI", name: "Littoral", i18n: {} },
        { code: "BJ-MO", name: "Mono", i18n: {} },
        { code: "BJ-OU", name: "Ouémé", i18n: {} },
        { code: "BJ-PL", name: "Plateau", i18n: {} },
        { code: "BJ-ZO", name: "Zou", i18n: {} },
    ],
    "BN": [
        { code: "BN-BE", name: "Belait", i18n: {"ms":"Daerah Belait"} },
        { code: "BN-BM", name: "Brunei-Muara", i18n: {"ms":"Daerah Brunei Muara"} },
        { code: "BN-TE", name: "Temburong", i18n: {"ms":"Daerah Temburong"} },
        { code: "BN-TU", name: "Tutong", i18n: {"ms":"Daerah Tutong"} },
    ],
    "BO": [
        { code: "BO-B", name: "Beni", i18n: {"es":"Departamento del Beni"} },
        { code: "BO-H", name: "Chuquisaca", i18n: {"es":"Departamento de Chuquisaca"} },
        { code: "BO-C", name: "Cochabamba", i18n: {"es":"Departamento de Cochabamba"} },
        { code: "BO-L", name: "La Paz", i18n: {} },
        { code: "BO-O", name: "Oruro", i18n: {"es":"Departamento de Oruro"} },
        { code: "BO-N", name: "Pando", i18n: {"es":"Departamento de Pando"} },
        { code: "BO-P", name: "Potosí", i18n: {"es":"Departamento de Potosí"} },
        { code: "BO-S", name: "Santa Cruz", i18n: {"es":"Departamento de Santa Cruz"} },
        { code: "BO-T", name: "Tarija", i18n: {"es":"Departamento de Tarija"} },
    ],
    "BQ": [
        { code: "BQ-BO", name: "Bonaire", i18n: {} },
        { code: "BQ-SA", name: "Saba", i18n: {} },
        { code: "BQ-SE", name: "Sint Eustatius", i18n: {} },
    ],
    "BR": [
        { code: "BR-AC", name: "Acre", i18n: {} },
        { code: "BR-AL", name: "Alagoas", i18n: {} },
        { code: "BR-AP", name: "Amapá", i18n: {} },
        { code: "BR-AM", name: "Amazonas", i18n: {} },
        { code: "BR-BA", name: "Bahia", i18n: {} },
        { code: "BR-CE", name: "Ceará", i18n: {} },
        { code: "BR-ES", name: "Espírito Santo", i18n: {} },
        { code: "BR-DF", name: "Federal District", i18n: {"pt":"Distrito Federal"} },
        { code: "BR-GO", name: "Goiás", i18n: {} },
        { code: "BR-MA", name: "Maranhão", i18n: {} },
        { code: "BR-MT", name: "Mato Grosso", i18n: {} },
        { code: "BR-MS", name: "Mato Grosso do Sul", i18n: {} },
        { code: "BR-MG", name: "Minas Gerais", i18n: {} },
        { code: "BR-PA", name: "Pará", i18n: {} },
        { code: "BR-PB", name: "Paraíba", i18n: {} },
        { code: "BR-PR", name: "Paraná", i18n: {} },
        { code: "BR-PE", name: "Pernambuco", i18n: {} },
        { code: "BR-PI", name: "Piauí", i18n: {} },
        { code: "BR-RJ", name: "Rio de Janeiro", i18n: {} },
        { code: "BR-RN", name: "Rio Grande do Norte", i18n: {} },
        { code: "BR-RS", name: "Rio Grande do Sul", i18n: {} },
        { code: "BR-RO", name: "Rondônia", i18n: {} },
        { code: "BR-RR", name: "Roraima", i18n: {} },
        { code: "BR-SC", name: "Santa Catarina", i18n: {} },
        { code: "BR-SP", name: "São Paulo", i18n: {} },
        { code: "BR-SE", name: "Sergipe", i18n: {} },
        { code: "BR-TO", name: "Tocantins", i18n: {} },
    ],
    "BS": [
        { code: "BS-AK", name: "Acklins", i18n: {} },
        { code: "BS-BY", name: "Berry Islands", i18n: {} },
        { code: "BS-BI", name: "Bimini", i18n: {} },
        { code: "BS-BP", name: "Black Point", i18n: {} },
        { code: "BS-CI", name: "Cat Island", i18n: {} },
        { code: "BS-CO", name: "Central Abaco", i18n: {} },
        { code: "BS-CS", name: "Central Andros", i18n: {} },
        { code: "BS-CE", name: "Central Eleuthera", i18n: {} },
        { code: "BS-CK", name: "Crooked Island", i18n: {} },
        { code: "BS-EG", name: "East Grand Bahama", i18n: {} },
        { code: "BS-EX", name: "Exuma", i18n: {} },
        { code: "BS-FP", name: "Freeport", i18n: {} },
        { code: "BS-GC", name: "Grand Cay", i18n: {} },
        { code: "BS-HI", name: "Harbour Island", i18n: {} },
        { code: "BS-HT", name: "Hope Town", i18n: {} },
        { code: "BS-IN", name: "Inagua", i18n: {} },
        { code: "BS-LI", name: "Long Island", i18n: {} },
        { code: "BS-MC", name: "Mangrove Cay", i18n: {} },
        { code: "BS-MG", name: "Mayaguana", i18n: {} },
        { code: "BS-MI", name: "Moore’s Island", i18n: {} },
        { code: "BS-NP", name: "New Providence", i18n: {} },
        { code: "BS-NO", name: "North Abaco", i18n: {} },
        { code: "BS-NS", name: "North Andros", i18n: {} },
        { code: "BS-NE", name: "North Eleuthera", i18n: {} },
        { code: "BS-RI", name: "Ragged Island", i18n: {} },
        { code: "BS-RC", name: "Rum Cay", i18n: {} },
        { code: "BS-SS", name: "San Salvador", i18n: {} },
        { code: "BS-SO", name: "South Abaco", i18n: {} },
        { code: "BS-SA", name: "South Andros", i18n: {} },
        { code: "BS-SE", name: "South Eleuthera", i18n: {} },
        { code: "BS-SW", name: "Spanish Wells", i18n: {} },
        { code: "BS-WG", name: "West Grand Bahama", i18n: {} },
    ],
    "BT": [
        { code: "BT-33", name: "Bumthang", i18n: {} },
        { code: "BT-12", name: "Chukha", i18n: {} },
        { code: "BT-22", name: "Dagana", i18n: {} },
        { code: "BT-GA", name: "Gasa", i18n: {} },
        { code: "BT-13", name: "Haa", i18n: {} },
        { code: "BT-44", name: "Lhuntse", i18n: {} },
        { code: "BT-42", name: "Mongar", i18n: {} },
        { code: "BT-11", name: "Paro", i18n: {} },
        { code: "BT-43", name: "Pemagatshel", i18n: {} },
        { code: "BT-23", name: "Punakha", i18n: {} },
        { code: "BT-45", name: "Samdrup Jongkhar", i18n: {} },
        { code: "BT-14", name: "Samtse", i18n: {} },
        { code: "BT-31", name: "Sarpang", i18n: {} },
        { code: "BT-15", name: "Thimphu", i18n: {} },
        { code: "BT-41", name: "Trashigang", i18n: {} },
        { code: "BT-TY", name: "Trashiyangtse", i18n: {} },
        { code: "BT-32", name: "Trongsa", i18n: {} },
        { code: "BT-21", name: "Tsirang", i18n: {} },
        { code: "BT-24", name: "Wangdue Phodrang", i18n: {} },
        { code: "BT-34", name: "Zhemgang", i18n: {} },
    ],
    "BW": [
        { code: "BW-CE", name: "Central", i18n: {} },
        { code: "BW-CH", name: "Chobe", i18n: {} },
        { code: "BW-FR", name: "Francistown", i18n: {} },
        { code: "BW-GA", name: "Gaborone", i18n: {} },
        { code: "BW-GH", name: "Ghanzi", i18n: {} },
        { code: "BW-JW", name: "Jwaneng", i18n: {} },
        { code: "BW-KG", name: "Kgalagadi", i18n: {} },
        { code: "BW-KL", name: "Kgatleng", i18n: {} },
        { code: "BW-KW", name: "Kweneng", i18n: {} },
        { code: "BW-LO", name: "Lobatse", i18n: {} },
        { code: "BW-NE", name: "North East", i18n: {} },
        { code: "BW-NW", name: "North West", i18n: {} },
        { code: "BW-SP", name: "Selibe Phikwe", i18n: {} },
        { code: "BW-SE", name: "South East", i18n: {} },
        { code: "BW-SO", name: "Southern", i18n: {} },
        { code: "BW-ST", name: "Sowa Town", i18n: {} },
    ],
    "BY": [
        { code: "BY-BR", name: "Brest", i18n: {"ru":"Брестская область"} },
        { code: "BY-HO", name: "Homel", i18n: {"ru":"Гомельская область"} },
        { code: "BY-HR", name: "Hrodna", i18n: {"ru":"Гродненская область"} },
        { code: "BY-MA", name: "Magileu", i18n: {"ru":"Могилёвская область"} },
        { code: "BY-HM", name: "Minsk", i18n: {"ru":"Минск"} },
        { code: "BY-MI", name: "Minsk Region", i18n: {"ru":"Минская область"} },
        { code: "BY-VI", name: "Vitebsk", i18n: {"ru":"Витебская область"} },
    ],
    "BZ": [
        { code: "BZ-BZ", name: "Belize", i18n: {} },
        { code: "BZ-CY", name: "Cayo", i18n: {} },
        { code: "BZ-CZL", name: "Corozal", i18n: {} },
        { code: "BZ-OW", name: "Orange Walk", i18n: {} },
        { code: "BZ-SC", name: "Stann Creek", i18n: {} },
        { code: "BZ-TOL", name: "Toledo", i18n: {} },
    ],
    "CA": [
        { code: "CA-AB", name: "Alberta", i18n: {} },
        { code: "CA-BC", name: "British Columbia", i18n: {} },
        { code: "CA-MB", name: "Manitoba", i18n: {} },
        { code: "CA-NB", name: "New Brunswick", i18n: {} },
        { code: "CA-NL", name: "Newfoundland and Labrador", i18n: {} },
        { code: "CA-NT", name: "Northwest Territories", i18n: {} },
        { code: "CA-NS", name: "Nova Scotia", i18n: {} },
        { code: "CA-NU", name: "Nunavut", i18n: {} },
        { code: "CA-ON", name: "Ontario", i18n: {} },
        { code: "CA-PE", name: "Prince Edward Island", i18n: {} },
        { code: "CA-QC", name: "Quebec", i18n: {} },
        { code: "CA-SK", name: "Saskatchewan", i18n: {} },
        { code: "CA-YT", name: "Yukon", i18n: {} },
    ],
    "CD": [
        { code: "CD-BC", name: "Bas-Congo", i18n: {} },
        { code: "CD-BU", name: "Bas-Uélé", i18n: {"fr":"Bas-Uele"} },
        { code: "CD-EQ", name: "Équateur", i18n: {} },
        { code: "CD-HK", name: "Haut-Katanga", i18n: {} },
        { code: "CD-HL", name: "Haut-Lomami", i18n: {} },
        { code: "CD-HU", name: "Haut-Uélé", i18n: {"fr":"Haut-Uele"} },
        { code: "CD-IT", name: "Ituri", i18n: {} },
        { code: "CD-KS", name: "Kasaï", i18n: {} },
        { code: "CD-KC", name: "Kasaï Central", i18n: {"fr":"Lulua"} },
        { code: "CD-KE", name: "Kasaï-Oriental", i18n: {"fr":"Kasaï oriental"} },
        { code: "CD-KN", name: "Kinshasa", i18n: {} },
        { code: "CD-KG", name: "Kwango", i18n: {} },
        { code: "CD-KL", name: "Kwilu", i18n: {} },
        { code: "CD-LO", name: "Lomami", i18n: {"fr":"Kabinda"} },
        { code: "CD-LU", name: "Lualaba", i18n: {} },
        { code: "CD-MN", name: "Mai-Ndombe", i18n: {} },
        { code: "CD-MA", name: "Maniema", i18n: {} },
        { code: "CD-MO", name: "Mongala", i18n: {} },
        { code: "CD-NU", name: "Nord-Ubangi", i18n: {} },
        { code: "CD-NK", name: "North Kivu", i18n: {"fr":"Nord-Kivu"} },
        { code: "CD-SA", name: "Sankuru", i18n: {} },
        { code: "CD-SK", name: "South Kivu", i18n: {"fr":"Sud-Kivu"} },
        { code: "CD-SU", name: "Sud-Ubangi", i18n: {} },
        { code: "CD-TA", name: "Tanganyika", i18n: {} },
        { code: "CD-TO", name: "Tshopo", i18n: {} },
        { code: "CD-TU", name: "Tshuapa", i18n: {} },
    ],
    "CF": [
        { code: "CF-BB", name: "Bamingui-Bangoran", i18n: {} },
        { code: "CF-BGF", name: "Bangui", i18n: {} },
        { code: "CF-BK", name: "Basse-Kotto", i18n: {} },
        { code: "CF-HM", name: "Haut-Mbomou", i18n: {} },
        { code: "CF-HK", name: "Haute-Kotto", i18n: {} },
        { code: "CF-KG", name: "Kémo", i18n: {} },
        { code: "CF-LB", name: "Lobaye", i18n: {} },
        { code: "CF-HS", name: "Mambéré-Kadéï", i18n: {} },
        { code: "CF-MB", name: "Mbomou", i18n: {} },
        { code: "CF-KB", name: "Nana-Grébizi", i18n: {} },
        { code: "CF-NM", name: "Nana-Mambéré", i18n: {} },
        { code: "CF-MP", name: "Ombella-M’Poko", i18n: {} },
        { code: "CF-UK", name: "Ouaka", i18n: {} },
        { code: "CF-AC", name: "Ouham", i18n: {} },
        { code: "CF-OP", name: "Ouham-Pendé", i18n: {} },
        { code: "CF-SE", name: "Sangha-Mbaéré", i18n: {} },
        { code: "CF-VK", name: "Vakaga", i18n: {} },
    ],
    "CG": [
        { code: "CG-11", name: "Bouenza", i18n: {} },
        { code: "CG-BZV", name: "Brazzaville", i18n: {} },
        { code: "CG-8", name: "Cuvette", i18n: {} },
        { code: "CG-15", name: "Cuvette-Ouest", i18n: {} },
        { code: "CG-5", name: "Kouilou", i18n: {} },
        { code: "CG-2", name: "Lékoumou", i18n: {} },
        { code: "CG-7", name: "Likouala", i18n: {} },
        { code: "CG-9", name: "Niari", i18n: {} },
        { code: "CG-14", name: "Plateaux", i18n: {} },
        { code: "CG-16", name: "Pointe-Noire", i18n: {} },
        { code: "CG-12", name: "Pool", i18n: {} },
        { code: "CG-13", name: "Sangha", i18n: {} },
    ],
    "CH": [
        { code: "CH-AG", name: "Aargau", i18n: {} },
        { code: "CH-AR", name: "Appenzell Ausserrhoden", i18n: {"de":"Appenzell Außerrhoden"} },
        { code: "CH-AI", name: "Appenzell Innerrhoden", i18n: {} },
        { code: "CH-BL", name: "Basel-Landschaft", i18n: {} },
        { code: "CH-BS", name: "Basel-Stadt", i18n: {} },
        { code: "CH-BE", name: "Bern", i18n: {} },
        { code: "CH-FR", name: "Fribourg", i18n: {"de":"Freiburg"} },
        { code: "CH-GE", name: "Geneva", i18n: {"de":"Genf"} },
        { code: "CH-GL", name: "Glarus", i18n: {} },
        { code: "CH-GR", name: "Graubünden", i18n: {} },
        { code: "CH-JU", name: "Jura", i18n: {} },
        { code: "CH-LU", name: "Lucerne", i18n: {"de":"Luzern"} },
        { code: "CH-NE", name: "Neuchâtel", i18n: {"de":"Neuenburg"} },
        { code: "CH-NW", name: "Nidwalden", i18n: {} },
        { code: "CH-OW", name: "Obwalden", i18n: {} },
        { code: "CH-SH", name: "Schaffhausen", i18n: {} },
        { code: "CH-SZ", name: "Schwyz", i18n: {} },
        { code: "CH-SO", name: "Solothurn", i18n: {} },
        { code: "CH-SG", name: "St. Gallen", i18n: {} },
        { code: "CH-TG", name: "Thurgau", i18n: {} },
        { code: "CH-TI", name: "Ticino", i18n: {"de":"Tessin"} },
        { code: "CH-UR", name: "Uri", i18n: {} },
        { code: "CH-VS", name: "Valais", i18n: {"de":"Wallis"} },
        { code: "CH-VD", name: "Vaud", i18n: {"de":"Waadt"} },
        { code: "CH-ZG", name: "Zug", i18n: {} },
        { code: "CH-ZH", name: "Zürich", i18n: {} },
    ],
    "CI": [
        { code: "CI-AB", name: "Abidjan", i18n: {} },
        { code: "CI-BS", name: "Bas-Sassandra²", i18n: {"fr":"District du Bas-Sassandra"} },
        { code: "CI-CM", name: "Comoé", i18n: {"fr":"District de la Comoé"} },
        { code: "CI-DN", name: "Denguélé²", i18n: {"fr":"Denguélé"} },
        { code: "CI-GD", name: "Gôh-Djiboua", i18n: {"fr":"District du Gôh-Djiboua"} },
        { code: "CI-LC", name: "Lacs²", i18n: {"fr":"District des Lacs"} },
        { code: "CI-LG", name: "Lagunes²", i18n: {"fr":"District des Lagunes"} },
        { code: "CI-MG", name: "Montagnes", i18n: {"fr":"District des Montagnes"} },
        { code: "CI-SM", name: "Sassandra-Marahoué", i18n: {"fr":"District du Sassandra-Marahoué"} },
        { code: "CI-SV", name: "Savanes", i18n: {} },
        { code: "CI-VB", name: "Vallée du Bandama²", i18n: {"fr":"Vallée du Bandama"} },
        { code: "CI-WR", name: "Woroba", i18n: {"fr":"District du Woroba"} },
        { code: "CI-YM", name: "Yamoussoukro", i18n: {} },
        { code: "CI-ZZ", name: "Zanzan²", i18n: {"fr":"Zanzan"} },
    ],
    "CL": [
        { code: "CL-AN", name: "Antofagasta", i18n: {"es":"Región de Antofagasta"} },
        { code: "CL-AR", name: "Araucanía", i18n: {"es":"Región de la Araucanía"} },
        { code: "CL-AP", name: "Arica y Parinacota", i18n: {"es":"Región de Arica y Parinacota"} },
        { code: "CL-AT", name: "Atacama", i18n: {"es":"Región de Atacama"} },
        { code: "CL-AI", name: "Aysén", i18n: {"es":"Región Aysén del General Carlos Ibáñez del Campo"} },
        { code: "CL-BI", name: "Bío Bío", i18n: {"es":"Región del Bío Bío"} },
        { code: "CL-CO", name: "Coquimbo", i18n: {"es":"Región de Coquimbo"} },
        { code: "CL-LI", name: "Libertador General Bernardo O’Higgins", i18n: {"es":"Región de O’Higgins"} },
        { code: "CL-LL", name: "Los Lagos", i18n: {"es":"Región de Los Lagos"} },
        { code: "CL-LR", name: "Los Ríos", i18n: {"es":"Región de Los Ríos"} },
        { code: "CL-MA", name: "Magallanes Region", i18n: {"es":"Región de Magallanes y de la Antártica Chilena"} },
        { code: "CL-ML", name: "Maule", i18n: {"es":"Región del Maule"} },
        { code: "CL-NB", name: "Ñuble", i18n: {"es":"Región de Ñuble"} },
        { code: "CL-RM", name: "Santiago Metropolitan", i18n: {"es":"Región Metropolitana de Santiago"} },
        { code: "CL-TA", name: "Tarapacá", i18n: {"es":"Región de Tarapacá"} },
        { code: "CL-VS", name: "Valparaíso", i18n: {"es":"Región de Valparaíso"} },
    ],
    "CM": [
        { code: "CM-AD", name: "Adamawa", i18n: {"fr":"Région de l’Adamaoua"} },
        { code: "CM-CE", name: "Centre", i18n: {"fr":"Région du Centre"} },
        { code: "CM-ES", name: "East", i18n: {"fr":"Région de l’Est"} },
        { code: "CM-EN", name: "Far North", i18n: {"fr":"Région de l’Extrême-Nord"} },
        { code: "CM-LT", name: "Littoral", i18n: {"fr":"Région du Littoral"} },
        { code: "CM-NO", name: "North", i18n: {"fr":"Région du Nord"} },
        { code: "CM-NW", name: "Northwest", i18n: {"fr":"Région du Nord-Ouest"} },
        { code: "CM-SU", name: "South", i18n: {"fr":"Région du Sud"} },
        { code: "CM-SW", name: "Southwest", i18n: {"fr":"Région du Sud-Ouest"} },
        { code: "CM-OU", name: "West", i18n: {"fr":"Région de l’Ouest"} },
    ],
    "CN": [
        { code: "CN-AH", name: "Anhui", i18n: {"zh":"安徽省"} },
        { code: "CN-BJ", name: "Beijing", i18n: {"zh":"北京市"} },
        { code: "CN-CQ", name: "Chongqing", i18n: {"zh":"重庆市"} },
        { code: "CN-FJ", name: "Fujian", i18n: {"zh":"福建省"} },
        { code: "CN-GS", name: "Gansu", i18n: {"zh":"甘肃省"} },
        { code: "CN-GD", name: "Guangdong", i18n: {"zh":"广东省"} },
        { code: "CN-GX", name: "Guangxi", i18n: {"zh":"广西壮族自治区"} },
        { code: "CN-GZ", name: "Guizhou", i18n: {"zh":"贵州省"} },
        { code: "CN-HI", name: "Hainan", i18n: {"zh":"海南省"} },
        { code: "CN-HE", name: "Hebei", i18n: {"zh":"河北省"} },
        { code: "CN-HL", name: "Heilongjiang", i18n: {"zh":"黑龙江省"} },
        { code: "CN-HA", name: "Henan", i18n: {"zh":"河南省"} },
        { code: "CN-HK", name: "Hong Kong", i18n: {"zh":"香港"} },
        { code: "CN-HB", name: "Hubei", i18n: {"zh":"湖北省"} },
        { code: "CN-HN", name: "Hunan", i18n: {"zh":"湖南省"} },
        { code: "CN-NM", name: "Inner Mongolia", i18n: {"zh":"内蒙古自治区"} },
        { code: "CN-JS", name: "Jiangsu", i18n: {"zh":"江苏省"} },
        { code: "CN-JX", name: "Jiangxi", i18n: {"zh":"江西省"} },
        { code: "CN-JL", name: "Jilin", i18n: {"zh":"吉林省"} },
        { code: "CN-LN", name: "Liaoning", i18n: {"zh":"辽宁省"} },
        { code: "CN-MO", name: "Macau", i18n: {"zh":"澳門"} },
        { code: "CN-NX", name: "Ningxia", i18n: {"zh":"宁夏回族自治区"} },
        { code: "CN-QH", name: "Qinghai", i18n: {"zh":"青海省"} },
        { code: "CN-SN", name: "Shaanxi", i18n: {"zh":"陕西省"} },
        { code: "CN-SD", name: "Shandong", i18n: {"zh":"山东省"} },
        { code: "CN-SH", name: "Shanghai", i18n: {"zh":"上海市"} },
        { code: "CN-SX", name: "Shanxi", i18n: {"zh":"山西省"} },
        { code: "CN-SC", name: "Sichuan", i18n: {"zh":"四川省"} },
        { code: "CN-TW", name: "Taiwan", i18n: {"zh":"台湾省 (中华人民共和国)"} },
        { code: "CN-TJ", name: "Tianjin", i18n: {"zh":"天津市"} },
        { code: "CN-XZ", name: "Tibet", i18n: {"zh":"西藏自治区"} },
        { code: "CN-XJ", name: "Xinjiang", i18n: {"zh":"新疆维吾尔自治区"} },
        { code: "CN-YN", name: "Yunnan", i18n: {"zh":"云南省"} },
        { code: "CN-ZJ", name: "Zhejiang", i18n: {"zh":"浙江省"} },
    ],
    "CO": [
        { code: "CO-AMA", name: "Amazonas", i18n: {} },
        { code: "CO-ANT", name: "Antioquia", i18n: {} },
        { code: "CO-ARA", name: "Arauca", i18n: {} },
        { code: "CO-ATL", name: "Atlántico", i18n: {} },
        { code: "CO-BOL", name: "Bolívar", i18n: {} },
        { code: "CO-BOY", name: "Boyacá", i18n: {} },
        { code: "CO-CAL", name: "Caldas", i18n: {} },
        { code: "CO-DC", name: "Capital District", i18n: {"es":"Bogotá"} },
        { code: "CO-CAQ", name: "Caquetá", i18n: {} },
        { code: "CO-CAS", name: "Casanare", i18n: {} },
        { code: "CO-CAU", name: "Cauca", i18n: {} },
        { code: "CO-CES", name: "Cesar", i18n: {} },
        { code: "CO-CHO", name: "Chocó", i18n: {} },
        { code: "CO-COR", name: "Córdoba", i18n: {} },
        { code: "CO-CUN", name: "Cundinamarca", i18n: {} },
        { code: "CO-GUA", name: "Guainía", i18n: {} },
        { code: "CO-GUV", name: "Guaviare", i18n: {} },
        { code: "CO-HUI", name: "Huila", i18n: {} },
        { code: "CO-LAG", name: "La Guajira", i18n: {} },
        { code: "CO-MAG", name: "Magdalena", i18n: {} },
        { code: "CO-MET", name: "Meta", i18n: {} },
        { code: "CO-NAR", name: "Nariño", i18n: {} },
        { code: "CO-NSA", name: "Norte de Santander", i18n: {} },
        { code: "CO-PUT", name: "Putumayo", i18n: {} },
        { code: "CO-QUI", name: "Quindío", i18n: {} },
        { code: "CO-RIS", name: "Risaralda", i18n: {} },
        { code: "CO-SAP", name: "San Andrés &amp; Providencia", i18n: {"es":"Archipiélago de San Andrés, Providencia y Santa Catalina"} },
        { code: "CO-SAN", name: "Santander", i18n: {} },
        { code: "CO-SUC", name: "Sucre", i18n: {} },
        { code: "CO-TOL", name: "Tolima", i18n: {} },
        { code: "CO-VAC", name: "Valle del Cauca", i18n: {} },
        { code: "CO-VAU", name: "Vaupés", i18n: {} },
        { code: "CO-VID", name: "Vichada", i18n: {} },
    ],
    "CR": [
        { code: "CR-A", name: "Alajuela", i18n: {"es":"Provincia de Alajuela"} },
        { code: "CR-C", name: "Cartago", i18n: {"es":"Provincia de Cartago"} },
        { code: "CR-G", name: "Guanacaste", i18n: {"es":"Provincia de Guanacaste"} },
        { code: "CR-H", name: "Heredia", i18n: {} },
        { code: "CR-L", name: "Limón", i18n: {} },
        { code: "CR-P", name: "Puntarenas", i18n: {} },
        { code: "CR-SJ", name: "San José", i18n: {"es":"Provincia de San José"} },
    ],
    "CU": [
        { code: "CU-15", name: "Artemisa", i18n: {"es":"Provincia de Artemisa"} },
        { code: "CU-09", name: "Camagüey", i18n: {"es":"Provincia de Camagüey"} },
        { code: "CU-08", name: "Ciego de Ávila", i18n: {"es":"Provincia de Ciego de Ávila"} },
        { code: "CU-06", name: "Cienfuegos", i18n: {"es":"Provincia de Cienfuegos"} },
        { code: "CU-12", name: "Granma", i18n: {"es":"Provincia de Granma"} },
        { code: "CU-14", name: "Guantánamo", i18n: {"es":"Provincia de Guantánamo"} },
        { code: "CU-03", name: "Havana", i18n: {"es":"Provincia de La Habana"} },
        { code: "CU-11", name: "Holguín", i18n: {"es":"Provincia de Holguín"} },
        { code: "CU-99", name: "Isla de la Juventud", i18n: {} },
        { code: "CU-10", name: "Las Tunas", i18n: {"es":"Provincia de Las Tunas"} },
        { code: "CU-04", name: "Matanzas", i18n: {"es":"Provincia de Matanzas"} },
        { code: "CU-16", name: "Mayabeque", i18n: {"es":"Provincia de Mayabeque"} },
        { code: "CU-01", name: "Pinar del Río", i18n: {"es":"Provincia de Pinar del Río"} },
        { code: "CU-07", name: "Sancti Spíritus", i18n: {"es":"Provincia de Sancti Spíritus"} },
        { code: "CU-13", name: "Santiago de Cuba", i18n: {"es":"Provincia de Santiago de Cuba"} },
        { code: "CU-05", name: "Villa Clara", i18n: {"es":"Provincia de Villa Clara"} },
    ],
    "CV": [
        { code: "CV-B", name: "Barlavento Islands", i18n: {"pt":"Ilhas de Barlavento"} },
        { code: "CV-BV", name: "Boa Vista", i18n: {} },
        { code: "CV-BR", name: "Brava", i18n: {} },
        { code: "CV-MA", name: "Maio", i18n: {} },
        { code: "CV-MO", name: "Mosteiros", i18n: {} },
        { code: "CV-PA", name: "Paul", i18n: {} },
        { code: "CV-PN", name: "Porto Novo", i18n: {} },
        { code: "CV-PR", name: "Praia", i18n: {} },
        { code: "CV-RB", name: "Ribeira Brava", i18n: {} },
        { code: "CV-RG", name: "Ribeira Grande", i18n: {} },
        { code: "CV-RS", name: "Ribeira Grande de Santiago", i18n: {} },
        { code: "CV-SL", name: "Sal", i18n: {} },
        { code: "CV-CA", name: "Santa Catarina", i18n: {} },
        { code: "CV-CF", name: "Santa Catarina do Fogo", i18n: {} },
        { code: "CV-CR", name: "Santa Cruz", i18n: {} },
        { code: "CV-SD", name: "São Domingos", i18n: {} },
        { code: "CV-SF", name: "São Filipe", i18n: {"pt":"São Filipe (concelho de Cabo Verde)"} },
        { code: "CV-SO", name: "São Lourenço dos Órgãos", i18n: {} },
        { code: "CV-SM", name: "São Miguel", i18n: {} },
        { code: "CV-SS", name: "São Salvador do Mundo", i18n: {} },
        { code: "CV-SV", name: "São Vicente", i18n: {} },
        { code: "CV-S", name: "Sotavento Islands", i18n: {"pt":"Ilhas de Sotavento"} },
        { code: "CV-TA", name: "Tarrafal", i18n: {} },
        { code: "CV-TS", name: "Tarrafal de São Nicolau", i18n: {} },
    ],
    "CY": [
        { code: "CY-04", name: "Famagusta", i18n: {"el":"Επαρχία Αμμοχώστου"} },
        { code: "CY-06", name: "Kyrenia", i18n: {"el":"Επαρχία Κερύνειας"} },
        { code: "CY-03", name: "Larnaca", i18n: {"el":"Επαρχία Λάρνακας"} },
        { code: "CY-02", name: "Limassol", i18n: {"el":"Επαρχία Λεμεσού"} },
        { code: "CY-01", name: "Nicosia", i18n: {"el":"Επαρχία Λευκωσίας"} },
        { code: "CY-05", name: "Paphos", i18n: {"el":"Επαρχία Πάφου"} },
    ],
    "CZ": [
        { code: "CZ-201", name: "Benešov", i18n: {"cs":"okres Benešov"} },
        { code: "CZ-202", name: "Beroun", i18n: {"cs":"okres Beroun"} },
        { code: "CZ-641", name: "Blansko", i18n: {"cs":"okres Blansko"} },
        { code: "CZ-644", name: "Břeclav", i18n: {"cs":"okres Břeclav"} },
        { code: "CZ-642", name: "Brno-město", i18n: {"cs":"okres Brno-město"} },
        { code: "CZ-643", name: "Brno-venkov", i18n: {"cs":"okres Brno-venkov"} },
        { code: "CZ-801", name: "Bruntál", i18n: {"cs":"okres Bruntál"} },
        { code: "CZ-511", name: "Česká Lípa", i18n: {"cs":"okres Česká Lípa"} },
        { code: "CZ-311", name: "České Budějovice", i18n: {"cs":"okres České Budějovice"} },
        { code: "CZ-312", name: "Český Krumlov", i18n: {"cs":"okres Český Krumlov"} },
        { code: "CZ-411", name: "Cheb", i18n: {"cs":"okres Cheb"} },
        { code: "CZ-422", name: "Chomutov", i18n: {"cs":"okres Chomutov"} },
        { code: "CZ-531", name: "Chrudim", i18n: {"cs":"okres Chrudim"} },
        { code: "CZ-421", name: "Děčín", i18n: {"cs":"okres Děčín"} },
        { code: "CZ-321", name: "Domažlice", i18n: {"cs":"okres Domažlice"} },
        { code: "CZ-802", name: "Frýdek-Místek", i18n: {"cs":"okres Frýdek-Místek"} },
        { code: "CZ-631", name: "Havlíčkův Brod", i18n: {"cs":"okres Havlíčkův Brod"} },
        { code: "CZ-645", name: "Hodonín", i18n: {"cs":"okres Hodonín"} },
        { code: "CZ-521", name: "Hradec Králové", i18n: {"cs":"okres Hradec Králové"} },
        { code: "CZ-512", name: "Jablonec nad Nisou", i18n: {"cs":"okres Jablonec nad Nisou"} },
        { code: "CZ-711", name: "Jeseník", i18n: {"cs":"okres Jeseník"} },
        { code: "CZ-522", name: "Jičín", i18n: {"cs":"okres Jičín"} },
        { code: "CZ-632", name: "Jihlava", i18n: {"cs":"okres Jihlava"} },
        { code: "CZ-31", name: "Jihočeský", i18n: {"cs":"Jihočeský kraj"} },
        { code: "CZ-64", name: "Jihomoravský", i18n: {"cs":"Jihomoravský kraj"} },
        { code: "CZ-313", name: "Jindřichův Hradec", i18n: {"cs":"okres Jindřichův Hradec"} },
        { code: "CZ-41", name: "Karlovarský", i18n: {"cs":"Karlovarský kraj"} },
        { code: "CZ-412", name: "Karlovy Vary", i18n: {"cs":"okres Karlovy Vary"} },
        { code: "CZ-803", name: "Karviná", i18n: {"cs":"okres Karviná"} },
        { code: "CZ-203", name: "Kladno", i18n: {"cs":"okres Kladno"} },
        { code: "CZ-322", name: "Klatovy", i18n: {"cs":"okres Klatovy"} },
        { code: "CZ-204", name: "Kolín", i18n: {"cs":"okres Kolín"} },
        { code: "CZ-52", name: "Královéhradecký", i18n: {"cs":"Královéhradecký kraj"} },
        { code: "CZ-721", name: "Kroměříž", i18n: {"cs":"okres Kroměříž"} },
        { code: "CZ-205", name: "Kutná Hora", i18n: {"cs":"okres Kutná Hora"} },
        { code: "CZ-513", name: "Liberec", i18n: {"cs":"okres Liberec"} },
        { code: "CZ-51", name: "Liberecký", i18n: {"cs":"Liberecký kraj"} },
        { code: "CZ-423", name: "Litoměřice", i18n: {"cs":"okres Litoměřice"} },
        { code: "CZ-424", name: "Louny", i18n: {"cs":"okres Louny"} },
        { code: "CZ-206", name: "Mělník", i18n: {"cs":"okres Mělník"} },
        { code: "CZ-207", name: "Mladá Boleslav", i18n: {"cs":"okres Mladá Boleslav"} },
        { code: "CZ-80", name: "Moravskoslezský", i18n: {"cs":"Moravskoslezský kraj"} },
        { code: "CZ-425", name: "Most", i18n: {"cs":"okres Most"} },
        { code: "CZ-523", name: "Náchod", i18n: {"cs":"okres Náchod"} },
        { code: "CZ-804", name: "Nový Jičín", i18n: {"cs":"okres Nový Jičín"} },
        { code: "CZ-208", name: "Nymburk", i18n: {"cs":"okres Nymburk"} },
        { code: "CZ-712", name: "Olomouc", i18n: {"cs":"okres Olomouc"} },
        { code: "CZ-71", name: "Olomoucký", i18n: {"cs":"Olomoucký kraj"} },
        { code: "CZ-805", name: "Opava", i18n: {"cs":"okres Opava"} },
        { code: "CZ-806", name: "Ostrava", i18n: {"cs":"okres Ostrava-město"} },
        { code: "CZ-532", name: "Pardubice", i18n: {"cs":"okres Pardubice"} },
        { code: "CZ-53", name: "Pardubický", i18n: {"cs":"Pardubický kraj"} },
        { code: "CZ-633", name: "Pelhřimov", i18n: {"cs":"okres Pelhřimov"} },
        { code: "CZ-314", name: "Písek", i18n: {"cs":"okres Písek"} },
        { code: "CZ-323", name: "Plzeň", i18n: {"cs":"okres Plzeň-město"} },
        { code: "CZ-325", name: "Plzeň-North", i18n: {"cs":"okres Plzeň-sever"} },
        { code: "CZ-324", name: "Plzeň-South", i18n: {"cs":"okres Plzeň-jih"} },
        { code: "CZ-32", name: "Plzeňský", i18n: {"cs":"Plzeňský kraj"} },
        { code: "CZ-315", name: "Prachatice", i18n: {"cs":"okres Prachatice"} },
        { code: "CZ-209", name: "Prague-East", i18n: {"cs":"okres Praha-východ"} },
        { code: "CZ-20A", name: "Prague-West", i18n: {"cs":"okres Praha-západ"} },
        { code: "CZ-10", name: "Prague, Hlavní mešto", i18n: {"cs":"Praha"} },
        { code: "CZ-714", name: "Přerov", i18n: {"cs":"okres Přerov"} },
        { code: "CZ-20B", name: "Příbram", i18n: {"cs":"okres Příbram"} },
        { code: "CZ-713", name: "Prostějov", i18n: {"cs":"okres Prostějov"} },
        { code: "CZ-20C", name: "Rakovník", i18n: {"cs":"okres Rakovník"} },
        { code: "CZ-326", name: "Rokycany", i18n: {"cs":"okres Rokycany"} },
        { code: "CZ-524", name: "Rychnov nad Kněžnou", i18n: {"cs":"okres Rychnov nad Kněžnou"} },
        { code: "CZ-514", name: "Semily", i18n: {"cs":"okres Semily"} },
        { code: "CZ-413", name: "Sokolov", i18n: {"cs":"okres Sokolov"} },
        { code: "CZ-316", name: "Strakonice", i18n: {"cs":"okres Strakonice"} },
        { code: "CZ-20", name: "Středočeský", i18n: {"cs":"Středočeský kraj"} },
        { code: "CZ-715", name: "Šumperk", i18n: {"cs":"okres Šumperk"} },
        { code: "CZ-533", name: "Svitavy", i18n: {"cs":"okres Svitavy"} },
        { code: "CZ-317", name: "Tábor", i18n: {"cs":"okres Tábor"} },
        { code: "CZ-327", name: "Tachov", i18n: {"cs":"okres Tachov"} },
        { code: "CZ-426", name: "Teplice", i18n: {"cs":"okres Teplice"} },
        { code: "CZ-634", name: "Třebíč", i18n: {"cs":"okres Třebíč"} },
        { code: "CZ-525", name: "Trutnov", i18n: {"cs":"okres Trutnov"} },
        { code: "CZ-722", name: "Uherské Hradiště", i18n: {"cs":"okres Uherské Hradiště"} },
        { code: "CZ-42", name: "Ústecký", i18n: {"cs":"Ústecký kraj"} },
        { code: "CZ-427", name: "Ústí nad Labem", i18n: {"cs":"okres Ústí nad Labem"} },
        { code: "CZ-534", name: "Ústí nad Orlicí", i18n: {"cs":"okres Ústí nad Orlicí"} },
        { code: "CZ-723", name: "Vsetín", i18n: {"cs":"okres Vsetín"} },
        { code: "CZ-646", name: "Vyškov", i18n: {"cs":"okres Vyškov"} },
        { code: "CZ-63", name: "Vysočina", i18n: {"cs":"Kraj Vysočina"} },
        { code: "CZ-635", name: "Žďár nad Sázavou", i18n: {"cs":"okres Žďár nad Sázavou"} },
        { code: "CZ-724", name: "Zlín", i18n: {"cs":"okres Zlín"} },
        { code: "CZ-72", name: "Zlínský", i18n: {"cs":"Zlínský kraj"} },
        { code: "CZ-647", name: "Znojmo", i18n: {"cs":"okres Znojmo"} },
    ],
    "DE": [
        { code: "DE-BW", name: "Baden-Württemberg", i18n: {} },
        { code: "DE-BY", name: "Bavaria", i18n: {"de":"Bayern"} },
        { code: "DE-BE", name: "Berlin", i18n: {} },
        { code: "DE-BB", name: "Brandenburg", i18n: {} },
        { code: "DE-HB", name: "Bremen", i18n: {} },
        { code: "DE-HH", name: "Hamburg", i18n: {} },
        { code: "DE-HE", name: "Hesse", i18n: {"de":"Hessen"} },
        { code: "DE-NI", name: "Lower Saxony", i18n: {"de":"Niedersachsen"} },
        { code: "DE-MV", name: "Mecklenburg-Vorpommern", i18n: {} },
        { code: "DE-NW", name: "North Rhine-Westphalia", i18n: {"de":"Nordrhein-Westfalen"} },
        { code: "DE-RP", name: "Rhineland-Palatinate", i18n: {"de":"Rheinland-Pfalz"} },
        { code: "DE-SL", name: "Saarland", i18n: {} },
        { code: "DE-SN", name: "Saxony", i18n: {"de":"Sachsen"} },
        { code: "DE-ST", name: "Saxony-Anhalt", i18n: {"de":"Sachsen-Anhalt"} },
        { code: "DE-SH", name: "Schleswig-Holstein", i18n: {} },
        { code: "DE-TH", name: "Thuringia", i18n: {"de":"Thüringen"} },
    ],
    "DJ": [
        { code: "DJ-AS", name: "Ali Sabieh", i18n: {"fr":"Région d’Ali Sabieh"} },
        { code: "DJ-AR", name: "Arta", i18n: {"fr":"Région d’Arta"} },
        { code: "DJ-DI", name: "Dikhil", i18n: {"fr":"Région de Dikhil"} },
        { code: "DJ-DJ", name: "Djibouti", i18n: {} },
        { code: "DJ-OB", name: "Obock", i18n: {"fr":"Région d’Obock"} },
        { code: "DJ-TA", name: "Tadjourah", i18n: {"fr":"Région de Tadjourah"} },
    ],
    "DK": [
        { code: "DK-84", name: "Capital Region", i18n: {"da":"Region Hovedstaden"} },
        { code: "DK-82", name: "Central Denmark", i18n: {"da":"Region Midtjylland"} },
        { code: "DK-81", name: "Northern Denmark", i18n: {"da":"Region Nordjylland"} },
        { code: "DK-83", name: "Southern Denmark", i18n: {"da":"Region Syddanmark"} },
        { code: "DK-85", name: "Zealand", i18n: {"da":"Region Sjælland"} },
    ],
    "DM": [
        { code: "DM-02", name: "Saint Andrew", i18n: {} },
        { code: "DM-03", name: "Saint David", i18n: {} },
        { code: "DM-04", name: "Saint George", i18n: {} },
        { code: "DM-05", name: "Saint John", i18n: {} },
        { code: "DM-06", name: "Saint Joseph", i18n: {} },
        { code: "DM-07", name: "Saint Luke", i18n: {} },
        { code: "DM-08", name: "Saint Mark", i18n: {} },
        { code: "DM-09", name: "Saint Patrick", i18n: {} },
        { code: "DM-10", name: "Saint Paul", i18n: {} },
        { code: "DM-11", name: "Saint Peter", i18n: {} },
    ],
    "DO": [
        { code: "DO-02", name: "Azua", i18n: {} },
        { code: "DO-03", name: "Baoruco", i18n: {"es":"Bahoruco"} },
        { code: "DO-04", name: "Barahona", i18n: {} },
        { code: "DO-33", name: "Cibao Nordeste", i18n: {} },
        { code: "DO-34", name: "Cibao Noroeste", i18n: {} },
        { code: "DO-35", name: "Cibao Norte", i18n: {} },
        { code: "DO-36", name: "Cibao Sur", i18n: {} },
        { code: "DO-05", name: "Dajabón", i18n: {} },
        { code: "DO-01", name: "Distrito Nacional", i18n: {} },
        { code: "DO-06", name: "Duarte", i18n: {"es":"Duarte (provincia)"} },
        { code: "DO-08", name: "El Seibo", i18n: {} },
        { code: "DO-37", name: "El Valle", i18n: {} },
        { code: "DO-07", name: "Elías Piña", i18n: {} },
        { code: "DO-38", name: "Enriquillo", i18n: {} },
        { code: "DO-09", name: "Espaillat", i18n: {} },
        { code: "DO-30", name: "Hato Mayor", i18n: {} },
        { code: "DO-19", name: "Hermanas Mirabal", i18n: {} },
        { code: "DO-39", name: "Higüamo", i18n: {} },
        { code: "DO-10", name: "Independencia", i18n: {} },
        { code: "DO-11", name: "La Altagracia", i18n: {} },
        { code: "DO-12", name: "La Romana", i18n: {} },
        { code: "DO-13", name: "La Vega", i18n: {} },
        { code: "DO-14", name: "María Trinidad Sánchez", i18n: {} },
        { code: "DO-28", name: "Monseñor Nouel", i18n: {} },
        { code: "DO-15", name: "Monte Cristi", i18n: {} },
        { code: "DO-29", name: "Monte Plata", i18n: {} },
        { code: "DO-40", name: "Ozama", i18n: {} },
        { code: "DO-16", name: "Pedernales", i18n: {} },
        { code: "DO-17", name: "Peravia", i18n: {} },
        { code: "DO-18", name: "Puerto Plata", i18n: {} },
        { code: "DO-20", name: "Samaná", i18n: {} },
        { code: "DO-21", name: "San Cristóbal", i18n: {} },
        { code: "DO-31", name: "San José de Ocoa", i18n: {} },
        { code: "DO-22", name: "San Juan", i18n: {} },
        { code: "DO-23", name: "San Pedro de Macorís", i18n: {} },
        { code: "DO-24", name: "Sánchez Ramírez", i18n: {} },
        { code: "DO-25", name: "Santiago", i18n: {} },
        { code: "DO-26", name: "Santiago Rodríguez", i18n: {"es":"Santiago Rodríguez (provincia)"} },
        { code: "DO-32", name: "Santo Domingo", i18n: {} },
        { code: "DO-41", name: "Valdesia", i18n: {} },
        { code: "DO-27", name: "Valverde", i18n: {} },
        { code: "DO-42", name: "Yuma", i18n: {} },
    ],
    "DZ": [
        { code: "DZ-01", name: "Adrar", i18n: {"ar":"ولاية أدرار"} },
        { code: "DZ-44", name: "Aïn Defla", i18n: {"ar":"ولاية عين الدفلى"} },
        { code: "DZ-46", name: "Aïn Témouchent", i18n: {"ar":"ولاية عين تموشنت"} },
        { code: "DZ-16", name: "Algiers", i18n: {"ar":"ولاية الجزائر"} },
        { code: "DZ-23", name: "Annaba", i18n: {"ar":"ولاية عنابة"} },
        { code: "DZ-05", name: "Batna", i18n: {"ar":"ولاية باتنة"} },
        { code: "DZ-08", name: "Béchar", i18n: {"ar":"ولاية بشار"} },
        { code: "DZ-06", name: "Béjaïa", i18n: {"ar":"ولاية بجاية"} },
        { code: "DZ-52", name: "Béni Abbès", i18n: {"ar":"ولاية بني عباس"} },
        { code: "DZ-07", name: "Biskra", i18n: {"ar":"ولاية بسكرة"} },
        { code: "DZ-09", name: "Blida", i18n: {"ar":"ولاية البليدة"} },
        { code: "DZ-50", name: "Bordj Badji Mokhtar", i18n: {"ar":"ولاية برج باجي مختار"} },
        { code: "DZ-34", name: "Bordj Bou Arréridj", i18n: {"ar":"ولاية برج بوعريريج"} },
        { code: "DZ-10", name: "Bouira", i18n: {"ar":"ولاية البويرة"} },
        { code: "DZ-35", name: "Boumerdès", i18n: {"ar":"ولاية بومرداس"} },
        { code: "DZ-02", name: "Chlef", i18n: {"ar":"ولاية الشلف"} },
        { code: "DZ-25", name: "Constantine", i18n: {"ar":"ولاية قسنطينة"} },
        { code: "DZ-56", name: "Djanet", i18n: {"ar":"ولاية جانت"} },
        { code: "DZ-17", name: "Djelfa", i18n: {"ar":"ولاية الجلفة"} },
        { code: "DZ-32", name: "El Bayadh", i18n: {"ar":"ولاية البيض"} },
        { code: "DZ-57", name: "El Meghaier", i18n: {"ar":"ولاية المغير الجزائرية"} },
        { code: "DZ-58", name: "El Meniaa", i18n: {"ar":"ولاية المنيعة"} },
        { code: "DZ-39", name: "El Oued", i18n: {"ar":"ولاية الوادي"} },
        { code: "DZ-36", name: "El Tarf", i18n: {"ar":"ولاية الطارف"} },
        { code: "DZ-47", name: "Ghardaïa", i18n: {"ar":"ولاية غرداية"} },
        { code: "DZ-24", name: "Guelma", i18n: {"ar":"ولاية قالمة"} },
        { code: "DZ-33", name: "Illizi", i18n: {"ar":"ولاية إليزي"} },
        { code: "DZ-54", name: "In Guezzam", i18n: {"ar":"ولاية عين قزام"} },
        { code: "DZ-53", name: "In Salah", i18n: {"ar":"ولاية عين صالح"} },
        { code: "DZ-18", name: "Jijel", i18n: {"ar":"ولاية جيجل"} },
        { code: "DZ-40", name: "Khenchela", i18n: {"ar":"ولاية خنشلة"} },
        { code: "DZ-03", name: "Laghouat", i18n: {"ar":"ولاية الأغواط"} },
        { code: "DZ-28", name: "M’Sila", i18n: {"ar":"ولاية المسيلة"} },
        { code: "DZ-29", name: "Mascara", i18n: {"ar":"ولاية معسكر"} },
        { code: "DZ-26", name: "Médéa", i18n: {"ar":"ولاية المدية"} },
        { code: "DZ-43", name: "Mila", i18n: {"ar":"ولاية ميلة"} },
        { code: "DZ-27", name: "Mostaganem", i18n: {"ar":"ولاية مستغانم"} },
        { code: "DZ-45", name: "Naama", i18n: {"ar":"ولاية النعامة"} },
        { code: "DZ-31", name: "Oran", i18n: {"ar":"ولاية وهران"} },
        { code: "DZ-30", name: "Ouargla", i18n: {"ar":"ولاية ورقلة"} },
        { code: "DZ-51", name: "Ouled Djellal", i18n: {"ar":"ولاية أولاد جلال"} },
        { code: "DZ-04", name: "Oum El Bouaghi", i18n: {"ar":"ولاية أم البواقي"} },
        { code: "DZ-48", name: "Relizane", i18n: {"ar":"ولاية غليزان"} },
        { code: "DZ-20", name: "Saïda", i18n: {"ar":"ولاية سعيدة"} },
        { code: "DZ-19", name: "Sétif", i18n: {"ar":"ولاية سطيف"} },
        { code: "DZ-22", name: "Sidi Bel Abbès", i18n: {"ar":"ولاية سيدي بلعباس"} },
        { code: "DZ-21", name: "Skikda", i18n: {"ar":"ولاية سكيكدة"} },
        { code: "DZ-41", name: "Souk Ahras", i18n: {"ar":"ولاية سوق أهراس"} },
        { code: "DZ-11", name: "Tamanghasset", i18n: {"ar":"ولاية تمنراست"} },
        { code: "DZ-12", name: "Tébessa", i18n: {"ar":"ولاية تبسة"} },
        { code: "DZ-14", name: "Tiaret", i18n: {"ar":"ولاية تيارت"} },
        { code: "DZ-49", name: "Timimoun", i18n: {"ar":"ولاية تيميمون"} },
        { code: "DZ-37", name: "Tindouf", i18n: {"ar":"ولاية تندوف"} },
        { code: "DZ-42", name: "Tipasa", i18n: {"ar":"ولاية تيبازة"} },
        { code: "DZ-38", name: "Tissemsilt", i18n: {"ar":"ولاية تيسمسيلت"} },
        { code: "DZ-15", name: "Tizi Ouzou", i18n: {"ar":"ولاية تيزي وزو"} },
        { code: "DZ-13", name: "Tlemcen", i18n: {"ar":"ولاية تلمسان"} },
        { code: "DZ-55", name: "Touggourt", i18n: {"ar":"ولاية تقرت"} },
    ],
    "EC": [
        { code: "EC-A", name: "Azuay", i18n: {"es":"Provincia de Azuay"} },
        { code: "EC-B", name: "Bolívar", i18n: {"es":"Provincia de Bolívar"} },
        { code: "EC-F", name: "Cañar", i18n: {"es":"Provincia de Cañar"} },
        { code: "EC-C", name: "Carchi", i18n: {"es":"Provincia de Carchi"} },
        { code: "EC-H", name: "Chimborazo", i18n: {"es":"Provincia de Chimborazo"} },
        { code: "EC-X", name: "Cotopaxi", i18n: {"es":"Provincia de Cotopaxi"} },
        { code: "EC-O", name: "El Oro", i18n: {"es":"Provincia de El Oro"} },
        { code: "EC-E", name: "Esmeraldas", i18n: {"es":"Provincia de Esmeraldas"} },
        { code: "EC-W", name: "Galápagos", i18n: {"es":"Provincia de Galápagos"} },
        { code: "EC-G", name: "Guayas", i18n: {"es":"Provincia de Guayas"} },
        { code: "EC-I", name: "Imbabura", i18n: {"es":"Provincia de Imbabura"} },
        { code: "EC-L", name: "Loja", i18n: {"es":"Provincia de Loja"} },
        { code: "EC-R", name: "Los Ríos", i18n: {} },
        { code: "EC-M", name: "Manabí", i18n: {"es":"Provincia de Manabí"} },
        { code: "EC-S", name: "Morona-Santiago", i18n: {"es":"Provincia de Morona Santiago"} },
        { code: "EC-N", name: "Napo", i18n: {"es":"Provincia de Napo"} },
        { code: "EC-D", name: "Orellana", i18n: {"es":"Provincia de Orellana"} },
        { code: "EC-Y", name: "Pastaza", i18n: {"es":"Provincia de Pastaza"} },
        { code: "EC-P", name: "Pichincha", i18n: {"es":"Provincia de Pichincha"} },
        { code: "EC-SE", name: "Santa Elena", i18n: {"es":"Provincia de Santa Elena"} },
        { code: "EC-SD", name: "Santo Domingo de los Tsáchilas", i18n: {"es":"Provincia de Santo Domingo de los Tsáchilas"} },
        { code: "EC-U", name: "Sucumbíos", i18n: {"es":"Provincia de Sucumbíos"} },
        { code: "EC-T", name: "Tungurahua", i18n: {"es":"Provincia de Tungurahua"} },
        { code: "EC-Z", name: "Zamora-Chinchipe", i18n: {"es":"Provincia de Zamora Chinchipe"} },
    ],
    "EE": [
        { code: "EE-130", name: "Alutaguse", i18n: {"et":"Alutaguse vald"} },
        { code: "EE-141", name: "Anija", i18n: {"et":"Anija vald"} },
        { code: "EE-142", name: "Antsla", i18n: {"et":"Antsla vald"} },
        { code: "EE-171", name: "Elva", i18n: {"et":"Elva vald"} },
        { code: "EE-214", name: "Häädemeeste", i18n: {"et":"Häädemeeste vald"} },
        { code: "EE-184", name: "Haapsalu", i18n: {} },
        { code: "EE-191", name: "Haljala", i18n: {} },
        { code: "EE-37", name: "Harju", i18n: {"et":"Harju maakond"} },
        { code: "EE-198", name: "Harku", i18n: {} },
        { code: "EE-39", name: "Hiiu", i18n: {"et":"Hiiu maakond"} },
        { code: "EE-205", name: "Hiiumaa", i18n: {"et":"Hiiumaa vald"} },
        { code: "EE-45", name: "Ida-Virumaa", i18n: {"et":"Ida-Viru maakond"} },
        { code: "EE-255", name: "Järva", i18n: {"et":"Järva vald"} },
        { code: "EE-52", name: "Järvamaa", i18n: {"et":"Järva maakond"} },
        { code: "EE-245", name: "Jõelähtme", i18n: {"et":"Jõelähtme vald"} },
        { code: "EE-247", name: "Jõgeva", i18n: {"et":"Jõgeva vald"} },
        { code: "EE-50", name: "Jõgevamaa", i18n: {"et":"Jõgeva maakond"} },
        { code: "EE-251", name: "Jõhvi", i18n: {"et":"Jõhvi vald"} },
        { code: "EE-272", name: "Kadrina", i18n: {} },
        { code: "EE-283", name: "Kambja", i18n: {} },
        { code: "EE-284", name: "Kanepi", i18n: {} },
        { code: "EE-291", name: "Kastre", i18n: {} },
        { code: "EE-293", name: "Kehtna", i18n: {} },
        { code: "EE-296", name: "Keila", i18n: {} },
        { code: "EE-303", name: "Kihnu", i18n: {} },
        { code: "EE-305", name: "Kiili", i18n: {} },
        { code: "EE-317", name: "Kohila", i18n: {} },
        { code: "EE-321", name: "Kohtla-Järve", i18n: {} },
        { code: "EE-338", name: "Kose", i18n: {} },
        { code: "EE-353", name: "Kuusalu", i18n: {} },
        { code: "EE-431", name: "Lääne-Harju", i18n: {"et":"Lääne-Harju vald"} },
        { code: "EE-441", name: "Lääne-Nigula", i18n: {"et":"Lääne-Nigula vald"} },
        { code: "EE-60", name: "Lääne-Virumaa", i18n: {"et":"Lääne-Viru maakond"} },
        { code: "EE-56", name: "Läänemaa", i18n: {"et":"Lääne maakond"} },
        { code: "EE-430", name: "Lääneranna", i18n: {"et":"Lääneranna vald"} },
        { code: "EE-424", name: "Loksa", i18n: {} },
        { code: "EE-442", name: "Lüganuse", i18n: {"et":"Lüganuse vald"} },
        { code: "EE-432", name: "Luunja", i18n: {} },
        { code: "EE-446", name: "Maardu", i18n: {} },
        { code: "EE-503", name: "Märjamaa", i18n: {} },
        { code: "EE-478", name: "Muhu", i18n: {} },
        { code: "EE-480", name: "Mulgi", i18n: {} },
        { code: "EE-486", name: "Mustvee", i18n: {} },
        { code: "EE-511", name: "Narva", i18n: {} },
        { code: "EE-514", name: "Narva-Jõesuu", i18n: {"et":"Narva-Jõesuu linn"} },
        { code: "EE-528", name: "Nõo", i18n: {} },
        { code: "EE-557", name: "Otepää", i18n: {"et":"Otepää vald"} },
        { code: "EE-567", name: "Paide", i18n: {} },
        { code: "EE-624", name: "Pärnu", i18n: {} },
        { code: "EE-68", name: "Pärnumaa", i18n: {"et":"Pärnu maakond"} },
        { code: "EE-586", name: "Peipsiääre", i18n: {"et":"Peipsiääre vald"} },
        { code: "EE-638", name: "Põhja-Pärnumaa", i18n: {"et":"Põhja-Pärnumaa vald"} },
        { code: "EE-615", name: "Põhja-Sakala", i18n: {"et":"Põhja-Sakala vald"} },
        { code: "EE-618", name: "Põltsamaa", i18n: {"et":"Põltsamaa vald"} },
        { code: "EE-622", name: "Põlva", i18n: {} },
        { code: "EE-64", name: "Põlvamaa", i18n: {"et":"Põlva maakond"} },
        { code: "EE-651", name: "Raasiku", i18n: {} },
        { code: "EE-653", name: "Rae", i18n: {} },
        { code: "EE-661", name: "Rakvere", i18n: {} },
        { code: "EE-663", name: "Rakvere²", i18n: {} },
        { code: "EE-708", name: "Räpina", i18n: {} },
        { code: "EE-668", name: "Rapla", i18n: {} },
        { code: "EE-71", name: "Raplamaa", i18n: {"et":"Rapla maakond"} },
        { code: "EE-698", name: "Rõuge", i18n: {"et":"Rõuge vald"} },
        { code: "EE-689", name: "Ruhnu", i18n: {} },
        { code: "EE-712", name: "Saarde", i18n: {} },
        { code: "EE-74", name: "Saare", i18n: {"et":"Saare maakond"} },
        { code: "EE-714", name: "Saaremaa", i18n: {} },
        { code: "EE-719", name: "Saku", i18n: {} },
        { code: "EE-726", name: "Saue", i18n: {} },
        { code: "EE-732", name: "Setomaa", i18n: {} },
        { code: "EE-735", name: "Sillamäe", i18n: {} },
        { code: "EE-784", name: "Tallinn", i18n: {} },
        { code: "EE-792", name: "Tapa", i18n: {} },
        { code: "EE-793", name: "Tartu", i18n: {} },
        { code: "EE-796", name: "Tartu²", i18n: {} },
        { code: "EE-79", name: "Tartumaa", i18n: {"et":"Tartu maakond"} },
        { code: "EE-803", name: "Toila", i18n: {} },
        { code: "EE-809", name: "Tori", i18n: {"et":"Tori vald"} },
        { code: "EE-824", name: "Tõrva", i18n: {} },
        { code: "EE-834", name: "Türi", i18n: {"et":"Türi vald"} },
        { code: "EE-928", name: "Väike-Maarja", i18n: {"et":"Väike-Maarja vald"} },
        { code: "EE-855", name: "Valga", i18n: {} },
        { code: "EE-81", name: "Valgamaa", i18n: {"et":"Valga maakond"} },
        { code: "EE-890", name: "Viimsi", i18n: {} },
        { code: "EE-84", name: "Viljandi", i18n: {"et":"Viljandi maakond"} },
        { code: "EE-897", name: "Viljandi²", i18n: {} },
        { code: "EE-899", name: "Viljandi³", i18n: {} },
        { code: "EE-901", name: "Vinni", i18n: {} },
        { code: "EE-903", name: "Viru-Nigula", i18n: {} },
        { code: "EE-907", name: "Vormsi", i18n: {} },
        { code: "EE-919", name: "Võru", i18n: {} },
        { code: "EE-917", name: "Võru²", i18n: {} },
        { code: "EE-87", name: "Võrumaa", i18n: {"et":"Võru maakond"} },
    ],
    "EG": [
        { code: "EG-SHR", name: "Al Sharqia", i18n: {"ar":"الشرقية"} },
        { code: "EG-ALX", name: "Alexandria", i18n: {"ar":"الإسكندرية"} },
        { code: "EG-ASN", name: "Aswan", i18n: {"ar":"محافظة أسوان"} },
        { code: "EG-AST", name: "Asyut", i18n: {"ar":"أسيوط"} },
        { code: "EG-BH", name: "Beheira", i18n: {"ar":"محافظة البحيرة"} },
        { code: "EG-BNS", name: "Beni Suef", i18n: {"ar":"بني سويف"} },
        { code: "EG-C", name: "Cairo", i18n: {"ar":"محافظة القاهرة"} },
        { code: "EG-DK", name: "Dakahlia", i18n: {"ar":"الدقهلية"} },
        { code: "EG-DT", name: "Damietta", i18n: {"ar":"محافظة دمياط"} },
        { code: "EG-FYM", name: "Faiyum", i18n: {"ar":"محافظة الفيوم"} },
        { code: "EG-GH", name: "Gharbia", i18n: {"ar":"الغربية"} },
        { code: "EG-GZ", name: "Giza", i18n: {"ar":"محافظة الجيزة"} },
        { code: "EG-IS", name: "Ismailia", i18n: {"ar":"الإسماعيلية"} },
        { code: "EG-KFS", name: "Kafr el-Sheikh", i18n: {"ar":"محافظة كفر الشيخ"} },
        { code: "EG-LX", name: "Luxor", i18n: {"ar":"محافظة الأقصر"} },
        { code: "EG-MT", name: "Matrouh", i18n: {"ar":"محافظة مطروح"} },
        { code: "EG-MN", name: "Minya", i18n: {"ar":"المنيا"} },
        { code: "EG-MNF", name: "Monufia", i18n: {"ar":"محافظة المنوفية"} },
        { code: "EG-WAD", name: "New Valley", i18n: {"ar":"محافظة الوادي الجديد"} },
        { code: "EG-SIN", name: "North Sinai", i18n: {"ar":"شمال سيناء"} },
        { code: "EG-PTS", name: "Port Said", i18n: {"ar":"بورسعيد"} },
        { code: "EG-KB", name: "Qalyubia", i18n: {"ar":"محافظة القليوبية"} },
        { code: "EG-KN", name: "Qena", i18n: {"ar":"محافظة قنا"} },
        { code: "EG-BA", name: "Red Sea", i18n: {"ar":"البحر الأحمر"} },
        { code: "EG-SHG", name: "Sohag", i18n: {"ar":"محافظة سوهاج"} },
        { code: "EG-JS", name: "South Sinai", i18n: {"ar":"جنوب سيناء"} },
        { code: "EG-SUZ", name: "Suez", i18n: {"ar":"السويس"} },
    ],
    "ER": [
        { code: "ER-AN", name: "Anseba", i18n: {} },
        { code: "ER-DU", name: "Debub", i18n: {} },
        { code: "ER-GB", name: "Gash-Barka", i18n: {} },
        { code: "ER-MA", name: "Maekel", i18n: {} },
        { code: "ER-SK", name: "Northern Red Sea", i18n: {} },
        { code: "ER-DK", name: "Southern Red Sea", i18n: {} },
    ],
    "ES": [
        { code: "ES-C", name: "A Coruña", i18n: {"es":"Provincia de La Coruña"} },
        { code: "ES-VI", name: "Álava", i18n: {} },
        { code: "ES-AB", name: "Albacete", i18n: {"es":"Provincia de Albacete"} },
        { code: "ES-A", name: "Alicante", i18n: {"es":"Provincia de Alicante"} },
        { code: "ES-AL", name: "Almería", i18n: {"es":"Provincia de Almería"} },
        { code: "ES-AN", name: "Andalusia", i18n: {"es":"Andalucía"} },
        { code: "ES-AR", name: "Aragon", i18n: {"es":"Aragón"} },
        { code: "ES-AS", name: "Asturias", i18n: {"es":"Principado de Asturias"} },
        { code: "ES-O", name: "Asturias Province", i18n: {"es":"provincia de Asturias"} },
        { code: "ES-AV", name: "Ávila", i18n: {"es":"Provincia de Ávila"} },
        { code: "ES-BA", name: "Badajoz", i18n: {"es":"Provincia de Badajoz"} },
        { code: "ES-IB", name: "Balearic Islands", i18n: {"es":"Islas Baleares"} },
        { code: "ES-PM", name: "Balears Province", i18n: {"es":"Islas Baleares²"} },
        { code: "ES-B", name: "Barcelona", i18n: {"es":"Provincia de Barcelona"} },
        { code: "ES-PV", name: "Basque Country", i18n: {"es":"País Vasco"} },
        { code: "ES-BI", name: "Biscay", i18n: {"es":"Vizcaya"} },
        { code: "ES-BU", name: "Burgos", i18n: {"es":"Provincia de Burgos"} },
        { code: "ES-CC", name: "Cáceres", i18n: {"es":"Provincia de Cáceres"} },
        { code: "ES-CA", name: "Cádiz", i18n: {"es":"Provincia de Cádiz"} },
        { code: "ES-CN", name: "Canary Islands", i18n: {"es":"Canarias"} },
        { code: "ES-CB", name: "Cantabria", i18n: {} },
        { code: "ES-S", name: "Cantabria Province", i18n: {"es":"Cantabria²"} },
        { code: "ES-CS", name: "Castellón", i18n: {"es":"Provincia de Castellón"} },
        { code: "ES-CL", name: "Castile and León", i18n: {"es":"Castilla y León"} },
        { code: "ES-CM", name: "Castile-La Mancha", i18n: {"es":"Castilla-La Mancha"} },
        { code: "ES-CT", name: "Catalonia", i18n: {"es":"Cataluña"} },
        { code: "ES-CE", name: "Ceuta", i18n: {} },
        { code: "ES-CR", name: "Ciudad Real", i18n: {"es":"Provincia de Ciudad Real"} },
        { code: "ES-CO", name: "Córdoba", i18n: {"es":"Provincia de Córdoba"} },
        { code: "ES-CU", name: "Cuenca", i18n: {"es":"Provincia de Cuenca"} },
        { code: "ES-EX", name: "Extremadura", i18n: {} },
        { code: "ES-GA", name: "Galicia", i18n: {} },
        { code: "ES-SS", name: "Gipuzkoa", i18n: {"es":"Guipúzcoa"} },
        { code: "ES-GI", name: "Girona", i18n: {"es":"Provincia de Gerona"} },
        { code: "ES-GR", name: "Granada", i18n: {"es":"Provincia de Granada"} },
        { code: "ES-GU", name: "Guadalajara", i18n: {"es":"Provincia de Guadalajara"} },
        { code: "ES-H", name: "Huelva", i18n: {"es":"Provincia de Huelva"} },
        { code: "ES-HU", name: "Huesca", i18n: {"es":"Provincia de Huesca"} },
        { code: "ES-J", name: "Jaén", i18n: {"es":"Provincia de Jaén"} },
        { code: "ES-RI", name: "La Rioja", i18n: {"es":"La Rioja²"} },
        { code: "ES-LO", name: "La Rioja Province", i18n: {"es":"La Rioja"} },
        { code: "ES-GC", name: "Las Palmas", i18n: {"es":"Provincia de Las Palmas"} },
        { code: "ES-LE", name: "León", i18n: {"es":"Provincia de León"} },
        { code: "ES-L", name: "Lleida", i18n: {"es":"Provincia de Lérida"} },
        { code: "ES-LU", name: "Lugo", i18n: {"es":"Provincia de Lugo"} },
        { code: "ES-MD", name: "Madrid Autonomous Community", i18n: {"es":"Comunidad de Madrid"} },
        { code: "ES-M", name: "Madrid Province", i18n: {"es":"provincia de Madrid"} },
        { code: "ES-MA", name: "Málaga", i18n: {"es":"provincia de Málaga"} },
        { code: "ES-ML", name: "Melilla", i18n: {} },
        { code: "ES-MU", name: "Murcia", i18n: {"es":"provincia de Murcia"} },
        { code: "ES-MC", name: "Murcia Region", i18n: {"es":"Región de Murcia"} },
        { code: "ES-NA", name: "Navarra", i18n: {"es":"Navarra²"} },
        { code: "ES-NC", name: "Navarra Chartered Community", i18n: {"es":"Navarra"} },
        { code: "ES-OR", name: "Ourense", i18n: {"es":"Provincia de Orense"} },
        { code: "ES-P", name: "Palencia", i18n: {"es":"Provincia de Palencia"} },
        { code: "ES-PO", name: "Pontevedra", i18n: {"es":"Provincia de Pontevedra"} },
        { code: "ES-SA", name: "Salamanca", i18n: {"es":"Provincia de Salamanca"} },
        { code: "ES-TF", name: "Santa Cruz de Tenerife", i18n: {"es":"Provincia de Santa Cruz de Tenerife"} },
        { code: "ES-SG", name: "Segovia", i18n: {"es":"Provincia de Segovia"} },
        { code: "ES-SE", name: "Seville", i18n: {"es":"Provincia de Sevilla"} },
        { code: "ES-SO", name: "Soria", i18n: {"es":"Provincia de Soria"} },
        { code: "ES-T", name: "Tarragona", i18n: {"es":"provincia de Tarragona"} },
        { code: "ES-TE", name: "Teruel", i18n: {"es":"Provincia de Teruel"} },
        { code: "ES-TO", name: "Toledo", i18n: {"es":"Provincia de Toledo"} },
        { code: "ES-V", name: "Valencia", i18n: {"es":"Provincia de Valencia"} },
        { code: "ES-VC", name: "Valencian Community", i18n: {"es":"Comunidad Valenciana"} },
        { code: "ES-VA", name: "Valladolid", i18n: {"es":"Provincia de Valladolid"} },
        { code: "ES-ZA", name: "Zamora", i18n: {"es":"Provincia de Zamora"} },
        { code: "ES-Z", name: "Zaragoza", i18n: {"es":"Provincia de Zaragoza"} },
    ],
    "ET": [
        { code: "ET-AA", name: "Addis Ababa", i18n: {"am":"አዲስ አበባ"} },
        { code: "ET-AF", name: "Afar", i18n: {"am":"አፋር"} },
        { code: "ET-AM", name: "Amhara", i18n: {"am":"አማራ"} },
        { code: "ET-BE", name: "Benishangul-Gumuz", i18n: {"am":"ቤንሻንጉል-ጉምዝ ክልል"} },
        { code: "ET-DD", name: "Dire Dawa", i18n: {"am":"ድሬዳዋ"} },
        { code: "ET-GA", name: "Gambela", i18n: {"am":"ጋምቤላ ሕዝቦች ክልል"} },
        { code: "ET-HA", name: "Harari", i18n: {"am":"ሐረሪ ሕዝብ ክልል"} },
        { code: "ET-OR", name: "Oromia", i18n: {"am":"ኦሮሚያ ክልል"} },
        { code: "ET-SI", name: "Sidama", i18n: {"am":"ሲዳማ ክልል"} },
        { code: "ET-SO", name: "Somali", i18n: {"am":"ሶማሌ ክልል"} },
        { code: "ET-SN", name: "Southern Nations, Nationalities, and Peoples", i18n: {"am":"ደቡብ ብሔሮች ብሔረሰቦችና ሕዝቦች ክልል"} },
        { code: "ET-SW", name: "Southwest Ethiopia Peoples", i18n: {"am":"ደቡብ ምዕራብ ኢትዮጵያ ህዝቦች ክልል"} },
        { code: "ET-TI", name: "Tigray", i18n: {"am":"ትግራይ ክልል"} },
    ],
    "FI": [
        { code: "FI-01", name: "Ahvenanmaan maakunta", i18n: {} },
        { code: "FI-08", name: "Central Finland", i18n: {"fi":"Keski-Suomen maakunta"} },
        { code: "FI-07", name: "Central Ostrobothnia", i18n: {"fi":"Keski-Pohjanmaan maakunta"} },
        { code: "FI-05", name: "Kainuu", i18n: {"fi":"Kainuun maakunta"} },
        { code: "FI-09", name: "Kymenlaakso", i18n: {"fi":"Kymenlaakson maakunta"} },
        { code: "FI-10", name: "Lapland", i18n: {"fi":"Lapin maakunta"} },
        { code: "FI-13", name: "North Karelia", i18n: {"fi":"Pohjois-Karjalan maakunta"} },
        { code: "FI-14", name: "Northern Ostrobothnia", i18n: {"fi":"Pohjois-Pohjanmaan maakunta"} },
        { code: "FI-15", name: "Northern Savonia", i18n: {"fi":"Pohjois-Savon maakunta"} },
        { code: "FI-12", name: "Ostrobothnia", i18n: {"fi":"Pohjanmaan maakunta"} },
        { code: "FI-16", name: "Päijänne Tavastia", i18n: {"fi":"Päijät-Hämeen maakunta"} },
        { code: "FI-11", name: "Pirkanmaa", i18n: {"fi":"Pirkanmaan maakunta"} },
        { code: "FI-17", name: "Satakunta", i18n: {"fi":"Satakunnan maakunta"} },
        { code: "FI-02", name: "South Karelia", i18n: {"fi":"Etelä-Karjalan maakunta"} },
        { code: "FI-03", name: "Southern Ostrobothnia", i18n: {"fi":"Etelä-Pohjanmaan maakunta"} },
        { code: "FI-04", name: "Southern Savonia", i18n: {"fi":"Etelä-Savon maakunta"} },
        { code: "FI-19", name: "Southwest Finland", i18n: {"fi":"Varsinais-Suomen maakunta"} },
        { code: "FI-06", name: "Tavastia Proper", i18n: {"fi":"Kanta-Hämeen maakunta"} },
        { code: "FI-18", name: "Uusimaa", i18n: {"fi":"Uudenmaan maakunta"} },
    ],
    "FJ": [
        { code: "FJ-01", name: "Ba", i18n: {} },
        { code: "FJ-02", name: "Bua", i18n: {} },
        { code: "FJ-03", name: "Cakaudrove", i18n: {} },
        { code: "FJ-C", name: "Central", i18n: {} },
        { code: "FJ-E", name: "Eastern", i18n: {} },
        { code: "FJ-04", name: "Kadavu", i18n: {} },
        { code: "FJ-05", name: "Lau", i18n: {} },
        { code: "FJ-06", name: "Lomaiviti", i18n: {} },
        { code: "FJ-07", name: "Macuata", i18n: {} },
        { code: "FJ-08", name: "Nadroga-Navosa", i18n: {} },
        { code: "FJ-09", name: "Naitasiri", i18n: {} },
        { code: "FJ-10", name: "Namosi", i18n: {} },
        { code: "FJ-N", name: "Northern", i18n: {} },
        { code: "FJ-11", name: "Ra", i18n: {} },
        { code: "FJ-12", name: "Rewa", i18n: {} },
        { code: "FJ-R", name: "Rotuma", i18n: {} },
        { code: "FJ-13", name: "Serua", i18n: {} },
        { code: "FJ-14", name: "Tailevu", i18n: {} },
        { code: "FJ-W", name: "Western", i18n: {} },
    ],
    "FM": [
        { code: "FM-TRK", name: "Chuuk", i18n: {} },
        { code: "FM-KSA", name: "Kosrae", i18n: {} },
        { code: "FM-PNI", name: "Pohnpei", i18n: {} },
        { code: "FM-YAP", name: "Yap", i18n: {} },
    ],
    "FR": [
        { code: "FR-01", name: "Ain", i18n: {} },
        { code: "FR-02", name: "Aisne", i18n: {} },
        { code: "FR-03", name: "Allier", i18n: {} },
        { code: "FR-04", name: "Alpes-de-Haute-Provence", i18n: {} },
        { code: "FR-06", name: "Alpes-Maritimes", i18n: {} },
        { code: "FR-6AE", name: "Alsace", i18n: {"fr":"Collectivité européenne d’Alsace"} },
        { code: "FR-07", name: "Ardèche", i18n: {} },
        { code: "FR-08", name: "Ardennes", i18n: {} },
        { code: "FR-09", name: "Ariège", i18n: {} },
        { code: "FR-10", name: "Aube", i18n: {} },
        { code: "FR-11", name: "Aude", i18n: {} },
        { code: "FR-ARA", name: "Auvergne-Rhône-Alpes", i18n: {} },
        { code: "FR-12", name: "Aveyron", i18n: {} },
        { code: "FR-67", name: "Bas-Rhin", i18n: {} },
        { code: "FR-13", name: "Bouches-du-Rhône", i18n: {} },
        { code: "FR-BRE", name: "Brittany", i18n: {"fr":"Bretagne"} },
        { code: "FR-BFC", name: "Burgundy-Franche-Comté", i18n: {"fr":"Bourgogne-Franche-Comté"} },
        { code: "FR-14", name: "Calvados", i18n: {} },
        { code: "FR-15", name: "Cantal", i18n: {} },
        { code: "FR-CVL", name: "Centre-Val de Loire", i18n: {} },
        { code: "FR-16", name: "Charente", i18n: {} },
        { code: "FR-17", name: "Charente-Maritime", i18n: {} },
        { code: "FR-18", name: "Cher", i18n: {} },
        { code: "FR-CP", name: "Clipperton", i18n: {} },
        { code: "FR-19", name: "Corrèze", i18n: {} },
        { code: "FR-20R", name: "Corse", i18n: {} },
        { code: "FR-2A", name: "Corse-du-Sud", i18n: {} },
        { code: "FR-21", name: "Côte-d’Or", i18n: {} },
        { code: "FR-22", name: "Côtes-d’Armor", i18n: {} },
        { code: "FR-23", name: "Creuse", i18n: {} },
        { code: "FR-79", name: "Deux-Sèvres", i18n: {} },
        { code: "FR-24", name: "Dordogne", i18n: {} },
        { code: "FR-25", name: "Doubs", i18n: {} },
        { code: "FR-26", name: "Drôme", i18n: {} },
        { code: "FR-91", name: "Essonne", i18n: {} },
        { code: "FR-27", name: "Eure", i18n: {} },
        { code: "FR-28", name: "Eure-et-Loir", i18n: {} },
        { code: "FR-29", name: "Finistère", i18n: {} },
        { code: "FR-30", name: "Gard", i18n: {} },
        { code: "FR-32", name: "Gers", i18n: {} },
        { code: "FR-33", name: "Gironde", i18n: {} },
        { code: "FR-GES", name: "Grand-Est", i18n: {"fr":"Grand Est"} },
        { code: "FR-971", name: "Guadeloupe", i18n: {} },
        { code: "FR-973", name: "Guyane (française)", i18n: {"fr":"Guyane"} },
        { code: "FR-68", name: "Haut-Rhin", i18n: {} },
        { code: "FR-2B", name: "Haute-Corse", i18n: {} },
        { code: "FR-31", name: "Haute-Garonne", i18n: {} },
        { code: "FR-43", name: "Haute-Loire", i18n: {} },
        { code: "FR-52", name: "Haute-Marne", i18n: {} },
        { code: "FR-70", name: "Haute-Saône", i18n: {} },
        { code: "FR-74", name: "Haute-Savoie", i18n: {} },
        { code: "FR-87", name: "Haute-Vienne", i18n: {} },
        { code: "FR-05", name: "Hautes-Alpes", i18n: {} },
        { code: "FR-65", name: "Hautes-Pyrénées", i18n: {} },
        { code: "FR-HDF", name: "Hauts-de-France", i18n: {} },
        { code: "FR-92", name: "Hauts-de-Seine", i18n: {} },
        { code: "FR-34", name: "Hérault", i18n: {} },
        { code: "FR-IDF", name: "Île-de-France²", i18n: {"fr":"Île-de-France"} },
        { code: "FR-35", name: "Ille-et-Vilaine", i18n: {} },
        { code: "FR-36", name: "Indre", i18n: {} },
        { code: "FR-37", name: "Indre-et-Loire", i18n: {} },
        { code: "FR-38", name: "Isère", i18n: {} },
        { code: "FR-39", name: "Jura", i18n: {} },
        { code: "FR-974", name: "La Réunion", i18n: {} },
        { code: "FR-40", name: "Landes", i18n: {} },
        { code: "FR-41", name: "Loir-et-Cher", i18n: {} },
        { code: "FR-42", name: "Loire", i18n: {} },
        { code: "FR-44", name: "Loire-Atlantique", i18n: {} },
        { code: "FR-45", name: "Loiret", i18n: {} },
        { code: "FR-46", name: "Lot", i18n: {} },
        { code: "FR-47", name: "Lot-et-Garonne", i18n: {} },
        { code: "FR-48", name: "Lozère", i18n: {} },
        { code: "FR-49", name: "Maine-et-Loire", i18n: {} },
        { code: "FR-50", name: "Manche", i18n: {} },
        { code: "FR-51", name: "Marne", i18n: {} },
        { code: "FR-972", name: "Martinique", i18n: {} },
        { code: "FR-53", name: "Mayenne", i18n: {} },
        { code: "FR-976", name: "Mayotte", i18n: {} },
        { code: "FR-69M", name: "Métropole de Lyon", i18n: {} },
        { code: "FR-54", name: "Meurthe-et-Moselle", i18n: {} },
        { code: "FR-55", name: "Meuse", i18n: {} },
        { code: "FR-56", name: "Morbihan", i18n: {} },
        { code: "FR-57", name: "Moselle", i18n: {} },
        { code: "FR-58", name: "Nièvre", i18n: {} },
        { code: "FR-59", name: "Nord", i18n: {} },
        { code: "FR-NOR", name: "Normandie", i18n: {} },
        { code: "FR-NAQ", name: "Nouvelle-Aquitaine", i18n: {} },
        { code: "FR-NC", name: "Nouvelle-Calédonie", i18n: {} },
        { code: "FR-OCC", name: "Occitanie", i18n: {} },
        { code: "FR-60", name: "Oise", i18n: {} },
        { code: "FR-61", name: "Orne", i18n: {} },
        { code: "FR-75C", name: "Paris", i18n: {} },
        { code: "FR-62", name: "Pas-de-Calais", i18n: {} },
        { code: "FR-PDL", name: "Pays-de-la-Loire", i18n: {"fr":"Pays de la Loire"} },
        { code: "FR-PF", name: "Polynésie française", i18n: {} },
        { code: "FR-PAC", name: "Provence-Alpes-Côte-d’Azur", i18n: {"fr":"Provence-Alpes-Côte d’Azur"} },
        { code: "FR-63", name: "Puy-de-Dôme", i18n: {} },
        { code: "FR-64", name: "Pyrénées-Atlantiques", i18n: {} },
        { code: "FR-66", name: "Pyrénées-Orientales", i18n: {} },
        { code: "FR-69", name: "Rhône", i18n: {} },
        { code: "FR-BL", name: "Saint-Barthélemy", i18n: {} },
        { code: "FR-MF", name: "Saint-Martin", i18n: {} },
        { code: "FR-PM", name: "Saint-Pierre-et-Miquelon", i18n: {} },
        { code: "FR-71", name: "Saône-et-Loire", i18n: {} },
        { code: "FR-72", name: "Sarthe", i18n: {} },
        { code: "FR-73", name: "Savoie", i18n: {} },
        { code: "FR-77", name: "Seine-et-Marne", i18n: {} },
        { code: "FR-76", name: "Seine-Maritime", i18n: {} },
        { code: "FR-93", name: "Seine-Saint-Denis", i18n: {} },
        { code: "FR-80", name: "Somme", i18n: {} },
        { code: "FR-81", name: "Tarn", i18n: {} },
        { code: "FR-82", name: "Tarn-et-Garonne", i18n: {} },
        { code: "FR-TF", name: "Terres australes françaises", i18n: {} },
        { code: "FR-90", name: "Territoire de Belfort", i18n: {} },
        { code: "FR-95", name: "Val-d’Oise", i18n: {} },
        { code: "FR-94", name: "Val-de-Marne", i18n: {} },
        { code: "FR-83", name: "Var", i18n: {} },
        { code: "FR-84", name: "Vaucluse", i18n: {} },
        { code: "FR-85", name: "Vendée", i18n: {} },
        { code: "FR-86", name: "Vienne", i18n: {} },
        { code: "FR-88", name: "Vosges", i18n: {} },
        { code: "FR-WF", name: "Wallis-et-Futuna", i18n: {} },
        { code: "FR-89", name: "Yonne", i18n: {} },
        { code: "FR-78", name: "Yvelines", i18n: {} },
    ],
    "GA": [
        { code: "GA-1", name: "Estuaire", i18n: {} },
        { code: "GA-2", name: "Haut-Ogooué", i18n: {} },
        { code: "GA-3", name: "Moyen-Ogooué", i18n: {} },
        { code: "GA-4", name: "Ngounié", i18n: {} },
        { code: "GA-5", name: "Nyanga", i18n: {} },
        { code: "GA-6", name: "Ogooué-Ivindo", i18n: {} },
        { code: "GA-7", name: "Ogooué-Lolo", i18n: {} },
        { code: "GA-8", name: "Ogooué-Maritime", i18n: {} },
        { code: "GA-9", name: "Woleu-Ntem", i18n: {} },
    ],
    "GB": [
        { code: "GB-ABE", name: "Aberdeen", i18n: {} },
        { code: "GB-ABD", name: "Aberdeenshire", i18n: {} },
        { code: "GB-AGY", name: "Anglesey", i18n: {} },
        { code: "GB-ANS", name: "Angus", i18n: {} },
        { code: "GB-ANN", name: "Antrim and Newtownabbey", i18n: {} },
        { code: "GB-AND", name: "Ards and North Down", i18n: {} },
        { code: "GB-AGB", name: "Argyll and Bute", i18n: {} },
        { code: "GB-ABC", name: "Armagh, Banbridge and Craigavon", i18n: {} },
        { code: "GB-BDG", name: "Barking and Dagenham", i18n: {} },
        { code: "GB-BNE", name: "Barnet", i18n: {} },
        { code: "GB-BNS", name: "Barnsley", i18n: {} },
        { code: "GB-BAS", name: "Bath and North East Somerset", i18n: {} },
        { code: "GB-BDF", name: "Bedford", i18n: {} },
        { code: "GB-BFS", name: "Belfast", i18n: {} },
        { code: "GB-BEX", name: "Bexley", i18n: {} },
        { code: "GB-BIR", name: "Birmingham", i18n: {} },
        { code: "GB-BBD", name: "Blackburn with Darwen", i18n: {} },
        { code: "GB-BPL", name: "Blackpool", i18n: {} },
        { code: "GB-BGW", name: "Blaenau Gwent", i18n: {} },
        { code: "GB-BOL", name: "Bolton", i18n: {} },
        { code: "GB-BCP", name: "Bournemouth, Christchurch and Poole", i18n: {} },
        { code: "GB-BRC", name: "Bracknell Forest", i18n: {} },
        { code: "GB-BRD", name: "Bradford", i18n: {} },
        { code: "GB-BEN", name: "Brent", i18n: {} },
        { code: "GB-BGE", name: "Bridgend", i18n: {} },
        { code: "GB-BNH", name: "Brighton and Hove", i18n: {} },
        { code: "GB-BST", name: "Bristol", i18n: {} },
        { code: "GB-BRY", name: "Bromley", i18n: {} },
        { code: "GB-BKM", name: "Buckinghamshire", i18n: {} },
        { code: "GB-BUR", name: "Bury", i18n: {} },
        { code: "GB-CAY", name: "Caerphilly", i18n: {} },
        { code: "GB-CLD", name: "Calderdale", i18n: {} },
        { code: "GB-CAM", name: "Cambridgeshire", i18n: {} },
        { code: "GB-CMD", name: "Camden", i18n: {} },
        { code: "GB-CRF", name: "Cardiff", i18n: {} },
        { code: "GB-CMN", name: "Carmarthenshire", i18n: {} },
        { code: "GB-CCG", name: "Causeway Coast and Glens", i18n: {} },
        { code: "GB-CBF", name: "Central Bedfordshire", i18n: {} },
        { code: "GB-CGN", name: "Ceredigion", i18n: {} },
        { code: "GB-CHE", name: "Cheshire East", i18n: {} },
        { code: "GB-CHW", name: "Cheshire West and Chester", i18n: {} },
        { code: "GB-CLK", name: "Clackmannanshire", i18n: {} },
        { code: "GB-CWY", name: "Conwy", i18n: {} },
        { code: "GB-CON", name: "Cornwall", i18n: {} },
        { code: "GB-COV", name: "Coventry", i18n: {} },
        { code: "GB-CRY", name: "Croydon", i18n: {} },
        { code: "GB-CMA", name: "Cumbria", i18n: {} },
        { code: "GB-DAL", name: "Darlington", i18n: {} },
        { code: "GB-DEN", name: "Denbighshire", i18n: {} },
        { code: "GB-DER", name: "Derby", i18n: {} },
        { code: "GB-DBY", name: "Derbyshire", i18n: {} },
        { code: "GB-DRS", name: "Derry and Strabane", i18n: {} },
        { code: "GB-DEV", name: "Devon", i18n: {} },
        { code: "GB-DNC", name: "Doncaster", i18n: {} },
        { code: "GB-DOR", name: "Dorset", i18n: {} },
        { code: "GB-DUD", name: "Dudley", i18n: {} },
        { code: "GB-DGY", name: "Dumfries and Galloway", i18n: {} },
        { code: "GB-DND", name: "Dundee", i18n: {} },
        { code: "GB-DUR", name: "Durham", i18n: {} },
        { code: "GB-EAL", name: "Ealing", i18n: {} },
        { code: "GB-EAY", name: "East Ayrshire", i18n: {} },
        { code: "GB-EDU", name: "East Dunbartonshire", i18n: {} },
        { code: "GB-ELN", name: "East Lothian", i18n: {} },
        { code: "GB-ERW", name: "East Renfrewshire", i18n: {} },
        { code: "GB-ERY", name: "East Riding of Yorkshire", i18n: {} },
        { code: "GB-ESX", name: "East Sussex", i18n: {} },
        { code: "GB-EDH", name: "Edinburgh", i18n: {} },
        { code: "GB-ENF", name: "Enfield", i18n: {} },
        { code: "GB-ENG", name: "England", i18n: {} },
        { code: "GB-ESS", name: "Essex", i18n: {} },
        { code: "GB-FAL", name: "Falkirk", i18n: {} },
        { code: "GB-FMO", name: "Fermanagh and Omagh", i18n: {} },
        { code: "GB-FIF", name: "Fife", i18n: {} },
        { code: "GB-FLN", name: "Flintshire", i18n: {} },
        { code: "GB-GAT", name: "Gateshead", i18n: {} },
        { code: "GB-GLG", name: "Glasgow", i18n: {} },
        { code: "GB-GLS", name: "Gloucestershire", i18n: {} },
        { code: "GB-GRE", name: "Greenwich", i18n: {} },
        { code: "GB-GWN", name: "Gwynedd", i18n: {} },
        { code: "GB-HCK", name: "Hackney", i18n: {} },
        { code: "GB-HAL", name: "Halton", i18n: {} },
        { code: "GB-HMF", name: "Hammersmith and Fulham", i18n: {} },
        { code: "GB-HAM", name: "Hampshire", i18n: {} },
        { code: "GB-HRY", name: "Haringey", i18n: {} },
        { code: "GB-HRW", name: "Harrow", i18n: {} },
        { code: "GB-HPL", name: "Hartlepool", i18n: {} },
        { code: "GB-HAV", name: "Havering", i18n: {} },
        { code: "GB-HEF", name: "Herefordshire", i18n: {} },
        { code: "GB-HRT", name: "Hertfordshire", i18n: {} },
        { code: "GB-HLD", name: "Highland", i18n: {} },
        { code: "GB-HIL", name: "Hillingdon", i18n: {} },
        { code: "GB-HNS", name: "Hounslow", i18n: {} },
        { code: "GB-IVC", name: "Inverclyde", i18n: {} },
        { code: "GB-IOW", name: "Isle of Wight", i18n: {} },
        { code: "GB-IOS", name: "Isles of Scilly", i18n: {} },
        { code: "GB-ISL", name: "Islington", i18n: {} },
        { code: "GB-KEC", name: "Kensington and Chelsea", i18n: {} },
        { code: "GB-KEN", name: "Kent", i18n: {} },
        { code: "GB-KHL", name: "Kingston upon Hull", i18n: {} },
        { code: "GB-KTT", name: "Kingston upon Thames", i18n: {} },
        { code: "GB-KIR", name: "Kirklees", i18n: {} },
        { code: "GB-KWL", name: "Knowsley", i18n: {} },
        { code: "GB-LBH", name: "Lambeth", i18n: {} },
        { code: "GB-LAN", name: "Lancashire", i18n: {} },
        { code: "GB-LDS", name: "Leeds", i18n: {} },
        { code: "GB-LCE", name: "Leicester", i18n: {} },
        { code: "GB-LEC", name: "Leicestershire", i18n: {} },
        { code: "GB-LEW", name: "Lewisham", i18n: {} },
        { code: "GB-LIN", name: "Lincolnshire", i18n: {} },
        { code: "GB-LBC", name: "Lisburn and Castlereagh", i18n: {} },
        { code: "GB-LIV", name: "Liverpool", i18n: {} },
        { code: "GB-LND", name: "London", i18n: {} },
        { code: "GB-LUT", name: "Luton", i18n: {} },
        { code: "GB-MAN", name: "Manchester", i18n: {} },
        { code: "GB-MDW", name: "Medway", i18n: {} },
        { code: "GB-MTY", name: "Merthyr Tydfil", i18n: {} },
        { code: "GB-MRT", name: "Merton", i18n: {} },
        { code: "GB-MEA", name: "Mid and East Antrim", i18n: {} },
        { code: "GB-MUL", name: "Mid Ulster", i18n: {} },
        { code: "GB-MDB", name: "Middlesbrough", i18n: {} },
        { code: "GB-MLN", name: "Midlothian", i18n: {} },
        { code: "GB-MIK", name: "Milton Keynes", i18n: {} },
        { code: "GB-MON", name: "Monmouthshire", i18n: {} },
        { code: "GB-MRY", name: "Moray", i18n: {} },
        { code: "GB-NTL", name: "Neath Port Talbot", i18n: {} },
        { code: "GB-NET", name: "Newcastle upon Tyne", i18n: {} },
        { code: "GB-NWM", name: "Newham", i18n: {} },
        { code: "GB-NWP", name: "Newport", i18n: {} },
        { code: "GB-NMD", name: "Newry, Mourne and Down", i18n: {} },
        { code: "GB-NFK", name: "Norfolk", i18n: {} },
        { code: "GB-NAY", name: "North Ayrshire", i18n: {} },
        { code: "GB-NEL", name: "North East Lincolnshire", i18n: {} },
        { code: "GB-NLK", name: "North Lanarkshire", i18n: {} },
        { code: "GB-NLN", name: "North Lincolnshire", i18n: {} },
        { code: "GB-NNH", name: "North Northamptonshire", i18n: {} },
        { code: "GB-NSM", name: "North Somerset", i18n: {} },
        { code: "GB-NTY", name: "North Tyneside", i18n: {} },
        { code: "GB-NYK", name: "North Yorkshire", i18n: {} },
        { code: "GB-NIR", name: "Northern Ireland", i18n: {} },
        { code: "GB-NBL", name: "Northumberland", i18n: {} },
        { code: "GB-NGM", name: "Nottingham", i18n: {} },
        { code: "GB-NTT", name: "Nottinghamshire", i18n: {} },
        { code: "GB-OLD", name: "Oldham", i18n: {} },
        { code: "GB-ORK", name: "Orkney Islands", i18n: {} },
        { code: "GB-ELS", name: "Outer Hebrides", i18n: {} },
        { code: "GB-OXF", name: "Oxfordshire", i18n: {} },
        { code: "GB-PEM", name: "Pembrokeshire", i18n: {} },
        { code: "GB-PKN", name: "Perth and Kinross", i18n: {} },
        { code: "GB-PTE", name: "Peter", i18n: {} },
        { code: "GB-PLY", name: "Plymouth", i18n: {} },
        { code: "GB-POR", name: "Portsmouth", i18n: {} },
        { code: "GB-POW", name: "Powys", i18n: {} },
        { code: "GB-RDG", name: "Reading", i18n: {} },
        { code: "GB-RDB", name: "Redbridge", i18n: {} },
        { code: "GB-RCC", name: "Redcar and Cleveland", i18n: {} },
        { code: "GB-RFW", name: "Renfrewshire", i18n: {} },
        { code: "GB-RCT", name: "Rhondda Cynon Taf", i18n: {} },
        { code: "GB-RIC", name: "Richmond upon Thames", i18n: {} },
        { code: "GB-RCH", name: "Rochdale", i18n: {} },
        { code: "GB-ROT", name: "Rotherham", i18n: {} },
        { code: "GB-RUT", name: "Rutland", i18n: {} },
        { code: "GB-SHN", name: "Saint Helens", i18n: {} },
        { code: "GB-SLF", name: "Salford", i18n: {} },
        { code: "GB-SAW", name: "Sandwell", i18n: {} },
        { code: "GB-SCT", name: "Scotland", i18n: {} },
        { code: "GB-SCB", name: "Scottish Borders", i18n: {} },
        { code: "GB-SFT", name: "Sefton", i18n: {} },
        { code: "GB-SHF", name: "Sheffield", i18n: {} },
        { code: "GB-ZET", name: "Shetland", i18n: {} },
        { code: "GB-SHR", name: "Shropshire", i18n: {} },
        { code: "GB-SLG", name: "Slough", i18n: {} },
        { code: "GB-SOL", name: "Solihull", i18n: {} },
        { code: "GB-SOM", name: "Somerset", i18n: {} },
        { code: "GB-SAY", name: "South Ayrshire", i18n: {} },
        { code: "GB-SGC", name: "South Gloucestershire", i18n: {} },
        { code: "GB-SLK", name: "South Lanarkshire", i18n: {} },
        { code: "GB-STY", name: "South Tyneside", i18n: {} },
        { code: "GB-STH", name: "Southampton", i18n: {} },
        { code: "GB-SOS", name: "Southend-on-Sea", i18n: {} },
        { code: "GB-SWK", name: "Southwark", i18n: {} },
        { code: "GB-STS", name: "Staffordshire", i18n: {} },
        { code: "GB-STG", name: "Stirling", i18n: {} },
        { code: "GB-SKP", name: "Stockport", i18n: {} },
        { code: "GB-STT", name: "Stockton-on-Tees", i18n: {} },
        { code: "GB-STE", name: "Stoke-on-Trent", i18n: {} },
        { code: "GB-SFK", name: "Suffolk", i18n: {} },
        { code: "GB-SND", name: "Sunderland", i18n: {} },
        { code: "GB-SRY", name: "Surrey", i18n: {} },
        { code: "GB-STN", name: "Sutton", i18n: {} },
        { code: "GB-SWA", name: "Swansea", i18n: {} },
        { code: "GB-SWD", name: "Swindon", i18n: {} },
        { code: "GB-TAM", name: "Tameside", i18n: {} },
        { code: "GB-TFW", name: "Telford and Wrekin", i18n: {} },
        { code: "GB-THR", name: "Thurrock", i18n: {} },
        { code: "GB-TOB", name: "Torbay", i18n: {} },
        { code: "GB-TOF", name: "Torfaen", i18n: {} },
        { code: "GB-TWH", name: "Tower Hamlets", i18n: {} },
        { code: "GB-TRF", name: "Trafford", i18n: {} },
        { code: "GB-VGL", name: "Vale of Glamorgan", i18n: {} },
        { code: "GB-WKF", name: "Wakefield", i18n: {} },
        { code: "GB-WLS", name: "Wales", i18n: {} },
        { code: "GB-WLL", name: "Walsall", i18n: {} },
        { code: "GB-WFT", name: "Waltham Forest", i18n: {} },
        { code: "GB-WND", name: "Wandsworth", i18n: {} },
        { code: "GB-WRT", name: "Warrington", i18n: {} },
        { code: "GB-WAR", name: "Warwickshire", i18n: {} },
        { code: "GB-WBK", name: "West Berkshire", i18n: {} },
        { code: "GB-WDU", name: "West Dunbartonshire", i18n: {} },
        { code: "GB-WLN", name: "West Lothian", i18n: {} },
        { code: "GB-WNH", name: "West Northamptonshire", i18n: {} },
        { code: "GB-WSX", name: "West Sussex", i18n: {} },
        { code: "GB-WSM", name: "Westminster", i18n: {} },
        { code: "GB-WGN", name: "Wigan", i18n: {} },
        { code: "GB-WIL", name: "Wiltshire", i18n: {} },
        { code: "GB-WNM", name: "Windsor and Maidenhead", i18n: {} },
        { code: "GB-WRL", name: "Wirral", i18n: {} },
        { code: "GB-WOK", name: "Wokingham", i18n: {} },
        { code: "GB-WLV", name: "Wolverhampton", i18n: {} },
        { code: "GB-WOR", name: "Worcestershire", i18n: {} },
        { code: "GB-WRX", name: "Wrexham", i18n: {} },
        { code: "GB-YOR", name: "York", i18n: {} },
    ],
    "GD": [
        { code: "GD-10", name: "Carriacou and Petite Martinique", i18n: {} },
        { code: "GD-01", name: "Saint Andrew", i18n: {} },
        { code: "GD-02", name: "Saint David", i18n: {} },
        { code: "GD-03", name: "Saint George", i18n: {} },
        { code: "GD-04", name: "Saint John", i18n: {} },
        { code: "GD-05", name: "Saint Mark", i18n: {} },
        { code: "GD-06", name: "Saint Patrick", i18n: {} },
    ],
    "GE": [
        { code: "GE-AB", name: "Abkhazia", i18n: {"ka":"აფხაზეთი"} },
        { code: "GE-AJ", name: "Adjara", i18n: {"ka":"აჭარის ავტონომიური რესპუბლიკა"} },
        { code: "GE-GU", name: "Guria", i18n: {"ka":"გურიის მხარე"} },
        { code: "GE-IM", name: "Imereti", i18n: {"ka":"იმერეთის მხარე"} },
        { code: "GE-KA", name: "Kakheti", i18n: {"ka":"კახეთის მხარე"} },
        { code: "GE-KK", name: "Kvemo Kartli", i18n: {"ka":"ქვემო ქართლის მხარე"} },
        { code: "GE-MM", name: "Mtskheta-Mtianeti", i18n: {"ka":"მცხეთა-მთიანეთის მხარე"} },
        { code: "GE-RL", name: "Racha-Lechkhumi and Kvemo Svaneti", i18n: {"ka":"რაჭა-ლეჩხუმისა და ქვემო სვანეთის მხარე"} },
        { code: "GE-SZ", name: "Samegrelo-Zemo Svaneti", i18n: {"ka":"სამეგრელო-ზემო სვანეთის მხარე"} },
        { code: "GE-SJ", name: "Samtskhe-Javakheti", i18n: {"ka":"სამცხე-ჯავახეთის მხარე"} },
        { code: "GE-SK", name: "Shida Kartli", i18n: {"ka":"შიდა ქართლის მხარე"} },
        { code: "GE-TB", name: "Tbilisi", i18n: {"ka":"თბილისი"} },
    ],
    "GH": [
        { code: "GH-AF", name: "Ahafo", i18n: {} },
        { code: "GH-AH", name: "Ashanti", i18n: {} },
        { code: "GH-BO", name: "Bono", i18n: {} },
        { code: "GH-BE", name: "Bono East", i18n: {} },
        { code: "GH-CP", name: "Central", i18n: {} },
        { code: "GH-EP", name: "Eastern", i18n: {} },
        { code: "GH-AA", name: "Greater Accra", i18n: {} },
        { code: "GH-NE", name: "North East", i18n: {} },
        { code: "GH-NP", name: "Northern", i18n: {} },
        { code: "GH-OT", name: "Oti", i18n: {} },
        { code: "GH-SV", name: "Savannah", i18n: {} },
        { code: "GH-UE", name: "Upper East", i18n: {} },
        { code: "GH-UW", name: "Upper West", i18n: {} },
        { code: "GH-TV", name: "Volta", i18n: {} },
        { code: "GH-WP", name: "Western", i18n: {} },
        { code: "GH-WN", name: "Western North", i18n: {} },
    ],
    "GL": [
        { code: "GL-AV", name: "Avannaata Kommunia", i18n: {} },
        { code: "GL-QT", name: "Kommune Qeqertalik", i18n: {} },
        { code: "GL-KU", name: "Kujalleq", i18n: {} },
        { code: "GL-QE", name: "Qeqqata", i18n: {} },
        { code: "GL-SM", name: "Sermersooq", i18n: {} },
    ],
    "GM": [
        { code: "GM-B", name: "Banjul", i18n: {} },
        { code: "GM-M", name: "Central River Division", i18n: {} },
        { code: "GM-L", name: "Lower River Division", i18n: {} },
        { code: "GM-N", name: "North Bank Division", i18n: {} },
        { code: "GM-U", name: "Upper River Division", i18n: {} },
        { code: "GM-W", name: "West Coast Division", i18n: {} },
    ],
    "GN": [
        { code: "GN-BE", name: "Beyla", i18n: {"fr":"préfecture de Beyla"} },
        { code: "GN-BF", name: "Boffa", i18n: {"fr":"préfecture de Boffa"} },
        { code: "GN-BK", name: "Boké", i18n: {"fr":"préfecture de Boké"} },
        { code: "GN-B", name: "Boké Region", i18n: {"fr":"Région de Boké"} },
        { code: "GN-C", name: "Conakry", i18n: {} },
        { code: "GN-CO", name: "Coyah", i18n: {"fr":"préfecture de Coyah"} },
        { code: "GN-DB", name: "Dabola", i18n: {"fr":"préfecture de Dabola"} },
        { code: "GN-DL", name: "Dalaba", i18n: {"fr":"préfecture de Dalaba"} },
        { code: "GN-DI", name: "Dinguiraye", i18n: {"fr":"préfecture de Dinguiraye"} },
        { code: "GN-DU", name: "Dubréka", i18n: {"fr":"préfecture de Dubréka"} },
        { code: "GN-FA", name: "Faranah", i18n: {"fr":"préfecture de Faranah"} },
        { code: "GN-F", name: "Faranah Region", i18n: {"fr":"Région de Faranah"} },
        { code: "GN-FO", name: "Forécariah", i18n: {"fr":"préfecture de Forécariah"} },
        { code: "GN-FR", name: "Fria", i18n: {"fr":"préfecture de Fria"} },
        { code: "GN-GA", name: "Gaoual", i18n: {"fr":"préfecture de Gaoual"} },
        { code: "GN-GU", name: "Guéckédou", i18n: {"fr":"préfecture de Guéckédou"} },
        { code: "GN-KA", name: "Kankan", i18n: {"fr":"préfecture de Kankan"} },
        { code: "GN-K", name: "Kankan Region", i18n: {"fr":"Région de Kankan"} },
        { code: "GN-KE", name: "Kérouané", i18n: {"fr":"préfecture de Kérouane"} },
        { code: "GN-KD", name: "Kindia", i18n: {"fr":"préfecture de Kindia"} },
        { code: "GN-D", name: "Kindia Region", i18n: {"fr":"Région de Kindia"} },
        { code: "GN-KS", name: "Kissidougou", i18n: {"fr":"préfecture de Kissidougou"} },
        { code: "GN-KB", name: "Koubia", i18n: {"fr":"préfecture de Koubia"} },
        { code: "GN-KN", name: "Koundara", i18n: {"fr":"préfecture de Koundara"} },
        { code: "GN-KO", name: "Kouroussa", i18n: {"fr":"préfecture de Kouroussa"} },
        { code: "GN-LA", name: "Labé", i18n: {"fr":"préfecture de Labé"} },
        { code: "GN-L", name: "Labé Region", i18n: {"fr":"Région de Labé"} },
        { code: "GN-LE", name: "Lélouma", i18n: {"fr":"préfecture de Lélouma"} },
        { code: "GN-LO", name: "Lola", i18n: {"fr":"préfecture de Lola"} },
        { code: "GN-MC", name: "Macenta", i18n: {"fr":"préfecture de Macenta"} },
        { code: "GN-ML", name: "Mali", i18n: {"fr":"préfecture de Mali"} },
        { code: "GN-MM", name: "Mamou", i18n: {"fr":"préfecture de Mamou"} },
        { code: "GN-M", name: "Mamou Region", i18n: {"fr":"Région de Mamou"} },
        { code: "GN-MD", name: "Mandiana", i18n: {"fr":"préfecture de Mandiana"} },
        { code: "GN-NZ", name: "Nzérékoré", i18n: {"fr":"préfecture de Nzérékoré"} },
        { code: "GN-N", name: "Nzérékoré Region", i18n: {"fr":"Région de Nzérékoré"} },
        { code: "GN-PI", name: "Pita", i18n: {"fr":"préfecture de Pita"} },
        { code: "GN-SI", name: "Siguiri", i18n: {"fr":"préfecture de Siguiri"} },
        { code: "GN-TE", name: "Télimélé", i18n: {"fr":"préfecture de Télimélé"} },
        { code: "GN-TO", name: "Tougué", i18n: {"fr":"préfecture de Tougué"} },
        { code: "GN-YO", name: "Yomou", i18n: {"fr":"préfecture de Yomou"} },
    ],
    "GQ": [
        { code: "GQ-AN", name: "Annobón", i18n: {"es":"Provincia de Annobón"} },
        { code: "GQ-BN", name: "Bioko Norte", i18n: {"es":"Provincia de Bioko Norte"} },
        { code: "GQ-BS", name: "Bioko Sur", i18n: {"es":"Provincia de Bioko Sur"} },
        { code: "GQ-CS", name: "Centro Sur", i18n: {"es":"Provincia Centro Sur"} },
        { code: "GQ-DJ", name: "Djibloho", i18n: {"es":"Provincia de Djibloho"} },
        { code: "GQ-I", name: "Insular", i18n: {"es":"Islas de Guinea Ecuatorial"} },
        { code: "GQ-KN", name: "Kié-Ntem", i18n: {"es":"Provincia Kié-Ntem"} },
        { code: "GQ-LI", name: "Litoral", i18n: {"es":"Provincia Litoral"} },
        { code: "GQ-C", name: "Río Muni", i18n: {} },
        { code: "GQ-WN", name: "Wele-Nzas", i18n: {"es":"Provincia Wele-Nzas"} },
    ],
    "GR": [
        { code: "GR-I", name: "Attica", i18n: {"el":"Αττική"} },
        { code: "GR-H", name: "Central Greece", i18n: {"el":"Περιφέρεια Στερεάς Ελλάδας"} },
        { code: "GR-B", name: "Central Macedonia", i18n: {"el":"Κεντρική Μακεδονία"} },
        { code: "GR-M", name: "Crete", i18n: {"el":"Περιφέρεια Κρήτης"} },
        { code: "GR-A", name: "East Macedonia and Thrace", i18n: {"el":"Περιφέρεια Ανατολικής Μακεδονίας και Θράκης"} },
        { code: "GR-D", name: "Epirus", i18n: {"el":"Περιφέρεια Ηπείρου"} },
        { code: "GR-F", name: "Ionian Islands", i18n: {"el":"Περιφέρεια Ιονίων Νήσων"} },
        { code: "GR-69", name: "Mount Athos", i18n: {"el":"Άγιο Όρος"} },
        { code: "GR-K", name: "North Aegean", i18n: {"el":"Περιφέρεια Βορείου Αιγαίου"} },
        { code: "GR-J", name: "Peloponnese", i18n: {"el":"Περιφέρεια Πελοποννήσου"} },
        { code: "GR-L", name: "South Aegean", i18n: {"el":"Περιφέρεια Νοτίου Αιγαίου"} },
        { code: "GR-E", name: "Thessaly", i18n: {"el":"Θεσσαλία"} },
        { code: "GR-G", name: "West Greece", i18n: {"el":"Περιφέρεια Δυτικής Ελλάδας"} },
        { code: "GR-C", name: "West Macedonia", i18n: {"el":"Περιφέρεια Δυτικής Μακεδονίας"} },
    ],
    "GT": [
        { code: "GT-16", name: "Alta Verapaz", i18n: {} },
        { code: "GT-15", name: "Baja Verapaz", i18n: {} },
        { code: "GT-04", name: "Chimaltenango", i18n: {} },
        { code: "GT-20", name: "Chiquimula", i18n: {} },
        { code: "GT-02", name: "El Progreso", i18n: {} },
        { code: "GT-05", name: "Escuintla", i18n: {} },
        { code: "GT-01", name: "Guatemala", i18n: {} },
        { code: "GT-13", name: "Huehuetenango", i18n: {} },
        { code: "GT-18", name: "Izabal", i18n: {} },
        { code: "GT-21", name: "Jalapa", i18n: {} },
        { code: "GT-22", name: "Jutiapa", i18n: {} },
        { code: "GT-17", name: "Petén", i18n: {} },
        { code: "GT-09", name: "Quetzaltenango", i18n: {} },
        { code: "GT-14", name: "Quiché", i18n: {} },
        { code: "GT-11", name: "Retalhuleu", i18n: {} },
        { code: "GT-03", name: "Sacatepéquez", i18n: {} },
        { code: "GT-12", name: "San Marcos", i18n: {} },
        { code: "GT-06", name: "Santa Rosa", i18n: {} },
        { code: "GT-07", name: "Sololá", i18n: {} },
        { code: "GT-10", name: "Suchitepéquez", i18n: {} },
        { code: "GT-08", name: "Totonicapán", i18n: {} },
        { code: "GT-19", name: "Zacapa", i18n: {} },
    ],
    "GW": [
        { code: "GW-BA", name: "Bafatá", i18n: {"pt":"Bafatá (região)"} },
        { code: "GW-BM", name: "Biombo", i18n: {} },
        { code: "GW-BS", name: "Bissau", i18n: {} },
        { code: "GW-BL", name: "Bolama", i18n: {} },
        { code: "GW-CA", name: "Cacheu", i18n: {} },
        { code: "GW-GA", name: "Gabú", i18n: {"pt":"Gabu"} },
        { code: "GW-L", name: "Leste", i18n: {"pt":"Província Leste"} },
        { code: "GW-N", name: "Norte", i18n: {"pt":"Província Norte"} },
        { code: "GW-OI", name: "Oio", i18n: {} },
        { code: "GW-QU", name: "Quinara", i18n: {} },
        { code: "GW-S", name: "Sul", i18n: {"pt":"Província Sul"} },
        { code: "GW-TO", name: "Tombali", i18n: {} },
    ],
    "GY": [
        { code: "GY-BA", name: "Barima-Waini", i18n: {} },
        { code: "GY-CU", name: "Cuyuni-Mazaruni", i18n: {} },
        { code: "GY-DE", name: "Demerara-Mahaica", i18n: {} },
        { code: "GY-EB", name: "East Berbice-Corentyne", i18n: {} },
        { code: "GY-ES", name: "Essequibo Islands-West Demerara", i18n: {} },
        { code: "GY-MA", name: "Mahaica-Berbice", i18n: {} },
        { code: "GY-PM", name: "Pomeroon-Supenaam", i18n: {} },
        { code: "GY-PT", name: "Potaro-Siparuni", i18n: {} },
        { code: "GY-UD", name: "Upper Demerara-Berbice", i18n: {} },
        { code: "GY-UT", name: "Upper Takutu-Upper Essequibo", i18n: {} },
    ],
    "HN": [
        { code: "HN-AT", name: "Atlántida", i18n: {"es":"Departamento de Atlántida"} },
        { code: "HN-IB", name: "Bay Islands", i18n: {"es":"Islas de la Bahía"} },
        { code: "HN-CH", name: "Choluteca", i18n: {"es":"Departamento de Choluteca"} },
        { code: "HN-CL", name: "Colón", i18n: {"es":"Departamento de Colón"} },
        { code: "HN-CM", name: "Comayagua", i18n: {} },
        { code: "HN-CP", name: "Copán", i18n: {"es":"Departamento de Copán"} },
        { code: "HN-CR", name: "Cortés", i18n: {} },
        { code: "HN-EP", name: "El Paraíso", i18n: {} },
        { code: "HN-FM", name: "Francisco Morazán", i18n: {} },
        { code: "HN-GD", name: "Gracias a Dios", i18n: {} },
        { code: "HN-IN", name: "Intibucá", i18n: {} },
        { code: "HN-LP", name: "La Paz", i18n: {} },
        { code: "HN-LE", name: "Lempira", i18n: {} },
        { code: "HN-OC", name: "Ocotepeque", i18n: {} },
        { code: "HN-OL", name: "Olancho", i18n: {} },
        { code: "HN-SB", name: "Santa Bárbara", i18n: {} },
        { code: "HN-VA", name: "Valle", i18n: {} },
        { code: "HN-YO", name: "Yoro", i18n: {} },
    ],
    "HR": [
        { code: "HR-07", name: "Bjelovar-Bilogora", i18n: {"hr":"Bjelovarsko-bilogorska županija"} },
        { code: "HR-12", name: "Brod-Posavina", i18n: {"hr":"Brodsko-posavska županija"} },
        { code: "HR-19", name: "Dubrovnik-Neretva", i18n: {"hr":"Dubrovačko-neretvanska županija"} },
        { code: "HR-18", name: "Istria", i18n: {"hr":"Istarska županija"} },
        { code: "HR-04", name: "Karlovac", i18n: {"hr":"Karlovačka županija"} },
        { code: "HR-06", name: "Koprivnica-Križevci", i18n: {"hr":"Koprivničko-križevačka županija"} },
        { code: "HR-02", name: "Krapina-Zagorje", i18n: {"hr":"Krapinsko-zagorska županija"} },
        { code: "HR-09", name: "Lika-Senj", i18n: {"hr":"Ličko-senjska županija"} },
        { code: "HR-20", name: "Međimurje", i18n: {"hr":"Međimurska županija"} },
        { code: "HR-14", name: "Osijek-Baranja", i18n: {"hr":"Osječko-baranjska županija"} },
        { code: "HR-11", name: "Požega-Slavonia", i18n: {"hr":"Požeško-slavonska županija"} },
        { code: "HR-08", name: "Primorje-Gorski Kotar", i18n: {"hr":"Primorsko-goranska županija"} },
        { code: "HR-15", name: "Šibenik-Knin", i18n: {"hr":"Šibensko-kninska županija"} },
        { code: "HR-03", name: "Sisak-Moslavina", i18n: {"hr":"Sisačko-moslavačka županija"} },
        { code: "HR-17", name: "Split-Dalmatia", i18n: {"hr":"Splitsko-dalmatinska županija"} },
        { code: "HR-05", name: "Varaždin", i18n: {"hr":"Varaždinska županija"} },
        { code: "HR-10", name: "Virovitica-Podravina", i18n: {"hr":"Virovitičko-Podravska županija"} },
        { code: "HR-16", name: "Vukovar-Syrmia", i18n: {"hr":"Vukovarsko-srijemska županija"} },
        { code: "HR-13", name: "Zadar", i18n: {"hr":"Zadarska županija"} },
        { code: "HR-21", name: "Zagreb", i18n: {} },
        { code: "HR-01", name: "Zagreb County", i18n: {"hr":"Zagrebačka županija"} },
    ],
    "HT": [
        { code: "HT-AR", name: "Artibonite", i18n: {} },
        { code: "HT-CE", name: "Centre", i18n: {} },
        { code: "HT-GA", name: "Grand’Anse", i18n: {} },
        { code: "HT-NI", name: "Nippes", i18n: {} },
        { code: "HT-ND", name: "Nord", i18n: {} },
        { code: "HT-NE", name: "Nord-Est", i18n: {} },
        { code: "HT-NO", name: "Nord-Ouest", i18n: {} },
        { code: "HT-OU", name: "Ouest", i18n: {} },
        { code: "HT-SD", name: "Sud", i18n: {} },
        { code: "HT-SE", name: "Sud-Est", i18n: {} },
    ],
    "HU": [
        { code: "HU-BK", name: "Bács-Kiskun", i18n: {"hu":"Bács-Kiskun megye"} },
        { code: "HU-BA", name: "Baranya", i18n: {"hu":"Baranya megye"} },
        { code: "HU-BE", name: "Békés", i18n: {"hu":"Békés megye"} },
        { code: "HU-BC", name: "Békéscsaba", i18n: {} },
        { code: "HU-BZ", name: "Borsod-Abaúj-Zemplén", i18n: {"hu":"Borsod-Abaúj-Zemplén megye"} },
        { code: "HU-BU", name: "Budapest", i18n: {} },
        { code: "HU-CS", name: "Csongrád", i18n: {"hu":"Csongrád megye"} },
        { code: "HU-DE", name: "Debrecen", i18n: {} },
        { code: "HU-DU", name: "Dunaújváros", i18n: {} },
        { code: "HU-EG", name: "Eger", i18n: {} },
        { code: "HU-ER", name: "Érd", i18n: {} },
        { code: "HU-FE", name: "Fejér", i18n: {"hu":"Fejér megye"} },
        { code: "HU-GY", name: "Győr", i18n: {} },
        { code: "HU-GS", name: "Győr-Moson-Sopron", i18n: {"hu":"Győr-Moson-Sopron megye"} },
        { code: "HU-HB", name: "Hajdú-Bihar", i18n: {"hu":"Hajdú-Bihar megye"} },
        { code: "HU-HE", name: "Heves", i18n: {"hu":"Heves megye"} },
        { code: "HU-HV", name: "Hódmezővásárhely", i18n: {} },
        { code: "HU-JN", name: "Jász-Nagykun-Szolnok", i18n: {"hu":"Jász-Nagykun-Szolnok megye"} },
        { code: "HU-KV", name: "Kaposvár", i18n: {} },
        { code: "HU-KM", name: "Kecskemét", i18n: {} },
        { code: "HU-KE", name: "Komárom-Esztergom", i18n: {"hu":"Komárom-Esztergom megye"} },
        { code: "HU-MI", name: "Miskolc", i18n: {} },
        { code: "HU-NK", name: "Nagykanizsa", i18n: {} },
        { code: "HU-NO", name: "Nógrád", i18n: {"hu":"Nógrád megye"} },
        { code: "HU-NY", name: "Nyíregyháza", i18n: {} },
        { code: "HU-PS", name: "Pécs", i18n: {} },
        { code: "HU-PE", name: "Pest", i18n: {"hu":"Pest megye"} },
        { code: "HU-ST", name: "Salgótarján", i18n: {} },
        { code: "HU-SO", name: "Somogy", i18n: {"hu":"Somogy megye"} },
        { code: "HU-SN", name: "Sopron", i18n: {} },
        { code: "HU-SZ", name: "Szabolcs-Szatmár-Bereg", i18n: {"hu":"Szabolcs-Szatmár-Bereg megye"} },
        { code: "HU-SD", name: "Szeged", i18n: {} },
        { code: "HU-SF", name: "Székesfehérvár", i18n: {} },
        { code: "HU-SS", name: "Szekszárd", i18n: {} },
        { code: "HU-SK", name: "Szolnok", i18n: {} },
        { code: "HU-SH", name: "Szombathely", i18n: {} },
        { code: "HU-TB", name: "Tatabánya", i18n: {} },
        { code: "HU-TO", name: "Tolna", i18n: {"hu":"Tolna megye"} },
        { code: "HU-VA", name: "Vas", i18n: {"hu":"Vas megye"} },
        { code: "HU-VM", name: "Veszprém", i18n: {} },
        { code: "HU-VE", name: "Veszprém County", i18n: {"hu":"Veszprém megye"} },
        { code: "HU-ZA", name: "Zala", i18n: {"hu":"Zala megye"} },
        { code: "HU-ZE", name: "Zalaegerszeg", i18n: {} },
    ],
    "ID": [
        { code: "ID-AC", name: "Aceh", i18n: {} },
        { code: "ID-BA", name: "Bali", i18n: {} },
        { code: "ID-BB", name: "Bangka–Belitung Islands", i18n: {"id":"Kepulauan Bangka Belitung"} },
        { code: "ID-BT", name: "Banten", i18n: {} },
        { code: "ID-BE", name: "Bengkulu", i18n: {} },
        { code: "ID-JT", name: "Central Java", i18n: {"id":"Jawa Tengah"} },
        { code: "ID-KT", name: "Central Kalimantan", i18n: {"id":"Kalimantan Tengah"} },
        { code: "ID-ST", name: "Central Sulawesi", i18n: {"id":"Sulawesi Tengah"} },
        { code: "ID-JI", name: "East Java", i18n: {"id":"Jawa Timur"} },
        { code: "ID-KI", name: "East Kalimantan", i18n: {"id":"Kalimantan Timur"} },
        { code: "ID-NT", name: "East Nusa Tenggara", i18n: {"id":"Nusa Tenggara Timur"} },
        { code: "ID-GO", name: "Gorontalo", i18n: {} },
        { code: "ID-JK", name: "Jakarta", i18n: {"id":"Daerah Khusus Ibukota Jakarta"} },
        { code: "ID-JA", name: "Jambi", i18n: {} },
        { code: "ID-JW", name: "Java", i18n: {"id":"Jawa"} },
        { code: "ID-KA", name: "Kalimantan", i18n: {} },
        { code: "ID-LA", name: "Lampung", i18n: {} },
        { code: "ID-NU", name: "Lesser Sunda Islands", i18n: {"id":"Kepulauan Nusa Tenggara"} },
        { code: "ID-MA", name: "Maluku", i18n: {} },
        { code: "ID-ML", name: "Maluku Islands", i18n: {"id":"Kepulauan Maluku"} },
        { code: "ID-KU", name: "North Kalimantan", i18n: {"id":"Kalimantan Utara"} },
        { code: "ID-MU", name: "North Maluku", i18n: {"id":"Maluku Utara"} },
        { code: "ID-SA", name: "North Sulawesi", i18n: {"id":"Sulawesi Utara"} },
        { code: "ID-SU", name: "North Sumatra", i18n: {"id":"Sumatera Utara"} },
        { code: "ID-PA", name: "Papua", i18n: {} },
        { code: "ID-PD", name: "Papua Barat Daya", i18n: {} },
        { code: "ID-PP", name: "Papua Islands", i18n: {"id":"Papua bagian barat"} },
        { code: "ID-PE", name: "Papua Pengunungan", i18n: {"id":"Papua Pegunungan"} },
        { code: "ID-PS", name: "Papua Selatan", i18n: {} },
        { code: "ID-PT", name: "Papua Tengah", i18n: {} },
        { code: "ID-RI", name: "Riau", i18n: {} },
        { code: "ID-KR", name: "Riau Islands", i18n: {"id":"Kepulauan Riau"} },
        { code: "ID-KS", name: "South Kalimantan", i18n: {"id":"Kalimantan Selatan"} },
        { code: "ID-SN", name: "South Sulawesi", i18n: {"id":"Sulawesi Selatan"} },
        { code: "ID-SS", name: "South Sumatra", i18n: {"id":"Sumatera Selatan"} },
        { code: "ID-SG", name: "Southeast Sulawesi", i18n: {"id":"Sulawesi Tenggara"} },
        { code: "ID-SL", name: "Sulawesi", i18n: {} },
        { code: "ID-SM", name: "Sumatra", i18n: {"id":"Sumatera"} },
        { code: "ID-JB", name: "West Java", i18n: {"id":"Jawa Barat"} },
        { code: "ID-KB", name: "West Kalimantan", i18n: {"id":"Kalimantan Barat"} },
        { code: "ID-NB", name: "West Nusa Tenggara", i18n: {"id":"Nusa Tenggara Barat"} },
        { code: "ID-PB", name: "West Papua", i18n: {"id":"Papua Barat"} },
        { code: "ID-SR", name: "West Sulawesi", i18n: {"id":"Sulawesi Barat"} },
        { code: "ID-SB", name: "West Sumatra", i18n: {"id":"Sumatera Barat"} },
        { code: "ID-YO", name: "Yogyakarta", i18n: {} },
    ],
    "IE": [
        { code: "IE-CW", name: "Carlow", i18n: {} },
        { code: "IE-CN", name: "Cavan", i18n: {} },
        { code: "IE-CE", name: "Clare", i18n: {} },
        { code: "IE-C", name: "Connacht", i18n: {} },
        { code: "IE-CO", name: "Cork", i18n: {} },
        { code: "IE-DL", name: "Donegal", i18n: {} },
        { code: "IE-D", name: "Dublin", i18n: {} },
        { code: "IE-G", name: "Galway", i18n: {} },
        { code: "IE-KY", name: "Kerry", i18n: {} },
        { code: "IE-KE", name: "Kildare", i18n: {} },
        { code: "IE-KK", name: "Kilkenny", i18n: {} },
        { code: "IE-LS", name: "Laois", i18n: {} },
        { code: "IE-L", name: "Leinster", i18n: {} },
        { code: "IE-LM", name: "Leitrim", i18n: {} },
        { code: "IE-LK", name: "Limerick", i18n: {} },
        { code: "IE-LD", name: "Longford", i18n: {} },
        { code: "IE-LH", name: "Louth", i18n: {} },
        { code: "IE-MO", name: "Mayo", i18n: {} },
        { code: "IE-MH", name: "Meath", i18n: {} },
        { code: "IE-MN", name: "Monaghan", i18n: {} },
        { code: "IE-M", name: "Munster", i18n: {} },
        { code: "IE-OY", name: "Offaly", i18n: {} },
        { code: "IE-RN", name: "Roscommon", i18n: {} },
        { code: "IE-SO", name: "Sligo", i18n: {} },
        { code: "IE-TA", name: "Tipperary", i18n: {} },
        { code: "IE-U", name: "Ulster", i18n: {} },
        { code: "IE-WD", name: "Waterford", i18n: {} },
        { code: "IE-WH", name: "Westmeath", i18n: {} },
        { code: "IE-WX", name: "Wexford", i18n: {} },
        { code: "IE-WW", name: "Wicklow", i18n: {} },
    ],
    "IL": [
        { code: "IL-M", name: "Central District", i18n: {"he":"מחוז המרכז"} },
        { code: "IL-HA", name: "Haifa District", i18n: {"he":"מחוז חיפה"} },
        { code: "IL-JM", name: "Jerusalem", i18n: {"he":"מחוז ירושלים"} },
        { code: "IL-Z", name: "Northern District", i18n: {"he":"מחוז הצפון"} },
        { code: "IL-D", name: "Southern District", i18n: {"he":"מחוז הדרום"} },
        { code: "IL-TA", name: "Tel Aviv District", i18n: {"he":"מחוז תל אביב"} },
    ],
    "IN": [
        { code: "IN-AN", name: "Andaman and Nicobar Islands", i18n: {"hi":"अण्डमान और निकोबार द्वीपसमूह"} },
        { code: "IN-AP", name: "Andhra Pradesh", i18n: {"hi":"आन्ध्र प्रदेश"} },
        { code: "IN-AR", name: "Arunachal Pradesh", i18n: {"hi":"अरुणाचल प्रदेश"} },
        { code: "IN-AS", name: "Assam", i18n: {"hi":"असम"} },
        { code: "IN-BR", name: "Bihar", i18n: {"hi":"बिहार"} },
        { code: "IN-CH", name: "Chandigarh", i18n: {"hi":"चण्डीगढ़"} },
        { code: "IN-CG", name: "Chhattīsgarh", i18n: {"hi":"छत्तीसगढ़"} },
        { code: "IN-DH", name: "Dādra and Nagar Haveli and Damān and Diu", i18n: {"hi":"दादरा और नगर हवेली और दमन और दीव"} },
        { code: "IN-DL", name: "Delhi", i18n: {"hi":"दिल्ली"} },
        { code: "IN-GA", name: "Goa", i18n: {"hi":"गोआ"} },
        { code: "IN-GJ", name: "Gujarat", i18n: {"hi":"गुजरात"} },
        { code: "IN-HR", name: "Haryana", i18n: {"hi":"हरियाणा"} },
        { code: "IN-HP", name: "Himachal Pradesh", i18n: {"hi":"हिमाचल प्रदेश"} },
        { code: "IN-JK", name: "Jammu and Kashmir", i18n: {"hi":"जम्मू और कश्मीर"} },
        { code: "IN-JH", name: "Jharkhand", i18n: {"hi":"झारखण्ड"} },
        { code: "IN-KA", name: "Karnataka", i18n: {"hi":"कर्नाटक"} },
        { code: "IN-KL", name: "Kerala", i18n: {"hi":"केरल"} },
        { code: "IN-LA", name: "Ladakh", i18n: {"hi":"लद्दाख़"} },
        { code: "IN-LD", name: "Lakshadweep", i18n: {"hi":"लक्षद्वीप"} },
        { code: "IN-MP", name: "Madhya Pradesh", i18n: {"hi":"मध्य प्रदेश"} },
        { code: "IN-MH", name: "Maharashtra", i18n: {"hi":"महाराष्ट्र"} },
        { code: "IN-MN", name: "Manipur", i18n: {"hi":"मणिपुर"} },
        { code: "IN-ML", name: "Meghalaya", i18n: {"hi":"मेघालय"} },
        { code: "IN-MZ", name: "Mizoram", i18n: {"hi":"मिज़ोरम"} },
        { code: "IN-NL", name: "Nagaland", i18n: {"hi":"नागालैण्ड"} },
        { code: "IN-OD", name: "Odisha", i18n: {"hi":"ओडिशा"} },
        { code: "IN-PY", name: "Puducherry", i18n: {"hi":"पुदुच्चेरी"} },
        { code: "IN-PB", name: "Punjab", i18n: {"hi":"पंजाब"} },
        { code: "IN-RJ", name: "Rajasthan", i18n: {"hi":"राजस्थान"} },
        { code: "IN-SK", name: "Sikkim", i18n: {"hi":"सिक्किम"} },
        { code: "IN-TN", name: "Tamil Nadu", i18n: {"hi":"तमिल नाडु"} },
        { code: "IN-TS", name: "Telangāna", i18n: {"hi":"तेलंगाना"} },
        { code: "IN-TR", name: "Tripura", i18n: {"hi":"त्रिपुरा"} },
        { code: "IN-UP", name: "Uttar Pradesh", i18n: {"hi":"उत्तर प्रदेश"} },
        { code: "IN-UK", name: "Uttarākhand", i18n: {"hi":"उत्तराखण्ड"} },
        { code: "IN-WB", name: "West Bengal", i18n: {"hi":"पश्चिम बंगाल"} },
    ],
    "IQ": [
        { code: "IQ-AN", name: "Al Anbar", i18n: {"ar":"محافظة الأنبار"} },
        { code: "IQ-MU", name: "Al Muthanna", i18n: {"ar":"محافظة المثنى"} },
        { code: "IQ-QA", name: "Al-Qādisiyyah", i18n: {"ar":"محافظة القادسية"} },
        { code: "IQ-BB", name: "Babylon", i18n: {"ar":"محافظة بابل"} },
        { code: "IQ-BG", name: "Baghdad", i18n: {"ar":"محافظة بغداد"} },
        { code: "IQ-BA", name: "Basra", i18n: {"ar":"محافظة البصرة"} },
        { code: "IQ-DQ", name: "Dhi Qar", i18n: {"ar":"ذي قار"} },
        { code: "IQ-DI", name: "Diyala", i18n: {"ar":"محافظة ديالى"} },
        { code: "IQ-DA", name: "Dohuk", i18n: {"ar":"دهوك"} },
        { code: "IQ-AR", name: "Erbil", i18n: {"ar":"أربيل"} },
        { code: "IQ-KA", name: "Karbala", i18n: {"ar":"كربلاء"} },
        { code: "IQ-KI", name: "Kirkuk", i18n: {"ar":"كركوك"} },
        { code: "IQ-KR", name: "Kurdistan", i18n: {} },
        { code: "IQ-MA", name: "Maysan", i18n: {"ar":"ميسان"} },
        { code: "IQ-NA", name: "Najaf", i18n: {"ar":"النجف"} },
        { code: "IQ-NI", name: "Nineveh", i18n: {"ar":"نينوى"} },
        { code: "IQ-SD", name: "Saladin", i18n: {"ar":"صلاح الدين"} },
        { code: "IQ-SU", name: "Sulaymaniyah", i18n: {"ar":"السليمانية"} },
        { code: "IQ-WA", name: "Wasit", i18n: {"ar":"واسط"} },
    ],
    "IR": [
        { code: "IR-03", name: "Ardabil", i18n: {"fa":"استان اردبیل"} },
        { code: "IR-06", name: "Bushehr", i18n: {"fa":"استان بوشهر"} },
        { code: "IR-08", name: "Chaharmahal and Bakhtiari", i18n: {"fa":"استان چهارمحال و بختیاری"} },
        { code: "IR-01", name: "East Azerbaijan", i18n: {"fa":"استان آذربایجان شرقی"} },
        { code: "IR-14", name: "Fars", i18n: {"fa":"استان فارس"} },
        { code: "IR-19", name: "Gilan", i18n: {"fa":"استان گیلان"} },
        { code: "IR-27", name: "Golestan", i18n: {"fa":"استان گلستان"} },
        { code: "IR-24", name: "Hamadan", i18n: {"fa":"استان همدان"} },
        { code: "IR-23", name: "Hormozgan", i18n: {"fa":"استان هرمزگان"} },
        { code: "IR-05", name: "Ilam", i18n: {"fa":"استان ایلام"} },
        { code: "IR-04", name: "Isfahan", i18n: {"fa":"استان اصفهان"} },
        { code: "IR-15", name: "Kerman", i18n: {"fa":"استان کرمان"} },
        { code: "IR-17", name: "Kermanshah", i18n: {"fa":"استان کرمانشاه"} },
        { code: "IR-09", name: "Khorāsān-e Raẕavī", i18n: {"fa":"استان خراسان رضوی²"} },
        { code: "IR-10", name: "Khuzestan", i18n: {"fa":"استان خوزستان"} },
        { code: "IR-18", name: "Kohgiluyeh and Boyer-Ahmad", i18n: {"fa":"استان کهگیلویه و بویراحمد"} },
        { code: "IR-16", name: "Kurdistan", i18n: {"fa":"استان کردستان"} },
        { code: "IR-20", name: "Lorestan", i18n: {"fa":"استان لرستان"} },
        { code: "IR-22", name: "Markazi", i18n: {"fa":"استان مرکزی"} },
        { code: "IR-00", name: "Markazī", i18n: {"fa":"استان مرکزی²"} },
        { code: "IR-21", name: "Mazandaran", i18n: {"fa":"استان مازندران"} },
        { code: "IR-28", name: "Qazvin", i18n: {"fa":"استان قزوین"} },
        { code: "IR-26", name: "Qom", i18n: {"fa":"استان قم"} },
        { code: "IR-30", name: "Razavi Khorasan", i18n: {"fa":"استان خراسان رضوی"} },
        { code: "IR-12", name: "Semnan", i18n: {"fa":"استان سمنان"} },
        { code: "IR-13", name: "Sistan and Baluchestan", i18n: {"fa":"استان سیستان و بلوچستان"} },
        { code: "IR-29", name: "South Khorasan", i18n: {"fa":"استان خراسان جنوبی"} },
        { code: "IR-07", name: "Tehran", i18n: {"fa":"استان تهران"} },
        { code: "IR-02", name: "West Azarbaijan", i18n: {"fa":"استان آذربایجان غربی"} },
        { code: "IR-25", name: "Yazd", i18n: {"fa":"استان یزد"} },
        { code: "IR-11", name: "Zanjan", i18n: {"fa":"استان زنجان"} },
    ],
    "IS": [
        { code: "IS-AKN", name: "Akraneskaupstaður", i18n: {} },
        { code: "IS-AKU", name: "Akureyrarbær", i18n: {"is":"Akureyri"} },
        { code: "IS-ARN", name: "Árneshreppur", i18n: {} },
        { code: "IS-ASA", name: "Ásahreppur", i18n: {} },
        { code: "IS-BLA", name: "Bláskógabyggð", i18n: {} },
        { code: "IS-BOL", name: "Bolungarvíkurkaupstaður", i18n: {} },
        { code: "IS-BOG", name: "Borgarbyggð", i18n: {} },
        { code: "IS-1", name: "Capital", i18n: {"is":"Höfuðborgarsvæðið"} },
        { code: "IS-DAB", name: "Dalabyggð", i18n: {} },
        { code: "IS-DAV", name: "Dalvíkurbyggð", i18n: {} },
        { code: "IS-7", name: "Eastern", i18n: {"is":"Austurland"} },
        { code: "IS-EOM", name: "Eyja- og Miklaholtshreppur", i18n: {} },
        { code: "IS-EYF", name: "Eyjafjarðarsveit", i18n: {} },
        { code: "IS-FJL", name: "Fjallabyggð", i18n: {} },
        { code: "IS-FJD", name: "Fjarðabyggð", i18n: {} },
        { code: "IS-FLR", name: "Fljótsdalshreppur", i18n: {} },
        { code: "IS-FLA", name: "Flóahreppur", i18n: {} },
        { code: "IS-GAR", name: "Garðabær", i18n: {} },
        { code: "IS-GOG", name: "Grímsnes- og Grafningshreppur", i18n: {} },
        { code: "IS-GRN", name: "Grindavíkurbær", i18n: {} },
        { code: "IS-GRU", name: "Grundarfjarðarbær", i18n: {} },
        { code: "IS-GRY", name: "Grýtubakkahreppur", i18n: {} },
        { code: "IS-HAF", name: "Hafnarfjarðarkaupstaður", i18n: {"is":"Hafnarfjörður"} },
        { code: "IS-HRG", name: "Hörgársveit", i18n: {} },
        { code: "IS-HRU", name: "Hrunamannahreppur", i18n: {} },
        { code: "IS-HUG", name: "Húnabyggð", i18n: {} },
        { code: "IS-HUV", name: "Húnaþing vestra", i18n: {} },
        { code: "IS-HVA", name: "Hvalfjarðarsveit", i18n: {} },
        { code: "IS-HVE", name: "Hveragerðisbær", i18n: {} },
        { code: "IS-ISA", name: "Ísafjarðarbær", i18n: {} },
        { code: "IS-KAL", name: "Kaldrananeshreppur", i18n: {} },
        { code: "IS-KJO", name: "Kjósarhreppur", i18n: {} },
        { code: "IS-KOP", name: "Kópavogsbær", i18n: {"is":"Kópavogur"} },
        { code: "IS-LAN", name: "Langanesbyggð", i18n: {} },
        { code: "IS-MOS", name: "Mosfellsbær", i18n: {} },
        { code: "IS-MUL", name: "Múlaþing", i18n: {} },
        { code: "IS-MYR", name: "Mýrdalshreppur", i18n: {} },
        { code: "IS-NOR", name: "Norðurþing", i18n: {} },
        { code: "IS-6", name: "Northeastern", i18n: {"is":"Norðurland eystra"} },
        { code: "IS-5", name: "Northwestern", i18n: {"is":"Norðurland vestra"} },
        { code: "IS-RGE", name: "Rangárþing eystra", i18n: {} },
        { code: "IS-RGY", name: "Rangárþing ytra", i18n: {} },
        { code: "IS-RHH", name: "Reykhólahreppur", i18n: {} },
        { code: "IS-RKN", name: "Reykjanesbær", i18n: {} },
        { code: "IS-RKV", name: "Reykjavíkurborg", i18n: {"is":"Reykjavík"} },
        { code: "IS-SEL", name: "Seltjarnarnesbær", i18n: {"is":"Seltjarnarnes"} },
        { code: "IS-SKF", name: "Skaftárhreppur", i18n: {} },
        { code: "IS-SKG", name: "Skagabyggð", i18n: {} },
        { code: "IS-SKR", name: "Skagafjörður", i18n: {"is":"Sveitarfélagið Skagafjörður"} },
        { code: "IS-SOG", name: "Skeiða- og Gnúpverjahreppur", i18n: {} },
        { code: "IS-SKO", name: "Skorradalshreppur", i18n: {} },
        { code: "IS-SNF", name: "Snæfellsbær", i18n: {} },
        { code: "IS-8", name: "Southern", i18n: {"is":"Suðurland"} },
        { code: "IS-2", name: "Southern Peninsula", i18n: {"is":"Suðurnes"} },
        { code: "IS-STR", name: "Strandabyggð", i18n: {} },
        { code: "IS-STY", name: "Stykkishólmsbær", i18n: {} },
        { code: "IS-SDV", name: "Súðavíkurhreppur", i18n: {} },
        { code: "IS-SDN", name: "Suðurnesjabær", i18n: {} },
        { code: "IS-SBT", name: "Svalbarðsstrandarhreppur", i18n: {} },
        { code: "IS-SFA", name: "Sveitarfélagið Árborg", i18n: {} },
        { code: "IS-SHF", name: "Sveitarfélagið Hornafjörður", i18n: {} },
        { code: "IS-SOL", name: "Sveitarfélagið Ölfus", i18n: {} },
        { code: "IS-SSS", name: "Sveitarfélagið Skagaströnd", i18n: {} },
        { code: "IS-SVG", name: "Sveitarfélagið Vogar", i18n: {} },
        { code: "IS-TAL", name: "Tálknafjarðarhreppur", i18n: {} },
        { code: "IS-TJO", name: "Tjörneshreppur", i18n: {} },
        { code: "IS-VEM", name: "Vestmannaeyjabær", i18n: {"is":"Vestmannaeyjar"} },
        { code: "IS-VER", name: "Vesturbyggð", i18n: {} },
        { code: "IS-VOP", name: "Vopnafjarðarhreppur", i18n: {} },
        { code: "IS-3", name: "Western", i18n: {"is":"Vesturland"} },
        { code: "IS-4", name: "Westfjords", i18n: {"is":"Vestfirðir"} },
        { code: "IS-THG", name: "Þingeyjarsveit", i18n: {} },
    ],
    "IT": [
        { code: "IT-65", name: "Abruzzo", i18n: {} },
        { code: "IT-AG", name: "Agrigento", i18n: {"it":"provincia di Agrigento"} },
        { code: "IT-AL", name: "Alessandria", i18n: {"it":"provincia di Alessandria"} },
        { code: "IT-AN", name: "Ancona", i18n: {"it":"provincia di Ancona"} },
        { code: "IT-23", name: "Aosta Valley", i18n: {"it":"Valle d’Aosta"} },
        { code: "IT-75", name: "Apulia", i18n: {"it":"Puglia"} },
        { code: "IT-AR", name: "Arezzo", i18n: {"it":"provincia di Arezzo"} },
        { code: "IT-AP", name: "Ascoli Piceno", i18n: {"it":"provincia di Ascoli Piceno"} },
        { code: "IT-AT", name: "Asti", i18n: {"it":"provincia di Asti"} },
        { code: "IT-AV", name: "Avellino", i18n: {"it":"provincia di Avellino"} },
        { code: "IT-BA", name: "Bari", i18n: {"it":"provincia di Bari"} },
        { code: "IT-BT", name: "Barletta-Andria-Trani", i18n: {"it":"provincia di Barletta-Andria-Trani"} },
        { code: "IT-77", name: "Basilicata", i18n: {} },
        { code: "IT-BL", name: "Belluno", i18n: {"it":"provincia di Belluno"} },
        { code: "IT-BN", name: "Benevento", i18n: {"it":"provincia di Benevento"} },
        { code: "IT-BG", name: "Bergamo", i18n: {"it":"provincia di Bergamo"} },
        { code: "IT-BI", name: "Biella", i18n: {"it":"provincia di Biella"} },
        { code: "IT-BO", name: "Bologna", i18n: {"it":"provincia di Bologna"} },
        { code: "IT-BS", name: "Brescia", i18n: {"it":"provincia di Brescia"} },
        { code: "IT-BR", name: "Brindisi", i18n: {"it":"provincia di Brindisi"} },
        { code: "IT-CA", name: "Cagliari", i18n: {"it":"provincia di Cagliari"} },
        { code: "IT-78", name: "Calabria", i18n: {} },
        { code: "IT-CL", name: "Caltanissetta", i18n: {"it":"provincia di Caltanissetta"} },
        { code: "IT-72", name: "Campania", i18n: {} },
        { code: "IT-CB", name: "Campobasso", i18n: {"it":"provincia di Campobasso"} },
        { code: "IT-CE", name: "Caserta", i18n: {"it":"provincia di Caserta"} },
        { code: "IT-CT", name: "Catania", i18n: {"it":"provincia di Catania"} },
        { code: "IT-CZ", name: "Catanzaro", i18n: {"it":"provincia di Catanzaro"} },
        { code: "IT-CH", name: "Chieti", i18n: {"it":"provincia di Chieti"} },
        { code: "IT-CO", name: "Como", i18n: {"it":"provincia di Como"} },
        { code: "IT-CS", name: "Cosenza", i18n: {"it":"provincia di Cosenza"} },
        { code: "IT-CR", name: "Cremona", i18n: {"it":"provincia di Cremona"} },
        { code: "IT-KR", name: "Crotone", i18n: {"it":"provincia di Crotone"} },
        { code: "IT-CN", name: "Cuneo", i18n: {"it":"Provincia di Cuneo"} },
        { code: "IT-45", name: "Emilia-Romagna", i18n: {} },
        { code: "IT-EN", name: "Enna", i18n: {"it":"provincia di Enna"} },
        { code: "IT-FM", name: "Fermo", i18n: {"it":"provincia di Fermo"} },
        { code: "IT-FE", name: "Ferrara", i18n: {"it":"provincia di Ferrara"} },
        { code: "IT-FI", name: "Florence", i18n: {"it":"provincia di Firenze"} },
        { code: "IT-FG", name: "Foggia", i18n: {"it":"provincia di Foggia"} },
        { code: "IT-FC", name: "Forlì-Cesena", i18n: {"it":"provincia di Forlì-Cesena"} },
        { code: "IT-36", name: "Friuli–Venezia Giulia", i18n: {"it":"Friuli-Venezia Giulia"} },
        { code: "IT-FR", name: "Frosinone", i18n: {"it":"provincia di Frosinone"} },
        { code: "IT-GE", name: "Genoa", i18n: {"it":"città metropolitana di Genova"} },
        { code: "IT-GO", name: "Gorizia", i18n: {"it":"provincia di Gorizia"} },
        { code: "IT-GR", name: "Grosseto", i18n: {"it":"provincia di Grosseto"} },
        { code: "IT-IM", name: "Imperia", i18n: {"it":"provincia di Imperia"} },
        { code: "IT-IS", name: "Isernia", i18n: {"it":"provincia di Isernia"} },
        { code: "IT-AQ", name: "L’Aquila", i18n: {"it":"provincia dell’Aquila"} },
        { code: "IT-SP", name: "La Spezia", i18n: {"it":"provincia della Spezia"} },
        { code: "IT-LT", name: "Latina", i18n: {"it":"provincia di Latina"} },
        { code: "IT-62", name: "Lazio", i18n: {} },
        { code: "IT-LE", name: "Lecce", i18n: {"it":"provincia di Lecce"} },
        { code: "IT-LC", name: "Lecco", i18n: {"it":"provincia di Lecco"} },
        { code: "IT-42", name: "Liguria", i18n: {} },
        { code: "IT-LI", name: "Livorno", i18n: {"it":"provincia di Livorno"} },
        { code: "IT-LO", name: "Lodi", i18n: {"it":"provincia di Lodi"} },
        { code: "IT-25", name: "Lombardy", i18n: {"it":"Lombardia"} },
        { code: "IT-LU", name: "Lucca", i18n: {"it":"provincia di Lucca"} },
        { code: "IT-MC", name: "Macerata", i18n: {"it":"provincia di Macerata"} },
        { code: "IT-MN", name: "Mantua", i18n: {"it":"provincia di Mantova"} },
        { code: "IT-57", name: "Marche", i18n: {} },
        { code: "IT-MS", name: "Massa and Carrara", i18n: {"it":"provincia di Massa e Carrara"} },
        { code: "IT-MT", name: "Matera", i18n: {"it":"provincia di Matera"} },
        { code: "IT-ME", name: "Messina", i18n: {"it":"provincia di Messina"} },
        { code: "IT-MI", name: "Milan", i18n: {"it":"provincia di Milano"} },
        { code: "IT-MO", name: "Modena", i18n: {"it":"provincia di Modena"} },
        { code: "IT-67", name: "Molise", i18n: {} },
        { code: "IT-MB", name: "Monza and Brianza", i18n: {"it":"provincia di Monza e della Brianza"} },
        { code: "IT-NA", name: "Naples", i18n: {"it":"città metropolitana di Napoli"} },
        { code: "IT-NO", name: "Novara", i18n: {"it":"provincia di Novara"} },
        { code: "IT-NU", name: "Nuoro", i18n: {"it":"provincia di Nuoro"} },
        { code: "IT-OR", name: "Oristano", i18n: {"it":"provincia di Oristano"} },
        { code: "IT-PD", name: "Padua", i18n: {"it":"provincia di Padova"} },
        { code: "IT-PA", name: "Palermo", i18n: {"it":"provincia di Palermo"} },
        { code: "IT-PR", name: "Parma", i18n: {"it":"provincia di Parma"} },
        { code: "IT-PV", name: "Pavia", i18n: {"it":"provincia di Pavia"} },
        { code: "IT-PG", name: "Perugia", i18n: {"it":"provincia di Perugia"} },
        { code: "IT-PU", name: "Pesaro and Urbino", i18n: {"it":"provincia di Pesaro e Urbino"} },
        { code: "IT-PE", name: "Pescara", i18n: {"it":"provincia di Pescara"} },
        { code: "IT-PC", name: "Piacenza", i18n: {"it":"provincia di Piacenza"} },
        { code: "IT-21", name: "Piedmont", i18n: {"it":"Piemonte"} },
        { code: "IT-PI", name: "Pisa", i18n: {"it":"provincia di Pisa"} },
        { code: "IT-PT", name: "Pistoia", i18n: {"it":"provincia di Pistoia"} },
        { code: "IT-PN", name: "Pordenone", i18n: {"it":"provincia di Pordenone"} },
        { code: "IT-PZ", name: "Potenza", i18n: {"it":"provincia di Potenza"} },
        { code: "IT-PO", name: "Prato", i18n: {"it":"provincia di Prato"} },
        { code: "IT-RG", name: "Ragusa", i18n: {"it":"provincia di Ragusa"} },
        { code: "IT-RA", name: "Ravenna", i18n: {"it":"provincia di Ravenna"} },
        { code: "IT-RC", name: "Reggio Calabria", i18n: {"it":"provincia di Reggio Calabria"} },
        { code: "IT-RE", name: "Reggio Emilia", i18n: {"it":"provincia di Reggio nell’Emilia"} },
        { code: "IT-RI", name: "Rieti", i18n: {"it":"provincia di Rieti"} },
        { code: "IT-RN", name: "Rimini", i18n: {"it":"provincia di Rimini"} },
        { code: "IT-RM", name: "Rome", i18n: {"it":"provincia di Roma"} },
        { code: "IT-RO", name: "Rovigo", i18n: {"it":"provincia di Rovigo"} },
        { code: "IT-SA", name: "Salerno", i18n: {"it":"provincia di Salerno"} },
        { code: "IT-88", name: "Sardinia", i18n: {"it":"Sardegna"} },
        { code: "IT-SS", name: "Sassari", i18n: {"it":"provincia di Sassari"} },
        { code: "IT-SV", name: "Savona", i18n: {"it":"provincia di Savona"} },
        { code: "IT-82", name: "Sicily", i18n: {"it":"Regione Siciliana"} },
        { code: "IT-SI", name: "Siena", i18n: {"it":"provincia di Siena"} },
        { code: "IT-SO", name: "Sondrio", i18n: {"it":"provincia di Sondrio"} },
        { code: "IT-BZ", name: "South Tyrol", i18n: {"it":"provincia autonoma di Bolzano"} },
        { code: "IT-SU", name: "Sud Sardegna", i18n: {"it":"provincia del Sud Sardegna"} },
        { code: "IT-SR", name: "Syracuse", i18n: {"it":"provincia di Siracusa"} },
        { code: "IT-TA", name: "Taranto", i18n: {"it":"provincia di Taranto"} },
        { code: "IT-TE", name: "Teramo", i18n: {"it":"provincia di Teramo"} },
        { code: "IT-TR", name: "Terni", i18n: {"it":"provincia di Terni"} },
        { code: "IT-TP", name: "Trapani", i18n: {"it":"provincia di Trapani"} },
        { code: "IT-TN", name: "Trentino", i18n: {"it":"provincia autonoma di Trento"} },
        { code: "IT-32", name: "Trentino-South Tyrol", i18n: {"it":"Trentino-Alto Adige"} },
        { code: "IT-TV", name: "Treviso", i18n: {"it":"provincia di Treviso"} },
        { code: "IT-TS", name: "Trieste", i18n: {"it":"provincia di Trieste"} },
        { code: "IT-TO", name: "Turin", i18n: {"it":"provincia di Torino"} },
        { code: "IT-52", name: "Tuscany", i18n: {"it":"Toscana"} },
        { code: "IT-UD", name: "Udine", i18n: {"it":"provincia di Udine"} },
        { code: "IT-55", name: "Umbria", i18n: {} },
        { code: "IT-VA", name: "Varese", i18n: {"it":"provincia di Varese"} },
        { code: "IT-34", name: "Veneto", i18n: {} },
        { code: "IT-VE", name: "Venice", i18n: {"it":"provincia di Venezia"} },
        { code: "IT-VB", name: "Verbano-Cusio-Ossola", i18n: {"it":"provincia del Verbano-Cusio-Ossola"} },
        { code: "IT-VC", name: "Vercelli", i18n: {"it":"provincia di Vercelli"} },
        { code: "IT-VR", name: "Verona", i18n: {"it":"provincia di Verona"} },
        { code: "IT-VV", name: "Vibo Valentia", i18n: {"it":"provincia di Vibo Valentia"} },
        { code: "IT-VI", name: "Vicenza", i18n: {"it":"provincia di Vicenza"} },
        { code: "IT-VT", name: "Viterbo", i18n: {"it":"provincia di Viterbo"} },
    ],
    "JM": [
        { code: "JM-13", name: "Clarendon", i18n: {} },
        { code: "JM-09", name: "Hanover", i18n: {} },
        { code: "JM-01", name: "Kingston", i18n: {} },
        { code: "JM-12", name: "Manchester", i18n: {} },
        { code: "JM-04", name: "Portland", i18n: {} },
        { code: "JM-02", name: "Saint Andrew", i18n: {} },
        { code: "JM-06", name: "Saint Ann", i18n: {} },
        { code: "JM-14", name: "Saint Catherine", i18n: {} },
        { code: "JM-11", name: "Saint Elizabeth", i18n: {} },
        { code: "JM-08", name: "Saint James", i18n: {} },
        { code: "JM-05", name: "Saint Mary", i18n: {} },
        { code: "JM-03", name: "Saint Thomas", i18n: {} },
        { code: "JM-07", name: "Trelawny", i18n: {} },
        { code: "JM-10", name: "Westmoreland", i18n: {} },
    ],
    "JO": [
        { code: "JO-AJ", name: "Ajloun", i18n: {"ar":"عجلون"} },
        { code: "JO-AM", name: "Amman", i18n: {"ar":"محافظة العاصمة"} },
        { code: "JO-AQ", name: "Aqaba", i18n: {"ar":"العقبة"} },
        { code: "JO-BA", name: "Balqa", i18n: {"ar":"البلقاء"} },
        { code: "JO-IR", name: "Irbid", i18n: {"ar":"إربد"} },
        { code: "JO-JA", name: "Jerash", i18n: {"ar":"جرش"} },
        { code: "JO-KA", name: "Karak", i18n: {"ar":"الكرك"} },
        { code: "JO-MN", name: "Ma’an", i18n: {"ar":"معان"} },
        { code: "JO-MD", name: "Madaba", i18n: {"ar":"مادبا"} },
        { code: "JO-MA", name: "Mafraq", i18n: {"ar":"المفرق"} },
        { code: "JO-AT", name: "Tafilah", i18n: {"ar":"الطفيلة"} },
        { code: "JO-AZ", name: "Zarqa", i18n: {"ar":"الزرقاء"} },
    ],
    "JP": [
        { code: "JP-23", name: "Aichi", i18n: {"ja":"愛知県"} },
        { code: "JP-05", name: "Akita", i18n: {"ja":"秋田県"} },
        { code: "JP-02", name: "Aomori", i18n: {"ja":"青森県"} },
        { code: "JP-12", name: "Chiba", i18n: {"ja":"千葉県"} },
        { code: "JP-38", name: "Ehime", i18n: {"ja":"愛媛県"} },
        { code: "JP-18", name: "Fukui", i18n: {"ja":"福井県"} },
        { code: "JP-40", name: "Fukuoka", i18n: {"ja":"福岡県"} },
        { code: "JP-07", name: "Fukushima", i18n: {"ja":"福島県"} },
        { code: "JP-21", name: "Gifu", i18n: {"ja":"岐阜県"} },
        { code: "JP-10", name: "Gunma", i18n: {"ja":"群馬県"} },
        { code: "JP-34", name: "Hiroshima", i18n: {"ja":"広島県"} },
        { code: "JP-01", name: "Hokkaidō", i18n: {"ja":"北海道"} },
        { code: "JP-28", name: "Hyōgo", i18n: {"ja":"兵庫県"} },
        { code: "JP-08", name: "Ibaraki", i18n: {"ja":"茨城県"} },
        { code: "JP-17", name: "Ishikawa", i18n: {"ja":"石川県"} },
        { code: "JP-03", name: "Iwate", i18n: {"ja":"岩手県"} },
        { code: "JP-37", name: "Kagawa", i18n: {"ja":"香川県"} },
        { code: "JP-46", name: "Kagoshima", i18n: {"ja":"鹿児島県"} },
        { code: "JP-14", name: "Kanagawa", i18n: {"ja":"神奈川県"} },
        { code: "JP-39", name: "Kōchi", i18n: {"ja":"高知県"} },
        { code: "JP-43", name: "Kumamoto", i18n: {"ja":"熊本県"} },
        { code: "JP-26", name: "Kyōto", i18n: {"ja":"京都府"} },
        { code: "JP-24", name: "Mie", i18n: {"ja":"三重県"} },
        { code: "JP-04", name: "Miyagi", i18n: {"ja":"宮城県"} },
        { code: "JP-45", name: "Miyazaki", i18n: {"ja":"宮崎県"} },
        { code: "JP-20", name: "Nagano", i18n: {"ja":"長野県"} },
        { code: "JP-42", name: "Nagasaki", i18n: {"ja":"長崎県"} },
        { code: "JP-29", name: "Nara", i18n: {"ja":"奈良県"} },
        { code: "JP-15", name: "Niigata", i18n: {"ja":"新潟県"} },
        { code: "JP-44", name: "Ōita", i18n: {"ja":"大分県"} },
        { code: "JP-33", name: "Okayama", i18n: {"ja":"岡山県"} },
        { code: "JP-47", name: "Okinawa", i18n: {"ja":"沖縄県"} },
        { code: "JP-27", name: "Ōsaka", i18n: {"ja":"大阪府"} },
        { code: "JP-41", name: "Saga", i18n: {"ja":"佐賀県"} },
        { code: "JP-11", name: "Saitama", i18n: {"ja":"埼玉県"} },
        { code: "JP-25", name: "Shiga", i18n: {"ja":"滋賀県"} },
        { code: "JP-32", name: "Shimane", i18n: {"ja":"島根県"} },
        { code: "JP-22", name: "Shizuoka", i18n: {"ja":"静岡県"} },
        { code: "JP-09", name: "Tochigi", i18n: {"ja":"栃木県"} },
        { code: "JP-36", name: "Tokushima", i18n: {"ja":"徳島県"} },
        { code: "JP-13", name: "Tokyo", i18n: {"ja":"東京都"} },
        { code: "JP-31", name: "Tottori", i18n: {"ja":"鳥取県"} },
        { code: "JP-16", name: "Toyama", i18n: {"ja":"富山県"} },
        { code: "JP-30", name: "Wakayama", i18n: {"ja":"和歌山県"} },
        { code: "JP-06", name: "Yamagata", i18n: {"ja":"山形県"} },
        { code: "JP-35", name: "Yamaguchi", i18n: {"ja":"山口県"} },
        { code: "JP-19", name: "Yamanashi", i18n: {"ja":"山梨県"} },
    ],
    "KE": [
        { code: "KE-01", name: "Baringo", i18n: {"sw":"Wilaya ya Baringo"} },
        { code: "KE-02", name: "Bomet", i18n: {"sw":"Wilaya ya Bomet"} },
        { code: "KE-03", name: "Bungoma", i18n: {"sw":"Wilaya ya Bungoma"} },
        { code: "KE-04", name: "Busia", i18n: {"sw":"Wilaya ya Busia, Kenya"} },
        { code: "KE-05", name: "Elgeyo-Marakwet", i18n: {"sw":"Kaunti ya Elgeyo-Marakwet"} },
        { code: "KE-06", name: "Embu", i18n: {"sw":"Wilaya ya Embu"} },
        { code: "KE-07", name: "Garissa", i18n: {"sw":"Wilaya ya Garissa"} },
        { code: "KE-08", name: "Homa Bay", i18n: {"sw":"Wilaya ya Homa Bay"} },
        { code: "KE-09", name: "Isiolo", i18n: {"sw":"Wilaya ya Isiolo"} },
        { code: "KE-10", name: "Kajiado", i18n: {"sw":"Wilaya ya Kajiado"} },
        { code: "KE-11", name: "Kakamega", i18n: {"sw":"Wilaya ya Kakamega"} },
        { code: "KE-12", name: "Kericho", i18n: {"sw":"Wilaya ya Kericho"} },
        { code: "KE-13", name: "Kiambu", i18n: {"sw":"Wilaya ya Kiambu"} },
        { code: "KE-14", name: "Kilifi", i18n: {"sw":"Wilaya ya Kilifi"} },
        { code: "KE-15", name: "Kirinyaga", i18n: {"sw":"Wilaya ya Kirinyaga"} },
        { code: "KE-16", name: "Kisii", i18n: {"sw":"Wilaya ya Kisii Kati"} },
        { code: "KE-17", name: "Kisumu", i18n: {"sw":"Wilaya ya Kisumu"} },
        { code: "KE-18", name: "Kitui", i18n: {"sw":"Wilaya ya Kitui"} },
        { code: "KE-19", name: "Kwale", i18n: {"sw":"Wilaya ya Kwale"} },
        { code: "KE-20", name: "Laikipia", i18n: {"sw":"Wilaya ya Laikipia"} },
        { code: "KE-21", name: "Lamu", i18n: {"sw":"Wilaya ya Lamu"} },
        { code: "KE-22", name: "Machakos", i18n: {"sw":"Wilaya ya Machakos"} },
        { code: "KE-23", name: "Makueni", i18n: {"sw":"Wilaya ya Makueni"} },
        { code: "KE-24", name: "Mandera", i18n: {"sw":"Wilaya ya Mandera"} },
        { code: "KE-25", name: "Marsabit", i18n: {"sw":"Wilaya ya Marsabit"} },
        { code: "KE-26", name: "Meru", i18n: {"sw":"Kaunti ya Meru"} },
        { code: "KE-27", name: "Migori", i18n: {"sw":"Wilaya ya Migori"} },
        { code: "KE-28", name: "Mombasa", i18n: {"sw":"Wilaya ya Mombasa"} },
        { code: "KE-29", name: "Murang’a", i18n: {"sw":"Wilaya ya Murang’a"} },
        { code: "KE-30", name: "Nairobi County", i18n: {"sw":"Kaunti ya Nairobi"} },
        { code: "KE-31", name: "Nakuru", i18n: {"sw":"Wilaya ya Nakuru"} },
        { code: "KE-32", name: "Nandi", i18n: {"sw":"Wilaya ya Nandi"} },
        { code: "KE-33", name: "Narok", i18n: {"sw":"Wilaya ya Narok"} },
        { code: "KE-34", name: "Nyamira", i18n: {"sw":"Wilaya ya Nyamira"} },
        { code: "KE-35", name: "Nyandarua", i18n: {"sw":"Wilaya ya Nyandarua"} },
        { code: "KE-36", name: "Nyeri", i18n: {"sw":"Wilaya ya Nyeri"} },
        { code: "KE-37", name: "Samburu", i18n: {"sw":"Wilaya ya Samburu"} },
        { code: "KE-38", name: "Siaya", i18n: {"sw":"Wilaya ya Siaya"} },
        { code: "KE-39", name: "Taita-Taveta", i18n: {"sw":"Wilaya ya Taita-Taveta"} },
        { code: "KE-40", name: "Tana River", i18n: {"sw":"Wilaya ya Mto Tana"} },
        { code: "KE-41", name: "Tharaka-Nithi", i18n: {"sw":"Wilaya ya Tharaka"} },
        { code: "KE-42", name: "Trans Nzoia", i18n: {"sw":"Wilaya ya Trans-Nzoia"} },
        { code: "KE-43", name: "Turkana", i18n: {"sw":"Wilaya ya Turkana"} },
        { code: "KE-44", name: "Uasin Gishu", i18n: {"sw":"Wilaya ya Uasin Gishu"} },
        { code: "KE-45", name: "Vihiga", i18n: {"sw":"Wilaya ya Vihiga"} },
        { code: "KE-46", name: "Wajir", i18n: {"sw":"Wilaya ya Wajir"} },
        { code: "KE-47", name: "West Pokot", i18n: {"sw":"Wilaya ya Pokot Magharibi"} },
    ],
    "KG": [
        { code: "KG-B", name: "Batken", i18n: {"ky":"Баткен облусу"} },
        { code: "KG-GB", name: "Bishkek", i18n: {"ky":"Бишкек"} },
        { code: "KG-C", name: "Chuy", i18n: {"ky":"Чүй облусу"} },
        { code: "KG-Y", name: "Issyk-Kul", i18n: {"ky":"Ысык-Көл областы"} },
        { code: "KG-J", name: "Jalal-Abad", i18n: {"ky":"Жалал-Абад облусу"} },
        { code: "KG-N", name: "Naryn", i18n: {"ky":"Нарын облусу"} },
        { code: "KG-GO", name: "Osh", i18n: {"ky":"Ош"} },
        { code: "KG-O", name: "Osh Region", i18n: {"ky":"Ош облусу"} },
        { code: "KG-T", name: "Talas", i18n: {"ky":"Талас облусу"} },
    ],
    "KH": [
        { code: "KH-1", name: "Banteay Meanchey", i18n: {"km":"ខេត្តបន្ទាយមានជ័យ"} },
        { code: "KH-2", name: "Battambang", i18n: {"km":"ខេត្តបាត់ដំបង"} },
        { code: "KH-3", name: "Kampong Cham", i18n: {"km":"ខេត្ត​កំពង់ចាម"} },
        { code: "KH-4", name: "Kampong Chhnang", i18n: {"km":"ខេត្តកំពង់ឆ្នាំង"} },
        { code: "KH-5", name: "Kampong Speu", i18n: {"km":"ខេត្តកំពង់ស្ពឺ"} },
        { code: "KH-6", name: "Kampong Thom", i18n: {"km":"ខេត្តកំពង់ធំ"} },
        { code: "KH-7", name: "Kampot", i18n: {"km":"ខេត្តកំពត"} },
        { code: "KH-8", name: "Kandal", i18n: {"km":"ខេត្តកណ្ដាល"} },
        { code: "KH-23", name: "Kep", i18n: {"km":"ខេត្ត កែប"} },
        { code: "KH-9", name: "Koh Kong", i18n: {"km":"ខេត្តកោះកុង"} },
        { code: "KH-10", name: "Kratié", i18n: {"km":"ខេត្ត ក្រចេះ"} },
        { code: "KH-11", name: "Mondulkiri", i18n: {"km":"ខេត្តមណ្ឌលគិរី"} },
        { code: "KH-22", name: "Oddar Meanchey", i18n: {"km":"ខេត្តឧត្ដរមានជ័យ"} },
        { code: "KH-24", name: "Pailin", i18n: {"km":"ខេត្ត ប៉ៃលិន"} },
        { code: "KH-12", name: "Phnom Penh", i18n: {"km":"ភ្នំពេញ"} },
        { code: "KH-13", name: "Preah Vihear", i18n: {"km":"ខេត្តព្រះវិហារ"} },
        { code: "KH-14", name: "Prey Veng", i18n: {"km":"ខេត្តព្រៃវែង"} },
        { code: "KH-15", name: "Pursat", i18n: {"km":"ខេត្តពោធិ៍សាត់"} },
        { code: "KH-16", name: "Ratanakiri", i18n: {"km":"ខេត្ត រតនគិរី"} },
        { code: "KH-17", name: "Siem Reap", i18n: {"km":"ខេត្តសៀមរាប"} },
        { code: "KH-18", name: "Sihanoukville", i18n: {"km":"ខេត្ត ព្រះសីហនុ"} },
        { code: "KH-19", name: "Stung Treng", i18n: {"km":"ខេត្តស្ទឹងត្រែង"} },
        { code: "KH-20", name: "Svay Rieng", i18n: {"km":"ខេត្តស្វាយរៀង"} },
        { code: "KH-21", name: "Takéo", i18n: {"km":"ខេត្តតាកែវ"} },
        { code: "KH-25", name: "Tbong Khmum", i18n: {"km":"ខេត្តត្បូងឃ្មុំ"} },
    ],
    "KI": [
        { code: "KI-G", name: "Gilbert Islands", i18n: {} },
        { code: "KI-L", name: "Line Islands", i18n: {} },
        { code: "KI-P", name: "Phoenix Islands", i18n: {} },
    ],
    "KM": [
        { code: "KM-A", name: "Anjouan", i18n: {"ar":"أنجوان"} },
        { code: "KM-G", name: "Grande Comore", i18n: {"ar":"القمر الكبرى"} },
        { code: "KM-M", name: "Mohéli", i18n: {"ar":"موهيلي"} },
    ],
    "KN": [
        { code: "KN-01", name: "Christ Church Nichola Town", i18n: {} },
        { code: "KN-N", name: "Nevis", i18n: {} },
        { code: "KN-02", name: "Saint Anne Sandy Point", i18n: {} },
        { code: "KN-03", name: "Saint George Basseterre", i18n: {} },
        { code: "KN-04", name: "Saint George Gingerland", i18n: {} },
        { code: "KN-05", name: "Saint James Windward", i18n: {} },
        { code: "KN-06", name: "Saint John Capisterre", i18n: {} },
        { code: "KN-07", name: "Saint John Figtree", i18n: {} },
        { code: "KN-K", name: "Saint Kitts", i18n: {} },
        { code: "KN-08", name: "Saint Mary Cayon", i18n: {} },
        { code: "KN-09", name: "Saint Paul Capisterre", i18n: {} },
        { code: "KN-10", name: "Saint Paul Charlestown", i18n: {} },
        { code: "KN-11", name: "Saint Peter Basseterre", i18n: {} },
        { code: "KN-12", name: "Saint Thomas Lowland", i18n: {} },
        { code: "KN-13", name: "Saint Thomas Middle Island", i18n: {} },
        { code: "KN-15", name: "Trinity Palmetto Point", i18n: {} },
    ],
    "KP": [
        { code: "KP-04", name: "Chagang", i18n: {"ko":"자강도"} },
        { code: "KP-15", name: "Kaeseong", i18n: {"ko":"개성시"} },
        { code: "KP-07", name: "Kangwon", i18n: {"ko":"강원도"} },
        { code: "KP-14", name: "Nampho", i18n: {"ko":"남포특별시"} },
        { code: "KP-09", name: "North Hamgyong", i18n: {"ko":"함경북도"} },
        { code: "KP-06", name: "North Hwanghae", i18n: {"ko":"황해북도"} },
        { code: "KP-03", name: "North Pyongan", i18n: {"ko":"평안북도"} },
        { code: "KP-01", name: "Pyongyang", i18n: {"ko":"평양직할시"} },
        { code: "KP-13", name: "Rason", i18n: {"ko":"라선특별시"} },
        { code: "KP-10", name: "Ryanggang", i18n: {"ko":"량강도"} },
        { code: "KP-08", name: "South Hamgyong", i18n: {"ko":"함경남도"} },
        { code: "KP-05", name: "South Hwanghae", i18n: {"ko":"황해남도"} },
        { code: "KP-02", name: "South Pyongan", i18n: {"ko":"평안남도"} },
    ],
    "KR": [
        { code: "KR-26", name: "Busan", i18n: {"ko":"부산광역시"} },
        { code: "KR-27", name: "Daegu", i18n: {"ko":"대구광역시"} },
        { code: "KR-30", name: "Daejeon", i18n: {"ko":"대전광역시"} },
        { code: "KR-42", name: "Gangwon", i18n: {"ko":"강원도"} },
        { code: "KR-29", name: "Gwangju City", i18n: {"ko":"광주광역시"} },
        { code: "KR-41", name: "Gyeonggi", i18n: {"ko":"경기도"} },
        { code: "KR-28", name: "Incheon", i18n: {"ko":"인천광역시"} },
        { code: "KR-49", name: "Jeju", i18n: {"ko":"제주특별자치도"} },
        { code: "KR-43", name: "North Chungcheong", i18n: {"ko":"충청북도"} },
        { code: "KR-47", name: "North Gyeongsang", i18n: {"ko":"경상북도"} },
        { code: "KR-45", name: "North Jeolla", i18n: {"ko":"전라북도"} },
        { code: "KR-50", name: "Sejong", i18n: {"ko":"세종특별자치시"} },
        { code: "KR-11", name: "Seoul", i18n: {"ko":"서울특별시"} },
        { code: "KR-44", name: "South Chungcheong", i18n: {"ko":"충청남도"} },
        { code: "KR-48", name: "South Gyeongsang", i18n: {"ko":"경상남도"} },
        { code: "KR-46", name: "South Jeolla", i18n: {"ko":"전라남도"} },
        { code: "KR-31", name: "Ulsan", i18n: {"ko":"울산광역시"} },
    ],
    "KW": [
        { code: "KW-AH", name: "Al Ahmadi", i18n: {"ar":"محافظة الأحمدي"} },
        { code: "KW-KU", name: "Al Asimah", i18n: {"ar":"محافظة العاصمة"} },
        { code: "KW-FA", name: "Al Farwaniyah", i18n: {"ar":"محافظة الفروانية"} },
        { code: "KW-JA", name: "Al Jahra", i18n: {"ar":"محافظة الجهراء"} },
        { code: "KW-HA", name: "Hawalli", i18n: {"ar":"محافظة حولي"} },
        { code: "KW-MU", name: "Mubarak Al-Kabeer", i18n: {"ar":"محافظة مبارك الكبير"} },
    ],
    "KZ": [
        { code: "KZ-10", name: "Abay oblysy", i18n: {"ru":"Абайская область"} },
        { code: "KZ-75", name: "Almaty", i18n: {"ru":"Алматы"} },
        { code: "KZ-19", name: "Almaty oblysy", i18n: {"ru":"Алматинская область"} },
        { code: "KZ-11", name: "Aqmola oblysy", i18n: {"ru":"Акмолинская область"} },
        { code: "KZ-15", name: "Aqtöbe oblysy", i18n: {"ru":"Актюбинская область"} },
        { code: "KZ-71", name: "Astana", i18n: {"ru":"Астана"} },
        { code: "KZ-23", name: "Atyraū oblysy", i18n: {"ru":"Атырауская область"} },
        { code: "KZ-27", name: "Batys Qazaqstan oblysy", i18n: {"ru":"Западно-Казахстанская область"} },
        { code: "KZ-47", name: "Mangghystaū oblysy", i18n: {"ru":"Мангистауская область"} },
        { code: "KZ-55", name: "Pavlodar oblysy", i18n: {"ru":"Павлодарская область"} },
        { code: "KZ-35", name: "Qaraghandy oblysy", i18n: {"ru":"Карагандинская область"} },
        { code: "KZ-39", name: "Qostanay oblysy", i18n: {"ru":"Костанайская область"} },
        { code: "KZ-43", name: "Qyzylorda oblysy", i18n: {"ru":"Кызылординская область"} },
        { code: "KZ-63", name: "Shyghys Qazaqstan oblysy", i18n: {"ru":"Восточно-Казахстанская область"} },
        { code: "KZ-79", name: "Shymkent", i18n: {"ru":"Шымкент"} },
        { code: "KZ-59", name: "Soltüstik Qazaqstan oblysy", i18n: {"ru":"Северо-Казахстанская область"} },
        { code: "KZ-61", name: "Türkistan oblysy", i18n: {"ru":"Туркестанская область"} },
        { code: "KZ-62", name: "Ulytaū oblysy", i18n: {"ru":"Улытауская область"} },
        { code: "KZ-31", name: "Zhambyl oblysy", i18n: {"ru":"Жамбылская область"} },
        { code: "KZ-33", name: "Zhetisū oblysy", i18n: {"ru":"Жетысуская область"} },
    ],
    "LA": [
        { code: "LA-AT", name: "Attapeu", i18n: {"lo":"ແຂວງອັດຕະປື"} },
        { code: "LA-BK", name: "Bokeo", i18n: {"lo":"ແຂວງບໍ່ແກ້ວ"} },
        { code: "LA-BL", name: "Bolikhamsai", i18n: {"lo":"ແຂວງບໍລິຄໍາໄຊ"} },
        { code: "LA-CH", name: "Champasak", i18n: {"lo":"ແຂວງຈໍາປາສັກ"} },
        { code: "LA-HO", name: "Houaphanh", i18n: {"lo":"ແຂວງຫົວພັນ"} },
        { code: "LA-KH", name: "Khammouane", i18n: {"lo":"ແຂວງຄຳມ່ວນ"} },
        { code: "LA-LM", name: "Luang Namtha", i18n: {"lo":"ແຂວງຫຼວງນໍ້າທາ"} },
        { code: "LA-LP", name: "Luang Prabang", i18n: {"lo":"ແຂວງຫຼວງພະບາງ"} },
        { code: "LA-OU", name: "Oudomxay", i18n: {"lo":"ແຂວງອຸດົມໄຊ"} },
        { code: "LA-PH", name: "Phongsaly", i18n: {"lo":"ແຂວງຜົ້ງສາລີ"} },
        { code: "LA-XA", name: "Sainyabuli", i18n: {"lo":"ແຂວງໄຊຍະບູລີ"} },
        { code: "LA-SL", name: "Salavan", i18n: {"lo":"ແຂວງສາລະວັນ"} },
        { code: "LA-SV", name: "Savannakhet", i18n: {"lo":"ແຂວງສະຫວັນນະເຂດ"} },
        { code: "LA-XE", name: "Sekong", i18n: {"lo":"ແຂວງເຊກອງ"} },
        { code: "LA-VT", name: "Vientiane", i18n: {"lo":"ນະຄອນຫຼວງວຽງຈັນ"} },
        { code: "LA-VI", name: "Vientiane Province", i18n: {"lo":"ແຂວງວຽງຈັນ"} },
        { code: "LA-XS", name: "Xaisomboun", i18n: {"lo":"ແຂວງໄຊສົມບູນ"} },
        { code: "LA-XI", name: "Xiangkhouang", i18n: {"lo":"ແຂວງຊຽງຂວາງ"} },
    ],
    "LB": [
        { code: "LB-AK", name: "Akkar", i18n: {"ar":"محافظة عكار"} },
        { code: "LB-BH", name: "Baalbek-Hermel", i18n: {"ar":"محافظة بعلبك الهرمل"} },
        { code: "LB-BA", name: "Beirut", i18n: {"ar":"بيروت"} },
        { code: "LB-BI", name: "Beqaa", i18n: {"ar":"البقاع"} },
        { code: "LB-JL", name: "Mount Lebanon", i18n: {"ar":"جبل لبنان"} },
        { code: "LB-NA", name: "Nabatieh", i18n: {"ar":"النبطية"} },
        { code: "LB-AS", name: "North", i18n: {"ar":"الشمال"} },
        { code: "LB-JA", name: "South", i18n: {"ar":"محافظة الجنوب"} },
    ],
    "LC": [
        { code: "LC-01", name: "Anse la Raye", i18n: {} },
        { code: "LC-12", name: "Canaries", i18n: {} },
        { code: "LC-02", name: "Castries", i18n: {} },
        { code: "LC-03", name: "Choiseul", i18n: {} },
        { code: "LC-05", name: "Dennery", i18n: {} },
        { code: "LC-06", name: "Gros Islet", i18n: {} },
        { code: "LC-07", name: "Laborie", i18n: {} },
        { code: "LC-08", name: "Micoud", i18n: {} },
        { code: "LC-10", name: "Soufrière", i18n: {} },
        { code: "LC-11", name: "Vieux Fort", i18n: {} },
    ],
    "LI": [
        { code: "LI-01", name: "Balzers", i18n: {} },
        { code: "LI-02", name: "Eschen", i18n: {} },
        { code: "LI-03", name: "Gamprin", i18n: {} },
        { code: "LI-04", name: "Mauren", i18n: {} },
        { code: "LI-05", name: "Planken", i18n: {} },
        { code: "LI-06", name: "Ruggell", i18n: {} },
        { code: "LI-07", name: "Schaan", i18n: {} },
        { code: "LI-08", name: "Schellenberg", i18n: {} },
        { code: "LI-09", name: "Triesen", i18n: {} },
        { code: "LI-10", name: "Triesenberg", i18n: {} },
        { code: "LI-11", name: "Vaduz", i18n: {} },
    ],
    "LK": [
        { code: "LK-52", name: "Ampara", i18n: {"si":"අම්පාර පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-71", name: "Anuradhapura", i18n: {"si":"අනුරාධපුර පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-81", name: "Badulla", i18n: {"si":"බදුල්ල පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-51", name: "Batticaloa", i18n: {"si":"මඩකලපුව පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-2", name: "Central", i18n: {"si":"මධ්‍යම පළාත, ශ්‍රී ලංකාව"} },
        { code: "LK-11", name: "Colombo", i18n: {"si":"කොළඹ දිස්ත් රික්කය"} },
        { code: "LK-5", name: "Eastern", i18n: {"si":"නැගෙනහිර පළාත, ශ් රී ලංකාව"} },
        { code: "LK-31", name: "Galle", i18n: {"si":"ගාල්ල පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-12", name: "Gampaha", i18n: {"si":"ගම්පහ පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-33", name: "Hambantota", i18n: {"si":"හම්බන්තොට පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-41", name: "Jaffna", i18n: {"si":"යාපනය පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-13", name: "Kalutara", i18n: {"si":"කළුතර පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-21", name: "Kandy", i18n: {"si":"මහනුවර දිස්ත් රික්කය"} },
        { code: "LK-92", name: "Kegalle", i18n: {"si":"කෑගල්ල පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-42", name: "Kilinochchi", i18n: {"si":"කිලිනොච්චි දිස්ත්‍රික්කය"} },
        { code: "LK-61", name: "Kurunegala", i18n: {"si":"කුරුණෑගල දිස්ත් රික්කය"} },
        { code: "LK-43", name: "Mannar", i18n: {"si":"මන්නාරම් දිස්ත්‍රික්කය"} },
        { code: "LK-22", name: "Matale", i18n: {"si":"මාතලේ පරිපාලන දිස්ත් රික්කය"} },
        { code: "LK-32", name: "Matara", i18n: {"si":"මාතර දිස්ත්‍රික්කය"} },
        { code: "LK-82", name: "Moneragala", i18n: {"si":"මොණරාගල දිස්ත්‍රික්කය"} },
        { code: "LK-45", name: "Mullaitivu", i18n: {"si":"මුලතිව් පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-7", name: "North Central", i18n: {"si":"උතුරු මැද පළාත"} },
        { code: "LK-6", name: "North Western", i18n: {"si":"වයඹ පළාත, ශ්‍රී ලංකාව"} },
        { code: "LK-4", name: "Northern", i18n: {"si":"උතුරු පළාත"} },
        { code: "LK-23", name: "Nuwara Eliya", i18n: {"si":"නුවරඑළිය පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-72", name: "Polonnaruwa", i18n: {"si":"පොළොන්නරුව දිස්ත්‍රික්කය"} },
        { code: "LK-62", name: "Puttalam", i18n: {"si":"පුත්තලම දිස්ත්‍රික්කය"} },
        { code: "LK-91", name: "Ratnapura", i18n: {"si":"රත්නපුර දිස්ත් රික්කය"} },
        { code: "LK-9", name: "Sabaragamuwa", i18n: {"si":"සබරගමුව පළාත"} },
        { code: "LK-3", name: "Southern", i18n: {"si":"දකුණු පළාත"} },
        { code: "LK-53", name: "Trincomalee", i18n: {"si":"ත්‍රිකුණාමල දිස්ත්‍රික්කය"} },
        { code: "LK-8", name: "Uva", i18n: {"si":"ඌව පළාත"} },
        { code: "LK-44", name: "Vavuniya", i18n: {"si":"වවුනියා පරිපාලන දිස්ත්‍රික්කය"} },
        { code: "LK-1", name: "Western", i18n: {"si":"බස්නාහිර පළාත, ශ් රී ලංකාව"} },
    ],
    "LR": [
        { code: "LR-BM", name: "Bomi", i18n: {} },
        { code: "LR-BG", name: "Bong", i18n: {} },
        { code: "LR-GP", name: "Gbarpolu", i18n: {} },
        { code: "LR-GB", name: "Grand Bassa", i18n: {} },
        { code: "LR-CM", name: "Grand Cape Mount", i18n: {} },
        { code: "LR-GG", name: "Grand Gedeh", i18n: {} },
        { code: "LR-GK", name: "Grand Kru", i18n: {} },
        { code: "LR-LO", name: "Lofa", i18n: {} },
        { code: "LR-MG", name: "Margibi", i18n: {} },
        { code: "LR-MY", name: "Maryland", i18n: {} },
        { code: "LR-MO", name: "Montserrado", i18n: {} },
        { code: "LR-NI", name: "Nimba", i18n: {} },
        { code: "LR-RG", name: "River Gee", i18n: {} },
        { code: "LR-RI", name: "Rivercess", i18n: {} },
        { code: "LR-SI", name: "Sinoe", i18n: {} },
    ],
    "LS": [
        { code: "LS-D", name: "Berea", i18n: {} },
        { code: "LS-B", name: "Butha-Buthe", i18n: {} },
        { code: "LS-C", name: "Leribe", i18n: {} },
        { code: "LS-E", name: "Mafeteng", i18n: {} },
        { code: "LS-A", name: "Maseru", i18n: {} },
        { code: "LS-F", name: "Mohale’s Hoek", i18n: {} },
        { code: "LS-J", name: "Mokhotlong", i18n: {} },
        { code: "LS-H", name: "Qacha’s Nek", i18n: {} },
        { code: "LS-G", name: "Quthing", i18n: {} },
        { code: "LS-K", name: "Thaba-Tseka", i18n: {} },
    ],
    "LT": [
        { code: "LT-01", name: "Akmenė", i18n: {"lt":"Akmenės rajono savivaldybė"} },
        { code: "LT-03", name: "Alytus", i18n: {"lt":"Alytaus rajono savivaldybė"} },
        { code: "LT-AL", name: "Alytus County", i18n: {"lt":"Alytaus apskritis"} },
        { code: "LT-02", name: "Alytus Municipality", i18n: {"lt":"Alytaus miesto savivaldybė"} },
        { code: "LT-04", name: "Anykščiai", i18n: {"lt":"Anykščių rajono savivaldybė"} },
        { code: "LT-05", name: "Birštonas", i18n: {"lt":"Birštono savivaldybė"} },
        { code: "LT-06", name: "Biržai", i18n: {"lt":"Biržų rajono savivaldybė"} },
        { code: "LT-07", name: "Druskininkai", i18n: {"lt":"Druskininkų savivaldybė"} },
        { code: "LT-08", name: "Elektrėnai", i18n: {"lt":"Elektrėnų savivaldybė"} },
        { code: "LT-09", name: "Ignalina", i18n: {"lt":"Ignalinos rajono savivaldybė"} },
        { code: "LT-10", name: "Jonava", i18n: {"lt":"Jonavos rajono savivaldybė"} },
        { code: "LT-11", name: "Joniškis", i18n: {"lt":"Joniškio rajono savivaldybė"} },
        { code: "LT-12", name: "Jurbarkas", i18n: {"lt":"Jurbarko rajono savivaldybė"} },
        { code: "LT-13", name: "Kaišiadorys", i18n: {"lt":"Kaišiadorių rajono savivaldybė"} },
        { code: "LT-14", name: "Kalvarija", i18n: {"lt":"Kalvarijos savivaldybė"} },
        { code: "LT-16", name: "Kaunas", i18n: {"lt":"Kauno rajono savivaldybė"} },
        { code: "LT-KU", name: "Kaunas County", i18n: {"lt":"Kauno apskritis"} },
        { code: "LT-15", name: "Kauno Municipality", i18n: {"lt":"Kauno miesto savivaldybė"} },
        { code: "LT-17", name: "Kazlų Rūda", i18n: {"lt":"Kazlų Rūdos savivaldybė"} },
        { code: "LT-18", name: "Kėdainiai", i18n: {"lt":"Kėdainių rajono savivaldybė"} },
        { code: "LT-19", name: "Kelmė", i18n: {"lt":"Kelmės rajono savivaldybė"} },
        { code: "LT-21", name: "Klaipėda", i18n: {"lt":"Klaipėdos rajono savivaldybė"} },
        { code: "LT-KL", name: "Klaipėda County", i18n: {"lt":"Klaipėdos apskritis"} },
        { code: "LT-20", name: "Klaipėdos Municipality", i18n: {"lt":"Klaipėdos miesto savivaldybė"} },
        { code: "LT-22", name: "Kretinga", i18n: {"lt":"Kretingos rajono savivaldybė"} },
        { code: "LT-23", name: "Kupiškis", i18n: {"lt":"Kupiškio rajono savivaldybė"} },
        { code: "LT-24", name: "Lazdijai", i18n: {"lt":"Lazdijų rajono savivaldybė"} },
        { code: "LT-25", name: "Marijampolė", i18n: {"lt":"Marijampolės savivaldybė"} },
        { code: "LT-MR", name: "Marijampolė County", i18n: {"lt":"Marijampolės apskritis"} },
        { code: "LT-26", name: "Mažeikiai", i18n: {"lt":"Mažeikių rajono savivaldybė"} },
        { code: "LT-27", name: "Molėtai", i18n: {"lt":"Molėtų rajono savivaldybė"} },
        { code: "LT-28", name: "Neringa", i18n: {"lt":"Neringos savivaldybė"} },
        { code: "LT-29", name: "Pagėgiai", i18n: {"lt":"Pagėgių savivaldybė"} },
        { code: "LT-30", name: "Pakruojis", i18n: {"lt":"Pakruojo rajono savivaldybė"} },
        { code: "LT-31", name: "Palanga", i18n: {"lt":"Palangos miesto savivaldybė"} },
        { code: "LT-32", name: "Panevėžio Municipality", i18n: {"lt":"Panevėžio miesto savivaldybė"} },
        { code: "LT-33", name: "Panevėžys", i18n: {"lt":"Panevėžio rajono savivaldybė"} },
        { code: "LT-PN", name: "Panevėžys County", i18n: {"lt":"Panevėžio apskritis"} },
        { code: "LT-34", name: "Pasvalys", i18n: {"lt":"Pasvalio rajono savivaldybė"} },
        { code: "LT-35", name: "Plungė", i18n: {"lt":"Plungės rajono savivaldybė"} },
        { code: "LT-36", name: "Prienai", i18n: {"lt":"Prienų rajono savivaldybė"} },
        { code: "LT-37", name: "Radviliškis", i18n: {"lt":"Radviliškio rajono savivaldybė"} },
        { code: "LT-38", name: "Raseiniai", i18n: {"lt":"Raseinių rajono savivaldybė"} },
        { code: "LT-39", name: "Rietavas", i18n: {"lt":"Rietavo savivaldybė"} },
        { code: "LT-40", name: "Rokiškis", i18n: {"lt":"Rokiškio rajono savivaldybė"} },
        { code: "LT-41", name: "Šakiai", i18n: {"lt":"Šakių rajono savivaldybė"} },
        { code: "LT-42", name: "Šalčininkai", i18n: {"lt":"Šalčininkų rajono savivaldybė"} },
        { code: "LT-44", name: "Šiauliai", i18n: {"lt":"Šiaulių rajono savivaldybė"} },
        { code: "LT-SA", name: "Šiauliai County", i18n: {"lt":"Šiaulių apskritis"} },
        { code: "LT-43", name: "Šiaulių Municipality", i18n: {"lt":"Šiaulių miesto savivaldybė"} },
        { code: "LT-45", name: "Šilalė", i18n: {"lt":"Šilalės rajono savivaldybė"} },
        { code: "LT-46", name: "Šilutė", i18n: {"lt":"Šilutės rajono savivaldybė"} },
        { code: "LT-47", name: "Širvintos", i18n: {"lt":"Širvintų rajono savivaldybė"} },
        { code: "LT-48", name: "Skuodas", i18n: {"lt":"Skuodo rajono savivaldybė"} },
        { code: "LT-49", name: "Švenčionys", i18n: {"lt":"Švenčionių rajono savivaldybė"} },
        { code: "LT-50", name: "Tauragė", i18n: {"lt":"Tauragės rajono savivaldybė"} },
        { code: "LT-TA", name: "Tauragė County", i18n: {"lt":"Tauragės apskritis"} },
        { code: "LT-51", name: "Telšiai", i18n: {"lt":"Telšių rajono savivaldybė"} },
        { code: "LT-TE", name: "Telšiai County", i18n: {"lt":"Telšių apskritis"} },
        { code: "LT-52", name: "Trakai", i18n: {"lt":"Trakų rajono savivaldybė"} },
        { code: "LT-53", name: "Ukmergė", i18n: {"lt":"Ukmergės rajono savivaldybė"} },
        { code: "LT-54", name: "Utena", i18n: {"lt":"Utenos rajono savivaldybė"} },
        { code: "LT-UT", name: "Utena County", i18n: {"lt":"Utenos apskritis"} },
        { code: "LT-55", name: "Varėna", i18n: {"lt":"Varėnos rajono savivaldybė"} },
        { code: "LT-56", name: "Vilkaviškis", i18n: {"lt":"Vilkaviškio rajono savivaldybė"} },
        { code: "LT-57", name: "Vilniaus Municipality", i18n: {"lt":"Vilniaus miesto savivaldybė"} },
        { code: "LT-58", name: "Vilnius", i18n: {"lt":"Vilniaus rajono savivaldybė"} },
        { code: "LT-VL", name: "Vilnius County", i18n: {"lt":"Vilniaus apskritis"} },
        { code: "LT-59", name: "Visaginas", i18n: {"lt":"Visagino savivaldybė"} },
        { code: "LT-60", name: "Zarasai", i18n: {"lt":"Zarasų rajono savivaldybė"} },
    ],
    "LU": [
        { code: "LU-CA", name: "Capellen", i18n: {"fr":"canton de Capellen"} },
        { code: "LU-CL", name: "Clervaux", i18n: {"fr":"canton de Clervaux"} },
        { code: "LU-DI", name: "Diekirch", i18n: {"fr":"canton de Diekirch"} },
        { code: "LU-EC", name: "Echternach", i18n: {"fr":"canton d’Echternach"} },
        { code: "LU-ES", name: "Esch-sur-Alzette", i18n: {"fr":"canton d’Esch-sur-Alzette"} },
        { code: "LU-GR", name: "Grevenmacher", i18n: {"fr":"canton de Grevenmacher"} },
        { code: "LU-LU", name: "Luxembourg", i18n: {"fr":"canton de Luxembourg"} },
        { code: "LU-ME", name: "Mersch", i18n: {"fr":"canton de Mersch"} },
        { code: "LU-RD", name: "Redange", i18n: {"fr":"canton de Redange"} },
        { code: "LU-RM", name: "Remich", i18n: {"fr":"canton de Remich"} },
        { code: "LU-VD", name: "Vianden", i18n: {"fr":"canton de Vianden"} },
        { code: "LU-WI", name: "Wiltz", i18n: {"fr":"canton de Wiltz"} },
    ],
    "LV": [
        { code: "LV-011", name: "Ādaži", i18n: {"lv":"Ādažu novads"} },
        { code: "LV-002", name: "Aizkraukle", i18n: {"lv":"Aizkraukles novads"} },
        { code: "LV-007", name: "Alūksne", i18n: {"lv":"Alūksnes novads"} },
        { code: "LV-111", name: "Augšdaugavas novads", i18n: {} },
        { code: "LV-015", name: "Balvi", i18n: {"lv":"Balvu novads"} },
        { code: "LV-016", name: "Bauska", i18n: {"lv":"Bauskas novads"} },
        { code: "LV-022", name: "Cēsis", i18n: {"lv":"Cēsu novads"} },
        { code: "LV-DGV", name: "Daugavpils", i18n: {} },
        { code: "LV-112", name: "Dienvidkurzemes Novads", i18n: {"lv":"Dienvidkurzemes novads"} },
        { code: "LV-026", name: "Dobele", i18n: {"lv":"Dobeles novads"} },
        { code: "LV-033", name: "Gulbene", i18n: {"lv":"Gulbenes novads"} },
        { code: "LV-042", name: "Jēkabpils Municipality", i18n: {"lv":"Jēkabpils novads"} },
        { code: "LV-JEL", name: "Jelgava", i18n: {} },
        { code: "LV-041", name: "Jelgava Municipality", i18n: {"lv":"Jelgavas novads"} },
        { code: "LV-JUR", name: "Jūrmala", i18n: {} },
        { code: "LV-052", name: "Ķekava", i18n: {"lv":"Ķekavas novads"} },
        { code: "LV-047", name: "Krāslava", i18n: {"lv":"Krāslavas novads"} },
        { code: "LV-050", name: "Kuldīga", i18n: {"lv":"Kuldīgas novads"} },
        { code: "LV-LPX", name: "Liepāja", i18n: {} },
        { code: "LV-054", name: "Limbaži", i18n: {"lv":"Limbažu novads"} },
        { code: "LV-056", name: "Līvāni", i18n: {"lv":"Līvānu novads"} },
        { code: "LV-058", name: "Ludza", i18n: {"lv":"Ludzas novads"} },
        { code: "LV-059", name: "Madona", i18n: {"lv":"Madonas novads"} },
        { code: "LV-062", name: "Mārupe", i18n: {"lv":"Mārupes novads"} },
        { code: "LV-067", name: "Ogre", i18n: {"lv":"Ogres novads"} },
        { code: "LV-068", name: "Olaine", i18n: {"lv":"Olaines novads"} },
        { code: "LV-073", name: "Preiļi", i18n: {"lv":"Preiļu novads"} },
        { code: "LV-REZ", name: "Rēzekne", i18n: {} },
        { code: "LV-077", name: "Rēzekne Municipality", i18n: {"lv":"Rēzeknes novads"} },
        { code: "LV-RIX", name: "Riga", i18n: {"lv":"Rīga"} },
        { code: "LV-080", name: "Ropaži", i18n: {"lv":"Ropažu novads"} },
        { code: "LV-087", name: "Salaspils", i18n: {"lv":"Salaspils novads"} },
        { code: "LV-088", name: "Saldus", i18n: {"lv":"Saldus novads"} },
        { code: "LV-089", name: "Saulkrasti", i18n: {"lv":"Saulkrastu novads"} },
        { code: "LV-091", name: "Sigulda", i18n: {"lv":"Siguldas novads"} },
        { code: "LV-094", name: "Smiltene", i18n: {"lv":"Smiltenes novads"} },
        { code: "LV-097", name: "Talsi", i18n: {"lv":"Talsu novads"} },
        { code: "LV-099", name: "Tukums", i18n: {"lv":"Tukuma novads"} },
        { code: "LV-101", name: "Valka", i18n: {"lv":"Valkas novads"} },
        { code: "LV-113", name: "Valmieras Novads", i18n: {"lv":"Valmieras novads"} },
        { code: "LV-102", name: "Varakļāni", i18n: {"lv":"Varakļānu novads"} },
        { code: "LV-VEN", name: "Ventspils", i18n: {} },
        { code: "LV-106", name: "Ventspils Municipality", i18n: {"lv":"Ventspils novads"} },
    ],
    "LY": [
        { code: "LY-WA", name: "Al Wahat", i18n: {"ar":"شعبية الواحات"} },
        { code: "LY-BA", name: "Benghazi", i18n: {"ar":"بنغازي"} },
        { code: "LY-BU", name: "Butnan", i18n: {"ar":"شعبية البطنان"} },
        { code: "LY-DR", name: "Derna", i18n: {"ar":"شعبية درنة"} },
        { code: "LY-GT", name: "Ghat", i18n: {"ar":"شعبية غات"} },
        { code: "LY-JA", name: "Jabal al Akhdar", i18n: {"ar":"شعبية الجبل الأخضر"} },
        { code: "LY-JG", name: "Jabal al Gharbi", i18n: {"ar":"شعبية الجبل الغربي"} },
        { code: "LY-JI", name: "Jafara", i18n: {"ar":"شعبية الجفارة"} },
        { code: "LY-JU", name: "Jufra", i18n: {"ar":"شعبية الجفرة"} },
        { code: "LY-KF", name: "Kufra", i18n: {"ar":"شعبية الكفرة"} },
        { code: "LY-MJ", name: "Marj", i18n: {"ar":"شعبية المرج"} },
        { code: "LY-MI", name: "Misrata", i18n: {"ar":"شعبية مصراتة"} },
        { code: "LY-MB", name: "Murqub", i18n: {"ar":"شعبية المرقب"} },
        { code: "LY-MQ", name: "Murzuq", i18n: {"ar":"شعبية مرزق"} },
        { code: "LY-NL", name: "Nalut", i18n: {"ar":"شعبية نالوت"} },
        { code: "LY-NQ", name: "Nuqat al Khams", i18n: {"ar":"شعبية النقاط الخمس"} },
        { code: "LY-SB", name: "Sabha", i18n: {"ar":"شعبية سبها"} },
        { code: "LY-SR", name: "Sirte", i18n: {"ar":"شعبية سرت"} },
        { code: "LY-TB", name: "Tripoli", i18n: {"ar":"شعبية طرابلس"} },
        { code: "LY-WD", name: "Wadi al Hayaa", i18n: {"ar":"شعبية وادي الحياة"} },
        { code: "LY-WS", name: "Wadi al Shatii", i18n: {"ar":"شعبية وادي الشاطئ"} },
        { code: "LY-ZA", name: "Zawiya", i18n: {"ar":"شعبية الزاوية"} },
    ],
    "MA": [
        { code: "MA-AGD", name: "Agadir-Ida Ou Tanane", i18n: {"ar":"أكادير"} },
        { code: "MA-HAO", name: "Al Haouz", i18n: {"ar":"إقليم الحوز"} },
        { code: "MA-HOC", name: "Al Hoceïma", i18n: {"ar":"إقليم الحسيمة"} },
        { code: "MA-AOU", name: "Aousserd", i18n: {"ar":"إقليم أوسرد"} },
        { code: "MA-ASZ", name: "Assa-Zag", i18n: {"ar":"إقليم آسا الزاك"} },
        { code: "MA-AZI", name: "Azilal", i18n: {"ar":"إقليم أزيلال"} },
        { code: "MA-BES", name: "Ben Slimane", i18n: {"ar":"إقليم بنسليمان"} },
        { code: "MA-BEM", name: "Béni-Mellal", i18n: {"ar":"إقليم بني ملال"} },
        { code: "MA-BER", name: "Berkane", i18n: {"ar":"إقليم بركان"} },
        { code: "MA-BRR", name: "Berrechid", i18n: {"ar":"إقليم برشيد"} },
        { code: "MA-BOD", name: "Boujdour", i18n: {"ar":"إقليم بوجدور"} },
        { code: "MA-BOM", name: "Boulemane", i18n: {"ar":"إقليم بولمان"} },
        { code: "MA-CAS", name: "Casablanca", i18n: {"ar":"الدار البيضاء"} },
        { code: "MA-09", name: "Chaouia-Ouardigha", i18n: {"ar":"الشاوية ورديغة"} },
        { code: "MA-CHE", name: "Chefchaouen", i18n: {"ar":"إقليم شفشاون"} },
        { code: "MA-CHI", name: "Chichaoua", i18n: {"ar":"إقليم شيشاوة"} },
        { code: "MA-CHT", name: "Chtouka Aït Baha", i18n: {"ar":"إقليم شتوكة آيت باها"} },
        { code: "MA-10", name: "Doukkala-Abda", i18n: {"ar":"دكالة عبدة"} },
        { code: "MA-DRI", name: "Driouch", i18n: {"ar":"إقليم الدريوش"} },
        { code: "MA-HAJ", name: "El Hajeb", i18n: {"ar":"إقليم الحاجب"} },
        { code: "MA-JDI", name: "El Jadida", i18n: {"ar":"إقليم الجديدة"} },
        { code: "MA-ERR", name: "Errachidia", i18n: {"ar":"إقليم الرشيدية"} },
        { code: "MA-ESM", name: "Es Semara", i18n: {"ar":"إقليم السمارة"} },
        { code: "MA-ESI", name: "Essaouira", i18n: {"ar":"إقليم الصويرة"} },
        { code: "MA-FAH", name: "Fahs-Beni Makada", i18n: {"ar":"إقليم فحص أنجرة"} },
        { code: "MA-05", name: "Fès-Boulemane", i18n: {"ar":"جهة فاس بولمان"} },
        { code: "MA-FES", name: "Fès-Dar-Dbibegh", i18n: {"ar":"فاس"} },
        { code: "MA-FIG", name: "Figuig", i18n: {"ar":"إقليم فكيك"} },
        { code: "MA-FQH", name: "Fquih Ben Salah", i18n: {"ar":"إقليم الفقيه بن صالح"} },
        { code: "MA-02", name: "Gharb-Chrarda-Béni Hssen", i18n: {"ar":"الغرب شراردة بني حسين"} },
        { code: "MA-08", name: "Grand Casablanca", i18n: {"ar":"جهة الدار البيضاء الكبرى"} },
        { code: "MA-GUE", name: "Guelmim", i18n: {"ar":"إقليم كلميم"} },
        { code: "MA-GUF", name: "Guercif", i18n: {"ar":"إقليم جرسيف"} },
        { code: "MA-IFR", name: "Ifrane", i18n: {"ar":"إقليم إفران"} },
        { code: "MA-INE", name: "Inezgane-Aït Melloul", i18n: {"ar":"عمالة إنزكان آيت ملول"} },
        { code: "MA-JRA", name: "Jerada", i18n: {"ar":"إقليم جرادة"} },
        { code: "MA-KES", name: "Kelaat Sraghna", i18n: {"ar":"إقليم قلعة السراغنة"} },
        { code: "MA-KEN", name: "Kénitra", i18n: {"ar":"إقليم القنيطرة"} },
        { code: "MA-KHE", name: "Khemisset", i18n: {"ar":"إقليم الخميسات"} },
        { code: "MA-KHN", name: "Khénifra", i18n: {"ar":"إقليم خنيفرة"} },
        { code: "MA-KHO", name: "Khouribga", i18n: {"ar":"إقليم خريبكة"} },
        { code: "MA-LAA", name: "Laâyoune", i18n: {"ar":"إقليم العيون"} },
        { code: "MA-LAR", name: "Larache", i18n: {"ar":"إقليم العرائش"} },
        { code: "MA-MDF", name: "M’diq-Fnideq", i18n: {"ar":"عمالة المضيق الفنيدق"} },
        { code: "MA-MAR", name: "Marrakech", i18n: {"ar":"عمالة مراكش"} },
        { code: "MA-11", name: "Marrakesh-Tensift-El Haouz", i18n: {"ar":"جهة مراكش تانسيفت الحوز"} },
        { code: "MA-MED", name: "Médiouna", i18n: {"ar":"إقليم مديونة"} },
        { code: "MA-MEK", name: "Meknès", i18n: {"ar":"مكناس"} },
        { code: "MA-06", name: "Meknès-Tafilalet", i18n: {"ar":"مكناس تافيلالت"} },
        { code: "MA-MID", name: "Midelt", i18n: {"ar":"إقليم ميدلت"} },
        { code: "MA-MOH", name: "Mohammedia", i18n: {"ar":"المحمدية"} },
        { code: "MA-MOU", name: "Moulay Yacoub", i18n: {"ar":"إقليم مولاي يعقوب"} },
        { code: "MA-NAD", name: "Nador", i18n: {"ar":"إقليم الناظور"} },
        { code: "MA-NOU", name: "Nouaceur", i18n: {"ar":"إقليم النواصر"} },
        { code: "MA-04", name: "Oriental", i18n: {"ar":"الجهة الشرقية"} },
        { code: "MA-OUA", name: "Ouarzazate", i18n: {"ar":"إقليم ورززات"} },
        { code: "MA-OUD", name: "Oued Ed-Dahab", i18n: {"ar":"إقليم وادي الذهب"} },
        { code: "MA-OUZ", name: "Ouezzane", i18n: {"ar":"إقليم وزان"} },
        { code: "MA-OUJ", name: "Oujda-Angad", i18n: {"ar":"وجدة"} },
        { code: "MA-RAB", name: "Rabat", i18n: {"ar":"الرباط"} },
        { code: "MA-07", name: "Rabat-Salé-Zemmour-Zaer", i18n: {"ar":"الرباط سلا زمور زعير"} },
        { code: "MA-REH", name: "Rehamna", i18n: {"ar":"إقليم الرحامنة"} },
        { code: "MA-SAF", name: "Safi", i18n: {"ar":"إقليم آسفي"} },
        { code: "MA-SAL", name: "Salé", i18n: {"ar":"سلا"} },
        { code: "MA-SEF", name: "Sefrou", i18n: {"ar":"إقليم صفرو"} },
        { code: "MA-SET", name: "Settat", i18n: {"ar":"إقليم سطات"} },
        { code: "MA-SIB", name: "Sidi Bennour", i18n: {"ar":"إقليم سيدي بنور"} },
        { code: "MA-SIF", name: "Sidi Ifni", i18n: {"ar":"إقليم سيدي إفني"} },
        { code: "MA-SIK", name: "Sidi Kacem", i18n: {"ar":"إقليم سيدي قاسم"} },
        { code: "MA-SIL", name: "Sidi Slimane", i18n: {"ar":"إقليم سيدي سليمان"} },
        { code: "MA-SKH", name: "Skhirat-Témara", i18n: {"ar":"تمارة"} },
        { code: "MA-12", name: "Tadla-Azilal", i18n: {"ar":"جهة تادلة أزيلال"} },
        { code: "MA-TNT", name: "Tan-Tan", i18n: {"ar":"إقليم طانطان"} },
        { code: "MA-TNG", name: "Tangier-Assilah", i18n: {"ar":"طنجة"} },
        { code: "MA-01", name: "Tangier-Tétouan", i18n: {"ar":"طنجة تطوان"} },
        { code: "MA-TAO", name: "Taounate", i18n: {"ar":"إقليم تاونات"} },
        { code: "MA-TAI", name: "Taourirt", i18n: {"ar":"إقليم تاوريرت"} },
        { code: "MA-TAF", name: "Tarfaya (EH-partial)", i18n: {"ar":"إقليم طرفاية"} },
        { code: "MA-TAR", name: "Taroudant", i18n: {"ar":"إقليم تارودانت"} },
        { code: "MA-TAT", name: "Tata", i18n: {"ar":"إقليم طاطا"} },
        { code: "MA-TAZ", name: "Taza", i18n: {"ar":"إقليم تازة"} },
        { code: "MA-03", name: "Taza-Al Hoceima-Taounate", i18n: {"ar":"جهة تازة الحسيمة تاونات"} },
        { code: "MA-TET", name: "Tétouan", i18n: {"ar":"إقليم تطوان"} },
        { code: "MA-TIN", name: "Tinghir", i18n: {"ar":"إقليم تنغير"} },
        { code: "MA-TIZ", name: "Tiznit", i18n: {"ar":"إقليم تيزنيت"} },
        { code: "MA-YUS", name: "Youssoufia", i18n: {"ar":"إقليم اليوسفية"} },
        { code: "MA-ZAG", name: "Zagora", i18n: {"ar":"إقليم زاكورة"} },
    ],
    "MC": [
        { code: "MC-FO", name: "Fontvieille", i18n: {} },
        { code: "MC-JE", name: "Jardin Exotique de Monaco", i18n: {"fr":"jardin exotique de Monaco"} },
        { code: "MC-CL", name: "La Colle", i18n: {} },
        { code: "MC-CO", name: "La Condamine", i18n: {} },
        { code: "MC-GA", name: "La Gare", i18n: {} },
        { code: "MC-SO", name: "La Source", i18n: {} },
        { code: "MC-LA", name: "Larvotto", i18n: {"fr":"Larvotto/Bas Moulins"} },
        { code: "MC-MA", name: "Malbousquet", i18n: {} },
        { code: "MC-MO", name: "Monaco-Ville", i18n: {} },
        { code: "MC-MG", name: "Moneghetti", i18n: {} },
        { code: "MC-MC", name: "Monte Carlo", i18n: {"fr":"Monte-Carlo"} },
        { code: "MC-MU", name: "Moulins", i18n: {} },
        { code: "MC-PH", name: "Port Hercules", i18n: {"fr":"Port Hercule"} },
        { code: "MC-SR", name: "Saint Roman", i18n: {"fr":"La Rousse"} },
        { code: "MC-SD", name: "Sainte-Dévote Chapel", i18n: {"fr":"église Sainte-Dévote"} },
        { code: "MC-SP", name: "Spélugues", i18n: {} },
        { code: "MC-VR", name: "Vallon de la Rousse", i18n: {} },
    ],
    "MD": [
        { code: "MD-AN", name: "Anenii Noi", i18n: {"ro":"raionul Anenii Noi"} },
        { code: "MD-BA", name: "Bălţi", i18n: {"ro":"Municipiul Bălți"} },
        { code: "MD-BS", name: "Basarabeasca", i18n: {"ro":"raionul Basarabeasca"} },
        { code: "MD-BD", name: "Bender", i18n: {"ro":"Municipiul Bender"} },
        { code: "MD-BR", name: "Briceni", i18n: {"ro":"raionul Briceni"} },
        { code: "MD-CA", name: "Cahul", i18n: {"ro":"raionul Cahul"} },
        { code: "MD-CL", name: "Călărași", i18n: {"ro":"raionul Călărași"} },
        { code: "MD-CT", name: "Cantemir", i18n: {"ro":"raionul Cantemir"} },
        { code: "MD-CS", name: "Căușeni", i18n: {"ro":"raionul Căușeni"} },
        { code: "MD-CU", name: "Chișinău", i18n: {"ro":"Municipiul Chișinău"} },
        { code: "MD-CM", name: "Cimișlia", i18n: {"ro":"raionul Cimișlia"} },
        { code: "MD-CR", name: "Criuleni", i18n: {"ro":"raionul Criuleni"} },
        { code: "MD-DO", name: "Dondușeni", i18n: {"ro":"raionul Dondușeni"} },
        { code: "MD-DR", name: "Drochia", i18n: {"ro":"raionul Drochia"} },
        { code: "MD-DU", name: "Dubăsari", i18n: {"ro":"raionul Dubăsari"} },
        { code: "MD-ED", name: "Edineț", i18n: {"ro":"raionul Edineț"} },
        { code: "MD-FA", name: "Fălești", i18n: {"ro":"raionul Fălești"} },
        { code: "MD-FL", name: "Florești", i18n: {"ro":"raionul Florești"} },
        { code: "MD-GA", name: "Gagauzia", i18n: {"ro":"Găgăuzia"} },
        { code: "MD-GL", name: "Glodeni", i18n: {"ro":"raionul Glodeni"} },
        { code: "MD-HI", name: "Hîncești", i18n: {"ro":"raionul Hîncești"} },
        { code: "MD-IA", name: "Ialoveni", i18n: {"ro":"raionul Ialoveni"} },
        { code: "MD-LE", name: "Leova", i18n: {"ro":"raionul Leova"} },
        { code: "MD-NI", name: "Nisporeni", i18n: {"ro":"raionul Nisporeni"} },
        { code: "MD-OC", name: "Ocniţa", i18n: {"ro":"raionul Ocnița"} },
        { code: "MD-OR", name: "Orhei", i18n: {"ro":"raionul Orhei"} },
        { code: "MD-RE", name: "Rezina", i18n: {"ro":"raionul Rezina"} },
        { code: "MD-RI", name: "Rîșcani", i18n: {"ro":"raionul Rîșcani"} },
        { code: "MD-SI", name: "Sîngerei", i18n: {"ro":"raionul Sîngerei"} },
        { code: "MD-SD", name: "Șoldănești", i18n: {"ro":"raionul Șoldănești"} },
        { code: "MD-SO", name: "Soroca", i18n: {"ro":"raionul Soroca"} },
        { code: "MD-SV", name: "Ştefan Vodă", i18n: {"ro":"raionul Ștefan Vodă"} },
        { code: "MD-ST", name: "Strășeni", i18n: {"ro":"raionul Strășeni"} },
        { code: "MD-TA", name: "Taraclia", i18n: {"ro":"raionul Taraclia"} },
        { code: "MD-TE", name: "Telenești", i18n: {"ro":"raionul Telenești"} },
        { code: "MD-SN", name: "Transnistria", i18n: {"ro":"Unitățile Administrativ-Teritoriale din Stînga Nistrului"} },
        { code: "MD-UN", name: "Ungheni", i18n: {"ro":"raionul Ungheni"} },
    ],
    "ME": [
        { code: "ME-01", name: "Andrijevica", i18n: {} },
        { code: "ME-02", name: "Bar", i18n: {} },
        { code: "ME-03", name: "Berane", i18n: {} },
        { code: "ME-04", name: "Bijelo Polje", i18n: {} },
        { code: "ME-05", name: "Budva", i18n: {} },
        { code: "ME-06", name: "Cetinje", i18n: {} },
        { code: "ME-07", name: "Danilovgrad", i18n: {} },
        { code: "ME-22", name: "Gusinje", i18n: {"sr_Latn":"Opština Gusinje"} },
        { code: "ME-08", name: "Herceg Novi", i18n: {} },
        { code: "ME-09", name: "Kolašin", i18n: {} },
        { code: "ME-10", name: "Kotor", i18n: {} },
        { code: "ME-11", name: "Mojkovac", i18n: {} },
        { code: "ME-12", name: "Nikšić", i18n: {} },
        { code: "ME-23", name: "Petnjica", i18n: {"sr_Latn":"Opština Petnjica"} },
        { code: "ME-13", name: "Plav", i18n: {} },
        { code: "ME-14", name: "Pljevlja", i18n: {} },
        { code: "ME-15", name: "Plužine", i18n: {} },
        { code: "ME-16", name: "Podgorica", i18n: {"sr_Latn":"Glavni grad Podgorica"} },
        { code: "ME-17", name: "Rožaje", i18n: {} },
        { code: "ME-18", name: "Šavnik", i18n: {} },
        { code: "ME-19", name: "Tivat", i18n: {} },
        { code: "ME-24", name: "Tuzi", i18n: {} },
        { code: "ME-20", name: "Ulcinj", i18n: {} },
        { code: "ME-21", name: "Žabljak", i18n: {} },
        { code: "ME-25", name: "Zeta", i18n: {} },
    ],
    "MG": [
        { code: "MG-T", name: "Antananarivo", i18n: {} },
        { code: "MG-D", name: "Antsiranana", i18n: {} },
        { code: "MG-F", name: "Fianarantsoa", i18n: {} },
        { code: "MG-M", name: "Mahajanga", i18n: {} },
        { code: "MG-A", name: "Toamasina", i18n: {} },
        { code: "MG-U", name: "Toliara", i18n: {} },
    ],
    "MH": [
        { code: "MH-ALL", name: "Ailinglaplap Atoll", i18n: {} },
        { code: "MH-ALK", name: "Ailuk Atoll", i18n: {} },
        { code: "MH-ARN", name: "Arno", i18n: {} },
        { code: "MH-AUR", name: "Aur Atoll", i18n: {} },
        { code: "MH-EBO", name: "Ebon Atoll", i18n: {} },
        { code: "MH-ENI", name: "Enewetak Atoll", i18n: {} },
        { code: "MH-JAB", name: "Jabat Island", i18n: {} },
        { code: "MH-JAL", name: "Jaluit Atoll", i18n: {} },
        { code: "MH-KIL", name: "Kili Island", i18n: {} },
        { code: "MH-KWA", name: "Kwajalein", i18n: {} },
        { code: "MH-LAE", name: "Lae Atoll", i18n: {} },
        { code: "MH-LIB", name: "Lib Island", i18n: {} },
        { code: "MH-LIK", name: "Likiep Atoll", i18n: {} },
        { code: "MH-MAJ", name: "Majuro", i18n: {} },
        { code: "MH-MAL", name: "Maloelap Atoll", i18n: {} },
        { code: "MH-MEJ", name: "Mejit Island", i18n: {} },
        { code: "MH-MIL", name: "Mili Atoll", i18n: {} },
        { code: "MH-NMK", name: "Namdrik Atoll", i18n: {} },
        { code: "MH-NMU", name: "Namu Atoll", i18n: {} },
        { code: "MH-L", name: "Ralik Chain", i18n: {} },
        { code: "MH-T", name: "Ratak Chain", i18n: {} },
        { code: "MH-RON", name: "Rongelap Atoll", i18n: {} },
        { code: "MH-UJA", name: "Ujae Atoll", i18n: {} },
        { code: "MH-UTI", name: "Utirik Atoll", i18n: {} },
        { code: "MH-WTH", name: "Wotho Atoll", i18n: {} },
        { code: "MH-WTJ", name: "Wotje Atoll", i18n: {} },
    ],
    "MK": [
        { code: "MK-801", name: "Aerodrom †", i18n: {"mk":"Општина Аеродром"} },
        { code: "MK-802", name: "Aračinovo", i18n: {"mk":"Општина Арачиново"} },
        { code: "MK-201", name: "Berovo", i18n: {"mk":"Општина Берово"} },
        { code: "MK-501", name: "Bitola", i18n: {"mk":"Општина Битола"} },
        { code: "MK-401", name: "Bogdanci", i18n: {"mk":"Општина Богданци"} },
        { code: "MK-601", name: "Bogovinje", i18n: {"mk":"Општина Боговиње"} },
        { code: "MK-402", name: "Bosilovo", i18n: {"mk":"Општина Босилово"} },
        { code: "MK-602", name: "Brvenica", i18n: {"mk":"Општина Брвеница"} },
        { code: "MK-803", name: "Butel †", i18n: {"mk":"Општина Бутел"} },
        { code: "MK-815", name: "Čair †", i18n: {"mk":"Општина Чаир"} },
        { code: "MK-109", name: "Čaška", i18n: {"mk":"Општина Чашка"} },
        { code: "MK-814", name: "Centar †", i18n: {"mk":"Општина Центар"} },
        { code: "MK-313", name: "Centar Župa", i18n: {"mk":"Општина Центар Жупа"} },
        { code: "MK-210", name: "Češinovo-Obleševo", i18n: {"mk":"Општина Чешиново-Облешево"} },
        { code: "MK-816", name: "Čučer-Sandevo", i18n: {"mk":"Општина Чучер-Сандево"} },
        { code: "MK-303", name: "Debar", i18n: {"mk":"Општина Дебар"} },
        { code: "MK-304", name: "Debrca", i18n: {"mk":"Општина Дебрца"} },
        { code: "MK-203", name: "Delčevo", i18n: {"mk":"Општина Делчево"} },
        { code: "MK-502", name: "Demir Hisar", i18n: {"mk":"Општина Демир Хисар"} },
        { code: "MK-103", name: "Demir Kapija", i18n: {"mk":"Општина Демир Капија"} },
        { code: "MK-406", name: "Dojran", i18n: {"mk":"Општина Дојран"} },
        { code: "MK-503", name: "Dolneni", i18n: {"mk":"Општина Долнени"} },
        { code: "MK-804", name: "Gazi Baba †", i18n: {"mk":"Општина Гази Баба"} },
        { code: "MK-405", name: "Gevgelija", i18n: {"mk":"Општина Гевгелија"} },
        { code: "MK-805", name: "Gjorče Petrov †", i18n: {"mk":"Општина Ѓорче Петров"} },
        { code: "MK-604", name: "Gostivar", i18n: {"mk":"Општина Гостивар"} },
        { code: "MK-102", name: "Gradsko", i18n: {"mk":"Општина Градско"} },
        { code: "MK-807", name: "Ilinden", i18n: {"mk":"Општина Илинден"} },
        { code: "MK-606", name: "Jegunovce", i18n: {"mk":"Општина Јегуновце"} },
        { code: "MK-205", name: "Karbinci", i18n: {"mk":"Општина Карбинци"} },
        { code: "MK-808", name: "Karpoš †", i18n: {"mk":"Општина Карпош"} },
        { code: "MK-104", name: "Kavadarci", i18n: {"mk":"Општина Кавадарци"} },
        { code: "MK-307", name: "Kičevo", i18n: {"mk":"Општина Кичево"} },
        { code: "MK-809", name: "Kisela Voda †", i18n: {"mk":"Општина Кисела Вода"} },
        { code: "MK-206", name: "Kočani", i18n: {"mk":"Општина Кочани"} },
        { code: "MK-407", name: "Konče", i18n: {"mk":"Општина Конче"} },
        { code: "MK-701", name: "Kratovo", i18n: {"mk":"Општина Кратово"} },
        { code: "MK-702", name: "Kriva Palanka", i18n: {"mk":"Општина Крива Паланка"} },
        { code: "MK-504", name: "Krivogaštani", i18n: {"mk":"Општина Кривогаштани"} },
        { code: "MK-505", name: "Kruševo", i18n: {"mk":"Општина Крушево"} },
        { code: "MK-703", name: "Kumanovo", i18n: {"mk":"Општина Куманово"} },
        { code: "MK-704", name: "Lipkovo", i18n: {"mk":"Општина Липково"} },
        { code: "MK-105", name: "Lozovo", i18n: {"mk":"Општина Лозово"} },
        { code: "MK-207", name: "Makedonska Kamenica", i18n: {"mk":"Општина Македонска Каменица"} },
        { code: "MK-308", name: "Makedonski Brod", i18n: {"mk":"Општина Македонски Брод"} },
        { code: "MK-607", name: "Mavrovo i Rostuše", i18n: {"mk":"Општина Маврово и Ростуше"} },
        { code: "MK-506", name: "Mogila", i18n: {"mk":"Општина Могила"} },
        { code: "MK-106", name: "Negotino", i18n: {"mk":"Општина Неготино"} },
        { code: "MK-507", name: "Novaci", i18n: {"mk":"Општина Новаци"} },
        { code: "MK-408", name: "Novo Selo", i18n: {"mk":"Општина Ново Село"} },
        { code: "MK-310", name: "Ohrid", i18n: {"mk":"Општина Охрид"} },
        { code: "MK-208", name: "Pehčevo", i18n: {"mk":"Општина Пехчево"} },
        { code: "MK-810", name: "Petrovec", i18n: {"mk":"Општина Петровец"} },
        { code: "MK-311", name: "Plasnica", i18n: {"mk":"Општина Пласница"} },
        { code: "MK-508", name: "Prilep", i18n: {"mk":"Општина Прилеп"} },
        { code: "MK-209", name: "Probištip", i18n: {"mk":"Општина Пробиштип"} },
        { code: "MK-409", name: "Radoviš", i18n: {"mk":"Општина Радовиш"} },
        { code: "MK-705", name: "Rankovce", i18n: {"mk":"Општина Ранковце"} },
        { code: "MK-509", name: "Resen", i18n: {"mk":"Општина Ресен"} },
        { code: "MK-107", name: "Rosoman", i18n: {"mk":"Општина Росоман"} },
        { code: "MK-811", name: "Saraj †", i18n: {"mk":"Општина Сарај"} },
        { code: "MK-812", name: "Sopište", i18n: {"mk":"Општина Сопиште"} },
        { code: "MK-706", name: "Staro Nagoričane", i18n: {"mk":"Општина Старо Нагоричане"} },
        { code: "MK-211", name: "Štip", i18n: {"mk":"Општина Штип"} },
        { code: "MK-312", name: "Struga", i18n: {"mk":"Општина Струга"} },
        { code: "MK-410", name: "Strumica", i18n: {"mk":"Општина Струмица"} },
        { code: "MK-813", name: "Studeničani", i18n: {"mk":"Општина Студеничани"} },
        { code: "MK-817", name: "Šuto Orizari †", i18n: {"mk":"Општина Шуто Оризари"} },
        { code: "MK-108", name: "Sveti Nikole", i18n: {"mk":"Општина Свети Николе"} },
        { code: "MK-608", name: "Tearce", i18n: {"mk":"Општина Теарце"} },
        { code: "MK-609", name: "Tetovo", i18n: {"mk":"Општина Тетово"} },
        { code: "MK-403", name: "Valandovo", i18n: {"mk":"Општина Валандово"} },
        { code: "MK-404", name: "Vasilevo", i18n: {"mk":"Општина Василево"} },
        { code: "MK-101", name: "Veles", i18n: {"mk":"Општина Велес"} },
        { code: "MK-301", name: "Vevčani", i18n: {"mk":"Општина Вевчани"} },
        { code: "MK-202", name: "Vinica", i18n: {"mk":"Општина Виница"} },
        { code: "MK-603", name: "Vrapčište", i18n: {"mk":"Општина Врапчиште"} },
        { code: "MK-806", name: "Zelenikovo", i18n: {"mk":"Општина Зелениково"} },
        { code: "MK-605", name: "Želino", i18n: {"mk":"Општина Желино"} },
        { code: "MK-204", name: "Zrnovci", i18n: {"mk":"Општина Зрновци"} },
    ],
    "ML": [
        { code: "ML-BKO", name: "Bamako", i18n: {} },
        { code: "ML-7", name: "Gao", i18n: {"fr":"Région de Gao"} },
        { code: "ML-1", name: "Kayes", i18n: {"fr":"Région de Kayes"} },
        { code: "ML-8", name: "Kidal", i18n: {"fr":"Région de Kidal"} },
        { code: "ML-2", name: "Koulikoro", i18n: {"fr":"Région de Koulikoro"} },
        { code: "ML-9", name: "Ménaka", i18n: {"fr":"Région de Ménaka"} },
        { code: "ML-5", name: "Mopti", i18n: {"fr":"Région de Mopti"} },
        { code: "ML-4", name: "Ségou", i18n: {"fr":"Région de Ségou"} },
        { code: "ML-3", name: "Sikasso", i18n: {"fr":"Région de Sikasso"} },
        { code: "ML-10", name: "Taoudénit", i18n: {"fr":"Région de Taoudénit"} },
        { code: "ML-6", name: "Tombouctou", i18n: {"fr":"Région de Tombouctou"} },
    ],
    "MM": [
        { code: "MM-07", name: "Ayeyarwady", i18n: {"my":"ဧရာဝတီတိုင်း"} },
        { code: "MM-02", name: "Bago", i18n: {"my":"ပဲခူးတိုင်း"} },
        { code: "MM-14", name: "Chin", i18n: {"my":"ချင်းပြည်နယ်"} },
        { code: "MM-11", name: "Kachin", i18n: {"my":"ကချင်ပြည်နယ်"} },
        { code: "MM-12", name: "Kayah", i18n: {"my":"ကယားပြည်နယ်"} },
        { code: "MM-13", name: "Kayin", i18n: {"my":"ကရင်ပြည်နယ်"} },
        { code: "MM-03", name: "Magway", i18n: {"my":"မကွေးတိုင်း"} },
        { code: "MM-04", name: "Mandalay", i18n: {"my":"မန္တလေးတိုင်း"} },
        { code: "MM-15", name: "Mon", i18n: {"my":"မွန်ပြည်နယ်"} },
        { code: "MM-18", name: "Naypyidaw", i18n: {"my":"နေပြည်တော် ပြည်ထောင်စုနယ်မြေ"} },
        { code: "MM-16", name: "Rakhine", i18n: {"my":"ရခိုင်ပြည်နယ်"} },
        { code: "MM-01", name: "Sagaing", i18n: {"my":"စစ်ကိုင်းတိုင်း"} },
        { code: "MM-17", name: "Shan", i18n: {"my":"ရှမ်းပြည်နယ်"} },
        { code: "MM-05", name: "Tanintharyi", i18n: {"my":"တနင်္သာရီတိုင်း"} },
        { code: "MM-06", name: "Yangon", i18n: {"my":"ရန်ကုန်တိုင်း"} },
    ],
    "MN": [
        { code: "MN-073", name: "Arkhangai", i18n: {"mn":"Архангай"} },
        { code: "MN-071", name: "Bayan-Ölgii", i18n: {"mn":"Баян-Өлгий"} },
        { code: "MN-069", name: "Bayankhongor", i18n: {"mn":"Баянхонгор"} },
        { code: "MN-067", name: "Bulgan", i18n: {"mn":"Булган"} },
        { code: "MN-037", name: "Darkhan-Uul", i18n: {"mn":"Дархан-Уул"} },
        { code: "MN-061", name: "Dornod", i18n: {"mn":"Дорнод"} },
        { code: "MN-063", name: "Dornogovi", i18n: {"mn":"Дорноговь"} },
        { code: "MN-059", name: "Dundgovi", i18n: {"mn":"Дундговь"} },
        { code: "MN-065", name: "Govi-Altai", i18n: {"mn":"Говь-Алтай"} },
        { code: "MN-064", name: "Govisümber", i18n: {"mn":"Говьсүмбэр"} },
        { code: "MN-039", name: "Khentii", i18n: {"mn":"Хэнтий"} },
        { code: "MN-043", name: "Khovd", i18n: {"mn":"Ховд"} },
        { code: "MN-041", name: "Khövsgöl", i18n: {"mn":"Хөвсгөл"} },
        { code: "MN-053", name: "Ömnögovi", i18n: {"mn":"Өмнөговь"} },
        { code: "MN-035", name: "Orkhon", i18n: {"mn":"Орхон"} },
        { code: "MN-055", name: "Övörkhangai", i18n: {"mn":"Өвөрхангай"} },
        { code: "MN-049", name: "Selenge", i18n: {"mn":"Сэлэнгэ"} },
        { code: "MN-051", name: "Sükhbaatar", i18n: {"mn":"Сүхбаатар"} },
        { code: "MN-047", name: "Töv", i18n: {"mn":"Төв"} },
        { code: "MN-1", name: "Ulaanbaatar", i18n: {"mn":"Улаанбаатар"} },
        { code: "MN-046", name: "Uvs", i18n: {"mn":"Увс"} },
        { code: "MN-057", name: "Zavkhan", i18n: {"mn":"Завхан"} },
    ],
    "MR": [
        { code: "MR-07", name: "Adrar", i18n: {"ar":"ولاية أدرار"} },
        { code: "MR-03", name: "Assaba", i18n: {"ar":"ولاية العصابة"} },
        { code: "MR-05", name: "Brakna", i18n: {"ar":"ولاية البراكنة"} },
        { code: "MR-08", name: "Dakhlet Nouadhibou", i18n: {"ar":"داخلة نواذيبو"} },
        { code: "MR-04", name: "Gorgol", i18n: {"ar":"ولاية كوركول"} },
        { code: "MR-10", name: "Guidimaka", i18n: {"ar":"ولاية غيديماغا"} },
        { code: "MR-01", name: "Hodh Ech Chargui", i18n: {"ar":"ولاية الحوض الشرقي"} },
        { code: "MR-02", name: "Hodh El Gharbi", i18n: {"ar":"ولاية الحوض الغربي"} },
        { code: "MR-12", name: "Inchiri", i18n: {"ar":"ولاية إينشيري"} },
        { code: "MR-14", name: "Nouakchott Nord", i18n: {"ar":"نواكشوط الشمالية"} },
        { code: "MR-13", name: "Nouakchott Ouest", i18n: {"ar":"ولاية نواكشوط الغربية"} },
        { code: "MR-15", name: "Nouakchott Sud", i18n: {"ar":"نواكشوط الجنوبية"} },
        { code: "MR-09", name: "Tagant", i18n: {"ar":"ولاية تكانت"} },
        { code: "MR-11", name: "Tiris Zemmour", i18n: {"ar":"ولاية تيرس زمور"} },
        { code: "MR-06", name: "Trarza", i18n: {"ar":"ولاية الترارزة"} },
    ],
    "MT": [
        { code: "MT-01", name: "Attard", i18n: {} },
        { code: "MT-02", name: "Balzan", i18n: {} },
        { code: "MT-03", name: "Birgu", i18n: {} },
        { code: "MT-04", name: "Birkirkara", i18n: {} },
        { code: "MT-05", name: "Birżebbuġa", i18n: {} },
        { code: "MT-06", name: "Cospicua", i18n: {} },
        { code: "MT-07", name: "Dingli", i18n: {} },
        { code: "MT-08", name: "Fgura", i18n: {} },
        { code: "MT-09", name: "Floriana", i18n: {} },
        { code: "MT-10", name: "Fontana", i18n: {} },
        { code: "MT-13", name: "Għajnsielem", i18n: {} },
        { code: "MT-14", name: "Għarb", i18n: {} },
        { code: "MT-15", name: "Għargħur", i18n: {} },
        { code: "MT-16", name: "Għasri", i18n: {} },
        { code: "MT-17", name: "Għaxaq", i18n: {} },
        { code: "MT-11", name: "Gudja", i18n: {} },
        { code: "MT-12", name: "Gżira", i18n: {} },
        { code: "MT-18", name: "Ħamrun", i18n: {} },
        { code: "MT-19", name: "Iklin", i18n: {} },
        { code: "MT-35", name: "Imtarfa", i18n: {} },
        { code: "MT-21", name: "Kalkara", i18n: {} },
        { code: "MT-22", name: "Kerċem", i18n: {} },
        { code: "MT-23", name: "Kirkop", i18n: {} },
        { code: "MT-24", name: "Lija", i18n: {} },
        { code: "MT-25", name: "Luqa", i18n: {} },
        { code: "MT-26", name: "Marsa", i18n: {} },
        { code: "MT-27", name: "Marsaskala", i18n: {} },
        { code: "MT-28", name: "Marsaxlokk", i18n: {} },
        { code: "MT-29", name: "Mdina", i18n: {} },
        { code: "MT-30", name: "Mellieħa", i18n: {} },
        { code: "MT-31", name: "Mġarr", i18n: {} },
        { code: "MT-32", name: "Mosta", i18n: {} },
        { code: "MT-33", name: "Mqabba", i18n: {} },
        { code: "MT-34", name: "Msida", i18n: {} },
        { code: "MT-36", name: "Munxar", i18n: {} },
        { code: "MT-37", name: "Nadur", i18n: {} },
        { code: "MT-38", name: "Naxxar", i18n: {} },
        { code: "MT-39", name: "Paola", i18n: {} },
        { code: "MT-40", name: "Pembroke", i18n: {} },
        { code: "MT-41", name: "Pietà", i18n: {} },
        { code: "MT-42", name: "Qala", i18n: {} },
        { code: "MT-43", name: "Qormi", i18n: {} },
        { code: "MT-44", name: "Qrendi", i18n: {} },
        { code: "MT-46", name: "Rabat", i18n: {} },
        { code: "MT-47", name: "Safi", i18n: {} },
        { code: "MT-50", name: "Saint Lawrence", i18n: {} },
        { code: "MT-49", name: "San Ġwann", i18n: {} },
        { code: "MT-52", name: "Sannat", i18n: {} },
        { code: "MT-53", name: "Santa Luċija", i18n: {} },
        { code: "MT-54", name: "Santa Venera", i18n: {} },
        { code: "MT-20", name: "Senglea", i18n: {} },
        { code: "MT-55", name: "Siġġiewi", i18n: {} },
        { code: "MT-56", name: "Sliema", i18n: {} },
        { code: "MT-48", name: "St. Julian’s", i18n: {} },
        { code: "MT-51", name: "St. Paul’s Bay", i18n: {} },
        { code: "MT-57", name: "Swieqi", i18n: {} },
        { code: "MT-58", name: "Ta’ Xbiex", i18n: {} },
        { code: "MT-59", name: "Tarxien", i18n: {} },
        { code: "MT-60", name: "Valletta", i18n: {} },
        { code: "MT-45", name: "Victoria", i18n: {} },
        { code: "MT-61", name: "Xagħra", i18n: {} },
        { code: "MT-62", name: "Xewkija", i18n: {} },
        { code: "MT-63", name: "Xgħajra", i18n: {} },
        { code: "MT-64", name: "Żabbar", i18n: {} },
        { code: "MT-66", name: "Żebbuġ", i18n: {} },
        { code: "MT-65", name: "Żebbuġ Gozo", i18n: {} },
        { code: "MT-67", name: "Żejtun", i18n: {} },
        { code: "MT-68", name: "Żurrieq", i18n: {} },
    ],
    "MU": [
        { code: "MU-AG", name: "Agaléga", i18n: {} },
        { code: "MU-CC", name: "Cargados Carajos", i18n: {"fr":"Saint-Brandon"} },
        { code: "MU-FL", name: "Flacq", i18n: {} },
        { code: "MU-GP", name: "Grand Port", i18n: {} },
        { code: "MU-MO", name: "Moka", i18n: {} },
        { code: "MU-PA", name: "Pamplemousses", i18n: {} },
        { code: "MU-PW", name: "Plaines Wilhems", i18n: {} },
        { code: "MU-PL", name: "Port Louis District", i18n: {"fr":"Port Louis"} },
        { code: "MU-RR", name: "Rivière du Rempart", i18n: {} },
        { code: "MU-BL", name: "Rivière Noire", i18n: {} },
        { code: "MU-RO", name: "Rodrigues", i18n: {} },
        { code: "MU-SA", name: "Savanne", i18n: {} },
    ],
    "MV": [
        { code: "MV-01", name: "Addu", i18n: {} },
        { code: "MV-02", name: "Alif Alif", i18n: {} },
        { code: "MV-00", name: "Alif Dhaal", i18n: {} },
        { code: "MV-20", name: "Baa", i18n: {} },
        { code: "MV-17", name: "Dhaalu", i18n: {} },
        { code: "MV-14", name: "Faafu", i18n: {} },
        { code: "MV-27", name: "Gaafu Alif", i18n: {} },
        { code: "MV-28", name: "Gaafu Dhaalu", i18n: {} },
        { code: "MV-29", name: "Gnaviyani", i18n: {} },
        { code: "MV-07", name: "Haa Alif", i18n: {} },
        { code: "MV-23", name: "Haa Dhaalu", i18n: {} },
        { code: "MV-26", name: "Kaafu", i18n: {} },
        { code: "MV-05", name: "Laamu", i18n: {} },
        { code: "MV-03", name: "Lhaviyani", i18n: {} },
        { code: "MV-MLE", name: "Malé", i18n: {} },
        { code: "MV-12", name: "Meemu", i18n: {} },
        { code: "MV-25", name: "Noonu", i18n: {} },
        { code: "MV-13", name: "Raa", i18n: {} },
        { code: "MV-24", name: "Shaviyani", i18n: {} },
        { code: "MV-08", name: "Thaa", i18n: {} },
        { code: "MV-04", name: "Vaavu", i18n: {} },
    ],
    "MW": [
        { code: "MW-BA", name: "Balaka", i18n: {} },
        { code: "MW-BL", name: "Blantyre", i18n: {} },
        { code: "MW-C", name: "Central", i18n: {} },
        { code: "MW-CK", name: "Chikwawa", i18n: {} },
        { code: "MW-CR", name: "Chiradzulu", i18n: {} },
        { code: "MW-CT", name: "Chitipa", i18n: {} },
        { code: "MW-DE", name: "Dedza", i18n: {} },
        { code: "MW-DO", name: "Dowa", i18n: {} },
        { code: "MW-KR", name: "Karonga", i18n: {} },
        { code: "MW-KS", name: "Kasungu", i18n: {} },
        { code: "MW-LK", name: "Likoma", i18n: {} },
        { code: "MW-LI", name: "Lilongwe", i18n: {} },
        { code: "MW-MH", name: "Machinga", i18n: {} },
        { code: "MW-MG", name: "Mangochi", i18n: {} },
        { code: "MW-MC", name: "Mchinji", i18n: {} },
        { code: "MW-MU", name: "Mulanje", i18n: {} },
        { code: "MW-MW", name: "Mwanza", i18n: {} },
        { code: "MW-MZ", name: "Mzimba", i18n: {} },
        { code: "MW-NE", name: "Neno", i18n: {} },
        { code: "MW-NB", name: "Nkhata Bay", i18n: {} },
        { code: "MW-NK", name: "Nkhotakota", i18n: {} },
        { code: "MW-N", name: "Northern", i18n: {} },
        { code: "MW-NS", name: "Nsanje", i18n: {} },
        { code: "MW-NU", name: "Ntcheu", i18n: {} },
        { code: "MW-NI", name: "Ntchisi", i18n: {} },
        { code: "MW-PH", name: "Phalombe", i18n: {} },
        { code: "MW-RU", name: "Rumphi", i18n: {} },
        { code: "MW-SA", name: "Salima", i18n: {} },
        { code: "MW-S", name: "Southern", i18n: {} },
        { code: "MW-TH", name: "Thyolo", i18n: {} },
        { code: "MW-ZO", name: "Zomba", i18n: {} },
    ],
    "MX": [
        { code: "MX-AGU", name: "Aguascalientes", i18n: {} },
        { code: "MX-BCN", name: "Baja California", i18n: {} },
        { code: "MX-BCS", name: "Baja California Sur", i18n: {} },
        { code: "MX-CAM", name: "Campeche", i18n: {} },
        { code: "MX-CHP", name: "Chiapas", i18n: {} },
        { code: "MX-CHH", name: "Chihuahua", i18n: {} },
        { code: "MX-CMX", name: "Ciudad de Mexico", i18n: {"es":"Ciudad de México"} },
        { code: "MX-COA", name: "Coahuila", i18n: {"es":"Coahuila de Zaragoza"} },
        { code: "MX-COL", name: "Colima", i18n: {} },
        { code: "MX-DUR", name: "Durango", i18n: {} },
        { code: "MX-GUA", name: "Guanajuato", i18n: {} },
        { code: "MX-GRO", name: "Guerrero", i18n: {"es":"Estado de Guerrero"} },
        { code: "MX-HID", name: "Hidalgo", i18n: {"es":"Estado de Hidalgo"} },
        { code: "MX-JAL", name: "Jalisco", i18n: {} },
        { code: "MX-MEX", name: "Mexico State", i18n: {"es":"Estado de México"} },
        { code: "MX-MIC", name: "Michoacán", i18n: {} },
        { code: "MX-MOR", name: "Morelos", i18n: {} },
        { code: "MX-NAY", name: "Nayarit", i18n: {} },
        { code: "MX-NLE", name: "Nuevo León", i18n: {} },
        { code: "MX-OAX", name: "Oaxaca", i18n: {} },
        { code: "MX-PUE", name: "Puebla", i18n: {} },
        { code: "MX-QUE", name: "Querétaro", i18n: {} },
        { code: "MX-ROO", name: "Quintana Roo", i18n: {} },
        { code: "MX-SLP", name: "San Luis Potosí", i18n: {} },
        { code: "MX-SIN", name: "Sinaloa", i18n: {} },
        { code: "MX-SON", name: "Sonora", i18n: {} },
        { code: "MX-TAB", name: "Tabasco", i18n: {} },
        { code: "MX-TAM", name: "Tamaulipas", i18n: {} },
        { code: "MX-TLA", name: "Tlaxcala", i18n: {} },
        { code: "MX-VER", name: "Veracruz", i18n: {} },
        { code: "MX-YUC", name: "Yucatán", i18n: {} },
        { code: "MX-ZAC", name: "Zacatecas", i18n: {} },
    ],
    "MY": [
        { code: "MY-01", name: "Johor", i18n: {} },
        { code: "MY-02", name: "Kedah", i18n: {} },
        { code: "MY-03", name: "Kelantan", i18n: {} },
        { code: "MY-14", name: "Kuala Lumpur", i18n: {} },
        { code: "MY-15", name: "Labuan", i18n: {} },
        { code: "MY-04", name: "Malacca", i18n: {"ms":"Melaka"} },
        { code: "MY-05", name: "Negeri Sembilan", i18n: {} },
        { code: "MY-06", name: "Pahang", i18n: {} },
        { code: "MY-07", name: "Penang", i18n: {"ms":"Pulau Pinang"} },
        { code: "MY-08", name: "Perak", i18n: {"ms":"Negeri Perak"} },
        { code: "MY-09", name: "Perlis", i18n: {} },
        { code: "MY-16", name: "Putrajaya", i18n: {} },
        { code: "MY-12", name: "Sabah", i18n: {} },
        { code: "MY-13", name: "Sarawak", i18n: {} },
        { code: "MY-10", name: "Selangor", i18n: {} },
        { code: "MY-11", name: "Terengganu", i18n: {} },
    ],
    "MZ": [
        { code: "MZ-P", name: "Cabo Delgado", i18n: {} },
        { code: "MZ-G", name: "Gaza", i18n: {} },
        { code: "MZ-I", name: "Inhambane", i18n: {} },
        { code: "MZ-B", name: "Manica", i18n: {} },
        { code: "MZ-MPM", name: "Maputo", i18n: {"pt":"Maputo²"} },
        { code: "MZ-L", name: "Maputo Province", i18n: {"pt":"Maputo"} },
        { code: "MZ-N", name: "Nampula", i18n: {} },
        { code: "MZ-A", name: "Niassa", i18n: {} },
        { code: "MZ-S", name: "Sofala", i18n: {} },
        { code: "MZ-T", name: "Tete", i18n: {} },
        { code: "MZ-Q", name: "Zambezia", i18n: {"pt":"Zambézia"} },
    ],
    "NA": [
        { code: "NA-ER", name: "Erongo", i18n: {} },
        { code: "NA-HA", name: "Hardap", i18n: {} },
        { code: "NA-KA", name: "Karas", i18n: {} },
        { code: "NA-KE", name: "Kavango East", i18n: {} },
        { code: "NA-KW", name: "Kavango West", i18n: {} },
        { code: "NA-KH", name: "Khomas", i18n: {} },
        { code: "NA-KU", name: "Kunene", i18n: {} },
        { code: "NA-OW", name: "Ohangwena", i18n: {} },
        { code: "NA-OH", name: "Omaheke", i18n: {} },
        { code: "NA-OS", name: "Omusati", i18n: {} },
        { code: "NA-ON", name: "Oshana", i18n: {} },
        { code: "NA-OT", name: "Oshikoto", i18n: {} },
        { code: "NA-OD", name: "Otjozondjupa", i18n: {} },
        { code: "NA-CA", name: "Zambezi", i18n: {} },
    ],
    "NE": [
        { code: "NE-1", name: "Agadez", i18n: {} },
        { code: "NE-2", name: "Diffa", i18n: {} },
        { code: "NE-3", name: "Dosso", i18n: {} },
        { code: "NE-4", name: "Maradi", i18n: {} },
        { code: "NE-8", name: "Niamey", i18n: {} },
        { code: "NE-5", name: "Tahoua", i18n: {} },
        { code: "NE-6", name: "Tillabéri", i18n: {} },
        { code: "NE-7", name: "Zinder", i18n: {} },
    ],
    "NG": [
        { code: "NG-AB", name: "Abia", i18n: {} },
        { code: "NG-AD", name: "Adamawa", i18n: {} },
        { code: "NG-AK", name: "Akwa Ibom", i18n: {} },
        { code: "NG-AN", name: "Anambra", i18n: {} },
        { code: "NG-BA", name: "Bauchi", i18n: {} },
        { code: "NG-BY", name: "Bayelsa", i18n: {} },
        { code: "NG-BE", name: "Benue", i18n: {} },
        { code: "NG-BO", name: "Borno", i18n: {} },
        { code: "NG-CR", name: "Cross River", i18n: {} },
        { code: "NG-DE", name: "Delta", i18n: {} },
        { code: "NG-EB", name: "Ebonyi", i18n: {} },
        { code: "NG-ED", name: "Edo", i18n: {} },
        { code: "NG-EK", name: "Ekiti", i18n: {} },
        { code: "NG-EN", name: "Enugu", i18n: {} },
        { code: "NG-FC", name: "Federal Capital Territory", i18n: {} },
        { code: "NG-GO", name: "Gombe", i18n: {} },
        { code: "NG-IM", name: "Imo", i18n: {} },
        { code: "NG-JI", name: "Jigawa", i18n: {} },
        { code: "NG-KD", name: "Kaduna", i18n: {} },
        { code: "NG-KN", name: "Kano", i18n: {} },
        { code: "NG-KT", name: "Katsina", i18n: {} },
        { code: "NG-KE", name: "Kebbi", i18n: {} },
        { code: "NG-KO", name: "Kogi", i18n: {} },
        { code: "NG-KW", name: "Kwara", i18n: {} },
        { code: "NG-LA", name: "Lagos", i18n: {} },
        { code: "NG-NA", name: "Nasarawa", i18n: {} },
        { code: "NG-NI", name: "Niger", i18n: {} },
        { code: "NG-OG", name: "Ogun", i18n: {} },
        { code: "NG-ON", name: "Ondo", i18n: {} },
        { code: "NG-OS", name: "Osun", i18n: {} },
        { code: "NG-OY", name: "Oyo", i18n: {} },
        { code: "NG-PL", name: "Plateau", i18n: {} },
        { code: "NG-RI", name: "Rivers", i18n: {} },
        { code: "NG-SO", name: "Sokoto", i18n: {} },
        { code: "NG-TA", name: "Taraba", i18n: {} },
        { code: "NG-YO", name: "Yobe", i18n: {} },
        { code: "NG-ZA", name: "Zamfara", i18n: {} },
    ],
    "NI": [
        { code: "NI-AN", name: "Atlántico Norte", i18n: {"es":"Región Autónoma del Atlántico Norte"} },
        { code: "NI-AS", name: "Atlántico Sur", i18n: {"es":"Región Autónoma del Atlántico Sur"} },
        { code: "NI-BO", name: "Boaco", i18n: {"es":"Departamento de Boaco"} },
        { code: "NI-CA", name: "Carazo", i18n: {"es":"Departamento de Carazo"} },
        { code: "NI-CI", name: "Chinandega", i18n: {"es":"Departamento de Chinandega"} },
        { code: "NI-CO", name: "Chontales", i18n: {"es":"Departamento de Chontales"} },
        { code: "NI-ES", name: "Estelí", i18n: {"es":"Departamento de Estelí"} },
        { code: "NI-GR", name: "Granada", i18n: {"es":"Departamento de Granada"} },
        { code: "NI-JI", name: "Jinotega", i18n: {"es":"Departamento de Jinotega"} },
        { code: "NI-LE", name: "León", i18n: {"es":"Departamento de León"} },
        { code: "NI-MD", name: "Madriz", i18n: {"es":"Departamento de Madriz"} },
        { code: "NI-MN", name: "Managua", i18n: {"es":"Departamento de Managua"} },
        { code: "NI-MS", name: "Masaya", i18n: {"es":"Departamento de Masaya"} },
        { code: "NI-MT", name: "Matagalpa", i18n: {"es":"Departamento de Matagalpa"} },
        { code: "NI-NS", name: "Nueva Segovia", i18n: {} },
        { code: "NI-SJ", name: "Río San Juan", i18n: {"es":"Departamento de Río San Juan"} },
        { code: "NI-RI", name: "Rivas", i18n: {"es":"Departamento de Rivas"} },
    ],
    "NL": [
        { code: "NL-AW", name: "Aruba", i18n: {} },
        { code: "NL-BQ1", name: "Bonaire", i18n: {} },
        { code: "NL-CW", name: "Curaçao", i18n: {} },
        { code: "NL-DR", name: "Drenthe", i18n: {} },
        { code: "NL-FL", name: "Flevoland", i18n: {} },
        { code: "NL-FR", name: "Friesland", i18n: {} },
        { code: "NL-GE", name: "Gelderland", i18n: {} },
        { code: "NL-GR", name: "Groningen", i18n: {} },
        { code: "NL-LI", name: "Limburg", i18n: {} },
        { code: "NL-NB", name: "North Brabant", i18n: {"nl":"Noord-Brabant"} },
        { code: "NL-NH", name: "North Holland", i18n: {"nl":"Noord-Holland"} },
        { code: "NL-OV", name: "Overijssel", i18n: {} },
        { code: "NL-BQ2", name: "Saba", i18n: {} },
        { code: "NL-BQ3", name: "Sint Eustatius", i18n: {} },
        { code: "NL-SX", name: "Sint Maarten", i18n: {} },
        { code: "NL-ZH", name: "South Holland", i18n: {"nl":"Zuid-Holland"} },
        { code: "NL-UT", name: "Utrecht", i18n: {} },
        { code: "NL-ZE", name: "Zeeland", i18n: {} },
    ],
    "NO": [
        { code: "NO-42", name: "Agder", i18n: {} },
        { code: "NO-34", name: "Innlandet", i18n: {} },
        { code: "NO-22", name: "Jan Mayen", i18n: {} },
        { code: "NO-15", name: "Møre og Romsdal", i18n: {} },
        { code: "NO-18", name: "Nordland", i18n: {} },
        { code: "NO-03", name: "Oslo", i18n: {} },
        { code: "NO-11", name: "Rogaland", i18n: {} },
        { code: "NO-21", name: "Svalbard", i18n: {} },
        { code: "NO-54", name: "Tromssan ja Finmarkun", i18n: {} },
        { code: "NO-50", name: "Trøndelag", i18n: {} },
        { code: "NO-38", name: "Vestfold og Telemark", i18n: {} },
        { code: "NO-46", name: "Vestland", i18n: {} },
        { code: "NO-30", name: "Viken", i18n: {} },
    ],
    "NP": [
        { code: "NP-P4", name: "Gandaki²", i18n: {} },
        { code: "NP-P6", name: "Karnali²", i18n: {"ne":"कर्णाली प्रदेश"} },
        { code: "NP-P1", name: "Province 1", i18n: {"ne":"कोशी प्रदेश"} },
        { code: "NP-P2", name: "Province 2", i18n: {"ne":"मधेश प्रदेश"} },
        { code: "NP-P3", name: "Province 3", i18n: {"ne":"बागमती प्रदेश"} },
        { code: "NP-P5", name: "Province 5", i18n: {"ne":"लुम्बिनी प्रदेश"} },
        { code: "NP-P7", name: "Province 7", i18n: {"ne":"सुदूरपश्चिम प्रदेश"} },
    ],
    "NR": [
        { code: "NR-01", name: "Aiwo", i18n: {} },
        { code: "NR-02", name: "Anabar", i18n: {} },
        { code: "NR-03", name: "Anetan", i18n: {} },
        { code: "NR-04", name: "Anibare", i18n: {} },
        { code: "NR-05", name: "Baiti", i18n: {} },
        { code: "NR-06", name: "Boe", i18n: {} },
        { code: "NR-07", name: "Buada", i18n: {} },
        { code: "NR-08", name: "Denigomodu", i18n: {} },
        { code: "NR-09", name: "Ewa", i18n: {} },
        { code: "NR-10", name: "Ijuw", i18n: {} },
        { code: "NR-11", name: "Meneng", i18n: {} },
        { code: "NR-12", name: "Nibok", i18n: {} },
        { code: "NR-13", name: "Uaboe", i18n: {} },
        { code: "NR-14", name: "Yaren", i18n: {} },
    ],
    "NZ": [
        { code: "NZ-AUK", name: "Auckland", i18n: {} },
        { code: "NZ-BOP", name: "Bay of Plenty", i18n: {} },
        { code: "NZ-CAN", name: "Canterbury", i18n: {} },
        { code: "NZ-CIT", name: "Chatham Islands", i18n: {} },
        { code: "NZ-GIS", name: "Gisborne", i18n: {} },
        { code: "NZ-HKB", name: "Hawke’s Bay", i18n: {} },
        { code: "NZ-MWT", name: "Manawatu-Wanganui", i18n: {} },
        { code: "NZ-MBH", name: "Marl", i18n: {} },
        { code: "NZ-NSN", name: "Nelson", i18n: {} },
        { code: "NZ-NTL", name: "Northland", i18n: {} },
        { code: "NZ-OTA", name: "Otago", i18n: {} },
        { code: "NZ-STL", name: "Southland", i18n: {} },
        { code: "NZ-TKI", name: "Taranaki", i18n: {} },
        { code: "NZ-TAS", name: "Tasman", i18n: {} },
        { code: "NZ-WKO", name: "Waikato", i18n: {} },
        { code: "NZ-WGN", name: "Wellington", i18n: {} },
        { code: "NZ-WTC", name: "West Coast", i18n: {} },
    ],
    "OM": [
        { code: "OM-DA", name: "Ad Dakhiliyah", i18n: {"ar":"محافظة الداخلية"} },
        { code: "OM-ZA", name: "Ad Dhahirah", i18n: {"ar":"محافظة الظاهرة"} },
        { code: "OM-BU", name: "Al Buraimi", i18n: {"ar":"محافظة البريمي"} },
        { code: "OM-WU", name: "Al Wusta", i18n: {"ar":"محافظة الوسطى"} },
        { code: "OM-ZU", name: "Dhofar", i18n: {"ar":"محافظة ظفار"} },
        { code: "OM-BJ", name: "Janub al Batinah", i18n: {"ar":"محافظة جنوب الباطنة"} },
        { code: "OM-SJ", name: "Janub ash Sharqiyah", i18n: {"ar":"محافظة جنوب الشرقية"} },
        { code: "OM-MU", name: "Musandam", i18n: {"ar":"محافظة مسندم"} },
        { code: "OM-MA", name: "Muscat", i18n: {"ar":"محافظة مسقط"} },
        { code: "OM-BS", name: "Shamal al Batinah", i18n: {"ar":"محافظة شمال الباطنة"} },
        { code: "OM-SS", name: "Shamal ash Sharqiyah", i18n: {"ar":"محافظة شمال الشرقية"} },
    ],
    "PA": [
        { code: "PA-1", name: "Bocas del Toro", i18n: {"es":"Provincia de Bocas del Toro"} },
        { code: "PA-4", name: "Chiriquí", i18n: {"es":"Provincia de Chiriquí"} },
        { code: "PA-2", name: "Coclé", i18n: {"es":"Provincia de Coclé"} },
        { code: "PA-3", name: "Colón", i18n: {"es":"Provincia de Colón"} },
        { code: "PA-5", name: "Darién", i18n: {"es":"Provincia de Darién"} },
        { code: "PA-EM", name: "Emberá", i18n: {"es":"Emberá-Wounaan"} },
        { code: "PA-KY", name: "Guna Yala", i18n: {} },
        { code: "PA-6", name: "Herrera", i18n: {"es":"Provincia de Herrera"} },
        { code: "PA-7", name: "Los Santos", i18n: {"es":"Provincia de Los Santos"} },
        { code: "PA-NT", name: "Naso Tjër Di", i18n: {"es":"Comarca Naso Tjër-Di"} },
        { code: "PA-NB", name: "Ngöbe-Buglé", i18n: {"es":"Ngäbe-Buglé"} },
        { code: "PA-8", name: "Panamá", i18n: {"es":"Provincia de Panamá"} },
        { code: "PA-9", name: "Veraguas", i18n: {"es":"Provincia de Veraguas"} },
        { code: "PA-10", name: "West Panamá", i18n: {"es":"Provincia de Panamá Oeste"} },
    ],
    "PE": [
        { code: "PE-AMA", name: "Amazonas", i18n: {"es":"Departamento de Amazonas"} },
        { code: "PE-ANC", name: "Ancash", i18n: {"es":"Departamento de Áncash"} },
        { code: "PE-APU", name: "Apurímac", i18n: {"es":"Departamento de Apurímac"} },
        { code: "PE-ARE", name: "Arequipa", i18n: {} },
        { code: "PE-AYA", name: "Ayacucho", i18n: {"es":"Departamento de Ayacucho"} },
        { code: "PE-CAJ", name: "Cajamarca", i18n: {"es":"Departamento de Cajamarca"} },
        { code: "PE-CUS", name: "Cusco", i18n: {"es":"Departamento de Cuzco"} },
        { code: "PE-CAL", name: "El Callao", i18n: {"es":"Gobierno Regional del Callao"} },
        { code: "PE-HUV", name: "Huancavelica", i18n: {"es":"Departamento de Huancavelica"} },
        { code: "PE-HUC", name: "Huánuco", i18n: {"es":"Departamento de Huánuco"} },
        { code: "PE-ICA", name: "Ica", i18n: {"es":"Departamento de Ica"} },
        { code: "PE-JUN", name: "Junín", i18n: {"es":"Departamento de Junín"} },
        { code: "PE-LAL", name: "La Libertad", i18n: {"es":"Departamento de La Libertad"} },
        { code: "PE-LAM", name: "Lambayeque", i18n: {"es":"Departamento de Lambayeque"} },
        { code: "PE-LMA", name: "Lima", i18n: {"es":"Provincia de Lima"} },
        { code: "PE-LIM", name: "Lima Region", i18n: {"es":"Lima"} },
        { code: "PE-LOR", name: "Loreto", i18n: {"es":"Departamento de Loreto"} },
        { code: "PE-MDD", name: "Madre de Dios", i18n: {"es":"Departamento de Madre de Dios"} },
        { code: "PE-MOQ", name: "Moquegua", i18n: {"es":"Departamento de Moquegua"} },
        { code: "PE-PAS", name: "Pasco", i18n: {"es":"Departamento de Pasco"} },
        { code: "PE-PIU", name: "Piura", i18n: {"es":"Departamento de Piura"} },
        { code: "PE-PUN", name: "Puno", i18n: {"es":"Departamento de Puno"} },
        { code: "PE-SAM", name: "San Martín", i18n: {"es":"Departamento de San Martín"} },
        { code: "PE-TAC", name: "Tacna", i18n: {"es":"Departamento de Tacna"} },
        { code: "PE-TUM", name: "Tumbes", i18n: {"es":"Departamento de Tumbes"} },
        { code: "PE-UCA", name: "Ucayali", i18n: {"es":"Departamento de Ucayali"} },
    ],
    "PG": [
        { code: "PG-NSB", name: "Bougainville", i18n: {} },
        { code: "PG-CPM", name: "Central", i18n: {} },
        { code: "PG-CPK", name: "Chimbu", i18n: {} },
        { code: "PG-EBR", name: "East New Britain", i18n: {} },
        { code: "PG-ESW", name: "East Sepik", i18n: {} },
        { code: "PG-EHG", name: "Eastern Highlands", i18n: {} },
        { code: "PG-EPW", name: "Enga", i18n: {} },
        { code: "PG-GPK", name: "Gulf", i18n: {} },
        { code: "PG-HLA", name: "Hela", i18n: {} },
        { code: "PG-JWK", name: "Jiwaka", i18n: {} },
        { code: "PG-MPM", name: "Madang", i18n: {} },
        { code: "PG-MRL", name: "Manus", i18n: {} },
        { code: "PG-MBA", name: "Milne Bay", i18n: {} },
        { code: "PG-MPL", name: "Morobe", i18n: {} },
        { code: "PG-NIK", name: "New Ireland", i18n: {} },
        { code: "PG-NPP", name: "Oro", i18n: {} },
        { code: "PG-NCD", name: "Port Moresby", i18n: {} },
        { code: "PG-SAN", name: "Sandaun", i18n: {} },
        { code: "PG-SHM", name: "Southern Highlands", i18n: {} },
        { code: "PG-WBK", name: "West New Britain", i18n: {} },
        { code: "PG-WPD", name: "Western", i18n: {} },
        { code: "PG-WHM", name: "Western Highlands", i18n: {} },
    ],
    "PH": [
        { code: "PH-ABR", name: "Abra", i18n: {} },
        { code: "PH-AGN", name: "Agusan del Norte", i18n: {} },
        { code: "PH-AGS", name: "Agusan del Sur", i18n: {} },
        { code: "PH-AKL", name: "Aklan", i18n: {} },
        { code: "PH-ALB", name: "Albay", i18n: {} },
        { code: "PH-ANT", name: "Antique", i18n: {} },
        { code: "PH-APA", name: "Apayao", i18n: {} },
        { code: "PH-AUR", name: "Aurora", i18n: {} },
        { code: "PH-BAS", name: "Basilan", i18n: {} },
        { code: "PH-BAN", name: "Bataan", i18n: {} },
        { code: "PH-BTN", name: "Batanes", i18n: {} },
        { code: "PH-BTG", name: "Batangas", i18n: {} },
        { code: "PH-BEN", name: "Benguet", i18n: {} },
        { code: "PH-05", name: "Bicol", i18n: {} },
        { code: "PH-BIL", name: "Biliran", i18n: {} },
        { code: "PH-BOH", name: "Bohol", i18n: {} },
        { code: "PH-BUK", name: "Bukidnon", i18n: {} },
        { code: "PH-BUL", name: "Bulacan", i18n: {} },
        { code: "PH-CAG", name: "Cagayan", i18n: {} },
        { code: "PH-02", name: "Cagayan Valley", i18n: {} },
        { code: "PH-40", name: "Calabarzon", i18n: {} },
        { code: "PH-CAN", name: "Camarines Norte", i18n: {} },
        { code: "PH-CAS", name: "Camarines Sur", i18n: {} },
        { code: "PH-CAM", name: "Camiguin", i18n: {} },
        { code: "PH-CAP", name: "Capiz", i18n: {} },
        { code: "PH-13", name: "Caraga", i18n: {} },
        { code: "PH-CAT", name: "Catanduanes", i18n: {} },
        { code: "PH-CAV", name: "Cavite", i18n: {} },
        { code: "PH-CEB", name: "Cebu", i18n: {} },
        { code: "PH-03", name: "Central Luzon", i18n: {} },
        { code: "PH-07", name: "Central Visayas", i18n: {} },
        { code: "PH-COM", name: "Compostela Valley", i18n: {} },
        { code: "PH-15", name: "Cordillera Administrative", i18n: {} },
        { code: "PH-NCO", name: "Cotabato", i18n: {} },
        { code: "PH-11", name: "Davao", i18n: {} },
        { code: "PH-DAV", name: "Davao del Norte", i18n: {} },
        { code: "PH-DAS", name: "Davao del Sur", i18n: {} },
        { code: "PH-DVO", name: "Davao Occidental", i18n: {} },
        { code: "PH-DAO", name: "Davao Oriental", i18n: {} },
        { code: "PH-DIN", name: "Dinagat Islands", i18n: {} },
        { code: "PH-EAS", name: "Eastern Samar", i18n: {} },
        { code: "PH-08", name: "Eastern Visayas", i18n: {} },
        { code: "PH-GUI", name: "Guimaras", i18n: {} },
        { code: "PH-IFU", name: "Ifugao", i18n: {} },
        { code: "PH-01", name: "Ilocos", i18n: {} },
        { code: "PH-ILN", name: "Ilocos Norte", i18n: {} },
        { code: "PH-ILS", name: "Ilocos Sur", i18n: {} },
        { code: "PH-ILI", name: "Iloilo", i18n: {} },
        { code: "PH-ISA", name: "Isabela", i18n: {} },
        { code: "PH-KAL", name: "Kalinga", i18n: {} },
        { code: "PH-LUN", name: "La Union", i18n: {} },
        { code: "PH-LAG", name: "Laguna", i18n: {} },
        { code: "PH-LAN", name: "Lanao del Norte", i18n: {} },
        { code: "PH-LAS", name: "Lanao del Sur", i18n: {} },
        { code: "PH-LEY", name: "Leyte", i18n: {} },
        { code: "PH-MGN", name: "Maguindanao del Norte", i18n: {} },
        { code: "PH-MGS", name: "Maguindanao del Sur", i18n: {} },
        { code: "PH-MAD", name: "Marinduque", i18n: {} },
        { code: "PH-MAS", name: "Masbate", i18n: {} },
        { code: "PH-00", name: "Metro Manila", i18n: {} },
        { code: "PH-41", name: "Mimaropa", i18n: {} },
        { code: "PH-MSC", name: "Misamis Occidental", i18n: {} },
        { code: "PH-MSR", name: "Misamis Oriental", i18n: {} },
        { code: "PH-MOU", name: "Mountain", i18n: {} },
        { code: "PH-14", name: "Muslim Mindanao", i18n: {} },
        { code: "PH-NEC", name: "Negros Occidental", i18n: {} },
        { code: "PH-NER", name: "Negros Oriental", i18n: {} },
        { code: "PH-10", name: "Northern Mindanao", i18n: {} },
        { code: "PH-NSA", name: "Northern Samar", i18n: {} },
        { code: "PH-NUE", name: "Nueva Ecija", i18n: {} },
        { code: "PH-NUV", name: "Nueva Vizcaya", i18n: {} },
        { code: "PH-MDC", name: "Occidental Mindoro", i18n: {} },
        { code: "PH-MDR", name: "Oriental Mindoro", i18n: {} },
        { code: "PH-PLW", name: "Palawan", i18n: {} },
        { code: "PH-PAM", name: "Pampanga", i18n: {} },
        { code: "PH-PAN", name: "Pangasinan", i18n: {} },
        { code: "PH-QUE", name: "Quezon", i18n: {} },
        { code: "PH-QUI", name: "Quirino", i18n: {} },
        { code: "PH-RIZ", name: "Rizal", i18n: {} },
        { code: "PH-ROM", name: "Romblon", i18n: {} },
        { code: "PH-WSA", name: "Samar", i18n: {} },
        { code: "PH-SAR", name: "Sarangani", i18n: {} },
        { code: "PH-SIG", name: "Siquijor", i18n: {} },
        { code: "PH-12", name: "Soccsksargen", i18n: {} },
        { code: "PH-SOR", name: "Sorsogon", i18n: {} },
        { code: "PH-SCO", name: "South Cotabato", i18n: {} },
        { code: "PH-SLE", name: "Southern Leyte", i18n: {} },
        { code: "PH-SUK", name: "Sultan Kudarat", i18n: {} },
        { code: "PH-SLU", name: "Sulu", i18n: {} },
        { code: "PH-SUN", name: "Surigao del Norte", i18n: {} },
        { code: "PH-SUR", name: "Surigao del Sur", i18n: {} },
        { code: "PH-TAR", name: "Tarlac", i18n: {} },
        { code: "PH-TAW", name: "Tawi-Tawi", i18n: {} },
        { code: "PH-06", name: "Western Visayas", i18n: {} },
        { code: "PH-ZMB", name: "Zambales", i18n: {} },
        { code: "PH-ZAN", name: "Zamboanga del Norte", i18n: {} },
        { code: "PH-ZAS", name: "Zamboanga del Sur", i18n: {} },
        { code: "PH-09", name: "Zamboanga Peninsula", i18n: {} },
        { code: "PH-ZSI", name: "Zamboanga Sibugay", i18n: {} },
    ],
    "PK": [
        { code: "PK-JK", name: "Azad Kashmir", i18n: {"ur":"آزاد کشمیر"} },
        { code: "PK-BA", name: "Balochistan", i18n: {"ur":"بلوچستان"} },
        { code: "PK-GB", name: "Gilgit-Baltistan", i18n: {"ur":"گلگت بلتستان"} },
        { code: "PK-IS", name: "Islamabad", i18n: {"ur":"وفاقی دارالحکومت"} },
        { code: "PK-KP", name: "Khyber Pakhtunkhwa", i18n: {"ur":"خیبر پختونخوا"} },
        { code: "PK-PB", name: "Punjab", i18n: {"ur":"پنجاب"} },
        { code: "PK-SD", name: "Sindh", i18n: {"ur":"سندھ"} },
    ],
    "PL": [
        { code: "PL-30", name: "Greater Poland", i18n: {"pl":"województwo wielkopolskie"} },
        { code: "PL-26", name: "Holy Cross", i18n: {"pl":"województwo świętokrzyskie"} },
        { code: "PL-04", name: "Kuyavia-Pomerania", i18n: {"pl":"województwo kujawsko-pomorskie"} },
        { code: "PL-12", name: "Lesser Poland", i18n: {"pl":"województwo małopolskie"} },
        { code: "PL-10", name: "Łódź", i18n: {"pl":"województwo łódzkie"} },
        { code: "PL-02", name: "Lower Silesia", i18n: {"pl":"województwo dolnośląskie"} },
        { code: "PL-06", name: "Lublin", i18n: {"pl":"województwo lubelskie"} },
        { code: "PL-08", name: "Lubusz", i18n: {"pl":"województwo lubuskie"} },
        { code: "PL-14", name: "Mazovia", i18n: {"pl":"województwo mazowieckie"} },
        { code: "PL-16", name: "Opole", i18n: {"pl":"województwo opolskie"} },
        { code: "PL-20", name: "Podlachia", i18n: {"pl":"województwo podlaskie"} },
        { code: "PL-22", name: "Pomerania", i18n: {"pl":"województwo pomorskie"} },
        { code: "PL-24", name: "Silesia", i18n: {"pl":"województwo śląskie"} },
        { code: "PL-18", name: "Subcarpathia", i18n: {"pl":"województwo podkarpackie"} },
        { code: "PL-28", name: "Warmia-Masuria", i18n: {"pl":"województwo warmińsko-mazurskie"} },
        { code: "PL-32", name: "West Pomerania", i18n: {"pl":"województwo zachodniopomorskie"} },
    ],
    "PS": [
        { code: "PS-BTH", name: "Bethlehem", i18n: {"ar":"محافظة بيت لحم"} },
        { code: "PS-DEB", name: "Deir al-Balah", i18n: {"ar":"الوسطى"} },
        { code: "PS-GZA", name: "Gaza", i18n: {"ar":"محافظة غزة"} },
        { code: "PS-HBN", name: "Hebron", i18n: {"ar":"محافظة الخليل"} },
        { code: "PS-JEN", name: "Jenin", i18n: {"ar":"جنين"} },
        { code: "PS-JRH", name: "Jericho", i18n: {"ar":"أريحا"} },
        { code: "PS-JEM", name: "Jerusalem", i18n: {"ar":"القدس"} },
        { code: "PS-KYS", name: "Khan Yunis", i18n: {"ar":"محافظة خان يونس"} },
        { code: "PS-NBS", name: "Nablus", i18n: {"ar":"محافظة نابلس"} },
        { code: "PS-NGZ", name: "North Gaza", i18n: {"ar":"شمال غزة"} },
        { code: "PS-QQA", name: "Qalqilya", i18n: {"ar":"محافظة قلقيلية"} },
        { code: "PS-RFH", name: "Rafah", i18n: {"ar":"محافظة رفح الفلسطينية"} },
        { code: "PS-RBH", name: "Ramallah and al-Bireh", i18n: {"ar":"رام الله والبيرة"} },
        { code: "PS-SLT", name: "Salfit", i18n: {"ar":"محافظة سلفيت"} },
        { code: "PS-TBS", name: "Tubas", i18n: {"ar":"محافظة طوباس"} },
        { code: "PS-TKM", name: "Tulkarm", i18n: {"ar":"محافظة طولكرم"} },
    ],
    "PT": [
        { code: "PT-01", name: "Aveiro", i18n: {} },
        { code: "PT-20", name: "Azores", i18n: {"pt":"Açores"} },
        { code: "PT-02", name: "Beja", i18n: {"pt":"Distrito de Beja"} },
        { code: "PT-03", name: "Braga", i18n: {"pt":"Distrito de Braga"} },
        { code: "PT-04", name: "Bragança", i18n: {} },
        { code: "PT-05", name: "Castelo Branco", i18n: {"pt":"Distrito de Castelo Branco"} },
        { code: "PT-06", name: "Coimbra", i18n: {"pt":"Distrito de Coimbra"} },
        { code: "PT-07", name: "Évora", i18n: {"pt":"Distrito de Évora"} },
        { code: "PT-08", name: "Faro", i18n: {"pt":"Distrito de Faro"} },
        { code: "PT-09", name: "Guarda", i18n: {"pt":"Distrito da Guarda"} },
        { code: "PT-10", name: "Leiria", i18n: {"pt":"Distrito de Leiria"} },
        { code: "PT-11", name: "Lisbon", i18n: {"pt":"Distrito de Lisboa"} },
        { code: "PT-30", name: "Madeira", i18n: {"pt":"Região Autónoma da Madeira"} },
        { code: "PT-12", name: "Portalegre", i18n: {"pt":"Distrito de Portalegre"} },
        { code: "PT-13", name: "Porto", i18n: {} },
        { code: "PT-14", name: "Santarém", i18n: {"pt":"Distrito de Santarém"} },
        { code: "PT-15", name: "Setúbal", i18n: {"pt":"Distrito de Setúbal"} },
        { code: "PT-16", name: "Viana do Castelo", i18n: {"pt":"Distrito de Viana do Castelo"} },
        { code: "PT-17", name: "Vila Real", i18n: {} },
        { code: "PT-18", name: "Viseu", i18n: {} },
    ],
    "PW": [
        { code: "PW-002", name: "Aimeliik", i18n: {} },
        { code: "PW-004", name: "Airai", i18n: {} },
        { code: "PW-010", name: "Angaur", i18n: {} },
        { code: "PW-050", name: "Hatohobei", i18n: {} },
        { code: "PW-100", name: "Kayangel", i18n: {} },
        { code: "PW-150", name: "Koror", i18n: {} },
        { code: "PW-212", name: "Melekeok", i18n: {} },
        { code: "PW-214", name: "Ngaraard", i18n: {} },
        { code: "PW-218", name: "Ngarchelong", i18n: {} },
        { code: "PW-222", name: "Ngardmau", i18n: {} },
        { code: "PW-224", name: "Ngatpang", i18n: {} },
        { code: "PW-226", name: "Ngchesar", i18n: {} },
        { code: "PW-227", name: "Ngeremlengui", i18n: {} },
        { code: "PW-228", name: "Ngiwal", i18n: {} },
        { code: "PW-350", name: "Peleliu", i18n: {} },
        { code: "PW-370", name: "Sonsorol", i18n: {} },
    ],
    "PY": [
        { code: "PY-16", name: "Alto Paraguay", i18n: {} },
        { code: "PY-10", name: "Alto Paraná", i18n: {} },
        { code: "PY-13", name: "Amambay", i18n: {} },
        { code: "PY-ASU", name: "Asunción", i18n: {} },
        { code: "PY-19", name: "Boquerón", i18n: {} },
        { code: "PY-5", name: "Caaguazú", i18n: {} },
        { code: "PY-6", name: "Caazapá", i18n: {} },
        { code: "PY-14", name: "Canindeyú", i18n: {} },
        { code: "PY-11", name: "Central", i18n: {} },
        { code: "PY-1", name: "Concepción", i18n: {} },
        { code: "PY-3", name: "Cordillera", i18n: {} },
        { code: "PY-4", name: "Guairá", i18n: {} },
        { code: "PY-7", name: "Itapúa", i18n: {} },
        { code: "PY-8", name: "Misiones", i18n: {} },
        { code: "PY-12", name: "Ñeembucú", i18n: {} },
        { code: "PY-9", name: "Paraguarí", i18n: {} },
        { code: "PY-15", name: "Presidente Hayes", i18n: {} },
        { code: "PY-2", name: "San Pedro", i18n: {} },
    ],
    "QA": [
        { code: "QA-ZA", name: "Al Daayen", i18n: {"ar":"بلدية الضعاين"} },
        { code: "QA-KH", name: "Al Khor", i18n: {"ar":"الخور والدخيرة"} },
        { code: "QA-RA", name: "Al Rayyan", i18n: {"ar":"بلدية الريان"} },
        { code: "QA-WA", name: "Al Wakrah", i18n: {"ar":"الوكرة"} },
        { code: "QA-SH", name: "Ash Shīḩānīyah", i18n: {"ar":"الشحانية"} },
        { code: "QA-DA", name: "Doha", i18n: {"ar":"الدوحة"} },
        { code: "QA-MS", name: "Madinat ash Shamal", i18n: {"ar":"بلدية الشمال"} },
        { code: "QA-US", name: "Umm Salal", i18n: {"ar":"بلدية أم صلال"} },
    ],
    "RO": [
        { code: "RO-AB", name: "Alba", i18n: {} },
        { code: "RO-AR", name: "Arad", i18n: {} },
        { code: "RO-AG", name: "Argeș", i18n: {} },
        { code: "RO-BC", name: "Bacău", i18n: {} },
        { code: "RO-BH", name: "Bihor", i18n: {} },
        { code: "RO-BN", name: "Bistriţa-Năsăud", i18n: {"ro":"Bistrița-Năsăud"} },
        { code: "RO-BT", name: "Botoşani", i18n: {"ro":"Botoșani"} },
        { code: "RO-BR", name: "Brăila", i18n: {} },
        { code: "RO-BV", name: "Braşov", i18n: {"ro":"Brașov"} },
        { code: "RO-B", name: "Bucharest", i18n: {"ro":"București"} },
        { code: "RO-BZ", name: "Buzău", i18n: {} },
        { code: "RO-CL", name: "Călărași", i18n: {} },
        { code: "RO-CS", name: "Caraș-Severin", i18n: {} },
        { code: "RO-CJ", name: "Cluj", i18n: {} },
        { code: "RO-CT", name: "Constanța", i18n: {} },
        { code: "RO-CV", name: "Covasna", i18n: {} },
        { code: "RO-DB", name: "Dâmbovița", i18n: {} },
        { code: "RO-DJ", name: "Dolj", i18n: {} },
        { code: "RO-GL", name: "Galați", i18n: {} },
        { code: "RO-GR", name: "Giurgiu", i18n: {} },
        { code: "RO-GJ", name: "Gorj", i18n: {} },
        { code: "RO-HR", name: "Harghita", i18n: {} },
        { code: "RO-HD", name: "Hunedoara", i18n: {} },
        { code: "RO-IL", name: "Ialomița", i18n: {} },
        { code: "RO-IS", name: "Iași", i18n: {} },
        { code: "RO-IF", name: "Ilfov", i18n: {} },
        { code: "RO-MM", name: "Maramureş", i18n: {"ro":"Maramureș"} },
        { code: "RO-MH", name: "Mehedinți", i18n: {} },
        { code: "RO-MS", name: "Mureş", i18n: {"ro":"Mureș"} },
        { code: "RO-NT", name: "Neamţ", i18n: {"ro":"Neamț"} },
        { code: "RO-OT", name: "Olt", i18n: {} },
        { code: "RO-PH", name: "Prahova", i18n: {} },
        { code: "RO-SJ", name: "Sălaj", i18n: {} },
        { code: "RO-SM", name: "Satu Mare", i18n: {} },
        { code: "RO-SB", name: "Sibiu", i18n: {} },
        { code: "RO-SV", name: "Suceava", i18n: {} },
        { code: "RO-TR", name: "Teleorman", i18n: {} },
        { code: "RO-TM", name: "Timiș", i18n: {} },
        { code: "RO-TL", name: "Tulcea", i18n: {} },
        { code: "RO-VL", name: "Vâlcea", i18n: {} },
        { code: "RO-VS", name: "Vaslui", i18n: {} },
        { code: "RO-VN", name: "Vrancea", i18n: {} },
    ],
    "RS": [
        { code: "RS-00", name: "Beograd", i18n: {"sr":"Београд"} },
        { code: "RS-14", name: "Bor", i18n: {"sr":"Борски управни округ"} },
        { code: "RS-11", name: "Braničevo", i18n: {"sr":"Браничевски управни округ"} },
        { code: "RS-02", name: "Central Banat", i18n: {"sr":"Средњобанатски управни округ"} },
        { code: "RS-23", name: "Jablanica", i18n: {"sr":"Јабланички управни округ"} },
        { code: "RS-09", name: "Kolubara", i18n: {"sr":"Колубарски управни округ"} },
        { code: "RS-25", name: "Kosovo", i18n: {"sr":"Косовски управни округ"} },
        { code: "RS-KM", name: "Kosovo-Metohija", i18n: {"sr":"Косово и Метохија"} },
        { code: "RS-29", name: "Kosovo-Pomoravlje", i18n: {"sr":"Косовскопоморавски управни округ"} },
        { code: "RS-28", name: "Kosovska Mitrovica", i18n: {"sr":"Косовскомитровачки управни округ"} },
        { code: "RS-08", name: "Mačva", i18n: {"sr":"Мачвански управни округ"} },
        { code: "RS-17", name: "Moravica", i18n: {"sr":"Моравички управни округ"} },
        { code: "RS-20", name: "Nišava", i18n: {"sr":"Нишавски управни округ"} },
        { code: "RS-01", name: "North Bačka", i18n: {"sr":"Севернобачки управни округ"} },
        { code: "RS-03", name: "North Banat", i18n: {"sr":"Севернобанатски управни округ"} },
        { code: "RS-24", name: "Pčinja", i18n: {"sr":"Пчињски управни округ"} },
        { code: "RS-26", name: "Peć", i18n: {"sr":"Пећки управни округ"} },
        { code: "RS-22", name: "Pirot", i18n: {"sr":"Пиротски управни округ"} },
        { code: "RS-10", name: "Podunavlje", i18n: {"sr":"Подунавски управни округ"} },
        { code: "RS-13", name: "Pomoravlje", i18n: {"sr":"Поморавски управни округ"} },
        { code: "RS-27", name: "Prizren", i18n: {"sr":"Призренски управни округ"} },
        { code: "RS-19", name: "Rasina", i18n: {"sr":"Расински управни округ"} },
        { code: "RS-18", name: "Raška", i18n: {"sr":"Рашки управни округ"} },
        { code: "RS-06", name: "South Bačka", i18n: {"sr":"Јужнобачки управни округ"} },
        { code: "RS-04", name: "South Banat", i18n: {"sr":"Јужнобанатски управни округ"} },
        { code: "RS-07", name: "Srem", i18n: {"sr":"Сремски управни округ"} },
        { code: "RS-12", name: "Šumadija", i18n: {"sr":"Шумадијски управни округ"} },
        { code: "RS-21", name: "Toplica", i18n: {"sr":"Топлички управни округ"} },
        { code: "RS-VO", name: "Vojvodina", i18n: {"sr":"Војводина"} },
        { code: "RS-05", name: "West Bačka", i18n: {"sr":"Западнобачки управни округ"} },
        { code: "RS-15", name: "Zaječar", i18n: {"sr":"Зајечарски управни округ"} },
        { code: "RS-16", name: "Zlatibor", i18n: {"sr":"Златиборски управни округ"} },
    ],
    "RU": [
        { code: "RU-AD", name: "Adygea", i18n: {"ru":"Адыгея"} },
        { code: "RU-AL", name: "Altai", i18n: {"ru":"Республика Алтай"} },
        { code: "RU-ALT", name: "Altai Krai", i18n: {"ru":"Алтайский край"} },
        { code: "RU-AMU", name: "Amur", i18n: {"ru":"Амурская область"} },
        { code: "RU-ARK", name: "Arkhangelsk", i18n: {"ru":"Архангельская область"} },
        { code: "RU-AST", name: "Astrakhan", i18n: {"ru":"Астраханская область"} },
        { code: "RU-BA", name: "Bashkortostan", i18n: {"ru":"Башкортостан"} },
        { code: "RU-BEL", name: "Belgorod", i18n: {"ru":"Белгородская область"} },
        { code: "RU-BRY", name: "Bryansk", i18n: {"ru":"Брянская область"} },
        { code: "RU-BU", name: "Buryat", i18n: {"ru":"Бурятия"} },
        { code: "RU-CE", name: "Chechen", i18n: {"ru":"Чечня"} },
        { code: "RU-CHE", name: "Chelyabinsk", i18n: {"ru":"Челябинская область"} },
        { code: "RU-CHU", name: "Chukotka Okrug", i18n: {"ru":"Чукотский автономный округ"} },
        { code: "RU-CU", name: "Chuvash", i18n: {"ru":"Чувашия"} },
        { code: "RU-DA", name: "Dagestan", i18n: {"ru":"Дагестан"} },
        { code: "RU-IN", name: "Ingushetia", i18n: {"ru":"Ингушетия"} },
        { code: "RU-IRK", name: "Irkutsk", i18n: {"ru":"Иркутская область"} },
        { code: "RU-IVA", name: "Ivanovo", i18n: {"ru":"Ивановская область"} },
        { code: "RU-YEV", name: "Jewish", i18n: {"ru":"Еврейская автономная область"} },
        { code: "RU-KB", name: "Kabardino-Balkar", i18n: {"ru":"Кабардино-Балкария"} },
        { code: "RU-KGD", name: "Kaliningrad", i18n: {"ru":"Калининградская область"} },
        { code: "RU-KL", name: "Kalmykia", i18n: {"ru":"Калмыкия"} },
        { code: "RU-KLU", name: "Kaluga", i18n: {"ru":"Калужская область"} },
        { code: "RU-KAM", name: "Kamchatka Krai", i18n: {"ru":"Камчатский край"} },
        { code: "RU-KC", name: "Karachay-Cherkess", i18n: {"ru":"Карачаево-Черкесия"} },
        { code: "RU-KR", name: "Karelia", i18n: {"ru":"Республика Карелия"} },
        { code: "RU-KEM", name: "Kemerovo", i18n: {"ru":"Кемеровская область"} },
        { code: "RU-KHA", name: "Khabarovsk Krai", i18n: {"ru":"Хабаровский край"} },
        { code: "RU-KK", name: "Khakassia", i18n: {"ru":"Хакасия"} },
        { code: "RU-KHM", name: "Khanty-Mansi", i18n: {"ru":"Ханты-Мансийский автономный округ — Югра"} },
        { code: "RU-KIR", name: "Kirov", i18n: {"ru":"Кировская область"} },
        { code: "RU-KO", name: "Komi", i18n: {"ru":"Республика Коми"} },
        { code: "RU-KOS", name: "Kostroma", i18n: {"ru":"Костромская область"} },
        { code: "RU-KDA", name: "Krasnodar Krai", i18n: {"ru":"Краснодарский край"} },
        { code: "RU-KYA", name: "Krasnoyarsk Krai", i18n: {"ru":"Красноярский край"} },
        { code: "RU-KGN", name: "Kurgan", i18n: {"ru":"Курганская область"} },
        { code: "RU-KRS", name: "Kursk", i18n: {"ru":"Курская область"} },
        { code: "RU-LEN", name: "Leningrad", i18n: {"ru":"Ленинградская область"} },
        { code: "RU-LIP", name: "Lipetsk", i18n: {"ru":"Липецкая область"} },
        { code: "RU-MAG", name: "Magadan", i18n: {"ru":"Магаданская область"} },
        { code: "RU-ME", name: "Mari El", i18n: {"ru":"Марий Эл"} },
        { code: "RU-MO", name: "Mordovia", i18n: {"ru":"Мордовия"} },
        { code: "RU-MOW", name: "Moscow", i18n: {"ru":"Москва"} },
        { code: "RU-MOS", name: "Moscow Province", i18n: {"ru":"Московская область"} },
        { code: "RU-MUR", name: "Murmansk", i18n: {"ru":"Мурманская область"} },
        { code: "RU-NEN", name: "Nenets", i18n: {"ru":"Ненецкий автономный округ"} },
        { code: "RU-NIZ", name: "Nizhny Novgorod", i18n: {"ru":"Нижегородская область"} },
        { code: "RU-SE", name: "North Ossetia-Alania", i18n: {"ru":"Республика Северная Осетия-Алания"} },
        { code: "RU-NGR", name: "Novgorod", i18n: {"ru":"Новгородская область"} },
        { code: "RU-NVS", name: "Novosibirsk", i18n: {"ru":"Новосибирская область"} },
        { code: "RU-OMS", name: "Omsk", i18n: {"ru":"Омская область"} },
        { code: "RU-ORE", name: "Orenburg", i18n: {"ru":"Оренбургская область"} },
        { code: "RU-ORL", name: "Oryol", i18n: {"ru":"Орловская область"} },
        { code: "RU-PNZ", name: "Penza", i18n: {"ru":"Пензенская область"} },
        { code: "RU-PER", name: "Perm Krai", i18n: {"ru":"Пермский край"} },
        { code: "RU-PRI", name: "Primorsky Krai", i18n: {"ru":"Приморский край"} },
        { code: "RU-PSK", name: "Pskov", i18n: {"ru":"Псковская область"} },
        { code: "RU-ROS", name: "Rostov", i18n: {"ru":"Ростовская область"} },
        { code: "RU-RYA", name: "Ryazan", i18n: {"ru":"Рязанская область"} },
        { code: "RU-SPE", name: "Saint Petersburg", i18n: {"ru":"Санкт-Петербург"} },
        { code: "RU-SA", name: "Sakha", i18n: {"ru":"Якутия"} },
        { code: "RU-SAK", name: "Sakhalin", i18n: {"ru":"Сахалинская область"} },
        { code: "RU-SAM", name: "Samara", i18n: {"ru":"Самарская область"} },
        { code: "RU-SAR", name: "Saratov", i18n: {"ru":"Саратовская область"} },
        { code: "RU-SMO", name: "Smolensk", i18n: {"ru":"Смоленская область"} },
        { code: "RU-STA", name: "Stavropol Krai", i18n: {"ru":"Ставропольский край"} },
        { code: "RU-SVE", name: "Sverdlovsk", i18n: {"ru":"Свердловская область"} },
        { code: "RU-TAM", name: "Tambov", i18n: {"ru":"Тамбовская область"} },
        { code: "RU-TA", name: "Tatarstan", i18n: {"ru":"Татарстан"} },
        { code: "RU-TOM", name: "Tomsk", i18n: {"ru":"Томская область"} },
        { code: "RU-TUL", name: "Tula", i18n: {"ru":"Тульская область"} },
        { code: "RU-TY", name: "Tuva", i18n: {"ru":"Тыва"} },
        { code: "RU-TVE", name: "Tver", i18n: {"ru":"Тверская область"} },
        { code: "RU-TYU", name: "Tyumen", i18n: {"ru":"Тюменская область"} },
        { code: "RU-UD", name: "Udmurt", i18n: {"ru":"Удмуртия"} },
        { code: "RU-ULY", name: "Ulyanovsk", i18n: {"ru":"Ульяновская область"} },
        { code: "RU-VLA", name: "Vladimir", i18n: {"ru":"Владимирская область"} },
        { code: "RU-VGG", name: "Volgograd", i18n: {"ru":"Волгоградская область"} },
        { code: "RU-VLG", name: "Vologda", i18n: {"ru":"Вологодская область"} },
        { code: "RU-VOR", name: "Voronezh", i18n: {"ru":"Воронежская область"} },
        { code: "RU-YAN", name: "Yamalo-Nenets Okrug", i18n: {"ru":"Ямало-Ненецкий автономный округ"} },
        { code: "RU-YAR", name: "Yaroslavl", i18n: {"ru":"Ярославская область"} },
        { code: "RU-ZAB", name: "Zabaykalsky Krai", i18n: {"ru":"Забайкальский край"} },
    ],
    "RW": [
        { code: "RW-02", name: "Eastern", i18n: {} },
        { code: "RW-01", name: "Kigali", i18n: {} },
        { code: "RW-03", name: "Northern", i18n: {} },
        { code: "RW-05", name: "Southern", i18n: {} },
        { code: "RW-04", name: "Western", i18n: {} },
    ],
    "SA": [
        { code: "SA-11", name: "Al Bahah", i18n: {"ar":"منطقة الباحة"} },
        { code: "SA-12", name: "Al Jawf", i18n: {"ar":"منطقة الجوف"} },
        { code: "SA-03", name: "Al Madinah", i18n: {"ar":"منطقة المدينة المنورة"} },
        { code: "SA-05", name: "Al-Qassim", i18n: {"ar":"منطقة القصيم"} },
        { code: "SA-14", name: "Asir", i18n: {"ar":"منطقة عسير"} },
        { code: "SA-04", name: "Eastern", i18n: {"ar":"المنطقة الشرقية"} },
        { code: "SA-06", name: "Ha’il", i18n: {"ar":"منطقة حائل"} },
        { code: "SA-09", name: "Jizan", i18n: {"ar":"منطقة جازان"} },
        { code: "SA-02", name: "Makkah", i18n: {"ar":"منطقة مكة المكرمة"} },
        { code: "SA-10", name: "Najran", i18n: {"ar":"منطقة نجران"} },
        { code: "SA-08", name: "Northern Borders", i18n: {"ar":"منطقة الحدود الشمالية"} },
        { code: "SA-01", name: "Riyadh", i18n: {"ar":"منطقة الرياض"} },
        { code: "SA-07", name: "Tabuk", i18n: {"ar":"منطقة تبوك"} },
    ],
    "SB": [
        { code: "SB-CE", name: "Central", i18n: {} },
        { code: "SB-CH", name: "Choiseul", i18n: {} },
        { code: "SB-GU", name: "Guadalcanal", i18n: {} },
        { code: "SB-CT", name: "Honiara", i18n: {} },
        { code: "SB-IS", name: "Isabel", i18n: {} },
        { code: "SB-MK", name: "Makira-Ulawa", i18n: {} },
        { code: "SB-ML", name: "Malaita", i18n: {} },
        { code: "SB-RB", name: "Rennell and Bellona", i18n: {} },
        { code: "SB-TE", name: "Temotu", i18n: {} },
        { code: "SB-WE", name: "Western", i18n: {} },
    ],
    "SC": [
        { code: "SC-01", name: "Anse aux Pins", i18n: {} },
        { code: "SC-02", name: "Anse Boileau", i18n: {} },
        { code: "SC-03", name: "Anse Etoile", i18n: {} },
        { code: "SC-05", name: "Anse Royale", i18n: {} },
        { code: "SC-04", name: "Au Cap", i18n: {} },
        { code: "SC-06", name: "Baie Lazare", i18n: {} },
        { code: "SC-07", name: "Baie Sainte Anne", i18n: {} },
        { code: "SC-08", name: "Beau Vallon", i18n: {"fr":"Beau Vallon (Seychelles)"} },
        { code: "SC-09", name: "Bel Air", i18n: {} },
        { code: "SC-10", name: "Bel Ombre", i18n: {} },
        { code: "SC-11", name: "Cascade", i18n: {} },
        { code: "SC-12", name: "Glacis", i18n: {} },
        { code: "SC-13", name: "Grand’Anse Mahé", i18n: {"fr":"Grand Anse"} },
        { code: "SC-14", name: "Grand’Anse Praslin", i18n: {"fr":"Grand’Anse"} },
        { code: "SC-26", name: "Ile Perseverance I", i18n: {"fr":"Île Persévérance I"} },
        { code: "SC-27", name: "Ile Perseverance II", i18n: {"fr":"Île Persévérance II"} },
        { code: "SC-15", name: "La Digue", i18n: {} },
        { code: "SC-16", name: "La Rivière Anglaise", i18n: {} },
        { code: "SC-24", name: "Les Mamelles", i18n: {} },
        { code: "SC-17", name: "Mont Buxton", i18n: {} },
        { code: "SC-18", name: "Mont Fleuri", i18n: {} },
        { code: "SC-19", name: "Plaisance", i18n: {} },
        { code: "SC-20", name: "Pointe La Rue", i18n: {} },
        { code: "SC-21", name: "Port Glaud", i18n: {} },
        { code: "SC-25", name: "Roche Caiman", i18n: {"fr":"Roche Caïman"} },
        { code: "SC-22", name: "Saint Louis", i18n: {} },
        { code: "SC-23", name: "Takamaka", i18n: {} },
    ],
    "SD": [
        { code: "SD-GZ", name: "Al Jazirah", i18n: {"ar":"الجزيرة"} },
        { code: "SD-GD", name: "Al Qadarif", i18n: {"ar":"القضارف"} },
        { code: "SD-NB", name: "Blue Nile", i18n: {"ar":"النيل الأزرق"} },
        { code: "SD-DC", name: "Central Darfur", i18n: {"ar":"وسط دار فور"} },
        { code: "SD-DE", name: "East Darfur", i18n: {"ar":"ولاية شرق دارفور"} },
        { code: "SD-KA", name: "Kassala", i18n: {"ar":"كسلا"} },
        { code: "SD-KH", name: "Khartoum", i18n: {"ar":"الخرطوم"} },
        { code: "SD-DN", name: "North Darfur", i18n: {"ar":"ولاية شمال دارفور"} },
        { code: "SD-KN", name: "North Kurdufan", i18n: {"ar":"ولاية شمال كردفان"} },
        { code: "SD-NO", name: "Northern", i18n: {"ar":"الشمالية"} },
        { code: "SD-RS", name: "Red Sea", i18n: {"ar":"البحر الأحمر"} },
        { code: "SD-NR", name: "River Nile", i18n: {"ar":"نهر النيل"} },
        { code: "SD-SI", name: "Sennar", i18n: {"ar":"سنار"} },
        { code: "SD-DS", name: "South Darfur", i18n: {"ar":"جنوب دارفور"} },
        { code: "SD-KS", name: "South Kurdufan", i18n: {"ar":"جنوب كردفان"} },
        { code: "SD-DW", name: "West Darfur", i18n: {"ar":"غرب دارفور"} },
        { code: "SD-GK", name: "West Kurdufan", i18n: {"ar":"ولاية غرب كردفان"} },
        { code: "SD-NW", name: "White Nile", i18n: {"ar":"النيل الأبيض"} },
    ],
    "SE": [
        { code: "SE-K", name: "Blekinge", i18n: {"sv":"Blekinge län"} },
        { code: "SE-W", name: "Dalarna", i18n: {"sv":"Dalarnas län"} },
        { code: "SE-X", name: "Gävleborg", i18n: {"sv":"Gävleborgs län"} },
        { code: "SE-I", name: "Gotland", i18n: {"sv":"Gotlands län"} },
        { code: "SE-N", name: "Halland", i18n: {"sv":"Hallands län"} },
        { code: "SE-Z", name: "Jämtland", i18n: {"sv":"Jämtlands län"} },
        { code: "SE-F", name: "Jönköping", i18n: {"sv":"Jönköpings län"} },
        { code: "SE-H", name: "Kalmar", i18n: {"sv":"Kalmar län"} },
        { code: "SE-G", name: "Kronoberg", i18n: {"sv":"Kronobergs län"} },
        { code: "SE-BD", name: "Norrbotten", i18n: {"sv":"Norrbottens län"} },
        { code: "SE-T", name: "Örebro", i18n: {"sv":"Örebro län"} },
        { code: "SE-E", name: "Östergötland", i18n: {"sv":"Östergötlands län"} },
        { code: "SE-M", name: "Skåne", i18n: {"sv":"Skåne län"} },
        { code: "SE-D", name: "Södermanland", i18n: {"sv":"Södermanlands län"} },
        { code: "SE-AB", name: "Stockholm", i18n: {"sv":"Stockholms län"} },
        { code: "SE-C", name: "Uppsala", i18n: {"sv":"Uppsala län"} },
        { code: "SE-S", name: "Värmland", i18n: {"sv":"Värmlands län"} },
        { code: "SE-AC", name: "Västerbotten", i18n: {"sv":"Västerbottens län"} },
        { code: "SE-Y", name: "Västernorrland", i18n: {"sv":"Västernorrlands län"} },
        { code: "SE-U", name: "Västmanland", i18n: {"sv":"Västmanlands län"} },
        { code: "SE-O", name: "Västra Götaland", i18n: {"sv":"Västra Götalands län"} },
    ],
    "SG": [
        { code: "SG-01", name: "Central Singapore", i18n: {} },
        { code: "SG-02", name: "North East", i18n: {} },
        { code: "SG-03", name: "North West", i18n: {} },
        { code: "SG-04", name: "South East", i18n: {} },
        { code: "SG-05", name: "South West", i18n: {} },
    ],
    "SH": [
        { code: "SH-AC", name: "Ascension Island", i18n: {} },
        { code: "SH-HL", name: "Saint Helena", i18n: {} },
        { code: "SH-TA", name: "Tristan da Cunha", i18n: {} },
    ],
    "SI": [
        { code: "SI-001", name: "Ajdovščina", i18n: {"sl":"Občina Ajdovščina"} },
        { code: "SI-213", name: "Ankaran", i18n: {"sl":"Občina Ankaran"} },
        { code: "SI-195", name: "Apače", i18n: {"sl":"Občina Apače"} },
        { code: "SI-002", name: "Beltinci", i18n: {"sl":"Občina Beltinci"} },
        { code: "SI-148", name: "Benedikt", i18n: {"sl":"Občina Benedikt"} },
        { code: "SI-149", name: "Bistrica ob Sotli", i18n: {"sl":"Občina Bistrica ob Sotli"} },
        { code: "SI-003", name: "Bled", i18n: {"sl":"Občina Bled"} },
        { code: "SI-150", name: "Bloke", i18n: {"sl":"Občina Bloke"} },
        { code: "SI-004", name: "Bohinj", i18n: {"sl":"Občina Bohinj"} },
        { code: "SI-005", name: "Borovnica", i18n: {"sl":"Občina Borovnica"} },
        { code: "SI-006", name: "Bovec", i18n: {"sl":"Občina Bovec"} },
        { code: "SI-151", name: "Braslovče", i18n: {} },
        { code: "SI-007", name: "Brda", i18n: {"sl":"Občina Brda"} },
        { code: "SI-009", name: "Brežice", i18n: {"sl":"Občina Brežice"} },
        { code: "SI-008", name: "Brezovica", i18n: {"sl":"Občina Brezovica"} },
        { code: "SI-152", name: "Cankova", i18n: {"sl":"Občina Cankova"} },
        { code: "SI-011", name: "Celje", i18n: {"sl":"Mestna občina Celje"} },
        { code: "SI-012", name: "Cerklje na Gorenjskem", i18n: {"sl":"Občina Cerklje na Gorenjskem"} },
        { code: "SI-013", name: "Cerknica", i18n: {"sl":"Občina Cerknica"} },
        { code: "SI-014", name: "Cerkno", i18n: {"sl":"Občina Cerkno"} },
        { code: "SI-153", name: "Cerkvenjak", i18n: {} },
        { code: "SI-196", name: "Cirkulane", i18n: {"sl":"Občina Cirkulane"} },
        { code: "SI-015", name: "Črenšovci", i18n: {"sl":"Občina Črenšovci"} },
        { code: "SI-016", name: "Črna na Koroškem", i18n: {"sl":"Občina Črna na Koroškem"} },
        { code: "SI-017", name: "Črnomelj", i18n: {"sl":"Občina Črnomelj"} },
        { code: "SI-018", name: "Destrnik", i18n: {"sl":"Občina Destrnik"} },
        { code: "SI-019", name: "Divača", i18n: {"sl":"Občina Divača"} },
        { code: "SI-154", name: "Dobje", i18n: {"sl":"Občina Dobje"} },
        { code: "SI-020", name: "Dobrepolje", i18n: {"sl":"Občina Dobrepolje"} },
        { code: "SI-155", name: "Dobrna", i18n: {"sl":"Občina Dobrna"} },
        { code: "SI-021", name: "Dobrova–Polhov Gradec", i18n: {"sl":"Občina Dobrova - Polhov Gradec"} },
        { code: "SI-156", name: "Dobrovnik", i18n: {"sl":"Občina Dobrovnik"} },
        { code: "SI-022", name: "Dol pri Ljubljani", i18n: {"sl":"Občina Dol pri Ljubljani"} },
        { code: "SI-157", name: "Dolenjske Toplice", i18n: {"sl":"Občina Dolenjske Toplice"} },
        { code: "SI-023", name: "Domžale", i18n: {"sl":"Občina Domžale"} },
        { code: "SI-024", name: "Dornava", i18n: {"sl":"Občina Dornava"} },
        { code: "SI-025", name: "Dravograd", i18n: {"sl":"Občina Dravograd"} },
        { code: "SI-026", name: "Duplek", i18n: {"sl":"Občina Duplek"} },
        { code: "SI-027", name: "Gorenja Vas–Poljane", i18n: {"sl":"Občina Gorenja vas-Poljane"} },
        { code: "SI-028", name: "Gorišnica", i18n: {"sl":"Občina Gorišnica"} },
        { code: "SI-207", name: "Gorje", i18n: {"sl":"Občina Gorje"} },
        { code: "SI-029", name: "Gornja Radgona", i18n: {"sl":"Občina Gornja Radgona"} },
        { code: "SI-030", name: "Gornji Grad", i18n: {"sl":"Občina Gornji Grad"} },
        { code: "SI-031", name: "Gornji Petrovci", i18n: {"sl":"Občina Gornji Petrovci"} },
        { code: "SI-158", name: "Grad", i18n: {"sl":"Občina Grad"} },
        { code: "SI-032", name: "Grosuplje", i18n: {"sl":"Občina Grosuplje"} },
        { code: "SI-159", name: "Hajdina", i18n: {"sl":"Občina Hajdina"} },
        { code: "SI-160", name: "Hoče–Slivnica", i18n: {"sl":"Občina Hoče - Slivnica"} },
        { code: "SI-161", name: "Hodoš", i18n: {"sl":"Občina Hodoš"} },
        { code: "SI-162", name: "Horjul", i18n: {"sl":"Občina Horjul"} },
        { code: "SI-034", name: "Hrastnik", i18n: {"sl":"Občina Hrastnik"} },
        { code: "SI-035", name: "Hrpelje–Kozina", i18n: {"sl":"Občina Hrpelje - Kozina"} },
        { code: "SI-036", name: "Idrija", i18n: {"sl":"Občina Idrija"} },
        { code: "SI-037", name: "Ig", i18n: {"sl":"Občina Ig"} },
        { code: "SI-038", name: "Ilirska Bistrica", i18n: {"sl":"Občina Ilirska Bistrica"} },
        { code: "SI-039", name: "Ivančna Gorica", i18n: {"sl":"Občina Ivančna Gorica"} },
        { code: "SI-040", name: "Izola", i18n: {"sl":"Občina Izola"} },
        { code: "SI-041", name: "Jesenice", i18n: {"sl":"Občina Jesenice"} },
        { code: "SI-163", name: "Jezersko", i18n: {"sl":"Občina Jezersko"} },
        { code: "SI-042", name: "Juršinci", i18n: {"sl":"Občina Juršinci"} },
        { code: "SI-043", name: "Kamnik", i18n: {"sl":"Občina Kamnik"} },
        { code: "SI-044", name: "Kanal", i18n: {"sl":"Občina Kanal ob Soči"} },
        { code: "SI-045", name: "Kidričevo", i18n: {"sl":"Občina Kidričevo"} },
        { code: "SI-046", name: "Kobarid", i18n: {"sl":"Občina Kobarid"} },
        { code: "SI-047", name: "Kobilje", i18n: {"sl":"Občina Kobilje"} },
        { code: "SI-048", name: "Kočevje", i18n: {"sl":"Občina Kočevje"} },
        { code: "SI-049", name: "Komen", i18n: {"sl":"Občina Komen"} },
        { code: "SI-164", name: "Komenda", i18n: {"sl":"Občina Komenda"} },
        { code: "SI-050", name: "Koper", i18n: {"sl":"Mestna občina Koper"} },
        { code: "SI-197", name: "Kostanjevica na Krki", i18n: {"sl":"Občina Kostanjevica na Krki"} },
        { code: "SI-165", name: "Kostel", i18n: {"sl":"Občina Kostel"} },
        { code: "SI-051", name: "Kozje", i18n: {"sl":"Občina Kozje"} },
        { code: "SI-052", name: "Kranj", i18n: {"sl":"Mestna občina Kranj"} },
        { code: "SI-053", name: "Kranjska Gora", i18n: {"sl":"Občina Kranjska Gora"} },
        { code: "SI-166", name: "Križevci", i18n: {"sl":"Občina Križevci"} },
        { code: "SI-054", name: "Krško", i18n: {"sl":"Občina Krško"} },
        { code: "SI-055", name: "Kungota", i18n: {"sl":"Občina Kungota"} },
        { code: "SI-056", name: "Kuzma", i18n: {"sl":"Občina Kuzma"} },
        { code: "SI-057", name: "Laško", i18n: {"sl":"Občina Laško"} },
        { code: "SI-058", name: "Lenart", i18n: {"sl":"Občina Lenart"} },
        { code: "SI-059", name: "Lendava", i18n: {"sl":"Občina Lendava"} },
        { code: "SI-060", name: "Litija", i18n: {} },
        { code: "SI-061", name: "Ljubljana", i18n: {"sl":"Mestna občina Ljubljana"} },
        { code: "SI-062", name: "Ljubno", i18n: {"sl":"Občina Ljubno"} },
        { code: "SI-063", name: "Ljutomer", i18n: {"sl":"Občina Ljutomer"} },
        { code: "SI-208", name: "Log–Dragomer", i18n: {"sl":"Občina Log - Dragomer"} },
        { code: "SI-064", name: "Logatec", i18n: {"sl":"Občina Logatec"} },
        { code: "SI-065", name: "Loška Dolina", i18n: {"sl":"Občina Loška dolina"} },
        { code: "SI-066", name: "Loški Potok", i18n: {"sl":"Občina Loški potok"} },
        { code: "SI-167", name: "Lovrenc na Pohorju", i18n: {"sl":"Občina Lovrenc na Pohorju"} },
        { code: "SI-067", name: "Luče", i18n: {"sl":"Občina Luče"} },
        { code: "SI-068", name: "Lukovica", i18n: {"sl":"Občina Lukovica"} },
        { code: "SI-069", name: "Majšperk", i18n: {"sl":"Občina Majšperk"} },
        { code: "SI-198", name: "Makole", i18n: {"sl":"Občina Makole"} },
        { code: "SI-070", name: "Maribor", i18n: {"sl":"Mestna občina Maribor"} },
        { code: "SI-168", name: "Markovci", i18n: {"sl":"Občina Markovci"} },
        { code: "SI-071", name: "Medvode", i18n: {"sl":"Občina Medvode"} },
        { code: "SI-072", name: "Mengeš", i18n: {"sl":"Občina Mengeš"} },
        { code: "SI-073", name: "Metlika", i18n: {"sl":"Občina Metlika"} },
        { code: "SI-074", name: "Mežica", i18n: {"sl":"Občina Mežica"} },
        { code: "SI-169", name: "Miklavž na Dravskem Polju", i18n: {"sl":"Občina Miklavž na Dravskem polju"} },
        { code: "SI-075", name: "Miren–Kostanjevica", i18n: {"sl":"Občina Miren - Kostanjevica"} },
        { code: "SI-212", name: "Mirna", i18n: {} },
        { code: "SI-170", name: "Mirna Peč", i18n: {"sl":"Občina Mirna Peč"} },
        { code: "SI-076", name: "Mislinja", i18n: {} },
        { code: "SI-199", name: "Mokronog–Trebelno", i18n: {"sl":"Občina Mokronog - Trebelno"} },
        { code: "SI-077", name: "Moravče", i18n: {"sl":"Občina Moravče"} },
        { code: "SI-078", name: "Moravske Toplice", i18n: {"sl":"Občina Moravske Toplice"} },
        { code: "SI-079", name: "Mozirje", i18n: {"sl":"Občina Mozirje"} },
        { code: "SI-080", name: "Murska Sobota", i18n: {"sl":"Mestna občina Murska Sobota"} },
        { code: "SI-081", name: "Muta", i18n: {"sl":"Občina Muta"} },
        { code: "SI-082", name: "Naklo", i18n: {"sl":"Občina Naklo"} },
        { code: "SI-083", name: "Nazarje", i18n: {"sl":"Občina Nazarje"} },
        { code: "SI-084", name: "Nova Gorica", i18n: {"sl":"Mestna občina Nova Gorica"} },
        { code: "SI-085", name: "Novo Mesto", i18n: {"sl":"Mestna občina Novo mesto"} },
        { code: "SI-086", name: "Odranci", i18n: {} },
        { code: "SI-171", name: "Oplotnica", i18n: {"sl":"Občina Oplotnica"} },
        { code: "SI-087", name: "Ormož", i18n: {} },
        { code: "SI-088", name: "Osilnica", i18n: {"sl":"Občina Osilnica"} },
        { code: "SI-089", name: "Pesnica", i18n: {"sl":"Občina Pesnica"} },
        { code: "SI-090", name: "Piran", i18n: {"sl":"Občina Piran"} },
        { code: "SI-091", name: "Pivka", i18n: {"sl":"Občina Pivka"} },
        { code: "SI-092", name: "Podčetrtek", i18n: {"sl":"Občina Podčetrtek"} },
        { code: "SI-172", name: "Podlehnik", i18n: {"sl":"Občina Podlehnik"} },
        { code: "SI-093", name: "Podvelka", i18n: {"sl":"Občina Podvelka"} },
        { code: "SI-200", name: "Poljčane", i18n: {"sl":"Občina Poljčane"} },
        { code: "SI-173", name: "Polzela", i18n: {"sl":"Občina Polzela"} },
        { code: "SI-094", name: "Postojna", i18n: {"sl":"Občina Postojna"} },
        { code: "SI-174", name: "Prebold", i18n: {"sl":"Občina Prebold"} },
        { code: "SI-095", name: "Preddvor", i18n: {"sl":"Občina Preddvor"} },
        { code: "SI-175", name: "Prevalje", i18n: {"sl":"Občina Prevalje"} },
        { code: "SI-096", name: "Ptuj", i18n: {"sl":"Mestna občina Ptuj"} },
        { code: "SI-097", name: "Puconci", i18n: {"sl":"Občina Puconci"} },
        { code: "SI-098", name: "Rače–Fram", i18n: {"sl":"Občina Rače-Fram"} },
        { code: "SI-099", name: "Radeče", i18n: {"sl":"Občina Radeče"} },
        { code: "SI-100", name: "Radenci", i18n: {"sl":"Občina Radenci"} },
        { code: "SI-101", name: "Radlje ob Dravi", i18n: {"sl":"Občina Radlje ob Dravi"} },
        { code: "SI-102", name: "Radovljica", i18n: {"sl":"Občina Radovljica"} },
        { code: "SI-103", name: "Ravne na Koroškem", i18n: {"sl":"Občina Ravne na Koroškem"} },
        { code: "SI-176", name: "Razkrižje", i18n: {"sl":"Občina Razkrižje"} },
        { code: "SI-209", name: "Rečica ob Savinji", i18n: {"sl":"Občina Rečica ob Savinji"} },
        { code: "SI-201", name: "Renče–Vogrsko", i18n: {"sl":"Občina Renče - Vogrsko"} },
        { code: "SI-104", name: "Ribnica", i18n: {"sl":"Občina Ribnica"} },
        { code: "SI-177", name: "Ribnica na Pohorju", i18n: {"sl":"Občina Ribnica na Pohorju"} },
        { code: "SI-106", name: "Rogaška Slatina", i18n: {} },
        { code: "SI-105", name: "Rogašovci", i18n: {"sl":"Občina Rogašovci"} },
        { code: "SI-107", name: "Rogatec", i18n: {"sl":"Občina Rogatec"} },
        { code: "SI-108", name: "Ruše", i18n: {"sl":"Občina Ruše"} },
        { code: "SI-033", name: "Šalovci", i18n: {"sl":"Občina Šalovci"} },
        { code: "SI-178", name: "Selnica ob Dravi", i18n: {"sl":"Občina Selnica ob Dravi"} },
        { code: "SI-109", name: "Semič", i18n: {"sl":"Občina Semič"} },
        { code: "SI-183", name: "Šempeter–Vrtojba", i18n: {"sl":"Občina Šempeter - Vrtojba"} },
        { code: "SI-117", name: "Šenčur", i18n: {"sl":"Občina Šenčur"} },
        { code: "SI-118", name: "Šentilj", i18n: {"sl":"Občina Šentilj"} },
        { code: "SI-119", name: "Šentjernej", i18n: {"sl":"Občina Šentjernej"} },
        { code: "SI-120", name: "Šentjur", i18n: {"sl":"Občina Šentjur"} },
        { code: "SI-211", name: "Šentrupert", i18n: {"sl":"Občina Šentrupert"} },
        { code: "SI-110", name: "Sevnica", i18n: {"sl":"Občina Sevnica"} },
        { code: "SI-111", name: "Sežana", i18n: {"sl":"Občina Sežana"} },
        { code: "SI-121", name: "Škocjan", i18n: {"sl":"Občina Škocjan"} },
        { code: "SI-122", name: "Škofja Loka", i18n: {"sl":"Občina Škofja Loka"} },
        { code: "SI-123", name: "Škofljica", i18n: {"sl":"Občina Škofljica"} },
        { code: "SI-112", name: "Slovenj Gradec", i18n: {"sl":"Mestna občina Slovenj Gradec"} },
        { code: "SI-113", name: "Slovenska Bistrica", i18n: {"sl":"Občina Slovenska Bistrica"} },
        { code: "SI-114", name: "Slovenske Konjice", i18n: {"sl":"Občina Slovenske Konjice"} },
        { code: "SI-124", name: "Šmarje pri Jelšah", i18n: {"sl":"Občina Šmarje pri Jelšah"} },
        { code: "SI-206", name: "Šmarješke Toplice", i18n: {"sl":"Občina Šmarješke Toplice"} },
        { code: "SI-125", name: "Šmartno ob Paki", i18n: {"sl":"Občina Šmartno ob Paki"} },
        { code: "SI-194", name: "Šmartno pri Litiji", i18n: {"sl":"Občina Šmartno pri Litiji"} },
        { code: "SI-179", name: "Sodražica", i18n: {"sl":"Občina Sodražica"} },
        { code: "SI-180", name: "Solčava", i18n: {"sl":"Občina Solčava"} },
        { code: "SI-126", name: "Šoštanj", i18n: {"sl":"Občina Šoštanj"} },
        { code: "SI-202", name: "Središče ob Dravi", i18n: {"sl":"Občina Središče ob Dravi"} },
        { code: "SI-115", name: "Starše", i18n: {"sl":"Občina Starše"} },
        { code: "SI-127", name: "Štore", i18n: {"sl":"Občina Štore"} },
        { code: "SI-203", name: "Straža", i18n: {"sl":"Občina Straža"} },
        { code: "SI-181", name: "Sveta Ana", i18n: {"sl":"Sveta Ana v Slovenskih goricah"} },
        { code: "SI-204", name: "Sveta Trojica v Slovenskih Goricah", i18n: {"sl":"Občina Sveta Trojica v Slovenskih goricah"} },
        { code: "SI-182", name: "Sveti Andraž v Slovenskih Goricah", i18n: {"sl":"Občina Sveti Andraž v Slovenskih goricah"} },
        { code: "SI-116", name: "Sveti Jurij", i18n: {"sl":"Občina Sveti Jurij ob Ščavnici"} },
        { code: "SI-210", name: "Sveti Jurij v Slovenskih Goricah", i18n: {"sl":"Občina Sveti Jurij v Slovenskih goricah"} },
        { code: "SI-205", name: "Sveti Tomaž", i18n: {"sl":"Občina Sveti Tomaž"} },
        { code: "SI-184", name: "Tabor", i18n: {"sl":"Tabor, Tabor"} },
        { code: "SI-010", name: "Tišina", i18n: {"sl":"Tišina, Tišina"} },
        { code: "SI-128", name: "Tolmin", i18n: {"sl":"Občina Tolmin"} },
        { code: "SI-129", name: "Trbovlje", i18n: {"sl":"Občina Trbovlje"} },
        { code: "SI-130", name: "Trebnje", i18n: {"sl":"Občina Trebnje"} },
        { code: "SI-185", name: "Trnovska Vas", i18n: {"sl":"Občina Trnovska vas"} },
        { code: "SI-131", name: "Tržič", i18n: {"sl":"Občina Tržič"} },
        { code: "SI-186", name: "Trzin", i18n: {} },
        { code: "SI-132", name: "Turnišče", i18n: {"sl":"Občina Turnišče"} },
        { code: "SI-133", name: "Velenje", i18n: {"sl":"Mestna občina Velenje"} },
        { code: "SI-187", name: "Velika Polana", i18n: {"sl":"Občina Velika Polana"} },
        { code: "SI-134", name: "Velike Lašče", i18n: {"sl":"Občina Velike Lašče"} },
        { code: "SI-188", name: "Veržej", i18n: {"sl":"Občina Veržej"} },
        { code: "SI-135", name: "Videm", i18n: {"sl":"Občina Videm"} },
        { code: "SI-136", name: "Vipava", i18n: {"sl":"Občina Vipava"} },
        { code: "SI-137", name: "Vitanje", i18n: {"sl":"Občina Vitanje"} },
        { code: "SI-138", name: "Vodice", i18n: {} },
        { code: "SI-139", name: "Vojnik", i18n: {"sl":"Občina Vojnik"} },
        { code: "SI-189", name: "Vransko", i18n: {"sl":"Občina Vransko"} },
        { code: "SI-140", name: "Vrhnika", i18n: {"sl":"Občina Vrhnika"} },
        { code: "SI-141", name: "Vuzenica", i18n: {"sl":"Občina Vuzenica"} },
        { code: "SI-142", name: "Zagorje ob Savi", i18n: {"sl":"Občina Zagorje ob Savi"} },
        { code: "SI-190", name: "Žalec", i18n: {"sl":"Občina Žalec"} },
        { code: "SI-143", name: "Zavrč", i18n: {"sl":"Občina Zavrč"} },
        { code: "SI-146", name: "Železniki", i18n: {"sl":"Občina Železniki"} },
        { code: "SI-191", name: "Žetale", i18n: {"sl":"Občina Žetale"} },
        { code: "SI-147", name: "Žiri", i18n: {"sl":"Občina Žiri"} },
        { code: "SI-192", name: "Žirovnica", i18n: {"sl":"Občina Žirovnica"} },
        { code: "SI-144", name: "Zreče", i18n: {"sl":"Občina Zreče"} },
        { code: "SI-193", name: "Žužemberk", i18n: {"sl":"Občina Žužemberk"} },
    ],
    "SK": [
        { code: "SK-BC", name: "Banská Bystrica", i18n: {"sk":"Banskobystrický kraj"} },
        { code: "SK-BL", name: "Bratislava", i18n: {"sk":"Bratislavský kraj"} },
        { code: "SK-KI", name: "Košice", i18n: {"sk":"Košický kraj"} },
        { code: "SK-NI", name: "Nitra", i18n: {"sk":"Nitriansky kraj"} },
        { code: "SK-PV", name: "Prešov", i18n: {"sk":"Prešovský kraj"} },
        { code: "SK-TC", name: "Trenčín", i18n: {"sk":"Trenčiansky kraj"} },
        { code: "SK-TA", name: "Trnava", i18n: {"sk":"Trnavský kraj"} },
        { code: "SK-ZI", name: "Žilina", i18n: {"sk":"Žilinský kraj"} },
    ],
    "SL": [
        { code: "SL-E", name: "Eastern", i18n: {} },
        { code: "SL-NW", name: "North Western", i18n: {} },
        { code: "SL-N", name: "Northern", i18n: {} },
        { code: "SL-S", name: "Southern", i18n: {} },
        { code: "SL-W", name: "Western Area", i18n: {} },
    ],
    "SM": [
        { code: "SM-01", name: "Acquaviva", i18n: {} },
        { code: "SM-06", name: "Borgo Maggiore", i18n: {} },
        { code: "SM-02", name: "Chiesanuova", i18n: {} },
        { code: "SM-03", name: "Domagnano", i18n: {} },
        { code: "SM-04", name: "Faetano", i18n: {} },
        { code: "SM-05", name: "Fiorentino", i18n: {} },
        { code: "SM-08", name: "Montegiardino", i18n: {} },
        { code: "SM-07", name: "San Marino", i18n: {"it":"Città di San Marino"} },
        { code: "SM-09", name: "Serravalle", i18n: {} },
    ],
    "SN": [
        { code: "SN-DK", name: "Dakar", i18n: {} },
        { code: "SN-DB", name: "Diourbel", i18n: {} },
        { code: "SN-FK", name: "Fatick", i18n: {} },
        { code: "SN-KA", name: "Kaffrine", i18n: {} },
        { code: "SN-KL", name: "Kaolack", i18n: {} },
        { code: "SN-KE", name: "Kédougou", i18n: {} },
        { code: "SN-KD", name: "Kolda", i18n: {} },
        { code: "SN-LG", name: "Louga", i18n: {} },
        { code: "SN-MT", name: "Matam", i18n: {} },
        { code: "SN-SL", name: "Saint-Louis", i18n: {} },
        { code: "SN-SE", name: "Sédhiou", i18n: {} },
        { code: "SN-TC", name: "Tambacounda", i18n: {} },
        { code: "SN-TH", name: "Thiès", i18n: {} },
        { code: "SN-ZG", name: "Ziguinchor", i18n: {} },
    ],
    "SO": [
        { code: "SO-AW", name: "Awdal", i18n: {} },
        { code: "SO-BK", name: "Bakool", i18n: {} },
        { code: "SO-BN", name: "Banaadir", i18n: {} },
        { code: "SO-BR", name: "Bari", i18n: {} },
        { code: "SO-BY", name: "Bay, Somalia", i18n: {"so":"Baay"} },
        { code: "SO-GA", name: "Galguduud", i18n: {} },
        { code: "SO-GE", name: "Gedo", i18n: {} },
        { code: "SO-HI", name: "Hiran", i18n: {"so":"Hiiraan"} },
        { code: "SO-JH", name: "Lower Juba", i18n: {"so":"Jubbada Hoose"} },
        { code: "SO-SH", name: "Lower Shebelle", i18n: {"so":"Shabeellaha Hoose"} },
        { code: "SO-JD", name: "Middle Juba", i18n: {"so":"Jubbada Dhexe"} },
        { code: "SO-SD", name: "Middle Shebelle", i18n: {"so":"Shabeellaha Dhexe"} },
        { code: "SO-MU", name: "Mudug", i18n: {} },
        { code: "SO-NU", name: "Nugal", i18n: {"so":"Nugaal"} },
        { code: "SO-SA", name: "Sanaag", i18n: {} },
        { code: "SO-SO", name: "Sool", i18n: {} },
        { code: "SO-TO", name: "Togdheer", i18n: {} },
        { code: "SO-WO", name: "Woqooyi Galbeed", i18n: {} },
    ],
    "SR": [
        { code: "SR-BR", name: "Brokopondo", i18n: {} },
        { code: "SR-CM", name: "Commewijne", i18n: {} },
        { code: "SR-CR", name: "Coronie", i18n: {} },
        { code: "SR-MA", name: "Marowijne", i18n: {} },
        { code: "SR-NI", name: "Nickerie", i18n: {} },
        { code: "SR-PR", name: "Para", i18n: {} },
        { code: "SR-PM", name: "Paramaribo", i18n: {} },
        { code: "SR-SA", name: "Saramacca", i18n: {} },
        { code: "SR-SI", name: "Sipaliwini", i18n: {} },
        { code: "SR-WA", name: "Wanica", i18n: {} },
    ],
    "SS": [
        { code: "SS-EC", name: "Central Equatoria", i18n: {} },
        { code: "SS-EE", name: "Eastern Equatoria", i18n: {} },
        { code: "SS-JG", name: "Jonglei", i18n: {} },
        { code: "SS-LK", name: "Lakes", i18n: {} },
        { code: "SS-BN", name: "Northern Bahr el Ghazal", i18n: {} },
        { code: "SS-UY", name: "Unity", i18n: {} },
        { code: "SS-NU", name: "Upper Nile", i18n: {} },
        { code: "SS-WR", name: "Warrap", i18n: {} },
        { code: "SS-BW", name: "Western Bahr el Ghazal", i18n: {} },
        { code: "SS-EW", name: "Western Equatoria", i18n: {} },
    ],
    "ST": [
        { code: "ST-01", name: "Água Grande", i18n: {} },
        { code: "ST-02", name: "Cantagalo", i18n: {"pt":"Cantagalo (São Tomé e Príncipe)"} },
        { code: "ST-03", name: "Caué", i18n: {} },
        { code: "ST-04", name: "Lembá", i18n: {} },
        { code: "ST-05", name: "Lobata", i18n: {} },
        { code: "ST-06", name: "Mé-Zóchi", i18n: {} },
        { code: "ST-P", name: "Príncipe", i18n: {} },
    ],
    "SV": [
        { code: "SV-AH", name: "Ahuachapán", i18n: {"es":"Departamento de Ahuachapán"} },
        { code: "SV-CA", name: "Cabañas", i18n: {} },
        { code: "SV-CH", name: "Chalatenango", i18n: {"es":"Departamento de Chalatenango"} },
        { code: "SV-CU", name: "Cuscatlán", i18n: {} },
        { code: "SV-LI", name: "La Libertad", i18n: {"es":"Departamento de La Libertad"} },
        { code: "SV-PA", name: "La Paz", i18n: {} },
        { code: "SV-UN", name: "La Unión", i18n: {} },
        { code: "SV-MO", name: "Morazán", i18n: {} },
        { code: "SV-SM", name: "San Miguel", i18n: {} },
        { code: "SV-SS", name: "San Salvador", i18n: {} },
        { code: "SV-SV", name: "San Vicente", i18n: {} },
        { code: "SV-SA", name: "Santa Ana", i18n: {"es":"Departamento de Santa Ana"} },
        { code: "SV-SO", name: "Sonsonate", i18n: {} },
        { code: "SV-US", name: "Usulután", i18n: {} },
    ],
    "SY": [
        { code: "SY-HA", name: "Al-Hasakah", i18n: {"ar":"محافظة الحسكة"} },
        { code: "SY-HL", name: "Aleppo", i18n: {"ar":"محافظة حلب"} },
        { code: "SY-RA", name: "Ar-Raqqah", i18n: {"ar":"محافظة الرقة"} },
        { code: "SY-SU", name: "As-Suwayda", i18n: {"ar":"محافظة السويداء"} },
        { code: "SY-DI", name: "Damascus", i18n: {"ar":"محافظة دمشق"} },
        { code: "SY-DR", name: "Daraa", i18n: {"ar":"محافظة درعا"} },
        { code: "SY-DY", name: "Deir ez-Zor", i18n: {"ar":"محافظة دير الزور"} },
        { code: "SY-HM", name: "Hama", i18n: {"ar":"محافظة حماة"} },
        { code: "SY-HI", name: "Homs", i18n: {"ar":"محافظة حمص"} },
        { code: "SY-ID", name: "Idlib", i18n: {"ar":"محافظة إدلب"} },
        { code: "SY-LA", name: "Latakia", i18n: {"ar":"محافظة اللاذقية"} },
        { code: "SY-QU", name: "Quneitra", i18n: {"ar":"محافظة القنيطرة"} },
        { code: "SY-RD", name: "Rif Dimashq", i18n: {"ar":"محافظة ريف دمشق"} },
        { code: "SY-TA", name: "Tartus", i18n: {"ar":"محافظة طرطوس"} },
    ],
    "SZ": [
        { code: "SZ-HH", name: "Hhohho", i18n: {} },
        { code: "SZ-LU", name: "Lubombo", i18n: {} },
        { code: "SZ-MA", name: "Manzini", i18n: {} },
        { code: "SZ-SH", name: "Shiselweni", i18n: {} },
    ],
    "TD": [
        { code: "TD-BG", name: "Bahr el Gazel", i18n: {"ar":"بحر الغزال"} },
        { code: "TD-BA", name: "Batha", i18n: {"ar":"منطقة البطحة"} },
        { code: "TD-BO", name: "Borkou", i18n: {"ar":"منطقة بوركو"} },
        { code: "TD-CB", name: "Chari-Baguirmi", i18n: {"ar":"منطقة كانم"} },
        { code: "TD-EE", name: "Ennedi-Est", i18n: {"ar":"إنيدي الشرقية"} },
        { code: "TD-EO", name: "Ennedi-Ouest", i18n: {"ar":"إنيدي الغربية"} },
        { code: "TD-GR", name: "Guéra", i18n: {"ar":"منطقة قيرا"} },
        { code: "TD-HL", name: "Hadjer-Lamis", i18n: {"ar":"منطقة حجر لميس"} },
        { code: "TD-KA", name: "Kanem", i18n: {"ar":"منطقة كانم²"} },
        { code: "TD-LC", name: "Lac", i18n: {"ar":"منطقة البحيرة"} },
        { code: "TD-LO", name: "Logone Occidental", i18n: {"ar":"منطقة لوقون الغربي"} },
        { code: "TD-LR", name: "Logone Oriental", i18n: {"ar":"منطقة لوقون الشرقي"} },
        { code: "TD-MA", name: "Mandoul", i18n: {"ar":"منطقة ماندول"} },
        { code: "TD-ME", name: "Mayo-Kebbi Est", i18n: {"ar":"منطقة مايو كيبي الشرقي"} },
        { code: "TD-MO", name: "Mayo-Kebbi Ouest", i18n: {"ar":"منطقة مايو كيبي الغربي"} },
        { code: "TD-MC", name: "Moyen-Chari", i18n: {"ar":"منطقة شاري الأوسط"} },
        { code: "TD-ND", name: "N’Djamena", i18n: {"ar":"انجمينا"} },
        { code: "TD-OD", name: "Ouaddaï", i18n: {"ar":"منطقة وداي"} },
        { code: "TD-SA", name: "Salamat", i18n: {"ar":"منطقة سلامات"} },
        { code: "TD-SI", name: "Sila", i18n: {"ar":"منطقة سيلا"} },
        { code: "TD-TA", name: "Tandjilé", i18n: {"ar":"منطقة تانجلي"} },
        { code: "TD-TI", name: "Tibesti", i18n: {"ar":"منطقة تبستي"} },
        { code: "TD-WF", name: "Wadi Fira", i18n: {"ar":"منطقة وادي فيرا"} },
    ],
    "TG": [
        { code: "TG-C", name: "Centrale", i18n: {"fr":"Région centrale"} },
        { code: "TG-K", name: "Kara", i18n: {"fr":"Région de la Kara"} },
        { code: "TG-M", name: "Maritime", i18n: {"fr":"Région maritime"} },
        { code: "TG-P", name: "Plateaux", i18n: {"fr":"Région des plateaux"} },
        { code: "TG-S", name: "Savanes", i18n: {"fr":"Région des Savanes"} },
    ],
    "TH": [
        { code: "TH-37", name: "Amnat Charoen", i18n: {"th":"จังหวัดอำนาจเจริญ"} },
        { code: "TH-15", name: "Ang Thong", i18n: {"th":"จังหวัดอ่างทอง"} },
        { code: "TH-10", name: "Bangkok", i18n: {"th":"กรุงเทพมหานคร"} },
        { code: "TH-38", name: "Bueng Kan", i18n: {"th":"จังหวัดบึงกาฬ"} },
        { code: "TH-31", name: "Buri Ram", i18n: {"th":"จังหวัดบุรีรัมย์"} },
        { code: "TH-24", name: "Chachoengsao", i18n: {"th":"จังหวัดฉะเชิงเทรา"} },
        { code: "TH-18", name: "Chai Nat", i18n: {"th":"จังหวัดชัยนาท"} },
        { code: "TH-36", name: "Chaiyaphum", i18n: {"th":"จังหวัดชัยภูมิ"} },
        { code: "TH-22", name: "Chanthaburi", i18n: {"th":"จังหวัดจันทบุรี"} },
        { code: "TH-50", name: "Chiang Mai", i18n: {"th":"จังหวัดเชียงใหม่"} },
        { code: "TH-57", name: "Chiang Rai", i18n: {"th":"จังหวัดเชียงราย"} },
        { code: "TH-20", name: "Chon Buri", i18n: {"th":"จังหวัดชลบุรี"} },
        { code: "TH-86", name: "Chumphon", i18n: {"th":"จังหวัดชุมพร"} },
        { code: "TH-46", name: "Kalasin", i18n: {"th":"จังหวัดกาฬสินธุ์"} },
        { code: "TH-62", name: "Kamphaeng Phet", i18n: {"th":"จังหวัดกำแพงเพชร"} },
        { code: "TH-71", name: "Kanchanaburi", i18n: {"th":"จังหวัดกาญจนบุรี"} },
        { code: "TH-40", name: "Khon Kaen", i18n: {"th":"จังหวัดขอนแก่น"} },
        { code: "TH-81", name: "Krabi", i18n: {"th":"จังหวัดกระบี่"} },
        { code: "TH-52", name: "Lampang", i18n: {"th":"จังหวัดลำปาง"} },
        { code: "TH-51", name: "Lamphun", i18n: {"th":"จังหวัดลำพูน"} },
        { code: "TH-42", name: "Loei", i18n: {"th":"จังหวัดเลย"} },
        { code: "TH-16", name: "Lopburi", i18n: {"th":"จังหวัดลพบุรี"} },
        { code: "TH-58", name: "Mae Hong Son", i18n: {"th":"จังหวัดแม่ฮ่องสอน"} },
        { code: "TH-44", name: "Maha Sarakham", i18n: {"th":"จังหวัดมหาสารคาม"} },
        { code: "TH-49", name: "Mukdahan", i18n: {"th":"จังหวัดมุกดาหาร"} },
        { code: "TH-26", name: "Nakhon Nayok", i18n: {"th":"จังหวัดนครนายก"} },
        { code: "TH-73", name: "Nakhon Pathom", i18n: {"th":"จังหวัดนครปฐม"} },
        { code: "TH-48", name: "Nakhon Phanom", i18n: {"th":"จังหวัดนครพนม"} },
        { code: "TH-30", name: "Nakhon Ratchasima", i18n: {"th":"จังหวัดนครราชสีมา"} },
        { code: "TH-60", name: "Nakhon Sawan", i18n: {"th":"จังหวัดนครสวรรค์"} },
        { code: "TH-80", name: "Nakhon Si Thammarat", i18n: {"th":"จังหวัดนครศรีธรรมราช"} },
        { code: "TH-55", name: "Nan", i18n: {"th":"จังหวัดน่าน"} },
        { code: "TH-96", name: "Narathiwat", i18n: {"th":"จังหวัดนราธิวาส"} },
        { code: "TH-39", name: "Nong Bua Lam Phu", i18n: {"th":"จังหวัดหนองบัวลำภู"} },
        { code: "TH-43", name: "Nong Khai", i18n: {"th":"จังหวัดหนองคาย"} },
        { code: "TH-12", name: "Nonthaburi", i18n: {"th":"จังหวัดนนทบุรี"} },
        { code: "TH-13", name: "Pathum Thani", i18n: {"th":"จังหวัดปทุมธานี"} },
        { code: "TH-94", name: "Pattani", i18n: {"th":"จังหวัดปัตตานี"} },
        { code: "TH-S", name: "Pattaya", i18n: {"th":"เมืองพัทยา"} },
        { code: "TH-82", name: "Phang Nga", i18n: {"th":"จังหวัดพังงา"} },
        { code: "TH-93", name: "Phatthalung", i18n: {"th":"จังหวัดพัทลุง"} },
        { code: "TH-56", name: "Phayao", i18n: {"th":"จังหวัดพะเยา"} },
        { code: "TH-67", name: "Phetchabun", i18n: {"th":"จังหวัดเพชรบูรณ์"} },
        { code: "TH-76", name: "Phetchaburi", i18n: {"th":"จังหวัดเพชรบุรี"} },
        { code: "TH-66", name: "Phichit", i18n: {"th":"จังหวัดพิจิตร"} },
        { code: "TH-65", name: "Phitsanulok", i18n: {"th":"จังหวัดพิษณุโลก"} },
        { code: "TH-14", name: "Phra Nakhon Si Ayutthaya", i18n: {"th":"จังหวัดพระนครศรีอยุธยา"} },
        { code: "TH-54", name: "Phrae", i18n: {"th":"จังหวัดแพร่"} },
        { code: "TH-83", name: "Phuket", i18n: {"th":"จังหวัดภูเก็ต"} },
        { code: "TH-25", name: "Prachin Buri", i18n: {"th":"จังหวัดปราจีนบุรี"} },
        { code: "TH-77", name: "Prachuap Khiri Khan", i18n: {"th":"จังหวัดประจวบคีรีขันธ์"} },
        { code: "TH-85", name: "Ranong", i18n: {"th":"จังหวัดระนอง"} },
        { code: "TH-70", name: "Ratchaburi", i18n: {"th":"จังหวัดราชบุรี"} },
        { code: "TH-21", name: "Rayong", i18n: {"th":"จังหวัดระยอง"} },
        { code: "TH-45", name: "Roi Et", i18n: {"th":"จังหวัดร้อยเอ็ด"} },
        { code: "TH-27", name: "Sa Kaeo", i18n: {"th":"จังหวัดสระแก้ว"} },
        { code: "TH-47", name: "Sakon Nakhon", i18n: {"th":"จังหวัดสกลนคร"} },
        { code: "TH-11", name: "Samut Prakan", i18n: {"th":"จังหวัดสมุทรปราการ"} },
        { code: "TH-74", name: "Samut Sakhon", i18n: {"th":"จังหวัดสมุทรสาคร"} },
        { code: "TH-75", name: "Samut Songkhram", i18n: {"th":"จังหวัดสมุทรสงคราม"} },
        { code: "TH-19", name: "Saraburi", i18n: {"th":"จังหวัดสระบุรี"} },
        { code: "TH-91", name: "Satun", i18n: {"th":"จังหวัดสตูล"} },
        { code: "TH-33", name: "Si Sa Ket", i18n: {"th":"จังหวัดศรีสะเกษ"} },
        { code: "TH-17", name: "Sing Buri", i18n: {"th":"จังหวัดสิงห์บุรี"} },
        { code: "TH-90", name: "Songkhla", i18n: {"th":"จังหวัดสงขลา"} },
        { code: "TH-64", name: "Sukhothai", i18n: {"th":"จังหวัดสุโขทัย"} },
        { code: "TH-72", name: "Suphanburi", i18n: {"th":"จังหวัดสุพรรณบุรี"} },
        { code: "TH-84", name: "Surat Thani", i18n: {"th":"จังหวัดสุราษฎร์ธานี"} },
        { code: "TH-32", name: "Surin", i18n: {"th":"จังหวัดสุรินทร์"} },
        { code: "TH-63", name: "Tak", i18n: {"th":"จังหวัดตาก"} },
        { code: "TH-92", name: "Trang", i18n: {"th":"จังหวัดตรัง"} },
        { code: "TH-23", name: "Trat", i18n: {"th":"จังหวัดตราด"} },
        { code: "TH-34", name: "Ubon Ratchathani", i18n: {"th":"จังหวัดอุบลราชธานี"} },
        { code: "TH-41", name: "Udon Thani", i18n: {"th":"จังหวัดอุดรธานี"} },
        { code: "TH-61", name: "Uthai Thani", i18n: {"th":"จังหวัดอุทัยธานี"} },
        { code: "TH-53", name: "Uttaradit", i18n: {"th":"จังหวัดอุตรดิตถ์"} },
        { code: "TH-95", name: "Yala", i18n: {"th":"จังหวัดยะลา"} },
        { code: "TH-35", name: "Yasothon", i18n: {"th":"จังหวัดยโสธร"} },
    ],
    "TJ": [
        { code: "TJ-DU", name: "Dushanbe", i18n: {} },
        { code: "TJ-GB", name: "Gorno-Badakhshan", i18n: {} },
        { code: "TJ-KT", name: "Khatlon", i18n: {} },
        { code: "TJ-RA", name: "Nohiyahoi Tobei Jumhurí", i18n: {} },
        { code: "TJ-SU", name: "Sughd", i18n: {} },
    ],
    "TL": [
        { code: "TL-AL", name: "Aileu", i18n: {} },
        { code: "TL-AN", name: "Ainaro", i18n: {} },
        { code: "TL-BA", name: "Baucau", i18n: {} },
        { code: "TL-BO", name: "Bobonaro", i18n: {} },
        { code: "TL-CO", name: "Cova Lima", i18n: {} },
        { code: "TL-DI", name: "Dili", i18n: {"pt":"Díli"} },
        { code: "TL-ER", name: "Ermera", i18n: {} },
        { code: "TL-LA", name: "Lautém", i18n: {} },
        { code: "TL-LI", name: "Liquiçá", i18n: {} },
        { code: "TL-MT", name: "Manatuto", i18n: {} },
        { code: "TL-MF", name: "Manufahi", i18n: {} },
        { code: "TL-OE", name: "Oecusse", i18n: {} },
        { code: "TL-VI", name: "Viqueque", i18n: {} },
    ],
    "TM": [
        { code: "TM-A", name: "Ahal", i18n: {} },
        { code: "TM-S", name: "Aşgabat", i18n: {} },
        { code: "TM-B", name: "Balkan", i18n: {"tk":"Balkan welaýaty"} },
        { code: "TM-D", name: "Daşoguz", i18n: {"tk":"Daşoguz welaýaty"} },
        { code: "TM-L", name: "Lebap", i18n: {"tk":"Lebap welaýaty"} },
        { code: "TM-M", name: "Mary", i18n: {"tk":"Mary welaýaty"} },
    ],
    "TN": [
        { code: "TN-12", name: "Ariana", i18n: {"ar":"ولاية أريانة"} },
        { code: "TN-31", name: "Béja", i18n: {"ar":"ولاية باجة"} },
        { code: "TN-13", name: "Ben Arous", i18n: {"ar":"ولاية بن عروس"} },
        { code: "TN-23", name: "Bizerte", i18n: {"ar":"ولاية بنزرت"} },
        { code: "TN-81", name: "Gabès", i18n: {"ar":"ولاية قابس"} },
        { code: "TN-71", name: "Gafsa", i18n: {"ar":"ولاية قفصة"} },
        { code: "TN-32", name: "Jendouba", i18n: {"ar":"ولاية جندوبة"} },
        { code: "TN-41", name: "Kairouan", i18n: {"ar":"ولاية القيروان"} },
        { code: "TN-42", name: "Kasserine", i18n: {"ar":"ولاية القصرين"} },
        { code: "TN-73", name: "Kebili", i18n: {"ar":"ولاية قبلي"} },
        { code: "TN-33", name: "Kef", i18n: {"ar":"ولاية الكاف"} },
        { code: "TN-53", name: "Mahdia", i18n: {"ar":"ولاية المهدية"} },
        { code: "TN-14", name: "Manouba", i18n: {"ar":"ولاية منوبة"} },
        { code: "TN-82", name: "Medenine", i18n: {"ar":"ولاية مدنين"} },
        { code: "TN-52", name: "Monastir", i18n: {"ar":"ولاية المنستير"} },
        { code: "TN-21", name: "Nabeul", i18n: {"ar":"ولاية نابل"} },
        { code: "TN-61", name: "Sfax", i18n: {"ar":"ولاية صفاقس"} },
        { code: "TN-43", name: "Sidi Bouzid", i18n: {"ar":"ولاية سيدي بوزيد"} },
        { code: "TN-34", name: "Siliana", i18n: {"ar":"ولاية سليانة"} },
        { code: "TN-51", name: "Sousse", i18n: {"ar":"ولاية سوسة"} },
        { code: "TN-83", name: "Tataouine", i18n: {"ar":"ولاية تطاوين"} },
        { code: "TN-72", name: "Tozeur", i18n: {"ar":"ولاية توزر"} },
        { code: "TN-11", name: "Tunis", i18n: {"ar":"ولاية تونس"} },
        { code: "TN-22", name: "Zaghouan", i18n: {"ar":"ولاية زغوان"} },
    ],
    "TO": [
        { code: "TO-02", name: "Haʻapai", i18n: {} },
        { code: "TO-01", name: "ʻEua", i18n: {} },
        { code: "TO-03", name: "Niuas", i18n: {} },
        { code: "TO-04", name: "Tongatapu", i18n: {} },
        { code: "TO-05", name: "Vavaʻu", i18n: {} },
    ],
    "TR": [
        { code: "TR-01", name: "Adana", i18n: {} },
        { code: "TR-02", name: "Adıyaman", i18n: {} },
        { code: "TR-03", name: "Afyonkarahisar", i18n: {} },
        { code: "TR-04", name: "Ağrı", i18n: {} },
        { code: "TR-68", name: "Aksaray", i18n: {} },
        { code: "TR-05", name: "Amasya", i18n: {} },
        { code: "TR-06", name: "Ankara", i18n: {} },
        { code: "TR-07", name: "Antalya", i18n: {} },
        { code: "TR-75", name: "Ardahan", i18n: {} },
        { code: "TR-08", name: "Artvin", i18n: {"tr":"Artvin ili"} },
        { code: "TR-09", name: "Aydın", i18n: {} },
        { code: "TR-10", name: "Balıkesir", i18n: {} },
        { code: "TR-74", name: "Bartın", i18n: {} },
        { code: "TR-72", name: "Batman", i18n: {} },
        { code: "TR-69", name: "Bayburt", i18n: {} },
        { code: "TR-11", name: "Bilecik", i18n: {} },
        { code: "TR-12", name: "Bingöl", i18n: {} },
        { code: "TR-13", name: "Bitlis", i18n: {} },
        { code: "TR-14", name: "Bolu", i18n: {} },
        { code: "TR-15", name: "Burdur", i18n: {} },
        { code: "TR-16", name: "Bursa", i18n: {} },
        { code: "TR-17", name: "Çanakkale", i18n: {} },
        { code: "TR-18", name: "Çankırı", i18n: {"tr":"Çankırı (il)"} },
        { code: "TR-19", name: "Çorum", i18n: {"tr":"Çorum (il)"} },
        { code: "TR-20", name: "Denizli", i18n: {} },
        { code: "TR-21", name: "Diyarbakır", i18n: {} },
        { code: "TR-81", name: "Düzce", i18n: {} },
        { code: "TR-22", name: "Edirne", i18n: {} },
        { code: "TR-23", name: "Elazığ", i18n: {"tr":"Elâzığ"} },
        { code: "TR-24", name: "Erzincan", i18n: {} },
        { code: "TR-25", name: "Erzurum", i18n: {} },
        { code: "TR-26", name: "Eskişehir", i18n: {} },
        { code: "TR-27", name: "Gaziantep", i18n: {} },
        { code: "TR-28", name: "Giresun", i18n: {} },
        { code: "TR-29", name: "Gümüşhane", i18n: {} },
        { code: "TR-30", name: "Hakkâri", i18n: {} },
        { code: "TR-31", name: "Hatay", i18n: {} },
        { code: "TR-76", name: "Iğdır", i18n: {} },
        { code: "TR-32", name: "Isparta", i18n: {} },
        { code: "TR-34", name: "Istanbul", i18n: {"tr":"İstanbul"} },
        { code: "TR-35", name: "Izmir", i18n: {"tr":"İzmir (il)"} },
        { code: "TR-46", name: "Kahramanmaraş", i18n: {} },
        { code: "TR-78", name: "Karabük", i18n: {} },
        { code: "TR-70", name: "Karaman", i18n: {} },
        { code: "TR-36", name: "Kars", i18n: {} },
        { code: "TR-37", name: "Kastamonu", i18n: {} },
        { code: "TR-38", name: "Kayseri", i18n: {} },
        { code: "TR-79", name: "Kilis", i18n: {} },
        { code: "TR-71", name: "Kırıkkale", i18n: {} },
        { code: "TR-39", name: "Kırklareli", i18n: {} },
        { code: "TR-40", name: "Kırşehir", i18n: {} },
        { code: "TR-41", name: "Kocaeli", i18n: {} },
        { code: "TR-42", name: "Konya", i18n: {} },
        { code: "TR-43", name: "Kütahya", i18n: {} },
        { code: "TR-44", name: "Malatya", i18n: {} },
        { code: "TR-45", name: "Manisa", i18n: {} },
        { code: "TR-47", name: "Mardin", i18n: {} },
        { code: "TR-33", name: "Mersin", i18n: {} },
        { code: "TR-48", name: "Muğla", i18n: {} },
        { code: "TR-49", name: "Muş", i18n: {} },
        { code: "TR-50", name: "Nevşehir", i18n: {} },
        { code: "TR-51", name: "Niğde", i18n: {} },
        { code: "TR-52", name: "Ordu", i18n: {} },
        { code: "TR-80", name: "Osmaniye", i18n: {} },
        { code: "TR-53", name: "Rize", i18n: {} },
        { code: "TR-54", name: "Sakarya", i18n: {} },
        { code: "TR-55", name: "Samsun", i18n: {} },
        { code: "TR-63", name: "Şanlıurfa", i18n: {} },
        { code: "TR-56", name: "Siirt", i18n: {} },
        { code: "TR-57", name: "Sinop", i18n: {} },
        { code: "TR-58", name: "Sivas", i18n: {} },
        { code: "TR-73", name: "Şırnak", i18n: {} },
        { code: "TR-59", name: "Tekirdağ", i18n: {} },
        { code: "TR-60", name: "Tokat", i18n: {} },
        { code: "TR-61", name: "Trabzon", i18n: {} },
        { code: "TR-62", name: "Tunceli", i18n: {} },
        { code: "TR-64", name: "Uşak", i18n: {} },
        { code: "TR-65", name: "Van", i18n: {} },
        { code: "TR-77", name: "Yalova", i18n: {} },
        { code: "TR-66", name: "Yozgat", i18n: {} },
        { code: "TR-67", name: "Zonguldak", i18n: {"tr":"Zonguldak (il)"} },
    ],
    "TT": [
        { code: "TT-ARI", name: "Arima", i18n: {} },
        { code: "TT-CHA", name: "Chaguanas", i18n: {} },
        { code: "TT-CTT", name: "Couva-Tabaquite-Talparo", i18n: {} },
        { code: "TT-DMN", name: "Diego Martin", i18n: {} },
        { code: "TT-MRC", name: "Mayaro-Rio Claro", i18n: {} },
        { code: "TT-PED", name: "Penal-Debe", i18n: {} },
        { code: "TT-PTF", name: "Point Fortin", i18n: {} },
        { code: "TT-POS", name: "Port of Spain", i18n: {} },
        { code: "TT-PRT", name: "Princes Town", i18n: {} },
        { code: "TT-SFO", name: "San Fernando", i18n: {} },
        { code: "TT-SJL", name: "San Juan-Laventille", i18n: {} },
        { code: "TT-SGE", name: "Sangre Grande", i18n: {} },
        { code: "TT-SIP", name: "Siparia", i18n: {} },
        { code: "TT-TOB", name: "Tobago", i18n: {} },
        { code: "TT-TUP", name: "Tunapuna-Piarco", i18n: {} },
    ],
    "TV": [
        { code: "TV-FUN", name: "Funafuti", i18n: {} },
        { code: "TV-NMG", name: "Nanumanga", i18n: {} },
        { code: "TV-NMA", name: "Nanumea", i18n: {} },
        { code: "TV-NIT", name: "Niutao", i18n: {} },
        { code: "TV-NUI", name: "Nui", i18n: {} },
        { code: "TV-NKF", name: "Nukufetau", i18n: {} },
        { code: "TV-NKL", name: "Nukulaelae", i18n: {} },
        { code: "TV-VAI", name: "Vaitupu", i18n: {} },
    ],
    "TW": [
        { code: "TW-CHA", name: "Changhua", i18n: {} },
        { code: "TW-CYQ", name: "Chiayi", i18n: {} },
        { code: "TW-CYI", name: "Chiayi County", i18n: {} },
        { code: "TW-HSZ", name: "Hsinchu", i18n: {} },
        { code: "TW-HSQ", name: "Hsinchu County", i18n: {} },
        { code: "TW-HUA", name: "Hualien", i18n: {} },
        { code: "TW-KHH", name: "Kaohsiung", i18n: {} },
        { code: "TW-KEE", name: "Keelung", i18n: {} },
        { code: "TW-KIN", name: "Kinmen", i18n: {} },
        { code: "TW-LIE", name: "Lienchiang", i18n: {} },
        { code: "TW-MIA", name: "Miaoli", i18n: {} },
        { code: "TW-NAN", name: "Nantou", i18n: {} },
        { code: "TW-NWT", name: "New Taipei", i18n: {} },
        { code: "TW-PEN", name: "Penghu", i18n: {} },
        { code: "TW-PIF", name: "Pingtung", i18n: {} },
        { code: "TW-TXG", name: "Taichung", i18n: {} },
        { code: "TW-TNN", name: "Tainan", i18n: {} },
        { code: "TW-TPE", name: "Taipei", i18n: {} },
        { code: "TW-TTT", name: "Taitung", i18n: {} },
        { code: "TW-TAO", name: "Taoyuan", i18n: {} },
        { code: "TW-ILA", name: "Yilan", i18n: {} },
        { code: "TW-YUN", name: "Yunlin", i18n: {} },
    ],
    "TZ": [
        { code: "TZ-01", name: "Arusha", i18n: {"sw":"Mkoa wa Arusha"} },
        { code: "TZ-02", name: "Dar es Salaam", i18n: {"sw":"Mkoa wa Dar es Salaam"} },
        { code: "TZ-03", name: "Dodoma", i18n: {"sw":"Mkoa wa Dodoma"} },
        { code: "TZ-27", name: "Geita", i18n: {"sw":"Mkoa wa Geita"} },
        { code: "TZ-04", name: "Iringa", i18n: {"sw":"Mkoa wa Iringa"} },
        { code: "TZ-05", name: "Kagera", i18n: {"sw":"Mkoa wa Kagera"} },
        { code: "TZ-28", name: "Katavi", i18n: {"sw":"Mkoa wa Katavi"} },
        { code: "TZ-08", name: "Kigoma", i18n: {"sw":"Mkoa wa Kigoma"} },
        { code: "TZ-09", name: "Kilimanjaro", i18n: {"sw":"Mkoa wa Kilimanjaro"} },
        { code: "TZ-12", name: "Lindi", i18n: {"sw":"Mkoa wa Lindi"} },
        { code: "TZ-26", name: "Manyara", i18n: {"sw":"Mkoa wa Manyara"} },
        { code: "TZ-13", name: "Mara", i18n: {"sw":"Mkoa wa Mara"} },
        { code: "TZ-14", name: "Mbeya", i18n: {"sw":"Mkoa wa Mbeya"} },
        { code: "TZ-16", name: "Morogoro", i18n: {"sw":"Mkoa wa Morogoro"} },
        { code: "TZ-17", name: "Mtwara", i18n: {"sw":"Mkoa wa Mtwara"} },
        { code: "TZ-18", name: "Mwanza", i18n: {"sw":"Mkoa wa Mwanza"} },
        { code: "TZ-29", name: "Njombe", i18n: {"sw":"Mkoa wa Njombe"} },
        { code: "TZ-06", name: "North Pemba", i18n: {"sw":"Mkoa wa Pemba Kaskazini"} },
        { code: "TZ-19", name: "Pwani", i18n: {"sw":"Mkoa wa Pwani"} },
        { code: "TZ-20", name: "Rukwa", i18n: {"sw":"Mkoa wa Rukwa"} },
        { code: "TZ-21", name: "Ruvuma", i18n: {"sw":"Mkoa wa Ruvuma"} },
        { code: "TZ-22", name: "Shinyanga", i18n: {"sw":"Mkoa wa Shinyanga"} },
        { code: "TZ-30", name: "Simiyu", i18n: {"sw":"Mkoa wa Simiyu"} },
        { code: "TZ-23", name: "Singida", i18n: {"sw":"Mkoa wa Singida"} },
        { code: "TZ-31", name: "Songwe", i18n: {"sw":"Mkoa wa Songwe"} },
        { code: "TZ-10", name: "South Pemba", i18n: {"sw":"Mkoa wa Pemba Kusini"} },
        { code: "TZ-24", name: "Tabora", i18n: {"sw":"Mkoa wa Tabora"} },
        { code: "TZ-25", name: "Tanga", i18n: {"sw":"Mkoa wa Tanga"} },
        { code: "TZ-11", name: "Zanzibar Central/South", i18n: {"sw":"Mkoa wa Unguja Kusini"} },
        { code: "TZ-07", name: "Zanzibar North", i18n: {"sw":"Mkoa wa Unguja Kaskazini"} },
        { code: "TZ-15", name: "Zanzibar Urban/West", i18n: {"sw":"Mkoa wa Unguja Mjini Magharibi"} },
    ],
    "UA": [
        { code: "UA-71", name: "Cherkashchyna", i18n: {"uk":"Черкаська область"} },
        { code: "UA-74", name: "Chernihivshchyna", i18n: {"uk":"Чернігівська область"} },
        { code: "UA-77", name: "Chernivtsi Oblast", i18n: {"uk":"Чернівецька область"} },
        { code: "UA-43", name: "Crimea", i18n: {"uk":"Автономна Республіка Крим"} },
        { code: "UA-12", name: "Dnipropetrovshchyna", i18n: {"uk":"Дніпропетровська область"} },
        { code: "UA-14", name: "Donechchyna", i18n: {"uk":"Донецька область"} },
        { code: "UA-63", name: "Kharkivshchyna", i18n: {"uk":"Харківська область"} },
        { code: "UA-65", name: "Khersonshchyna", i18n: {"uk":"Херсонська область"} },
        { code: "UA-68", name: "Khmelnychchyna", i18n: {"uk":"Хмельницька область"} },
        { code: "UA-35", name: "Kirovohradschyna", i18n: {"uk":"Кіровоградська область"} },
        { code: "UA-30", name: "Kyiv", i18n: {"uk":"Київ"} },
        { code: "UA-32", name: "Kyivshchyna", i18n: {"uk":"Київська область"} },
        { code: "UA-09", name: "Luhanshchyna", i18n: {"uk":"Луганська область"} },
        { code: "UA-46", name: "Lvivshchyna", i18n: {"uk":"Львівська область"} },
        { code: "UA-48", name: "Mykolayivschyna", i18n: {"uk":"Миколаївська область"} },
        { code: "UA-51", name: "Odeshchyna", i18n: {"uk":"Одеська область"} },
        { code: "UA-53", name: "Poltavshchyna", i18n: {"uk":"Полтавська область"} },
        { code: "UA-26", name: "Prykarpattia", i18n: {"uk":"Івано-Франківська область"} },
        { code: "UA-56", name: "Rivnenshchyna", i18n: {"uk":"Рівненська область"} },
        { code: "UA-40", name: "Sevastopol", i18n: {"uk":"Севастополь"} },
        { code: "UA-59", name: "Sumshchyna", i18n: {"uk":"Сумська область"} },
        { code: "UA-61", name: "Ternopilshchyna", i18n: {"uk":"Тернопільська область"} },
        { code: "UA-05", name: "Vinnychchyna", i18n: {"uk":"Вінницька область"} },
        { code: "UA-07", name: "Volyn", i18n: {"uk":"Волинська область"} },
        { code: "UA-21", name: "Zakarpattia", i18n: {"uk":"Закарпатська область"} },
        { code: "UA-23", name: "Zaporizhzhya", i18n: {"uk":"Запорізька область"} },
        { code: "UA-18", name: "Zhytomyrshchyna", i18n: {"uk":"Житомирська область"} },
    ],
    "UG": [
        { code: "UG-314", name: "Abim", i18n: {"sw":"Wilaya ya Abim"} },
        { code: "UG-301", name: "Adjumani", i18n: {"sw":"Wilaya ya Adjumani"} },
        { code: "UG-322", name: "Agago", i18n: {"sw":"Wilaya ya Agago"} },
        { code: "UG-323", name: "Alebtong", i18n: {"sw":"Wilaya ya Alebtong"} },
        { code: "UG-315", name: "Amolatar", i18n: {"sw":"Wilaya ya Kaabong"} },
        { code: "UG-324", name: "Amudat", i18n: {"sw":"Wilaya ya Amudat"} },
        { code: "UG-216", name: "Amuria", i18n: {"sw":"Wilaya ya Amuria"} },
        { code: "UG-316", name: "Amuru", i18n: {"sw":"Wilaya ya Amuru"} },
        { code: "UG-302", name: "Apac", i18n: {"sw":"Wilaya ya Apac"} },
        { code: "UG-303", name: "Arua", i18n: {"sw":"Wilaya ya Arua"} },
        { code: "UG-217", name: "Budaka", i18n: {"sw":"Wilaya ya Budaka"} },
        { code: "UG-218", name: "Bududa", i18n: {"sw":"Wilaya ya Bududa"} },
        { code: "UG-201", name: "Bugiri", i18n: {"sw":"Wilaya ya Bugiri"} },
        { code: "UG-235", name: "Bugweri", i18n: {} },
        { code: "UG-420", name: "Buhweju", i18n: {"sw":"Wilaya ya Buhweju"} },
        { code: "UG-117", name: "Buikwe", i18n: {"sw":"Wilaya ya Buikwe"} },
        { code: "UG-219", name: "Bukedea", i18n: {"sw":"Wilaya ya Butaleja"} },
        { code: "UG-118", name: "Bukomansibi", i18n: {"sw":"Wilaya ya Bukomansimbi"} },
        { code: "UG-220", name: "Bukwa", i18n: {"sw":"Wilaya ya Kaliro"} },
        { code: "UG-225", name: "Bulambuli", i18n: {"sw":"Wilaya ya Bulambuli"} },
        { code: "UG-416", name: "Buliisa", i18n: {"sw":"Wilaya ya Ibanda"} },
        { code: "UG-401", name: "Bundibugyo", i18n: {"sw":"Wilaya ya Bundibugyo"} },
        { code: "UG-430", name: "Bunyangabu", i18n: {"sw":"Wilaya ya Bunyangabu"} },
        { code: "UG-402", name: "Bushenyi", i18n: {"sw":"Wilaya ya Bushenyi"} },
        { code: "UG-202", name: "Busia", i18n: {"sw":"Wilaya ya Busia"} },
        { code: "UG-221", name: "Butaleja", i18n: {"sw":"Wilaya ya Manafwa"} },
        { code: "UG-119", name: "Butambala", i18n: {"sw":"Wilaya ya Butambala"} },
        { code: "UG-233", name: "Butebo", i18n: {"sw":"Wilaya ya Butebo"} },
        { code: "UG-120", name: "Buvuma", i18n: {"sw":"Wilaya ya Buvuma"} },
        { code: "UG-226", name: "Buyende", i18n: {"sw":"Wilaya ya Buyende"} },
        { code: "UG-C", name: "Central", i18n: {"sw":"Mkoa wa Kati"} },
        { code: "UG-317", name: "Dokolo", i18n: {"sw":"Wilaya ya Abim²"} },
        { code: "UG-E", name: "Eastern", i18n: {"sw":"Mkoa wa Mashariki"} },
        { code: "UG-121", name: "Gomba", i18n: {"sw":"Wilaya ya Gomba"} },
        { code: "UG-304", name: "Gulu", i18n: {"sw":"Wilaya ya Gulu"} },
        { code: "UG-403", name: "Hoima", i18n: {"sw":"Wilaya ya Hoima"} },
        { code: "UG-417", name: "Ibanda", i18n: {"sw":"Wilaya ya Isingiro"} },
        { code: "UG-203", name: "Iganga", i18n: {"sw":"Wilaya ya Iganga"} },
        { code: "UG-418", name: "Isingiro", i18n: {"sw":"Wilaya ya Isingiro²"} },
        { code: "UG-204", name: "Jinja", i18n: {"sw":"Wilaya ya Jinja"} },
        { code: "UG-318", name: "Kaabong", i18n: {"sw":"Wilaya ya Kaabong²"} },
        { code: "UG-404", name: "Kabale", i18n: {"sw":"Wilaya ya Kabale"} },
        { code: "UG-405", name: "Kabarole", i18n: {"sw":"Wilaya ya Kabarole"} },
        { code: "UG-213", name: "Kaberamaido", i18n: {"sw":"Wilaya ya Kaberamaido"} },
        { code: "UG-427", name: "Kagadi", i18n: {"sw":"Wilaya ya Kagadi"} },
        { code: "UG-428", name: "Kakumiro", i18n: {"sw":"Wilaya ya Kakumiro"} },
        { code: "UG-237", name: "Kalaki", i18n: {} },
        { code: "UG-101", name: "Kalangala", i18n: {"sw":"Wilaya ya Kalangala"} },
        { code: "UG-222", name: "Kaliro", i18n: {"sw":"Wilaya ya Kaliro²"} },
        { code: "UG-122", name: "Kalungu", i18n: {"sw":"Wilaya ya Kalungu"} },
        { code: "UG-102", name: "Kampala", i18n: {"sw":"Wilaya ya Kampala"} },
        { code: "UG-205", name: "Kamuli", i18n: {"sw":"Wilaya ya Kamuli"} },
        { code: "UG-413", name: "Kamwenge", i18n: {"sw":"Wilaya ya Kamwenge"} },
        { code: "UG-414", name: "Kanungu", i18n: {"sw":"Wilaya ya Kanungu"} },
        { code: "UG-206", name: "Kapchorwa", i18n: {"sw":"Wilaya ya Kapchorwa"} },
        { code: "UG-236", name: "Kapelebyong", i18n: {} },
        { code: "UG-335", name: "Karenga", i18n: {"sw":"Wilaya ya Karenga"} },
        { code: "UG-126", name: "Kasanda", i18n: {} },
        { code: "UG-406", name: "Kasese", i18n: {"sw":"Wilaya ya Kasese"} },
        { code: "UG-207", name: "Katakwi", i18n: {"sw":"Wilaya ya Katakwi"} },
        { code: "UG-112", name: "Kayunga", i18n: {"sw":"Wilaya ya Kayunga"} },
        { code: "UG-433", name: "Kazo", i18n: {"sw":"Wilaya ya Kazo"} },
        { code: "UG-407", name: "Kibaale", i18n: {"sw":"Wilaya ya Kibaale"} },
        { code: "UG-103", name: "Kiboga", i18n: {"sw":"Wilaya ya Kiboga"} },
        { code: "UG-227", name: "Kibuku", i18n: {"sw":"Wilaya ya Kibuku"} },
        { code: "UG-432", name: "Kikuube", i18n: {} },
        { code: "UG-419", name: "Kiruhura", i18n: {"sw":"Wilaya ya Kiruhura"} },
        { code: "UG-421", name: "Kiryandongo", i18n: {} },
        { code: "UG-408", name: "Kisoro", i18n: {"sw":"Wilaya ya Kisoro"} },
        { code: "UG-434", name: "Kitagwenda", i18n: {"sw":"Wilaya ya Kitagwenda"} },
        { code: "UG-305", name: "Kitgum", i18n: {"sw":"Wilaya ya Kitgum"} },
        { code: "UG-319", name: "Koboko", i18n: {"sw":"Wilaya ya Amuru²"} },
        { code: "UG-325", name: "Kole", i18n: {"sw":"Wilaya ya Kole"} },
        { code: "UG-306", name: "Kotido", i18n: {"sw":"Wilaya ya Kotido"} },
        { code: "UG-208", name: "Kumi", i18n: {"sw":"Wilaya ya Kumi"} },
        { code: "UG-333", name: "Kwania", i18n: {} },
        { code: "UG-228", name: "Kween", i18n: {"sw":"Wilaya ya Kween"} },
        { code: "UG-123", name: "Kyankwanzi", i18n: {"sw":"Wilaya ya Kyankwanzi"} },
        { code: "UG-422", name: "Kyegegwa", i18n: {"sw":"Wilaya ya Kyegegwa"} },
        { code: "UG-415", name: "Kyenjojo", i18n: {"sw":"Wilaya ya Kyenjojo"} },
        { code: "UG-125", name: "Kyotera", i18n: {"sw":"Wilaya ya Kyotera"} },
        { code: "UG-326", name: "Lamwo", i18n: {"sw":"Wilaya ya Lamwo"} },
        { code: "UG-307", name: "Lira", i18n: {"sw":"Wilaya ya Lira"} },
        { code: "UG-229", name: "Luuka", i18n: {"sw":"Wilaya ya Luuka"} },
        { code: "UG-104", name: "Luwero", i18n: {"sw":"Wilaya ya Luweero"} },
        { code: "UG-124", name: "Lwengo", i18n: {"sw":"Wilaya ya Lwengo"} },
        { code: "UG-114", name: "Lyantonde", i18n: {"sw":"Wilaya ya Lyantonde"} },
        { code: "UG-336", name: "Madi-Okollo", i18n: {"sw":"Wilaya ya Madi-Okollo"} },
        { code: "UG-223", name: "Manafwa", i18n: {"sw":"Wilaya ya Manafwa²"} },
        { code: "UG-320", name: "Maracha", i18n: {} },
        { code: "UG-105", name: "Masaka", i18n: {"sw":"Wilaya ya Masaka"} },
        { code: "UG-409", name: "Masindi", i18n: {"sw":"Wilaya ya Masindi"} },
        { code: "UG-214", name: "Mayuge", i18n: {"sw":"Wilaya ya Mayuge"} },
        { code: "UG-209", name: "Mbale", i18n: {"sw":"Wilaya ya Mbale"} },
        { code: "UG-410", name: "Mbarara", i18n: {"sw":"Wilaya ya Mbarara"} },
        { code: "UG-423", name: "Mitooma", i18n: {"sw":"Wilaya ya Mitooma"} },
        { code: "UG-115", name: "Mityana", i18n: {"sw":"Wilaya ya Mityana"} },
        { code: "UG-308", name: "Moroto", i18n: {"sw":"Wilaya ya Moroto"} },
        { code: "UG-309", name: "Moyo", i18n: {"sw":"Wilaya ya Moyo"} },
        { code: "UG-106", name: "Mpigi", i18n: {"sw":"Wilaya ya Mpigi"} },
        { code: "UG-107", name: "Mubende", i18n: {"sw":"Wilaya ya Mubende"} },
        { code: "UG-108", name: "Mukono", i18n: {"sw":"Wilaya ya Mukono"} },
        { code: "UG-334", name: "Nabilatuk", i18n: {} },
        { code: "UG-311", name: "Nakapiripirit", i18n: {"sw":"Wilaya ya Nakapiripirit"} },
        { code: "UG-116", name: "Nakaseke", i18n: {"sw":"Wilaya ya Lyantonde²"} },
        { code: "UG-109", name: "Nakasongola", i18n: {"sw":"Wilaya ya Nakasongola"} },
        { code: "UG-230", name: "Namayingo", i18n: {"sw":"Wilaya ya Namayingo"} },
        { code: "UG-234", name: "Namisindwa", i18n: {"sw":"Wilaya ya Namisindwa"} },
        { code: "UG-224", name: "Namutumba", i18n: {"sw":"Wilaya ya Bukedea"} },
        { code: "UG-327", name: "Napak", i18n: {"sw":"Wilaya ya Napak"} },
        { code: "UG-310", name: "Nebbi", i18n: {"sw":"Wilaya ya Nebbi"} },
        { code: "UG-231", name: "Ngora", i18n: {"sw":"Wilaya ya Ngora"} },
        { code: "UG-N", name: "Northern", i18n: {"sw":"Mkoa wa Kaskazini"} },
        { code: "UG-424", name: "Ntoroko", i18n: {"sw":"Wilaya ya Ntoroko"} },
        { code: "UG-411", name: "Ntungamo", i18n: {"sw":"Wilaya ya Ntungamo"} },
        { code: "UG-328", name: "Nwoya", i18n: {"sw":"Wilaya ya Nwoya"} },
        { code: "UG-337", name: "Obongi", i18n: {"sw":"Wilaya ya Obongi"} },
        { code: "UG-329", name: "Otuke", i18n: {"sw":"Wilaya ya Otuke"} },
        { code: "UG-321", name: "Oyam", i18n: {"sw":"Wilaya ya Oyam"} },
        { code: "UG-312", name: "Pader", i18n: {"sw":"Wilaya ya Pader"} },
        { code: "UG-332", name: "Pakwach", i18n: {"sw":"Wilaya ya Pakwach"} },
        { code: "UG-210", name: "Pallisa", i18n: {"sw":"Wilaya ya Pallisa"} },
        { code: "UG-110", name: "Rakai", i18n: {"sw":"Wilaya ya Rakai"} },
        { code: "UG-429", name: "Rubanda", i18n: {"sw":"Wilaya ya Rubanda"} },
        { code: "UG-425", name: "Rubirizi", i18n: {"sw":"Wilaya ya Rubirizi"} },
        { code: "UG-431", name: "Rukiga", i18n: {"sw":"Wilaya ya Rukiga"} },
        { code: "UG-412", name: "Rukungiri", i18n: {"sw":"Wilaya ya Rukungiri"} },
        { code: "UG-435", name: "Rwampara", i18n: {"sw":"Wilaya ya Rwampara"} },
        { code: "UG-111", name: "Sembabule", i18n: {"sw":"Wilaya ya Sembabule"} },
        { code: "UG-232", name: "Serere", i18n: {"sw":"Wilaya ya Serere"} },
        { code: "UG-426", name: "Sheema", i18n: {"sw":"Wilaya ya Sheema"} },
        { code: "UG-215", name: "Sironko", i18n: {"sw":"Wilaya ya Sironko"} },
        { code: "UG-211", name: "Soroti", i18n: {"sw":"Wilaya ya Soroti"} },
        { code: "UG-212", name: "Tororo", i18n: {"sw":"Wilaya ya Tororo"} },
        { code: "UG-113", name: "Wakiso", i18n: {"sw":"Wilaya ya Wakiso"} },
        { code: "UG-W", name: "Western", i18n: {"sw":"Mkoa wa Magharibi"} },
        { code: "UG-313", name: "Yumbe", i18n: {"sw":"Wilaya ya Yumbe"} },
        { code: "UG-331", name: "Zombo", i18n: {"sw":"Wilaya ya Omoro"} },
        { code: "UG-330", name: "Zombo²", i18n: {"sw":"Wilaya ya Zombo"} },
    ],
    "UM": [
        { code: "UM-81", name: "Baker Island", i18n: {} },
        { code: "UM-84", name: "Howland Island", i18n: {} },
        { code: "UM-86", name: "Jarvis Island", i18n: {} },
        { code: "UM-67", name: "Johnston Atoll", i18n: {} },
        { code: "UM-89", name: "Kingman Reef", i18n: {} },
        { code: "UM-71", name: "Midway Atoll", i18n: {} },
        { code: "UM-76", name: "Navassa Island", i18n: {} },
        { code: "UM-95", name: "Palmyra Atoll", i18n: {} },
        { code: "UM-79", name: "Wake Island", i18n: {} },
    ],
    "US": [
        { code: "US-AL", name: "Alabama", i18n: {} },
        { code: "US-AK", name: "Alaska", i18n: {} },
        { code: "US-AS", name: "American Samoa", i18n: {} },
        { code: "US-AZ", name: "Arizona", i18n: {} },
        { code: "US-AR", name: "Arkansas", i18n: {} },
        { code: "US-CA", name: "California", i18n: {} },
        { code: "US-CO", name: "Colorado", i18n: {} },
        { code: "US-CT", name: "Connecticut", i18n: {} },
        { code: "US-DE", name: "Delaware", i18n: {} },
        { code: "US-FL", name: "Florida", i18n: {} },
        { code: "US-GA", name: "Georgia", i18n: {} },
        { code: "US-GU", name: "Guam", i18n: {} },
        { code: "US-HI", name: "Hawaii", i18n: {} },
        { code: "US-ID", name: "Idaho", i18n: {} },
        { code: "US-IL", name: "Illinois", i18n: {} },
        { code: "US-IN", name: "Indiana", i18n: {} },
        { code: "US-IA", name: "Iowa", i18n: {} },
        { code: "US-KS", name: "Kansas", i18n: {} },
        { code: "US-KY", name: "Kentucky", i18n: {} },
        { code: "US-LA", name: "Louisiana", i18n: {} },
        { code: "US-ME", name: "Maine", i18n: {} },
        { code: "US-MD", name: "Maryland", i18n: {} },
        { code: "US-MA", name: "Massachusetts", i18n: {} },
        { code: "US-MI", name: "Michigan", i18n: {} },
        { code: "US-MN", name: "Minnesota", i18n: {} },
        { code: "US-MS", name: "Mississippi", i18n: {} },
        { code: "US-MO", name: "Missouri", i18n: {} },
        { code: "US-MT", name: "Montana", i18n: {} },
        { code: "US-NE", name: "Nebraska", i18n: {} },
        { code: "US-NV", name: "Nevada", i18n: {} },
        { code: "US-NH", name: "New Hampshire", i18n: {} },
        { code: "US-NJ", name: "New Jersey", i18n: {} },
        { code: "US-NM", name: "New Mexico", i18n: {} },
        { code: "US-NY", name: "New York", i18n: {} },
        { code: "US-NC", name: "North Carolina", i18n: {} },
        { code: "US-ND", name: "North Dakota", i18n: {} },
        { code: "US-MP", name: "Northern Mariana Islands", i18n: {} },
        { code: "US-OH", name: "Ohio", i18n: {} },
        { code: "US-OK", name: "Oklahoma", i18n: {} },
        { code: "US-OR", name: "Oregon", i18n: {} },
        { code: "US-PA", name: "Pennsylvania", i18n: {} },
        { code: "US-PR", name: "Puerto Rico", i18n: {} },
        { code: "US-RI", name: "Rhode Island", i18n: {} },
        { code: "US-SC", name: "South Carolina", i18n: {} },
        { code: "US-SD", name: "South Dakota", i18n: {} },
        { code: "US-TN", name: "Tennessee", i18n: {} },
        { code: "US-TX", name: "Texas", i18n: {} },
        { code: "US-UM", name: "United States Minor Outlying Islands", i18n: {} },
        { code: "US-UT", name: "Utah", i18n: {} },
        { code: "US-VT", name: "Vermont", i18n: {} },
        { code: "US-VI", name: "Virgin Islands", i18n: {} },
        { code: "US-VA", name: "Virginia", i18n: {} },
        { code: "US-WA", name: "Washington", i18n: {} },
        { code: "US-DC", name: "Washington DC", i18n: {} },
        { code: "US-WV", name: "West Virginia", i18n: {} },
        { code: "US-WI", name: "Wisconsin", i18n: {} },
        { code: "US-WY", name: "Wyoming", i18n: {} },
    ],
    "UY": [
        { code: "UY-AR", name: "Artigas", i18n: {"es":"Departamento de Artigas"} },
        { code: "UY-CA", name: "Canelones", i18n: {"es":"Departamento de Canelones"} },
        { code: "UY-CL", name: "Cerro Largo", i18n: {"es":"Departamento de Cerro Largo"} },
        { code: "UY-CO", name: "Colonia", i18n: {"es":"Departamento de Colonia"} },
        { code: "UY-DU", name: "Durazno", i18n: {"es":"Departamento de Durazno"} },
        { code: "UY-FS", name: "Flores", i18n: {"es":"Departamento de Flores"} },
        { code: "UY-FD", name: "Florida", i18n: {"es":"Departamento de Florida"} },
        { code: "UY-LA", name: "Lavalleja", i18n: {"es":"Departamento de Lavalleja"} },
        { code: "UY-MA", name: "Maldonado", i18n: {"es":"Departamento de Maldonado"} },
        { code: "UY-MO", name: "Montevideo", i18n: {"es":"Departamento de Montevideo"} },
        { code: "UY-PA", name: "Paysandú", i18n: {"es":"Departamento de Paysandú"} },
        { code: "UY-RN", name: "Río Negro", i18n: {"es":"Departamento de Río Negro"} },
        { code: "UY-RV", name: "Rivera", i18n: {"es":"Departamento de Rivera"} },
        { code: "UY-RO", name: "Rocha", i18n: {"es":"Departamento de Rocha"} },
        { code: "UY-SA", name: "Salto", i18n: {"es":"Departamento de Salto"} },
        { code: "UY-SJ", name: "San José", i18n: {"es":"Departamento de San José"} },
        { code: "UY-SO", name: "Soriano", i18n: {"es":"Departamento de Soriano"} },
        { code: "UY-TA", name: "Tacuarembó", i18n: {"es":"Departamento de Tacuarembó"} },
        { code: "UY-TT", name: "Treinta y Tres", i18n: {"es":"Departamento de Treinta y Tres"} },
    ],
    "UZ": [
        { code: "UZ-AN", name: "Andijan", i18n: {"uz":"Andijon"} },
        { code: "UZ-BU", name: "Bukhara", i18n: {"uz":"Buxoro viloyati"} },
        { code: "UZ-FA", name: "Fergana", i18n: {"uz":"Fargʻona viloyati"} },
        { code: "UZ-JI", name: "Jizzakh", i18n: {"uz":"Jizzax viloyati"} },
        { code: "UZ-QR", name: "Karakalpakstan", i18n: {"uz":"Qoraqalpogʻiston"} },
        { code: "UZ-NG", name: "Namangan", i18n: {} },
        { code: "UZ-NW", name: "Navoiy", i18n: {"uz":"Navoiy viloyati"} },
        { code: "UZ-QA", name: "Qashqadaryo", i18n: {"uz":"Qashqadaryo viloyati"} },
        { code: "UZ-SA", name: "Samarqand", i18n: {"uz":"Samarqand viloyati"} },
        { code: "UZ-SI", name: "Sirdaryo", i18n: {"uz":"Sirdaryo viloyati"} },
        { code: "UZ-SU", name: "Surxondaryo", i18n: {"uz":"Surxondaryo viloyati"} },
        { code: "UZ-TK", name: "Tashkent", i18n: {"uz":"Toshkent"} },
        { code: "UZ-TO", name: "Tashkent Province", i18n: {"uz":"Toshkent viloyati"} },
        { code: "UZ-XO", name: "Xorazm", i18n: {"uz":"Xorazm viloyati"} },
    ],
    "VC": [
        { code: "VC-01", name: "Charlotte", i18n: {} },
        { code: "VC-06", name: "Grenadines", i18n: {} },
        { code: "VC-02", name: "Saint Andrew", i18n: {} },
        { code: "VC-03", name: "Saint David", i18n: {} },
        { code: "VC-04", name: "Saint George", i18n: {} },
        { code: "VC-05", name: "Saint Patrick", i18n: {} },
    ],
    "VE": [
        { code: "VE-Z", name: "Amazonas", i18n: {} },
        { code: "VE-B", name: "Anzoátegui", i18n: {} },
        { code: "VE-C", name: "Apure", i18n: {} },
        { code: "VE-D", name: "Aragua", i18n: {} },
        { code: "VE-E", name: "Barinas", i18n: {} },
        { code: "VE-F", name: "Bolívar", i18n: {} },
        { code: "VE-A", name: "Capital", i18n: {"es":"Distrito Capital"} },
        { code: "VE-G", name: "Carabobo", i18n: {} },
        { code: "VE-H", name: "Cojedes", i18n: {} },
        { code: "VE-Y", name: "Delta Amacuro", i18n: {} },
        { code: "VE-I", name: "Falcón", i18n: {} },
        { code: "VE-W", name: "Federal Dependencies", i18n: {"es":"Dependencias Federales Venezolanas"} },
        { code: "VE-J", name: "Guárico", i18n: {} },
        { code: "VE-K", name: "Lara", i18n: {} },
        { code: "VE-L", name: "Mérida", i18n: {} },
        { code: "VE-M", name: "Miranda", i18n: {} },
        { code: "VE-N", name: "Monagas", i18n: {} },
        { code: "VE-O", name: "Nueva Esparta", i18n: {} },
        { code: "VE-P", name: "Portuguesa", i18n: {} },
        { code: "VE-R", name: "Sucre", i18n: {} },
        { code: "VE-S", name: "Táchira", i18n: {} },
        { code: "VE-T", name: "Trujillo", i18n: {} },
        { code: "VE-X", name: "Vargas", i18n: {} },
        { code: "VE-U", name: "Yaracuy", i18n: {} },
        { code: "VE-V", name: "Zulia", i18n: {} },
    ],
    "VN": [
        { code: "VN-44", name: "An Giang", i18n: {} },
        { code: "VN-43", name: "Bà Rịa–Vũng Tàu", i18n: {"vi":"Bà Rịa - Vũng Tàu"} },
        { code: "VN-54", name: "Bắc Giang", i18n: {} },
        { code: "VN-53", name: "Bắc Kạn", i18n: {} },
        { code: "VN-55", name: "Bạc Liêu", i18n: {} },
        { code: "VN-56", name: "Bắc Ninh", i18n: {} },
        { code: "VN-50", name: "Bến Tre", i18n: {} },
        { code: "VN-31", name: "Bình Định", i18n: {} },
        { code: "VN-57", name: "Bình Dương", i18n: {} },
        { code: "VN-58", name: "Bình Phước", i18n: {} },
        { code: "VN-40", name: "Bình Thuận", i18n: {} },
        { code: "VN-59", name: "Cà Mau", i18n: {} },
        { code: "VN-CT", name: "Can Tho", i18n: {"vi":"Cần Thơ"} },
        { code: "VN-04", name: "Cao Bằng", i18n: {} },
        { code: "VN-DN", name: "Da Nang", i18n: {"vi":"Đà Nẵng"} },
        { code: "VN-33", name: "Đắk Lắk", i18n: {} },
        { code: "VN-72", name: "Đắk Nông", i18n: {} },
        { code: "VN-71", name: "Điện Biên", i18n: {} },
        { code: "VN-39", name: "Đồng Nai", i18n: {} },
        { code: "VN-45", name: "Đồng Tháp", i18n: {"vi":"Tỉnh Đồng Tháp"} },
        { code: "VN-30", name: "Gia Lai", i18n: {} },
        { code: "VN-03", name: "Hà Giang", i18n: {} },
        { code: "VN-63", name: "Hà Nam", i18n: {} },
        { code: "VN-23", name: "Hà Tĩnh", i18n: {} },
        { code: "VN-61", name: "Hải Dương", i18n: {} },
        { code: "VN-HP", name: "Haiphong", i18n: {"vi":"Hải Phòng"} },
        { code: "VN-HN", name: "Hanoi", i18n: {"vi":"Hà Nội"} },
        { code: "VN-73", name: "Hậu Giang", i18n: {} },
        { code: "VN-SG", name: "Ho Chi Minh City", i18n: {"vi":"Thành phố Hồ Chí Minh"} },
        { code: "VN-14", name: "Hòa Bình", i18n: {} },
        { code: "VN-66", name: "Hưng Yên", i18n: {} },
        { code: "VN-34", name: "Khánh Hòa", i18n: {} },
        { code: "VN-47", name: "Kiên Giang", i18n: {} },
        { code: "VN-28", name: "Kon Tum", i18n: {} },
        { code: "VN-01", name: "Lai Châu", i18n: {} },
        { code: "VN-35", name: "Lâm Đồng", i18n: {} },
        { code: "VN-09", name: "Lạng Sơn", i18n: {} },
        { code: "VN-02", name: "Lào Cai", i18n: {} },
        { code: "VN-41", name: "Long An", i18n: {} },
        { code: "VN-67", name: "Nam Định", i18n: {} },
        { code: "VN-22", name: "Nghệ An", i18n: {} },
        { code: "VN-18", name: "Ninh Bình", i18n: {} },
        { code: "VN-36", name: "Ninh Thuận", i18n: {} },
        { code: "VN-68", name: "Phú Thọ", i18n: {} },
        { code: "VN-32", name: "Phú Yên", i18n: {} },
        { code: "VN-24", name: "Quảng Bình", i18n: {} },
        { code: "VN-27", name: "Quảng Nam", i18n: {} },
        { code: "VN-29", name: "Quảng Ngãi", i18n: {} },
        { code: "VN-13", name: "Quảng Ninh", i18n: {} },
        { code: "VN-25", name: "Quảng Trị", i18n: {} },
        { code: "VN-52", name: "Sóc Trăng", i18n: {} },
        { code: "VN-05", name: "Sơn La", i18n: {} },
        { code: "VN-37", name: "Tây Ninh", i18n: {} },
        { code: "VN-20", name: "Thái Bình", i18n: {} },
        { code: "VN-69", name: "Thái Nguyên", i18n: {} },
        { code: "VN-21", name: "Thanh Hóa", i18n: {} },
        { code: "VN-26", name: "Thừa Thiên–Huế", i18n: {"vi":"Thừa Thiên - Huế"} },
        { code: "VN-46", name: "Tiền Giang", i18n: {} },
        { code: "VN-51", name: "Trà Vinh", i18n: {} },
        { code: "VN-07", name: "Tuyên Quang", i18n: {} },
        { code: "VN-49", name: "Vĩnh Long", i18n: {} },
        { code: "VN-70", name: "Vĩnh Phúc", i18n: {} },
        { code: "VN-06", name: "Yên Bái", i18n: {} },
    ],
    "VU": [
        { code: "VU-MAP", name: "Malampa", i18n: {} },
        { code: "VU-PAM", name: "Penama", i18n: {} },
        { code: "VU-SAM", name: "Sanma", i18n: {} },
        { code: "VU-SEE", name: "Shefa", i18n: {} },
        { code: "VU-TAE", name: "Tafea", i18n: {} },
        { code: "VU-TOB", name: "Torba", i18n: {} },
    ],
    "WF": [
        { code: "WF-AL", name: "Alo", i18n: {} },
        { code: "WF-SG", name: "Sigave", i18n: {} },
        { code: "WF-UV", name: "Uvea", i18n: {"fr":"Royaume coutumier de Uvea"} },
    ],
    "WS": [
        { code: "WS-AA", name: "A’ana", i18n: {} },
        { code: "WS-AL", name: "Aiga-i-le-Tai", i18n: {} },
        { code: "WS-AT", name: "Atua", i18n: {} },
        { code: "WS-FA", name: "Fa’asaleleaga", i18n: {} },
        { code: "WS-GE", name: "Gaga’emauga", i18n: {} },
        { code: "WS-GI", name: "Gaga’ifomauga", i18n: {} },
        { code: "WS-PA", name: "Palauli", i18n: {} },
        { code: "WS-SA", name: "Satupa’itea", i18n: {} },
        { code: "WS-TU", name: "Tuamasaga", i18n: {} },
        { code: "WS-VF", name: "Va’a-o-Fonoti", i18n: {} },
        { code: "WS-VS", name: "Vaisigano", i18n: {} },
    ],
    "YE": [
        { code: "YE-AD", name: "’Adan", i18n: {"ar":"محافظة عدن"} },
        { code: "YE-AB", name: "Abyan", i18n: {"ar":"محافظة أبين"} },
        { code: "YE-BA", name: "Al Bayda", i18n: {"ar":"محافظة البيضاء"} },
        { code: "YE-HU", name: "Al Hudaydah", i18n: {"ar":"محافظة الحديدة"} },
        { code: "YE-JA", name: "Al Jawf", i18n: {"ar":"محافظة الجوف"} },
        { code: "YE-MR", name: "Al Mahrah", i18n: {"ar":"محافظة المهرة"} },
        { code: "YE-MW", name: "Al Mahwit", i18n: {"ar":"محافظة المحويت"} },
        { code: "YE-SA", name: "Amanat Al Asimah", i18n: {"ar":"صنعاء"} },
        { code: "YE-AM", name: "Amran", i18n: {"ar":"محافظة عمران"} },
        { code: "YE-SU", name: "Arkhabil Suqutra", i18n: {"ar":"محافظة أرخبيل سقطرى"} },
        { code: "YE-DA", name: "Dhale", i18n: {"ar":"محافظة الضالع"} },
        { code: "YE-DH", name: "Dhamar", i18n: {"ar":"محافظة ذمار"} },
        { code: "YE-HD", name: "Hadramaut", i18n: {"ar":"محافظة حضرموت"} },
        { code: "YE-HJ", name: "Hajjah", i18n: {"ar":"محافظة حجة"} },
        { code: "YE-IB", name: "Ibb", i18n: {"ar":"محافظة إب"} },
        { code: "YE-LA", name: "Lahij", i18n: {"ar":"محافظة لحج"} },
        { code: "YE-MA", name: "Ma’rib", i18n: {"ar":"محافظة مأرب"} },
        { code: "YE-RA", name: "Raymah", i18n: {"ar":"محافظة ريمة"} },
        { code: "YE-SD", name: "Sa’dah", i18n: {"ar":"محافظة صعدة"} },
        { code: "YE-SN", name: "Sana’a", i18n: {"ar":"محافظة صنعاء"} },
        { code: "YE-SH", name: "Shabwah", i18n: {"ar":"محافظة شبوة"} },
        { code: "YE-TA", name: "Taiz", i18n: {"ar":"محافظة تعز"} },
    ],
    "ZA": [
        { code: "ZA-EC", name: "Eastern Cape", i18n: {} },
        { code: "ZA-FS", name: "Free State", i18n: {} },
        { code: "ZA-GP", name: "Gauteng", i18n: {} },
        { code: "ZA-KZN", name: "KwaZulu-Natal", i18n: {} },
        { code: "ZA-LP", name: "Limpopo", i18n: {} },
        { code: "ZA-MP", name: "Mpumalanga", i18n: {} },
        { code: "ZA-NW", name: "North West", i18n: {} },
        { code: "ZA-NC", name: "Northern Cape", i18n: {} },
        { code: "ZA-WC", name: "Western Cape", i18n: {} },
    ],
    "ZM": [
        { code: "ZM-02", name: "Central", i18n: {} },
        { code: "ZM-08", name: "Copperbelt", i18n: {} },
        { code: "ZM-03", name: "Eastern", i18n: {} },
        { code: "ZM-04", name: "Luapula", i18n: {} },
        { code: "ZM-09", name: "Lusaka", i18n: {} },
        { code: "ZM-10", name: "Muchinga", i18n: {} },
        { code: "ZM-06", name: "North-Western", i18n: {} },
        { code: "ZM-05", name: "Northern", i18n: {} },
        { code: "ZM-07", name: "Southern", i18n: {} },
        { code: "ZM-01", name: "Western", i18n: {} },
    ],
    "ZW": [
        { code: "ZW-BU", name: "Bulawayo", i18n: {} },
        { code: "ZW-HA", name: "Harare", i18n: {} },
        { code: "ZW-MA", name: "Manicaland", i18n: {} },
        { code: "ZW-MC", name: "Mashonaland Central", i18n: {} },
        { code: "ZW-ME", name: "Mashonaland East", i18n: {} },
        { code: "ZW-MW", name: "Mashonaland West", i18n: {} },
        { code: "ZW-MV", name: "Masvingo", i18n: {} },
        { code: "ZW-MN", name: "Matabeleland North", i18n: {} },
        { code: "ZW-MS", name: "Matabeleland South", i18n: {} },
        { code: "ZW-MI", name: "Midlands", i18n: {} },
    ],
};

export const getStatesByCountry = (countryCode) => STATES_BY_COUNTRY[countryCode] || [];

// Localized display name for a state, falling back to the canonical (English) name.
export const getStateLabel = (state, locale) =>
    (state && ((state.i18n && state.i18n[locale]) || state.name)) || '';

export default STATES_BY_COUNTRY;
